import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  IdOrReference: { input: any; output: any; }
  Long: { input: any; output: any; }
  Reference: { input: any; output: any; }
};

/** Abstract Customer folder. */
export type AbstractCustomerFolder = {
  /** Folder administrative status */
  adminStatus: AdminStatus;
  /** Customer folder analysis */
  analysis?: Maybe<Scalars['String']['output']>;
  areMultipleCustomersEditable: Scalars['Boolean']['output'];
  /** Customer folder attachments */
  attachments: Array<Attachment>;
  /** Available required fields */
  availableRequiredFields: Scalars['Int']['output'];
  /** beneficial owners provider link */
  beneficialOwnersProviderLink?: Maybe<BeneficialOwnersProviderLink>;
  /** Folder completion status */
  completionStatus: FolderCompletionStatus;
  /** Indicates if the shareholding of the folder is considered as complex according to the rules defined in the configuration */
  complexShareholding: Scalars['Boolean']['output'];
  contactPerson?: Maybe<ContactPerson>;
  /** The mode by which beneficiary owners that are not automatically computed by the application can be selected. This depends on both the folderType and the fileType, if any */
  contextualManualBeneficiaryOwnerIdentificationMode: ManualBeneficiaryOwnerIdentificationMode;
  /**
   * Id of the current version of the object.
   * Will be null if object itself is the current/main version and does not belong to a snapshot
   */
  currentVersionId?: Maybe<Scalars['ID']['output']>;
  /** The customer of the folder */
  customer: RootEntity;
  /** Customer folder KYC review status */
  customerFolderKycReviewStatus: CustomerFolderKycReviewStatus;
  /** Customer folder type */
  customerFolderType: CustomerFolderType;
  /** Indicates if a DccpAlert is active on this folder. When true, any folder file created on this folder will require an agreement of the DC */
  dccp: Scalars['Boolean']['output'];
  /** Stakeholders in the folder that have at least one DccpAlert. The onlyActiveAlerts filter excludes those entities that have only disabled alerts */
  dccpAlertStakeholders: Array<Entity>;
  families: Array<Family>;
  /** All the files linked to the customer folder */
  folderFiles: CustomerFolderFilesPage;
  /** Customer folder system identifier */
  id: Scalars['ID']['output'];
  /** Used inputValue by code */
  inputValue?: Maybe<InputValue>;
  /** Used inputValues by code */
  inputValues: Array<InputValue>;
  isDeletable: Scalars['Boolean']['output'];
  missions: Array<Mission>;
  pendingStatusUpdate: PendingStatusUpdate;
  preferences?: Maybe<Scalars['String']['output']>;
  questionnaires: Array<Questionnaire>;
  /** Required fields */
  requiredFields: Scalars['Int']['output'];
  /** Customer folder risk status */
  riskStatus?: Maybe<FolderRiskStatus>;
  /** The Customer (of the CustomerFolder) or the ThirdParty (of the ThirdPartyFolder) */
  rootEntity: RootEntity;
  /**
   * Snapshot to which the object belongs.
   * Will be null if object is the current/main version and does not belong to a snapshot
   */
  snapshot?: Maybe<Snapshot>;
  /** Customer folder status */
  status: FolderStatus;
  /** The expected questionnaires according to the customerFolderType, as well as the saved questionnaires if any */
  supportingQuestionnaires: Array<SupportingQuestionnaire>;
  whatIfSourceId?: Maybe<Scalars['ID']['output']>;
};


/** Abstract Customer folder. */
export type AbstractCustomerFolderDccpAlertStakeholdersArgs = {
  onlyWithActiveAlerts?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Abstract Customer folder. */
export type AbstractCustomerFolderFolderFilesArgs = {
  limit: Scalars['Int']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


/** Abstract Customer folder. */
export type AbstractCustomerFolderInputValueArgs = {
  fieldCode: Scalars['String']['input'];
};


/** Abstract Customer folder. */
export type AbstractCustomerFolderInputValuesArgs = {
  fieldCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Abstract Customer folder. */
export type AbstractCustomerFolderSupportingQuestionnairesArgs = {
  includeFileQuestionnaires?: InputMaybe<Scalars['Boolean']['input']>;
  includeFolderOnlyQuestionnaires?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A documentType or a group of document types */
export type AbstractDocumentType = {
  /** It always exists in the product types. It is optional for the other elements */
  category?: Maybe<Scalars['String']['output']>;
  /** The code of the element. */
  code: Scalars['String']['output'];
  content: Array<DocumentType>;
  /** Has the element been disabled */
  disabled: Scalars['Boolean']['output'];
  /** A comment about element disabling */
  disabledComment?: Maybe<Scalars['String']['output']>;
  /** element type */
  elementType: Scalars['String']['output'];
  /** The id of the element. */
  id: Scalars['ID']['output'];
  /** The name of the element. */
  name: Scalars['String']['output'];
  /** The status of the element. */
  status: VersionStatus;
  /** The version code of the element. */
  versionCode: Scalars['String']['output'];
};

export type AbstractEreputation = {
  details?: Maybe<EReputationDetail>;
  isComplete: Scalars['Boolean']['output'];
};

/** Common Role and FolderRole fields. */
export type AbstractRole = {
  /** Custom voting rights */
  customVotingRights?: Maybe<Scalars['Float']['output']>;
  /** Direct beneficiary owner */
  directBeneficiaryOwner?: Maybe<DirectBeneficiaryOwner>;
  /** Relation entity type */
  relatedEntityType?: Maybe<RelatedEntityType>;
  /** Relation name */
  relationDescription?: Maybe<Scalars['String']['output']>;
  /** Role type */
  roleType: RoleType;
  /** Role share */
  share?: Maybe<Scalars['Float']['output']>;
  /** Source entity */
  sourceEntity?: Maybe<Entity>;
  /** Subsidiary total share */
  subsidiaryTotalShare?: Maybe<Scalars['Float']['output']>;
  /** Subsidiary type */
  subsidiaryType?: Maybe<SubsidiaryType>;
  /** Target entity */
  targetEntity?: Maybe<Entity>;
  /** Voting rights */
  votingRights?: Maybe<Scalars['Float']['output']>;
};

/** Folder file workflow action */
export type Action = WorkflowAction & {
  __typename?: 'Action';
  backward: Scalars['Boolean']['output'];
  /** This can be used instead of the id in any mutation that requires an actionId */
  code: Scalars['String']['output'];
  confirmationMessage?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isValidation: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

/** Administrative status. */
export type AdminStatus = {
  __typename?: 'AdminStatus';
  /** Author */
  author: User;
  /** Creation date */
  creation: Scalars['String']['output'];
  /** Last moddification date */
  lastModification: Scalars['String']['output'];
  /** Last modifier user */
  lastModifier: User;
};

export type Attachment = {
  __typename?: 'Attachment';
  contentType?: Maybe<Scalars['String']['output']>;
  currentVersionId?: Maybe<Scalars['ID']['output']>;
  /** Id of the attachment in the file database */
  fileId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

/** An audit event */
export type AuditEvent = {
  date: Scalars['String']['output'];
  /** State of the file after the event */
  state: WorkflowState;
  type: EventType;
  user: User;
};

export type AutocreationCorporationResult = {
  __typename?: 'AutocreationCorporationResult';
  customer?: Maybe<Corporation>;
  errors: Array<AutocreationFailure>;
};

export enum AutocreationElementType {
  BeneficialOwner = 'BeneficialOwner',
  CorporationRepresentative = 'CorporationRepresentative',
  CustomerCompany = 'CustomerCompany',
  CustomerPerson = 'CustomerPerson',
  PersonRepresentative = 'PersonRepresentative'
}

/** Failure from creation of a specific element or subGraph or whole customer graph */
export type AutocreationFailure = {
  __typename?: 'AutocreationFailure';
  elementType: AutocreationElementType;
  identifier: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type AutocreationPersonResult = {
  __typename?: 'AutocreationPersonResult';
  customer?: Maybe<Person>;
  errors: Array<AutocreationFailure>;
};

export type AutomaticDccpAnalysis = {
  __typename?: 'AutomaticDccpAnalysis';
  inputValues: Array<WorkflowInputValue>;
};

/** AxisStatus */
export type AxisStatus = {
  __typename?: 'AxisStatus';
  axisName: Scalars['String']['output'];
  dccpApprovalRequired: Scalars['Boolean']['output'];
  /** Count of items of each RiskEntityType in the axis configuration */
  itemCounts: Array<RiskItemCount>;
  riskLevel: RiskLevel;
  /** All risks except those with a score of 0 and a false dccpApprovalRequired */
  risks: Array<Risk>;
  score: Scalars['Int']['output'];
  weight: Scalars['Float']['output'];
  weightedScore: Scalars['Int']['output'];
};

export type BeneficialOwnersProviderLink = {
  __typename?: 'BeneficialOwnersProviderLink';
  downloadText: Scalars['String']['output'];
  fields: Array<ProviderField>;
  invalidParametersText: Scalars['String']['output'];
};

export type Body = {
  variables: Array<Variable>;
};

export enum CategoryUsageLevel {
  Mandatory = 'MANDATORY',
  NotUsed = 'NOT_USED',
  Optional = 'OPTIONAL'
}

/** City. */
export type City = ClientConfElement & {
  __typename?: 'City';
  code: Scalars['String']['output'];
  countryCode: Scalars['String']['output'];
  /** Has the element been disabled */
  disabled: Scalars['Boolean']['output'];
  /** A comment about element disabling */
  disabledComment?: Maybe<Scalars['String']['output']>;
  /** element type */
  elementType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
};

/** An element of client configuration */
export type ClientConfElement = {
  /** The code of the element. */
  code: Scalars['String']['output'];
  /** Has the element been disabled */
  disabled: Scalars['Boolean']['output'];
  /** A comment about element disabling */
  disabledComment?: Maybe<Scalars['String']['output']>;
  /** element type */
  elementType: Scalars['String']['output'];
  /** The id of the element. */
  id: Scalars['ID']['output'];
  /** The name of the element. */
  name: Scalars['String']['output'];
};

export enum ConfField {
  Category = 'CATEGORY',
  Code = 'CODE',
  Name = 'NAME',
  Ordinal = 'ORDINAL'
}

/** ConfInputValueContent. */
export type ConfInputValueContent = {
  codes: Array<Scalars['String']['input']>;
  entityClass: EntityClass;
  fieldCode: Scalars['String']['input'];
};

export type ConfInputValueFilter = {
  __typename?: 'ConfInputValueFilter';
  entityClass: EntityClass;
  excludedCodes: Array<Scalars['String']['output']>;
  fieldCode: Scalars['String']['output'];
  includedCodes: Array<Scalars['String']['output']>;
};

/** Constraint (stored in the DB) used to validate the field by the back */
export type Constraint = {
  __typename?: 'Constraint';
  code: Scalars['String']['output'];
  dataType?: Maybe<DataType>;
  description: Scalars['String']['output'];
  languageTextKey?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** Contact person. */
export type ContactPerson = InputEntity & {
  __typename?: 'ContactPerson';
  contactPersonType: ContactPersonType;
  currentVersionId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  /** Used inputValue by code */
  inputValue?: Maybe<InputValue>;
  /** Used inputValues by code */
  inputValues: Array<InputValue>;
  /**
   * Snapshot to which the object belongs.
   * Will be null if object is the current/main version and does not belong to a snapshot
   */
  snapshot?: Maybe<Snapshot>;
};


/** Contact person. */
export type ContactPersonInputValueArgs = {
  fieldCode: Scalars['String']['input'];
};


/** Contact person. */
export type ContactPersonInputValuesArgs = {
  fieldCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Contact person type. */
export type ContactPersonType = ClientConfElement & HistorizedClientConfElement & ListElement & {
  __typename?: 'ContactPersonType';
  category?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  disabled: Scalars['Boolean']['output'];
  disabledComment?: Maybe<Scalars['String']['output']>;
  documentFilter?: Maybe<Scalars['String']['output']>;
  /** element type */
  elementType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  inputFields: Array<InputField>;
  inputForm?: Maybe<InputForm>;
  name: Scalars['String']['output'];
  ordinal: Scalars['Long']['output'];
  status: VersionStatus;
  versionCode: Scalars['String']['output'];
};


/** Contact person type. */
export type ContactPersonTypeInputFormArgs = {
  key: Scalars['String']['input'];
};

/** Corporation. */
export type Corporation = DocumentableEntity & Entity & InputEntity & RiskEntity & RootEntity & SingleRootEntity & {
  __typename?: 'Corporation';
  adminStatus: EntityAdminStatus;
  /** Returns all documents associated with this entity */
  allDocuments: Array<Document>;
  attachments: Array<Attachment>;
  /**
   * The total percentage of a corporation's shares that has been successfully identified in the database. In other words,
   * the sum of all the shares of the corporation stakeholders, including OtherShareholders.
   * In the context of a folder, use FolderStakeholder.capitalizationTable instead.
   */
  capitalizationTable: Scalars['Float']['output'];
  /** RootEntity content. Only if we are dealing with a customer which is a group of persons can there be more than one Entity. */
  content: Array<Entity>;
  /** The identifier of the entity in the current state. It will return its own id if this entity is not a snapshot */
  currentEntityId: Scalars['ID']['output'];
  currentVersionId?: Maybe<Scalars['ID']['output']>;
  /** RootEntity customer folders */
  customerFolders: Array<CustomerFolder>;
  customVotingRightsEnabled: Scalars['Boolean']['output'];
  dccp: Scalars['Boolean']['output'];
  /** Entity dccp alerts */
  dccpAlerts: Array<DccpAlert>;
  documentComment?: Maybe<Scalars['String']['output']>;
  /** Customer has refused to provide some supporting documents */
  documentRefusal: Scalars['Boolean']['output'];
  /** Returns all documents associated with this entity, except those that are specific to a folder or file */
  documents: Array<Document>;
  eReputation?: Maybe<Ereputation>;
  /** Entity eReputation alerts */
  eReputationAlerts: Array<EReputationAlert>;
  eReputationComment?: Maybe<Scalars['String']['output']>;
  hasAlert: Scalars['Boolean']['output'];
  historizedStakeholderProperties?: Maybe<FolderStakeholderProperties>;
  /** The id (or sharedId) of the entity. */
  id: Scalars['ID']['output'];
  /** Used inputValue by code */
  inputValue?: Maybe<InputValue>;
  /** Used inputValues by code */
  inputValues: Array<InputValue>;
  /** Corporation is the customer of a folder */
  isCustomer: Scalars['Boolean']['output'];
  /** isPerson flag */
  isPerson: Scalars['Boolean']['output'];
  lastValidatedEReputation?: Maybe<LastValidatedEReputation>;
  /** Corporation is linked to a master corporation */
  linked: Scalars['Boolean']['output'];
  managers: Array<Manager>;
  otherShareholders?: Maybe<OtherShareholders>;
  relatedEntities: Array<RelatedEntity>;
  roles: Array<Role>;
  shareholders: Array<Shareholder>;
  /**
   * Snapshot to which the object belongs.
   * Will be null if object is the current/main version and does not belong to a snapshot
   */
  snapshot?: Maybe<Snapshot>;
  /** Entity type. */
  type: EntityType;
  /** The real id of the entity (so, never a sharedId). For debugging purposes */
  underlyingId: Scalars['ID']['output'];
  /**
   * The total percentage of a corporation's voting rights that has been successfully identified.
   * In the context of a folder, use FolderStakeholder.votingRightsTable instead.
   */
  votingRightsTable: Scalars['Float']['output'];
  whatIfSourceId?: Maybe<Scalars['ID']['output']>;
};


/** Corporation. */
export type CorporationAllDocumentsArgs = {
  displayDocsSharingType?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Corporation. */
export type CorporationDccpAlertsArgs = {
  onlyActiveAlerts?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Corporation. */
export type CorporationDocumentsArgs = {
  displayDocsSharingType?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Corporation. */
export type CorporationEReputationAlertsArgs = {
  onlyActiveAlerts?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Corporation. */
export type CorporationInputValueArgs = {
  fieldCode: Scalars['String']['input'];
};


/** Corporation. */
export type CorporationInputValuesArgs = {
  fieldCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Corporation. */
export type CorporationRolesArgs = {
  direction?: InputMaybe<RoleDirection>;
};

/** A page of corporations and page info. */
export type CorporationPage = {
  __typename?: 'CorporationPage';
  corporations: Array<Corporation>;
  pageInfo: PageInfo;
};

/** A succession of Corporation IDs */
export type CorporationsInputValue = InputValue & {
  __typename?: 'CorporationsInputValue';
  /** @deprecated Use inputField (fieldType) instead */
  dataType: DataType;
  entities: Array<Corporation>;
  /** @deprecated Use inputField (fieldCode) instead */
  fieldCode: Scalars['String']['output'];
  inputField: InputField;
  stringValue?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use stringValue instead */
  value?: Maybe<Scalars['String']['output']>;
};

/** Country. */
export type Country = ClientConfElement & HistorizedClientConfElement & ListElement & ListElementWithFamily & ListElementWithRisk & {
  __typename?: 'Country';
  alpha2: Scalars['String']['output'];
  alpha3: Scalars['String']['output'];
  category?: Maybe<Scalars['String']['output']>;
  cities: Array<City>;
  code: Scalars['String']['output'];
  disabled: Scalars['Boolean']['output'];
  disabledComment?: Maybe<Scalars['String']['output']>;
  documentFilter?: Maybe<Scalars['String']['output']>;
  /** element type */
  elementType: Scalars['String']['output'];
  family?: Maybe<Family>;
  hasCities: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  ordinal: Scalars['Long']['output'];
  /** It always contains at least one element */
  riskValues: Array<RiskValue>;
  status: VersionStatus;
  versionCode: Scalars['String']['output'];
};


/** Country. */
export type CountryCitiesArgs = {
  limit: Scalars['Int']['input'];
  searchString?: InputMaybe<Scalars['String']['input']>;
};

export type CountryRiskMapConfiguration = ClientConfElement & {
  __typename?: 'CountryRiskMapConfiguration';
  code: Scalars['String']['output'];
  defaultColor: Scalars['String']['output'];
  defaultLegend: Scalars['String']['output'];
  /** Has the element been disabled */
  disabled: Scalars['Boolean']['output'];
  /** A comment about element disabling */
  disabledComment?: Maybe<Scalars['String']['output']>;
  /** element type */
  elementType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  riskValueDisplays: Array<RiskValueDisplay>;
};

/** CreationEvent. */
export type CreationEvent = AuditEvent & {
  __typename?: 'CreationEvent';
  date: Scalars['String']['output'];
  state: WorkflowState;
  type: EventType;
  user: User;
};

/** Customer folder. */
export type CustomerFolder = AbstractCustomerFolder & FieldCompletion & Folder & InputEntity & Preferenceable & Questionnaireable & RiskEntity & {
  __typename?: 'CustomerFolder';
  /** Folder administrative status */
  adminStatus: AdminStatus;
  /** Customer folder analysis */
  analysis?: Maybe<Scalars['String']['output']>;
  areMultipleCustomersEditable: Scalars['Boolean']['output'];
  /** Customer folder attachments */
  attachments: Array<Attachment>;
  auditEvents: Array<FolderAuditEvent>;
  /** Available required fields */
  availableRequiredFields: Scalars['Int']['output'];
  /** beneficial owners provider link */
  beneficialOwnersProviderLink?: Maybe<BeneficialOwnersProviderLink>;
  /** Folder completion status */
  completionStatus: FolderCompletionStatus;
  /** Indicates if the shareholding of the folder is considered as complex according to the rules defined in the configuration */
  complexShareholding: Scalars['Boolean']['output'];
  contactPerson?: Maybe<ContactPerson>;
  /** The mode by which beneficiary owners that are not automatically computed by the application can be selected. This depends on both the folderType and the fileType, if any */
  contextualManualBeneficiaryOwnerIdentificationMode: ManualBeneficiaryOwnerIdentificationMode;
  /** All the corporations linked to the Customer (of the CustomerFolder) or the ThirdParty (of the ThirdPartyFolder) */
  corporations: Array<Corporation>;
  /**
   * Id of the current version of the object.
   * Will be null if object itself is the current/main version and does not belong to a snapshot
   */
  currentVersionId?: Maybe<Scalars['ID']['output']>;
  /** The customer of the folder */
  customer: RootEntity;
  /** Customer folder KYC review status */
  customerFolderKycReviewStatus: CustomerFolderKycReviewStatus;
  /** Customer folder type */
  customerFolderType: CustomerFolderType;
  /** Indicates if a DccpAlert is active on this folder. When true, any folder file created on this folder will require an agreement of the DC */
  dccp: Scalars['Boolean']['output'];
  /** Stakeholders in the folder that have at least one DccpAlert. The onlyActiveAlerts filter excludes those entities that have only disabled alerts */
  dccpAlertStakeholders: Array<Entity>;
  families: Array<Family>;
  /** All the files linked to the customer folder */
  folderFiles: CustomerFolderFilesPage;
  /** Is Customer folder followed by current users */
  followedByCurrentUser: Scalars['Boolean']['output'];
  /** Customer folder following users */
  followingUsers: Array<User>;
  /** Customer folder system identifier */
  id: Scalars['ID']['output'];
  /** Used inputValue by code */
  inputValue?: Maybe<InputValue>;
  /** Used inputValues by code */
  inputValues: Array<InputValue>;
  isDeletable: Scalars['Boolean']['output'];
  missions: Array<Mission>;
  /** Customer folder owner */
  owner?: Maybe<User>;
  pendingStatusUpdate: PendingStatusUpdate;
  /** All the persons linked to the Customer (of the CustomerFolder) or the ThirdParty (of the ThirdPartyFolder) */
  persons: Array<Person>;
  preferences?: Maybe<Scalars['String']['output']>;
  questionnaires: Array<Questionnaire>;
  /** Required fields */
  requiredFields: Scalars['Int']['output'];
  /** Customer folder risk status */
  riskStatus?: Maybe<FolderRiskStatus>;
  /** The Customer (of the CustomerFolder) or the ThirdParty (of the ThirdPartyFolder) */
  rootEntity: RootEntity;
  /**
   * Snapshot to which the object belongs.
   * Will be null if object is the current/main version and does not belong to a snapshot
   */
  snapshot?: Maybe<Snapshot>;
  /** All the stakeholders linked to the Customer (of the CustomerFolder) or the ThirdParty (of the ThirdPartyFolder) */
  stakeholders: Array<FolderStakeholder>;
  /** Customer folder status */
  status: FolderStatus;
  /** The expected questionnaires according to the customerFolderType, as well as the saved questionnaires if any */
  supportingQuestionnaires: Array<SupportingQuestionnaire>;
  /** Use external corporations */
  useExternalCorporations: Scalars['Boolean']['output'];
  whatIfSourceId?: Maybe<Scalars['ID']['output']>;
};


/** Customer folder. */
export type CustomerFolderDccpAlertStakeholdersArgs = {
  onlyWithActiveAlerts?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Customer folder. */
export type CustomerFolderFolderFilesArgs = {
  limit: Scalars['Int']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


/** Customer folder. */
export type CustomerFolderInputValueArgs = {
  fieldCode: Scalars['String']['input'];
};


/** Customer folder. */
export type CustomerFolderInputValuesArgs = {
  fieldCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Customer folder. */
export type CustomerFolderSupportingQuestionnairesArgs = {
  includeFileQuestionnaires?: InputMaybe<Scalars['Boolean']['input']>;
  includeFolderOnlyQuestionnaires?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Customer Folder files page and page info. */
export type CustomerFolderFilesPage = {
  __typename?: 'CustomerFolderFilesPage';
  pageInfo: PageInfo;
  summaries: Array<FolderFile>;
};

/** CustomerFolderKycReviewStatus. */
export type CustomerFolderKycReviewStatus = {
  __typename?: 'CustomerFolderKycReviewStatus';
  failedKycReviewReason?: Maybe<StandardListElement>;
  kycReviewStatus?: Maybe<KycReviewStatus>;
  kycReviewStatusLastModification?: Maybe<Scalars['String']['output']>;
  kycReviewStatusLastModifier?: Maybe<User>;
  updateRequired: Scalars['Boolean']['output'];
  updateRequiredDate?: Maybe<Scalars['String']['output']>;
  updateRequiredNotificationDate?: Maybe<Scalars['String']['output']>;
};

/** Customer folders page and page info. */
export type CustomerFoldersPage = {
  __typename?: 'CustomerFoldersPage';
  pageInfo: PageInfo;
  summaries: Array<CustomerFolderSummary>;
};

export enum CustomerFoldersPageSortingFieldName {
  RenewDate = 'RenewDate',
  RiskLevel = 'RiskLevel'
}

/** Customer folder summary. */
export type CustomerFolderSummary = {
  __typename?: 'CustomerFolderSummary';
  customer: RootEntity;
  customerFolder: CustomerFolder;
  file?: Maybe<FolderFile>;
  maxEventDate?: Maybe<Scalars['String']['output']>;
  mission?: Maybe<Mission>;
};

/** Customer folder type. */
export type CustomerFolderType = ClientConfElement & HistorizedClientConfElement & ListElement & {
  __typename?: 'CustomerFolderType';
  allowCorporationCustomer: Scalars['Boolean']['output'];
  allowedFolderFileTypes: Array<FolderFileType>;
  allowMultipleCustomers: Scalars['Boolean']['output'];
  allowPersonCustomer: Scalars['Boolean']['output'];
  category?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  /** Has the element been disabled */
  disabled: Scalars['Boolean']['output'];
  /** A comment about element disabling */
  disabledComment?: Maybe<Scalars['String']['output']>;
  documentFilter?: Maybe<Scalars['String']['output']>;
  /** element type */
  elementType: Scalars['String']['output'];
  iconName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inputFields: Array<InputField>;
  inputForm?: Maybe<InputForm>;
  manualBeneficiaryOwnerIdentificationMode: ManualBeneficiaryOwnerIdentificationMode;
  name: Scalars['String']['output'];
  ordinal: Scalars['Long']['output'];
  permissions: Array<Scope>;
  status: VersionStatus;
  useExternalCorporations: Scalars['Boolean']['output'];
  useMasterDataIntegration: Scalars['Boolean']['output'];
  versionCode: Scalars['String']['output'];
};


/** Customer folder type. */
export type CustomerFolderTypeInputFormArgs = {
  corporationLifeStatusKey?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
};

export type CustomerGraphComparisonResult = {
  __typename?: 'CustomerGraphComparisonResult';
  errors: Array<AutocreationFailure>;
  stakeholdersWithDiffs: Array<FolderStakeholderWithDiffs>;
};

export enum DataType {
  /** Boolean data type */
  Boolean = 'Boolean',
  /** Configuration element code in String format */
  Code = 'Code',
  /** List of codes */
  Codes = 'Codes',
  /** Double precision float number */
  Float = 'Float',
  /** GPS coordinates in decimal degree format: 'lat, lon' where -90 <= lat <= 90 and -180 <= lon <= 180 */
  Gps = 'GPS',
  /** Long integer */
  Integer = 'Integer',
  /** String data type */
  String = 'String',
  /** List of strings */
  StringList = 'StringList',
  /** Map of string key-values */
  StringMap = 'StringMap',
  /** Timestamp: String representing the time stamp formatted in ISO 8601 format */
  Timestamp = 'Timestamp',
  /** Vertex ID */
  VertexId = 'VertexId',
  /** List of Vertex IDs */
  VertexIdList = 'VertexIdList'
}

/** DccpAlert. */
export type DccpAlert = {
  __typename?: 'DccpAlert';
  adminStatus: AdminStatus;
  attachments: Array<Attachment>;
  comment?: Maybe<Scalars['String']['output']>;
  currentVersionId?: Maybe<Scalars['ID']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /**
   * Snapshot to which the object belongs.
   * Will be null if object is the current/main version and does not belong to a snapshot
   */
  snapshot?: Maybe<Snapshot>;
  startDate: Scalars['String']['output'];
  type: DccpAlertType;
};

/** Dccp alert input. */
export type DccpAlertInputType = {
  alertTypeCode?: InputMaybe<Scalars['String']['input']>;
  alertTypeId?: InputMaybe<Scalars['ID']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
};

/** DCCP alert type. */
export type DccpAlertType = ClientConfElement & HistorizedClientConfElement & ListElement & ListElementWithFamily & ListElementWithRisk & {
  __typename?: 'DccpAlertType';
  category?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  disabled: Scalars['Boolean']['output'];
  disabledComment?: Maybe<Scalars['String']['output']>;
  documentFilter?: Maybe<Scalars['String']['output']>;
  /** element type */
  elementType: Scalars['String']['output'];
  family?: Maybe<Family>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  ordinal: Scalars['Long']['output'];
  /** It always contains at least one element */
  riskValues: Array<RiskValue>;
  status: VersionStatus;
  versionCode: Scalars['String']['output'];
};

export type DccpAnalysis = InputEntity & {
  __typename?: 'DccpAnalysis';
  adminStatus: AdminStatus;
  attachments: Array<Attachment>;
  dccpAnalysisType: DccpAnalysisType;
  id: Scalars['ID']['output'];
  /** Used inputValue by code */
  inputValue?: Maybe<InputValue>;
  /** Used inputValues by code */
  inputValues: Array<InputValue>;
};


export type DccpAnalysisInputValueArgs = {
  fieldCode: Scalars['String']['input'];
};


export type DccpAnalysisInputValuesArgs = {
  fieldCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Dccp Analysis type. */
export type DccpAnalysisType = ClientConfElement & {
  __typename?: 'DccpAnalysisType';
  code: Scalars['String']['output'];
  /** Has the element been disabled */
  disabled: Scalars['Boolean']['output'];
  /** A comment about element disabling */
  disabledComment?: Maybe<Scalars['String']['output']>;
  /** element type */
  elementType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  inputFields: Array<InputField>;
  inputForm?: Maybe<InputForm>;
  name: Scalars['String']['output'];
  status: VersionStatus;
  versionCode: Scalars['String']['output'];
};


/** Dccp Analysis type. */
export type DccpAnalysisTypeInputFormArgs = {
  key: Scalars['String']['input'];
};

/** DccpEvent. */
export type DccpEvent = AuditEvent & {
  __typename?: 'DccpEvent';
  date: Scalars['String']['output'];
  eventType: EventType;
  state: WorkflowState;
  type: EventType;
  user: User;
};

export type DccpFollowUp = InputEntity & {
  __typename?: 'DccpFollowUp';
  adminStatus: AdminStatus;
  attachments: Array<Attachment>;
  dccpFollowUpType: DccpFollowUpType;
  id: Scalars['ID']['output'];
  /** Used inputValue by code */
  inputValue?: Maybe<InputValue>;
  /** Used inputValues by code */
  inputValues: Array<InputValue>;
};


export type DccpFollowUpInputValueArgs = {
  fieldCode: Scalars['String']['input'];
};


export type DccpFollowUpInputValuesArgs = {
  fieldCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Dccp FollowUp type. */
export type DccpFollowUpType = ClientConfElement & {
  __typename?: 'DccpFollowUpType';
  code: Scalars['String']['output'];
  /** Has the element been disabled */
  disabled: Scalars['Boolean']['output'];
  /** A comment about element disabling */
  disabledComment?: Maybe<Scalars['String']['output']>;
  /** element type */
  elementType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  inputFields: Array<InputField>;
  inputForm?: Maybe<InputForm>;
  name: Scalars['String']['output'];
  status: VersionStatus;
  versionCode: Scalars['String']['output'];
};


/** Dccp FollowUp type. */
export type DccpFollowUpTypeInputFormArgs = {
  key: Scalars['String']['input'];
};

export type DetailedResult = {
  __typename?: 'DetailedResult';
  content: Scalars['String']['output'];
  entityId?: Maybe<Scalars['String']['output']>;
  positionInSearchResults: Scalars['Int']['output'];
};

/** A task which is suggested to be performed in the context of a file */
export type Diligence = {
  __typename?: 'Diligence';
  adminStatus: AdminStatus;
  category?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  file: FolderFile;
  id: Scalars['ID']['output'];
  index: Scalars['Long']['output'];
  name: Scalars['String']['output'];
  selected: Scalars['Boolean']['output'];
};

export type DiligenceDefinition = ClientConfElement & HistorizedClientConfElement & ListElement & {
  __typename?: 'DiligenceDefinition';
  category?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  disabled: Scalars['Boolean']['output'];
  disabledComment?: Maybe<Scalars['String']['output']>;
  documentFilter?: Maybe<Scalars['String']['output']>;
  /** element type */
  elementType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  ordinal: Scalars['Long']['output'];
  ORfilters: Array<ConfInputValueFilter>;
  riskLevels: Array<RiskLevel>;
  showOnlyIfPep: Scalars['Boolean']['output'];
  status: VersionStatus;
  versionCode: Scalars['String']['output'];
};

/** DirectBeneficiaryOwner. */
export type DirectBeneficiaryOwner = {
  __typename?: 'DirectBeneficiaryOwner';
  directBeneficiaryOwnerReason: StandardListElement;
  share?: Maybe<Scalars['Float']['output']>;
  votingRights?: Maybe<Scalars['Float']['output']>;
};

/** Input to make a person the beneficiary owner of a customer or third party, regardless of its position in the graph. This is an alternative to setForcedBeneficiaryOwner that cannot always be used (check FolderStakeholder.acceptDirectBeneficiaryOwners) */
export type DirectBeneficiaryOwnerInput = {
  directBOReasonCode: Scalars['String']['input'];
  share?: InputMaybe<Scalars['Float']['input']>;
  votingRights?: InputMaybe<Scalars['Float']['input']>;
};

/** Direct Beneficiary Owner input type. */
export type DirectBeneficiaryOwnerInputType = {
  __typename?: 'DirectBeneficiaryOwnerInputType';
  directBOReasonCode: Scalars['String']['output'];
  share?: Maybe<Scalars['Float']['output']>;
  votingRights?: Maybe<Scalars['Float']['output']>;
};

export type Display = {
  __typename?: 'Display';
  category: RiskCategory;
  color: Scalars['String']['output'];
  dccp?: Maybe<Scalars['Boolean']['output']>;
  legend: Scalars['String']['output'];
};

/** Supporting document, referencing a file which is stored in some Flaminem database */
export type Document = MainDocument & {
  __typename?: 'Document';
  adminStatus?: Maybe<AdminStatus>;
  contentType?: Maybe<Scalars['String']['output']>;
  currentVersionId?: Maybe<Scalars['ID']['output']>;
  documentValidation?: Maybe<DocumentValidation>;
  emissionDate?: Maybe<Scalars['String']['output']>;
  expirationDate?: Maybe<Scalars['String']['output']>;
  externalReference?: Maybe<Scalars['String']['output']>;
  /** Id of the document in the file database */
  fileId: Scalars['String']['output'];
  hasValidationReport: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  providerInformation?: Maybe<ProviderInformation>;
  /**
   * Snapshot to which the object belongs.
   * Will be null if object is the current/main version and does not belong to a snapshot
   */
  snapshot?: Maybe<Snapshot>;
  /** Supporting document status */
  status: DocumentStatus;
  /** Supporting document type */
  type: DocumentType;
  validationStatus?: Maybe<DocumentValidationStatus>;
};

/** A documentable entity */
export type DocumentableEntity = {
  /** Returns all documents associated with this entity */
  allDocuments: Array<Document>;
  documentComment?: Maybe<Scalars['String']['output']>;
  /** Customer has refused to provide some supporting documents */
  documentRefusal: Scalars['Boolean']['output'];
  /** Returns all documents associated with this entity, except those that are specific to a folder or file */
  documents: Array<Document>;
  /** The id of the entity. */
  id: Scalars['ID']['output'];
};


/** A documentable entity */
export type DocumentableEntityAllDocumentsArgs = {
  displayDocsSharingType?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A documentable entity */
export type DocumentableEntityDocumentsArgs = {
  displayDocsSharingType?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input for document related fields of a documentable entity. */
export type DocumentFieldsInputType = {
  documentComment?: InputMaybe<Scalars['String']['input']>;
  documentRefusal?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DocumentProviderLink = {
  __typename?: 'DocumentProviderLink';
  downloadText: Scalars['String']['output'];
  fields: Array<ProviderField>;
  invalidParametersText: Scalars['String']['output'];
  providerId: Scalars['String']['output'];
  sourceId: Scalars['String']['output'];
};

export type DocumentRefreshResponse = {
  __typename?: 'DocumentRefreshResponse';
  document?: Maybe<Document>;
  status: DocumentRefreshStatus;
};

export enum DocumentRefreshStatus {
  NotFound = 'NOT_FOUND',
  Unchanged = 'UNCHANGED',
  Updated = 'UPDATED'
}

export enum DocumentSharingStatus {
  DocumentExistsInRootEntity = 'DOCUMENT_EXISTS_IN_ROOT_ENTITY',
  DocumentShared = 'DOCUMENT_SHARED'
}

export enum DocumentStatus {
  Expired = 'EXPIRED',
  Incomplete = 'INCOMPLETE',
  Valid = 'VALID'
}

export type DocumentType = AbstractDocumentType & ClientConfElement & HistorizedClientConfElement & ListElement & {
  __typename?: 'DocumentType';
  allowSharedDocument: Scalars['Boolean']['output'];
  category?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  content: Array<DocumentType>;
  disabled: Scalars['Boolean']['output'];
  disabledComment?: Maybe<Scalars['String']['output']>;
  documentFilter?: Maybe<Scalars['String']['output']>;
  /** element type */
  elementType: Scalars['String']['output'];
  emissionDateRequired: Scalars['Boolean']['output'];
  excludeFromPortal: Scalars['Boolean']['output'];
  expirationDateRequired: Scalars['Boolean']['output'];
  externalEReputationProof: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  ordinal: Scalars['Long']['output'];
  provider?: Maybe<DocumentProviderLink>;
  stateRequired: Scalars['Boolean']['output'];
  status: VersionStatus;
  validation?: Maybe<DocumentValidationLink>;
  /** Validity period in months */
  validityPeriod?: Maybe<Scalars['Int']['output']>;
  versionCode: Scalars['String']['output'];
};

/** DocumentTypeGroup. */
export type DocumentTypeGroup = AbstractDocumentType & ClientConfElement & HistorizedClientConfElement & ListElement & {
  __typename?: 'DocumentTypeGroup';
  /** It always exists in the product types. It is optional for the other elements */
  category?: Maybe<Scalars['String']['output']>;
  /** The code of the element. */
  code: Scalars['String']['output'];
  content: Array<DocumentType>;
  /** Has the element been disabled */
  disabled: Scalars['Boolean']['output'];
  /** A comment about element disabling */
  disabledComment?: Maybe<Scalars['String']['output']>;
  /** element type */
  elementType: Scalars['String']['output'];
  /** The id of the element. */
  id: Scalars['ID']['output'];
  /** The name of the element. */
  name: Scalars['String']['output'];
  /** The status of the element. */
  status: VersionStatus;
  /** The version code of the element. */
  versionCode: Scalars['String']['output'];
};

export type DocumentValidation = {
  __typename?: 'DocumentValidation';
  validationReportId?: Maybe<Scalars['String']['output']>;
  validationResponse: ValidationResponse;
};

export type DocumentValidationLink = {
  __typename?: 'DocumentValidationLink';
  maxFileSize?: Maybe<Scalars['Int']['output']>;
  providerId: Scalars['String']['output'];
  sourceId: Scalars['String']['output'];
};

export enum DocumentValidationStatus {
  Invalid = 'INVALID',
  Uncontrolled = 'UNCONTROLLED',
  Valid = 'VALID'
}

/** Domicile */
export type Domicile = {
  __typename?: 'Domicile';
  addresse_domicile_benef?: Maybe<Scalars['String']['output']>;
  code_postal_domicile_benef?: Maybe<Scalars['String']['output']>;
  commune_domicile_benef?: Maybe<Scalars['String']['output']>;
  pays_domicile_benef?: Maybe<Scalars['String']['output']>;
};

/** An input value associated to a configuration element */
export type ElementInputValue = InputValue & {
  __typename?: 'ElementInputValue';
  /** @deprecated Use inputField (fieldType) instead */
  dataType: DataType;
  element?: Maybe<ClientConfElement>;
  /** @deprecated Use inputField (fieldCode) instead */
  fieldCode: Scalars['String']['output'];
  inputField: InputField;
  stringValue?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use stringValue instead */
  value?: Maybe<Scalars['String']['output']>;
};

/**
 * The metadata of a list of configuration elements (ListElement).
 *                        For example, the ElementList with listElementsType "Country" is used to tell which is the field to sort the list of countries (France, Spain, China...), in which fields we can search...
 *                        The firstElement and the defaultElement must match a configuration element of the list itself (for example, Croatia, or Serbia)
 */
export type ElementList = ClientConfElement & {
  __typename?: 'ElementList';
  categoryUsageLevel: CategoryUsageLevel;
  code: Scalars['String']['output'];
  defaultElement?: Maybe<ClientConfElement>;
  disabled: Scalars['Boolean']['output'];
  disabledComment?: Maybe<Scalars['String']['output']>;
  /** element type */
  elementType: Scalars['String']['output'];
  firstElement?: Maybe<ClientConfElement>;
  id: Scalars['ID']['output'];
  listElementsType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  riskValueKeys: Array<Scalars['String']['output']>;
  searchFields: Array<ConfField>;
  sortingField: ConfField;
  standard: Scalars['Boolean']['output'];
  status: VersionStatus;
  useDocumentFilter: Scalars['Boolean']['output'];
  useFamily: Scalars['Boolean']['output'];
  versionCode: Scalars['String']['output'];
};

/** An input value associated to a list of configuration elements */
export type ElementsInputValue = InputValue & {
  __typename?: 'ElementsInputValue';
  /** @deprecated Use inputField (fieldType) instead */
  dataType: DataType;
  elements: Array<ClientConfElement>;
  /** @deprecated Use inputField (fieldCode) instead */
  fieldCode: Scalars['String']['output'];
  inputField: InputField;
  stringValue?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use stringValue instead */
  value?: Maybe<Scalars['String']['output']>;
};

/** An entity : physical person or legal entity */
export type Entity = {
  /** Administration status */
  adminStatus: EntityAdminStatus;
  /** Returns all documents associated with this entity */
  allDocuments: Array<Document>;
  attachments: Array<Attachment>;
  /** RootEntity content. Only if we are dealing with a customer which is a group of persons can there be more than one Entity. */
  content: Array<Entity>;
  /** The identifier of the entity in the current state. It will return its own id if this entity is not a snapshot */
  currentEntityId: Scalars['ID']['output'];
  /**
   * Id of the current version of the object.
   * Will be null if object itself is the current/main version and does not belong to a snapshot
   */
  currentVersionId?: Maybe<Scalars['ID']['output']>;
  /** RootEntity customer folders */
  customerFolders: Array<CustomerFolder>;
  /** Indicates if a DccpAlert is active on this entity */
  dccp: Scalars['Boolean']['output'];
  /** Entity dccp alerts */
  dccpAlerts: Array<DccpAlert>;
  documentComment?: Maybe<Scalars['String']['output']>;
  /** Customer has refused to provide some supporting documents */
  documentRefusal: Scalars['Boolean']['output'];
  /** Returns all documents associated with this entity, except those that are specific to a folder or file */
  documents: Array<Document>;
  eReputation?: Maybe<Ereputation>;
  /** Entity eReputation alerts */
  eReputationAlerts: Array<EReputationAlert>;
  eReputationComment?: Maybe<Scalars['String']['output']>;
  hasAlert: Scalars['Boolean']['output'];
  /** The id (or sharedId) of the entity. */
  id: Scalars['ID']['output'];
  /** Used inputValue by code */
  inputValue?: Maybe<InputValue>;
  /** Used inputValues by code */
  inputValues: Array<InputValue>;
  /** isPerson flag */
  isPerson: Scalars['Boolean']['output'];
  relatedEntities: Array<RelatedEntity>;
  roles: Array<Role>;
  /**
   * Snapshot to which the object belongs.
   * Will be null if object is the current/main version and does not belong to a snapshot
   */
  snapshot?: Maybe<Snapshot>;
  /** Entity type. */
  type: EntityType;
  /** The real id of the entity (so, never a sharedId). For debugging purposes */
  underlyingId: Scalars['ID']['output'];
  whatIfSourceId?: Maybe<Scalars['ID']['output']>;
};


/** An entity : physical person or legal entity */
export type EntityAllDocumentsArgs = {
  displayDocsSharingType?: InputMaybe<Scalars['Boolean']['input']>;
};


/** An entity : physical person or legal entity */
export type EntityDccpAlertsArgs = {
  onlyActiveAlerts?: InputMaybe<Scalars['Boolean']['input']>;
};


/** An entity : physical person or legal entity */
export type EntityDocumentsArgs = {
  displayDocsSharingType?: InputMaybe<Scalars['Boolean']['input']>;
};


/** An entity : physical person or legal entity */
export type EntityEReputationAlertsArgs = {
  onlyActiveAlerts?: InputMaybe<Scalars['Boolean']['input']>;
};


/** An entity : physical person or legal entity */
export type EntityInputValueArgs = {
  fieldCode: Scalars['String']['input'];
};


/** An entity : physical person or legal entity */
export type EntityInputValuesArgs = {
  fieldCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** An entity : physical person or legal entity */
export type EntityRolesArgs = {
  direction?: InputMaybe<RoleDirection>;
};

/** Administrative status. */
export type EntityAdminStatus = {
  __typename?: 'EntityAdminStatus';
  author?: Maybe<User>;
  creation?: Maybe<Scalars['String']['output']>;
  lastModification?: Maybe<Scalars['String']['output']>;
  lastModifier?: Maybe<User>;
};

/** An entity and its alert */
export type EntityAndAlert = {
  __typename?: 'EntityAndAlert';
  /** Alert associated to the entity */
  alert: EReputationAlert;
  /** Entity */
  entity: Entity;
};

/** entity and alert page and page info. */
export type EntityAndAlertPage = {
  __typename?: 'EntityAndAlertPage';
  entityAndAlerts: Array<EntityAndAlert>;
  pageInfo: PageInfo;
};

export enum EntityClass {
  ContactPerson = 'ContactPerson',
  Corporation = 'Corporation',
  CustomerFolder = 'CustomerFolder',
  DccpAnalysis = 'DccpAnalysis',
  DccpFollowUp = 'DccpFollowUp',
  FolderFile = 'FolderFile',
  Mission = 'Mission',
  Person = 'Person',
  ThirdPartyFolder = 'ThirdPartyFolder'
}

/** Entity page. */
export type EntityPage = {
  __typename?: 'EntityPage';
  /** Entity page summaries */
  entities: Array<Entity>;
  /** Entity page information */
  pageInfo: PageInfo;
};

export type EntityType = ClientConfElement & HistorizedClientConfElement & ListElement & ListElementWithFamily & ListElementWithRisk & {
  __typename?: 'EntityType';
  /** False if shareholding is forbidden. True otherwise */
  acceptShareholders: Scalars['Boolean']['output'];
  acceptSubsidiaries: Scalars['Boolean']['output'];
  category?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  contextualAcceptSubsidiaries: Scalars['Boolean']['output'];
  contextualRequiresBeneficiaryOwner: Scalars['Boolean']['output'];
  contextualShareholding: Shareholding;
  disabled: Scalars['Boolean']['output'];
  disabledComment?: Maybe<Scalars['String']['output']>;
  documentFilter?: Maybe<Scalars['String']['output']>;
  /** element type */
  elementType: Scalars['String']['output'];
  family?: Maybe<Family>;
  iconName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inputFields: Array<InputField>;
  inputForm?: Maybe<InputForm>;
  name: Scalars['String']['output'];
  ordinal: Scalars['Long']['output'];
  overloadedProperties: Array<OverloadedProperties>;
  requiresBeneficiaryOwner: Scalars['Boolean']['output'];
  /** It always contains at least one element */
  riskValues: Array<RiskValue>;
  shareholding: Shareholding;
  status: VersionStatus;
  versionCode: Scalars['String']['output'];
};


export type EntityTypeContextualAcceptSubsidiariesArgs = {
  customerFolderType?: InputMaybe<Scalars['String']['input']>;
  fileType?: InputMaybe<Scalars['String']['input']>;
  thirdPartyFolderType?: InputMaybe<Scalars['String']['input']>;
};


export type EntityTypeContextualRequiresBeneficiaryOwnerArgs = {
  customerFolderType?: InputMaybe<Scalars['String']['input']>;
  fileType?: InputMaybe<Scalars['String']['input']>;
  thirdPartyFolderType?: InputMaybe<Scalars['String']['input']>;
};


export type EntityTypeContextualShareholdingArgs = {
  customerFolderType?: InputMaybe<Scalars['String']['input']>;
  fileType?: InputMaybe<Scalars['String']['input']>;
  thirdPartyFolderType?: InputMaybe<Scalars['String']['input']>;
};


export type EntityTypeInputFieldsArgs = {
  corporationLifeStatusCode?: InputMaybe<Scalars['String']['input']>;
  customerFolderTypeCode?: InputMaybe<Scalars['String']['input']>;
};


export type EntityTypeInputFormArgs = {
  corporationLifeStatusKey?: InputMaybe<Scalars['String']['input']>;
  customerFolderTypeKey?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
};

export type ERepResultSelectionInputType = {
  noResult: Scalars['Boolean']['input'];
  resultId?: InputMaybe<Scalars['String']['input']>;
};

/** Ereputation of a stakeholder. */
export type Ereputation = AbstractEreputation & {
  __typename?: 'Ereputation';
  details?: Maybe<EReputationDetail>;
  entries: Array<EReputationEntry>;
  eReputationDate?: Maybe<Scalars['String']['output']>;
  idERep?: Maybe<Scalars['String']['output']>;
  isAdverseMedia: Scalars['Boolean']['output'];
  isComplete: Scalars['Boolean']['output'];
  isMonitored?: Maybe<Scalars['Boolean']['output']>;
  isPep: Scalars['Boolean']['output'];
  isSanction: Scalars['Boolean']['output'];
  isSpecialInterest: Scalars['Boolean']['output'];
  resultSelection?: Maybe<ResultSelection>;
};

/** EReputationAlert. */
export type EReputationAlert = {
  __typename?: 'EReputationAlert';
  adminStatus: AdminStatus;
  /** Transitions allowed for this EReputationAlert for current user */
  allowedTransitions: Array<Transition>;
  attachments: Array<Attachment>;
  auditEvents: Array<AuditEvent>;
  comment?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  eReputation?: Maybe<Ereputation>;
  eReputationComment?: Maybe<Scalars['String']['output']>;
  eReputationIsEditable: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  lastPepEReputationAnalysis?: Maybe<PepEReputationAnalysis>;
  origin: EReputationAlertOrigin;
  startDate: Scalars['String']['output'];
  workflowStatus: EreputationAlertWorkflowStatus;
};

/** Ereputation alert workflow action */
export type EreputationAlertAction = WorkflowAction & {
  __typename?: 'EreputationAlertAction';
  backward: Scalars['Boolean']['output'];
  /** This can be used instead of the id in any mutation that requires an actionId */
  code: Scalars['String']['output'];
  confirmationMessage?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isValidation: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export enum EReputationAlertOrigin {
  ManualCreation = 'MANUAL_CREATION',
  Monitoring = 'MONITORING',
  NewValidatedEreputation = 'NEW_VALIDATED_EREPUTATION'
}

/** Ereputation alert workflow state */
export type EreputationAlertState = WorkflowState & {
  __typename?: 'EreputationAlertState';
  assignableUserGroups: Array<Scalars['String']['output']>;
  /** The canceled field of a workflow state. */
  canceled: Scalars['Boolean']['output'];
  closed: Scalars['Boolean']['output'];
  code: Scalars['String']['output'];
  editable: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  singleUserAssignment: SingleUserAssignment;
};

/** Ereputation alert workflow status. */
export type EreputationAlertWorkflowStatus = WorkflowStatus & {
  __typename?: 'EreputationAlertWorkflowStatus';
  /** The user who is assigned to workflow state. */
  assignedUser?: Maybe<User>;
  lastModification: Scalars['String']['output'];
  /** The user who modified status last. */
  lastModifier: User;
  state: EreputationAlertState;
};

/** EReputation analysis. */
export type EReputationAnalysis = ClientConfElement & HistorizedClientConfElement & ListElement & ListElementWithFamily & ListElementWithRisk & {
  __typename?: 'EReputationAnalysis';
  category?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  disabled: Scalars['Boolean']['output'];
  disabledComment?: Maybe<Scalars['String']['output']>;
  documentFilter?: Maybe<Scalars['String']['output']>;
  /** element type */
  elementType: Scalars['String']['output'];
  eRepCategoryCode?: Maybe<Scalars['String']['output']>;
  family?: Maybe<Family>;
  hit: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  noResult: Scalars['Boolean']['output'];
  ordinal: Scalars['Long']['output'];
  providerResultCondition?: Maybe<Scalars['Boolean']['output']>;
  /** It always contains at least one element */
  riskValues: Array<RiskValue>;
  status: VersionStatus;
  versionCode: Scalars['String']['output'];
};

/** EReputation category. */
export type EReputationCategory = ClientConfElement & HistorizedClientConfElement & ListElement & ListElementWithFamily & ListElementWithRisk & {
  __typename?: 'EReputationCategory';
  adverseMedia?: Maybe<Scalars['Boolean']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  disabled: Scalars['Boolean']['output'];
  disabledComment?: Maybe<Scalars['String']['output']>;
  documentFilter?: Maybe<Scalars['String']['output']>;
  /** element type */
  elementType: Scalars['String']['output'];
  family?: Maybe<Family>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  ordinal: Scalars['Long']['output'];
  pep?: Maybe<Scalars['Boolean']['output']>;
  /** It always contains at least one element */
  riskValues: Array<RiskValue>;
  sanction?: Maybe<Scalars['Boolean']['output']>;
  specialInterest?: Maybe<Scalars['Boolean']['output']>;
  status: VersionStatus;
  versionCode: Scalars['String']['output'];
};

export type EReputationDetail = {
  __typename?: 'EReputationDetail';
  detailedResults: Array<DetailedResult>;
  format: FormatEnum;
  idERep: Scalars['String']['output'];
  searchResults: Scalars['String']['output'];
};

export type EReputationEntry = {
  __typename?: 'EReputationEntry';
  allowedAnalyses: Array<EReputationAnalysis>;
  analysis?: Maybe<EReputationAnalysis>;
  category: EReputationCategory;
  confVersionCode: Scalars['String']['output'];
  providerResult: Scalars['Boolean']['output'];
};

/** EReputationEvent. */
export type EReputationEvent = AuditEvent & {
  __typename?: 'EReputationEvent';
  date: Scalars['String']['output'];
  state: WorkflowState;
  type: EventType;
  user: User;
};

export type EReputationInputType = {
  analysisCode?: InputMaybe<Scalars['String']['input']>;
  analysisId?: InputMaybe<Scalars['ID']['input']>;
  categoryCode?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['ID']['input']>;
};

export enum EReputationMode {
  External = 'EXTERNAL',
  None = 'NONE',
  Standard = 'STANDARD'
}

export enum EReputationProvider {
  DowJones = 'DOW_JONES',
  WorldCheck = 'WORLD_CHECK'
}

export enum EventType {
  Creation = 'CREATION',
  DccpAnalysisCreation = 'DCCP_ANALYSIS_CREATION',
  DccpAnalysisDeletion = 'DCCP_ANALYSIS_DELETION',
  DccpFollowUpCreation = 'DCCP_FOLLOW_UP_CREATION',
  DccpFollowUpDeletion = 'DCCP_FOLLOW_UP_DELETION',
  Ereputation = 'EREPUTATION',
  ForceRiskLevel = 'FORCE_RISK_LEVEL',
  Update = 'UPDATE',
  Workflow = 'WORKFLOW'
}

/** Document expected for this type of entity */
export type ExpectedDocument = {
  __typename?: 'ExpectedDocument';
  abstractDocumentType: AbstractDocumentType;
  /** Either document or external document. Only in the context of a DocumentTypeGroup could there be more than one */
  availableDocuments: Array<MainDocument>;
  /** @deprecated Use mainDocument or availableDocuments instead */
  document?: Maybe<Document>;
  documentSharingStatus?: Maybe<DocumentSharingStatus>;
  /** Shows if document is taken into account for a file completion */
  isOptional: Scalars['Boolean']['output'];
  /** It will return the last modified document (or external document) */
  mainDocument?: Maybe<MainDocument>;
  status: DocumentStatus;
  /** @deprecated Use abstractDocumentType instead */
  type: DocumentType;
};

/** External beneficial owner. */
export type ExternalBeneficialOwner = {
  __typename?: 'ExternalBeneficialOwner';
  person: ExternalPerson;
  providerData: ProviderData;
};

/** External corporation. */
export type ExternalCorporation = ExternalEntity & {
  __typename?: 'ExternalCorporation';
  activity?: Maybe<StandardListElement>;
  /** @deprecated Use activity instead */
  activityCode?: Maybe<Scalars['String']['output']>;
  creationDate?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<EntityType>;
  /** @deprecated Use entityType instead */
  entityTypeCode?: Maybe<Scalars['String']['output']>;
  /** The external id of the entity. */
  externalId?: Maybe<Scalars['String']['output']>;
  localMatches: Array<Corporation>;
  name?: Maybe<Scalars['String']['output']>;
  registration?: Maybe<Scalars['String']['output']>;
  registrationCountry?: Maybe<Country>;
  /** @deprecated Use registrationCountry instead */
  registrationCountryCode?: Maybe<Scalars['String']['output']>;
  siren?: Maybe<Scalars['String']['output']>;
};

/** Container for properties and roles differences between existing stakeholder state and external dataset. */
export type ExternalDataDiff = {
  __typename?: 'ExternalDataDiff';
  diffInputValues: Array<InputValueView>;
  fullInputValues: Array<InputValueView>;
  identifiersMatchStatus: IdentifiersMatchStatus;
  isCorporation: Scalars['Boolean']['output'];
  isPerson: Scalars['Boolean']['output'];
  rolesToAdd: Array<RoleInputView>;
  rolesToDelete: Array<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type ExternalDataProviderAssignment = {
  __typename?: 'ExternalDataProviderAssignment';
  link: ExternalDataProviderLink;
};

export type ExternalDataProviderLink = {
  __typename?: 'ExternalDataProviderLink';
  directors?: Maybe<ExternalDataProviderLinkCapabilities>;
  downloadText: Scalars['String']['output'];
  externalCorporations?: Maybe<ExternalDataProviderLinkCapabilities>;
  invalidParametersText: Scalars['String']['output'];
  providerId: Scalars['String']['output'];
  shareholders?: Maybe<ExternalDataProviderLinkCapabilities>;
  subsidiaries?: Maybe<ExternalDataProviderLinkCapabilities>;
};

export type ExternalDataProviderLinkCapabilities = {
  __typename?: 'ExternalDataProviderLinkCapabilities';
  fields: Array<ProviderField>;
};

export type ExternalDataProvidersConfiguration = {
  __typename?: 'ExternalDataProvidersConfiguration';
  assignments: Array<ExternalDataProviderAssignment>;
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** External director. */
export type ExternalDirector = {
  __typename?: 'ExternalDirector';
  entity: ExternalEntity;
  jobTitle?: Maybe<Scalars['String']['output']>;
};

/** Supporting document, representing a file which is not stored in Flaminem */
export type ExternalDocument = MainDocument & {
  __typename?: 'ExternalDocument';
  adminStatus: AdminStatus;
  currentVersionId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  /**
   * Snapshot to which the object belongs.
   * Will be null if object is the current/main version and does not belong to a snapshot
   */
  snapshot?: Maybe<Snapshot>;
  /** Supporting document status */
  status: DocumentStatus;
  /** Supporting document type */
  type: DocumentType;
  url?: Maybe<Scalars['String']['output']>;
};

/** External entity */
export type ExternalEntity = {
  /** The external id of the entity. */
  externalId?: Maybe<Scalars['String']['output']>;
};

/** External person. */
export type ExternalPerson = ExternalEntity & {
  __typename?: 'ExternalPerson';
  birthDate?: Maybe<Scalars['String']['output']>;
  birthName?: Maybe<Scalars['String']['output']>;
  citizenshipCountry?: Maybe<Country>;
  /** @deprecated Use citizenshipCountry instead */
  citizenshipCountryCode?: Maybe<Scalars['String']['output']>;
  /** The external id of the entity. */
  externalId?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  residenceCountry?: Maybe<Country>;
  /** @deprecated Use residenceCountry instead */
  residenceCountryCode?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Gender>;
};

/** External shareholder. */
export type ExternalShareholder = {
  __typename?: 'ExternalShareholder';
  entity: ExternalEntity;
  share?: Maybe<Scalars['Float']['output']>;
  votingRights?: Maybe<Scalars['Float']['output']>;
};

/** External subsidiary. */
export type ExternalSubsidiary = {
  __typename?: 'ExternalSubsidiary';
  entity: ExternalCorporation;
  share?: Maybe<Scalars['Float']['output']>;
  votingRights?: Maybe<Scalars['Float']['output']>;
};

/** Family. */
export type Family = ClientConfElement & HistorizedClientConfElement & ListElement & {
  __typename?: 'Family';
  category?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  disabled: Scalars['Boolean']['output'];
  disabledComment?: Maybe<Scalars['String']['output']>;
  documentFilter?: Maybe<Scalars['String']['output']>;
  /** element type */
  elementType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  ordinal: Scalars['Long']['output'];
  status: VersionStatus;
  versionCode: Scalars['String']['output'];
};

export type Features = {
  __typename?: 'Features';
  allowCustomerNameInEmails: Scalars['Boolean']['output'];
  allowDocumentsInPortal: Scalars['Boolean']['output'];
  allowExternalFolderFileActionOnWhatIfs: Scalars['Boolean']['output'];
  allowQuestionnaireInPortal: Scalars['Boolean']['output'];
  allowSunsetFileCreation: Scalars['Boolean']['output'];
  beneficialOwners: Scalars['Boolean']['output'];
  corpMasterDataIntegration: Scalars['Boolean']['output'];
  countryRiskMap: Scalars['Boolean']['output'];
  customerSubsidiaries: Scalars['Boolean']['output'];
  dccpAnalysis: Scalars['Boolean']['output'];
  dccpFollowUp: Scalars['Boolean']['output'];
  demonitorInactiveEntities: Scalars['Boolean']['output'];
  displayKycReviewStatus: Scalars['Boolean']['output'];
  displayOnlyContextualDocuments: Scalars['Boolean']['output'];
  downloadDocsFromKyc: Scalars['Boolean']['output'];
  eRepResultSelection: Scalars['Boolean']['output'];
  eRepResultSelectionRequired: Scalars['Boolean']['output'];
  eReputationAlerts: Scalars['Boolean']['output'];
  factivaContentIntegration: Scalars['Boolean']['output'];
  flaminemPro: Scalars['Boolean']['output'];
  folderFileTag: Scalars['Boolean']['output'];
  folderRiskPeriodicUpdate: Scalars['Boolean']['output'];
  folderStatus: Scalars['Boolean']['output'];
  forbidMoreThanOneOpenFile: Scalars['Boolean']['output'];
  forbidPersonDuplicates: Scalars['Boolean']['output'];
  groupFilesByFamily: Scalars['Boolean']['output'];
  messageThread: Scalars['Boolean']['output'];
  missionsUsageLevel: MissionsUsageLevel;
  monitoring: Scalars['Boolean']['output'];
  newValidatedEReputationAlerts: NewValidatedEReputationAlerts;
  notary: Scalars['Boolean']['output'];
  pepEReputationAnalysis: Scalars['Boolean']['output'];
  personMasterDataIntegration: Scalars['Boolean']['output'];
  questionnaires: Scalars['Boolean']['output'];
  recreateCurrentStakeholderRoles: Scalars['Boolean']['output'];
  searchCustomersByCp1AndCp2: Scalars['Boolean']['output'];
  searchOnFileNamesByDefault: Scalars['Boolean']['output'];
  standaloneEreputation: Scalars['Boolean']['output'];
  transformAttachmentIntoDocument: Scalars['Boolean']['output'];
  triggerExternalFolderFileAction: Scalars['Boolean']['output'];
  updateCurrentFoldersRiskStatusUsingLastValidatedERep: Scalars['Boolean']['output'];
  useHashForRequired: Scalars['Boolean']['output'];
  votingRights: Scalars['Boolean']['output'];
};

export type FieldCompletion = {
  /** Available required fields */
  availableRequiredFields: Scalars['Int']['output'];
  /** Required fields */
  requiredFields: Scalars['Int']['output'];
};

/** File completion status. */
export type FileCompletionStatus = {
  __typename?: 'FileCompletionStatus';
  activeMissionMissing?: Maybe<Scalars['Boolean']['output']>;
  beneficiaryOwnerMissing?: Maybe<Scalars['Boolean']['output']>;
  capitalizationTable?: Maybe<Scalars['Float']['output']>;
  complete: Scalars['Boolean']['output'];
  eReputationMissing?: Maybe<Scalars['Boolean']['output']>;
  hasDisabledValues: Scalars['Boolean']['output'];
  legalRepresentativeMissing?: Maybe<Scalars['Boolean']['output']>;
  requiredFieldsMissing: Scalars['Boolean']['output'];
  statusLastModification: Scalars['String']['output'];
  subsidiaryNotLinked?: Maybe<Scalars['Boolean']['output']>;
  supportingDocumentsMissing: Scalars['Boolean']['output'];
  validatedQuestionnaires?: Maybe<Scalars['Float']['output']>;
  votingRightsTable?: Maybe<Scalars['Float']['output']>;
};

/** File Customer folder. */
export type FileCustomerFolder = AbstractCustomerFolder & FieldCompletion & FileFolder & Folder & InputEntity & Preferenceable & Questionnaireable & RiskEntity & {
  __typename?: 'FileCustomerFolder';
  adminStatus: AdminStatus;
  analysis?: Maybe<Scalars['String']['output']>;
  areMultipleCustomersEditable: Scalars['Boolean']['output'];
  attachments: Array<Attachment>;
  availableRequiredFields: Scalars['Int']['output'];
  /** beneficial owners provider link */
  beneficialOwnersProviderLink?: Maybe<BeneficialOwnersProviderLink>;
  completionStatus: FolderCompletionStatus;
  complexShareholding: Scalars['Boolean']['output'];
  contactPerson?: Maybe<ContactPerson>;
  /** The mode by which beneficiary owners that are not automatically computed by the application can be selected. This depends on both the folderType and the fileType, if any */
  contextualManualBeneficiaryOwnerIdentificationMode: ManualBeneficiaryOwnerIdentificationMode;
  /** All the corporations linked to the Customer (of the CustomerFolder) or the ThirdParty (of the ThirdPartyFolder) */
  corporations: Array<Corporation>;
  currentVersionId?: Maybe<Scalars['ID']['output']>;
  /** The customer of the folder */
  customer: RootEntity;
  customerFolderKycReviewStatus: CustomerFolderKycReviewStatus;
  /** Customer folder type */
  customerFolderType: CustomerFolderType;
  dccp: Scalars['Boolean']['output'];
  /** Stakeholders in the folder that have at least one DccpAlert. The onlyActiveAlerts filter excludes those entities that have only disabled alerts */
  dccpAlertStakeholders: Array<Entity>;
  disabledValues: Scalars['Int']['output'];
  families: Array<Family>;
  file: FolderFile;
  /** The file linked to the folder */
  folderFile: FolderFile;
  /** All the files linked to the customer folder */
  folderFiles: CustomerFolderFilesPage;
  id: Scalars['ID']['output'];
  /** Used inputValue by code */
  inputValue?: Maybe<InputValue>;
  /** Used inputValues by code */
  inputValues: Array<InputValue>;
  isDeletable: Scalars['Boolean']['output'];
  missions: Array<Mission>;
  pendingStatusUpdate: PendingStatusUpdate;
  /** All the persons linked to the Customer (of the CustomerFolder) or the ThirdParty (of the ThirdPartyFolder) */
  persons: Array<Person>;
  preferences?: Maybe<Scalars['String']['output']>;
  questionnaires: Array<Questionnaire>;
  requiredFields: Scalars['Int']['output'];
  riskStatus?: Maybe<FolderRiskStatus>;
  /** The Customer (of the CustomerFolder) or the ThirdParty (of the ThirdPartyFolder) */
  rootEntity: RootEntity;
  /**
   * Snapshot to which the object belongs.
   * Will be null if object is the current/main version and does not belong to a snapshot
   */
  snapshot?: Maybe<Snapshot>;
  /** All the stakeholders linked to the Customer (of the CustomerFolder) or the ThirdParty (of the ThirdPartyFolder) */
  stakeholders: Array<FolderStakeholder>;
  stakeholdersWithName: Array<FolderStakeholder>;
  /** Customer folder status */
  status: FolderStatus;
  /** The expected questionnaires according to the customerFolderType, as well as the saved questionnaires if any */
  supportingQuestionnaires: Array<SupportingQuestionnaire>;
  whatIfSourceId?: Maybe<Scalars['ID']['output']>;
};


/** File Customer folder. */
export type FileCustomerFolderDccpAlertStakeholdersArgs = {
  onlyWithActiveAlerts?: InputMaybe<Scalars['Boolean']['input']>;
};


/** File Customer folder. */
export type FileCustomerFolderFolderFilesArgs = {
  limit: Scalars['Int']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


/** File Customer folder. */
export type FileCustomerFolderInputValueArgs = {
  fieldCode: Scalars['String']['input'];
};


/** File Customer folder. */
export type FileCustomerFolderInputValuesArgs = {
  fieldCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** File Customer folder. */
export type FileCustomerFolderStakeholdersWithNameArgs = {
  name: Scalars['String']['input'];
};


/** File Customer folder. */
export type FileCustomerFolderSupportingQuestionnairesArgs = {
  includeFileQuestionnaires?: InputMaybe<Scalars['Boolean']['input']>;
  includeFolderOnlyQuestionnaires?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A Folder within a file context */
export type FileFolder = {
  /** All the corporations linked to the Customer (of the CustomerFolder) or the ThirdParty (of the ThirdPartyFolder) */
  corporations: Array<Corporation>;
  /** The file linked to the folder */
  folderFile: FolderFile;
  /** FileFolder system identifier */
  id: Scalars['ID']['output'];
  /** All the persons linked to the Customer (of the CustomerFolder) or the ThirdParty (of the ThirdPartyFolder) */
  persons: Array<Person>;
  /** All the stakeholders linked to the Customer (of the CustomerFolder) or the ThirdParty (of the ThirdPartyFolder) */
  stakeholders: Array<FolderStakeholder>;
  stakeholdersWithName: Array<FolderStakeholder>;
};


/** A Folder within a file context */
export type FileFolderStakeholdersWithNameArgs = {
  name: Scalars['String']['input'];
};

export type FilePurgeConfig = {
  __typename?: 'FilePurgeConfig';
  code: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  retentionDays: Scalars['Int']['output'];
};

/** FileRiskStatus */
export type FileRiskStatus = RiskStatus & {
  __typename?: 'FileRiskStatus';
  dccpApprovalRequired: Scalars['Boolean']['output'];
  forcedRisk?: Maybe<ForcedRisk>;
  globalRiskLevel: RiskLevel;
  globalScore: Scalars['Int']['output'];
  lastModification?: Maybe<Scalars['String']['output']>;
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  riskDetail: RiskDetail;
  standardRiskLevel: RiskLevel;
  subTotals: Array<SubTotal>;
};

export enum FilesPageSortFieldName {
  LastModification = 'LastModification',
  RiskLevel = 'RiskLevel'
}

/** Entity usage detail within a fileFolder. */
export type FileUsageDetail = {
  __typename?: 'FileUsageDetail';
  file?: Maybe<FolderFile>;
  fileFolder?: Maybe<FileFolder>;
  rootEntity: RootEntity;
  stakeholder: FolderStakeholder;
};

export type Filter = {
  __typename?: 'Filter';
  customerFolderType?: Maybe<Scalars['String']['output']>;
  fileType?: Maybe<Scalars['String']['output']>;
  thirdPartyFolderType?: Maybe<Scalars['String']['output']>;
};

/** A CustomerFolder or a ThirdPartyFolder */
export type Folder = {
  /** Folder administrative status */
  adminStatus: AdminStatus;
  /** Available required fields */
  availableRequiredFields: Scalars['Int']['output'];
  /** beneficial owners provider link */
  beneficialOwnersProviderLink?: Maybe<BeneficialOwnersProviderLink>;
  /** Folder completion status */
  completionStatus: FolderCompletionStatus;
  /** Indicates if the shareholding of the folder is considered as complex according to the rules defined in the configuration */
  complexShareholding: Scalars['Boolean']['output'];
  /** The mode by which beneficiary owners that are not automatically computed by the application can be selected. This depends on both the folderType and the fileType, if any */
  contextualManualBeneficiaryOwnerIdentificationMode: ManualBeneficiaryOwnerIdentificationMode;
  /**
   * Id of the current version of the object.
   * Will be null if object itself is the current/main version and does not belong to a snapshot
   */
  currentVersionId?: Maybe<Scalars['ID']['output']>;
  /** All the files linked to the customer folder */
  folderFiles: CustomerFolderFilesPage;
  /** Folder system identifier */
  id: Scalars['ID']['output'];
  /** Used inputValue by code */
  inputValue?: Maybe<InputValue>;
  /** Used inputValues by code */
  inputValues: Array<InputValue>;
  preferences?: Maybe<Scalars['String']['output']>;
  /** Required fields */
  requiredFields: Scalars['Int']['output'];
  /** The Customer (of the CustomerFolder) or the ThirdParty (of the ThirdPartyFolder) */
  rootEntity: RootEntity;
  /**
   * Snapshot to which the object belongs.
   * Will be null if object is the current/main version and does not belong to a snapshot
   */
  snapshot?: Maybe<Snapshot>;
  /** Risk entity whatIf source identifier. */
  whatIfSourceId?: Maybe<Scalars['ID']['output']>;
};


/** A CustomerFolder or a ThirdPartyFolder */
export type FolderFolderFilesArgs = {
  limit: Scalars['Int']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


/** A CustomerFolder or a ThirdPartyFolder */
export type FolderInputValueArgs = {
  fieldCode: Scalars['String']['input'];
};


/** A CustomerFolder or a ThirdPartyFolder */
export type FolderInputValuesArgs = {
  fieldCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** An audit event */
export type FolderAuditEvent = {
  date: Scalars['String']['output'];
  type: FolderEventType;
  user: User;
};

/** CustomerFolder or ThirdPartyFolder completion status. */
export type FolderCompletionStatus = {
  __typename?: 'FolderCompletionStatus';
  atLeastOneActiveMission?: Maybe<Scalars['Boolean']['output']>;
  availableEReputationResults?: Maybe<Scalars['Float']['output']>;
  beneficiaryOwnerIsRequired: Scalars['Boolean']['output'];
  capitalizationTable?: Maybe<Scalars['Float']['output']>;
  disabledValues: Scalars['Int']['output'];
  hasBeneficiaryOwner?: Maybe<Scalars['Boolean']['output']>;
  hasLegalRepresentative?: Maybe<Scalars['Boolean']['output']>;
  legalRepresentativeIsRequired: Scalars['Boolean']['output'];
  requiredFieldsCompletion: Scalars['Float']['output'];
  shareholdingIsRequired: Scalars['Boolean']['output'];
  statusLastModification: Scalars['String']['output'];
  subsidiaryNotLinked?: Maybe<Scalars['Boolean']['output']>;
  validatedEReputationResults?: Maybe<Scalars['Float']['output']>;
  validatedQuestionnaires?: Maybe<Scalars['Float']['output']>;
  validSupportingDocuments?: Maybe<Scalars['Float']['output']>;
  votingRightsTable?: Maybe<Scalars['Float']['output']>;
};

export enum FolderEventType {
  RiskChange = 'RISK_CHANGE',
  RiskDeleted = 'RISK_DELETED'
}

/** A file: operation, update or funding. */
export type FolderFile = DocumentableEntity & FieldCompletion & InputEntity & Preferenceable & Questionnaireable & RiskEntity & {
  __typename?: 'FolderFile';
  adminStatus: AdminStatus;
  /** Returns all documents associated with this entity */
  allDocuments: Array<Document>;
  /** Workflow transitions allowed on this file for current user */
  allowedTransitions: Array<Transition>;
  analysis?: Maybe<Scalars['String']['output']>;
  analysis2?: Maybe<Scalars['String']['output']>;
  analysis3?: Maybe<Scalars['String']['output']>;
  attachments: Array<Attachment>;
  auditEvents: Array<AuditEvent>;
  availableRequiredFields: Scalars['Int']['output'];
  canBeReinstructed: Scalars['Boolean']['output'];
  completionStatus: FileCompletionStatus;
  currentCustomerFolder: CustomerFolder;
  /** Risk entity current version identifier. */
  currentVersionId?: Maybe<Scalars['ID']['output']>;
  dccpAnalysis?: Maybe<DccpAnalysis>;
  dccpFollowUp?: Maybe<DccpFollowUp>;
  dccpYearSequenceNumber?: Maybe<Scalars['String']['output']>;
  diligences: Array<Diligence>;
  disabledValues: Scalars['Int']['output'];
  documentComment?: Maybe<Scalars['String']['output']>;
  documentRefusal: Scalars['Boolean']['output'];
  /** Returns all documents associated with this entity, except those that are specific to a folder or file */
  documents: Array<Document>;
  externalEReputationResults: Scalars['Boolean']['output'];
  families: Array<Family>;
  fileCategory: FolderFileCategory;
  /**
   * Get the version of the customer folder attached to this folder file.
   * Will be:
   *    - the current version of the customer folder if file state is DRAFT
   *    - the version of the customer folder saved when file has been first submitted otherwise
   */
  fileCustomerFolder: FileCustomerFolder;
  folderFileType: FolderFileType;
  id: Scalars['ID']['output'];
  /** Used inputValue by code */
  inputValue?: Maybe<InputValue>;
  /** Used inputValues by code */
  inputValues: Array<InputValue>;
  isDeletable: Scalars['Boolean']['output'];
  isEditable: Scalars['Boolean']['output'];
  isOpen: Scalars['Boolean']['output'];
  isReinstructed: Scalars['Boolean']['output'];
  isReinstruction: Scalars['Boolean']['output'];
  isRestorable: Scalars['Boolean']['output'];
  isWhatIf: Scalars['Boolean']['output'];
  legacyDocumentModel: Scalars['Boolean']['output'];
  messageThreads: Array<MessageThread>;
  pendingStatusUpdate: PendingStatusUpdate;
  preferences?: Maybe<Scalars['String']['output']>;
  purgeEligibleDate?: Maybe<Scalars['String']['output']>;
  questionnaires: Array<Questionnaire>;
  reinstructionFileSource?: Maybe<FolderFile>;
  requiredFields: Scalars['Int']['output'];
  riskStatus: FileRiskStatus;
  supportingDocuments: Array<ExpectedDocument>;
  /** The expected questionnaires according to the FolderFileType, as well as the saved questionnaires if any */
  supportingQuestionnaires: Array<SupportingQuestionnaire>;
  tag?: Maybe<Scalars['String']['output']>;
  terminatedDate?: Maybe<Scalars['String']['output']>;
  thirdPartyFolders: Array<ThirdPartyFolder>;
  toBePurged?: Maybe<Scalars['String']['output']>;
  /** Risk entity whatIf source identifier. */
  whatIfSourceId?: Maybe<Scalars['ID']['output']>;
  workflowStatus: FolderFileWorkflowStatus;
};


/** A file: operation, update or funding. */
export type FolderFileAllDocumentsArgs = {
  displayDocsSharingType?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A file: operation, update or funding. */
export type FolderFileDocumentsArgs = {
  displayDocsSharingType?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A file: operation, update or funding. */
export type FolderFileInputValueArgs = {
  fieldCode: Scalars['String']['input'];
};


/** A file: operation, update or funding. */
export type FolderFileInputValuesArgs = {
  fieldCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** FolderFileAnalysisConfig. */
export type FolderFileAnalysisConfig = {
  __typename?: 'FolderFileAnalysisConfig';
  id: FolderFileAnalysisId;
  isEnabled: Scalars['Boolean']['output'];
  languageTextKey: Scalars['String']['output'];
};

export enum FolderFileAnalysisId {
  Analysis = 'analysis',
  Analysis2 = 'analysis2',
  Analysis3 = 'analysis3'
}

export enum FolderFileCategory {
  FolderUpdate = 'FOLDER_UPDATE',
  Funding = 'FUNDING',
  Operation = 'OPERATION',
  Takeover = 'TAKEOVER'
}

export type FolderFileResource = ClientConfElement & {
  __typename?: 'FolderFileResource';
  code: Scalars['String']['output'];
  customerFolderTypeCodes: Array<Scalars['String']['output']>;
  disabled: Scalars['Boolean']['output'];
  disabledComment?: Maybe<Scalars['String']['output']>;
  /** element type */
  elementType: Scalars['String']['output'];
  folderFileFamilyCodes: Array<Scalars['String']['output']>;
  folderFileTypeCodes: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** Folder files page and page info. */
export type FolderFilesPage = {
  __typename?: 'FolderFilesPage';
  pageInfo: PageInfo;
  summaries: Array<FolderFileSummary>;
};

export type FolderFilesPageSortingFieldInputType = {
  direction: SortingOrder;
  name: FilesPageSortFieldName;
};

/** Folder file summary. */
export type FolderFileSummary = {
  __typename?: 'FolderFileSummary';
  customer: RootEntity;
  customerFolder: FileCustomerFolder;
  folderFile: FolderFile;
  maxEventDate?: Maybe<Scalars['String']['output']>;
};

/** Folder file type. */
export type FolderFileType = ClientConfElement & HistorizedClientConfElement & ListElement & ListElementWithFamily & ListElementWithRisk & {
  __typename?: 'FolderFileType';
  acceptThirdPartyFolders: Scalars['Boolean']['output'];
  acceptWhatIf: Scalars['Boolean']['output'];
  analysesConfig: Array<FolderFileAnalysisConfig>;
  category?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  disabled: Scalars['Boolean']['output'];
  disabledComment?: Maybe<Scalars['String']['output']>;
  documentFilter?: Maybe<Scalars['String']['output']>;
  /** element type */
  elementType: Scalars['String']['output'];
  eReputationMode: EReputationMode;
  externalEReputation: Scalars['Boolean']['output'];
  externalFolderFileAction: Scalars['Boolean']['output'];
  family?: Maybe<Family>;
  fileCategory: FolderFileCategory;
  iconName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  ignoreDocumentExpirationDate: Scalars['Boolean']['output'];
  includeShareholders: Scalars['Boolean']['output'];
  inputFields: Array<InputField>;
  inputForm?: Maybe<InputForm>;
  manualBeneficiaryOwnerIdentificationMode?: Maybe<ManualBeneficiaryOwnerIdentificationMode>;
  name: Scalars['String']['output'];
  ordinal: Scalars['Long']['output'];
  permissions: Array<Scope>;
  requiresBeneficiaryOwner: Scalars['Boolean']['output'];
  requiresLegalRepresentative: Scalars['Boolean']['output'];
  /** It always contains at least one element */
  riskValues: Array<RiskValue>;
  status: VersionStatus;
  /** If true, the fileType is in end of life and it will no longer be possible to create files that use it (preparatory step before disabling it for good) */
  sunset: Scalars['Boolean']['output'];
  takeover: Scalars['Boolean']['output'];
  versionCode: Scalars['String']['output'];
};


/** Folder file type. */
export type FolderFileTypeInputFormArgs = {
  key: Scalars['String']['input'];
};

/** Folder file workflow status. */
export type FolderFileWorkflowStatus = WorkflowStatus & {
  __typename?: 'FolderFileWorkflowStatus';
  /** The user who is assigned to workflow state. */
  assignedUser?: Maybe<User>;
  dccpApprovalRequired: Scalars['Boolean']['output'];
  lastModification: Scalars['String']['output'];
  /** The user who modified status last. */
  lastModifier: User;
  state: State;
};

/** FolderRiskChangeEvent. */
export type FolderRiskChangeEvent = FolderAuditEvent & {
  __typename?: 'FolderRiskChangeEvent';
  date: Scalars['String']['output'];
  origin: RiskChangeOrigin;
  riskStatus: FolderRiskStatus;
  type: FolderEventType;
  user: User;
};

/** FolderRiskDeletedEvent. */
export type FolderRiskDeletedEvent = FolderAuditEvent & {
  __typename?: 'FolderRiskDeletedEvent';
  date: Scalars['String']['output'];
  origin: RiskChangeOrigin;
  type: FolderEventType;
  user: User;
};

/** FolderRiskStatus */
export type FolderRiskStatus = RiskStatus & {
  __typename?: 'FolderRiskStatus';
  dccpApprovalRequired: Scalars['Boolean']['output'];
  folderFile?: Maybe<FolderFile>;
  forcedRisk?: Maybe<ForcedRisk>;
  globalRiskLevel: RiskLevel;
  globalScore: Scalars['Int']['output'];
  lastModification: Scalars['String']['output'];
  lastModifier: User;
  overloadedVersionCode?: Maybe<Scalars['String']['output']>;
  riskDetail: RiskDetail;
  standardRiskLevel: RiskLevel;
  subTotals: Array<SubTotal>;
};

/** The folder role for this entity */
export type FolderRole = AbstractRole & {
  __typename?: 'FolderRole';
  customVotingRights?: Maybe<Scalars['Float']['output']>;
  directBeneficiaryOwner?: Maybe<DirectBeneficiaryOwner>;
  /** Relation entity type */
  relatedEntityType?: Maybe<RelatedEntityType>;
  relationDescription?: Maybe<Scalars['String']['output']>;
  /** Role type */
  roleType: RoleType;
  share?: Maybe<Scalars['Float']['output']>;
  /** Source entity */
  sourceEntity?: Maybe<Entity>;
  /** @deprecated Use sourceEntity.id instead */
  sourceEntityId: Scalars['ID']['output'];
  subsidiaryTotalShare?: Maybe<Scalars['Float']['output']>;
  /** Subsidiary type */
  subsidiaryType?: Maybe<SubsidiaryType>;
  /** Target entity */
  targetEntity?: Maybe<Entity>;
  /** @deprecated Use targetEntity.id instead */
  targetEntityId: Scalars['ID']['output'];
  /** Voting rights */
  votingRights?: Maybe<Scalars['Float']['output']>;
};

/** Stakeholder of a folder. */
export type FolderStakeholder = FieldCompletion & {
  __typename?: 'FolderStakeholder';
  acceptDirectBeneficiaryOwners: Scalars['Boolean']['output'];
  acceptForcedBeneficiaryOwners: Scalars['Boolean']['output'];
  acceptLegalRepresentatives: Scalars['Boolean']['output'];
  acceptRelatedEntities: Scalars['Boolean']['output'];
  acceptShareholders: Scalars['Boolean']['output'];
  acceptSubsidiaries: Scalars['Boolean']['output'];
  availableRequiredFields: Scalars['Int']['output'];
  beneficiaryOwner: Scalars['Boolean']['output'];
  capitalizationBeneficiaryOwner: Scalars['Boolean']['output'];
  /**
   * The total percentage of a corporation's shares that has been successfully identified in the graph.
   * Will return nothing if the entity does not accept shareholders in the context of this folder.
   */
  capitalizationTable?: Maybe<Scalars['Float']['output']>;
  directBeneficiaryOwner: Scalars['Boolean']['output'];
  disabledValues: Scalars['Int']['output'];
  /** Returns all documents associated with this entity, except those that are specific to a folder or file outside the scope of the stakeholder */
  documents: Array<Document>;
  /**
   * Shares held by this entity (referring to the customer of the folder) that do not belong to any other. In other words:
   * - If the entity type accepts shareholders: the shares (in percentage) that remain to be distributed among its shareholders
   * (this means that there are still shareholders to be identified).
   * - If the entity type does not accept shareholders (natural persons...): the percentage that the entity itself owns, without
   * further consideration.
   * Will return nothing if the customer does not accept shareholders.
   */
  effectiveShare?: Maybe<Scalars['Float']['output']>;
  effectiveVotingRights?: Maybe<Scalars['Float']['output']>;
  entity: Entity;
  folderRoles: Array<FolderRole>;
  forcedBeneficiaryOwner: Scalars['Boolean']['output'];
  forcedBeneficiaryOwnerReason?: Maybe<Scalars['String']['output']>;
  hasLegalRepresentativeRole: Scalars['Boolean']['output'];
  ignoreSupportingDocuments: Scalars['Boolean']['output'];
  inputFields: Array<InputField>;
  /** Used inputValue by code */
  inputValue?: Maybe<InputValue>;
  /** Used inputValues by code */
  inputValues: Array<InputValue>;
  isEReputationOutdated: Scalars['Boolean']['output'];
  isFolderCustomer: Scalars['Boolean']['output'];
  /** True if the entity is a manager of the customer's manager, or a manager of the manager's manager... */
  isIndirectLegalRepresentative: Scalars['Boolean']['output'];
  /** True only if the entity is a direct manager of the customer, false otherwise */
  isLegalRepresentative: Scalars['Boolean']['output'];
  isRelatedEntity: Scalars['Boolean']['output'];
  isShareholder: Scalars['Boolean']['output'];
  isSubsidiary: Scalars['Boolean']['output'];
  isThirdParty: Scalars['Boolean']['output'];
  lastPepEReputationAnalysis?: Maybe<PepEReputationAnalysis>;
  optionalShareholding: Scalars['Boolean']['output'];
  otherShareholders?: Maybe<OtherShareholders>;
  otherShareholdersEffectiveShare?: Maybe<Scalars['Float']['output']>;
  otherShareholdersEffectiveVotingRights?: Maybe<Scalars['Float']['output']>;
  requiredFields: Scalars['Int']['output'];
  supportingDocuments: Array<ExpectedDocument>;
  /**
   * The shares (in percentage) that this entity holds in total (referring to the customer of the folder). For its calculation,
   * the shares held by all the shareholders interposed between the customer and this entity are taken into account.
   * Will return nothing if the customer does not accept shareholders.
   */
  totalShare?: Maybe<Scalars['Float']['output']>;
  totalVotingRights?: Maybe<Scalars['Float']['output']>;
  votingRightsBeneficiaryOwner: Scalars['Boolean']['output'];
  /** Will return nothing if the entity does not accept shareholders in the context of this folder */
  votingRightsTable?: Maybe<Scalars['Float']['output']>;
};


/** Stakeholder of a folder. */
export type FolderStakeholderDocumentsArgs = {
  displayDocsSharingType?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Stakeholder of a folder. */
export type FolderStakeholderFolderRolesArgs = {
  direction?: InputMaybe<RoleDirection>;
};


/** Stakeholder of a folder. */
export type FolderStakeholderInputValueArgs = {
  fieldCode: Scalars['String']['input'];
};


/** Stakeholder of a folder. */
export type FolderStakeholderInputValuesArgs = {
  fieldCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** FolderStakeholder properties. */
export type FolderStakeholderProperties = {
  __typename?: 'FolderStakeholderProperties';
  capitalizationBeneficiaryOwner: Scalars['Boolean']['output'];
  directBeneficiaryOwner: Scalars['Boolean']['output'];
  effectiveShare?: Maybe<Scalars['Float']['output']>;
  effectiveVotingRights?: Maybe<Scalars['Float']['output']>;
  forcedBeneficiaryOwner: Scalars['Boolean']['output'];
  forcedBeneficiaryOwnerReason?: Maybe<Scalars['String']['output']>;
  hasLegalRepresentativeRole?: Maybe<Scalars['Boolean']['output']>;
  isFolderCustomer: Scalars['Boolean']['output'];
  isIndirectLegalRepresentative?: Maybe<Scalars['Boolean']['output']>;
  isLegalRepresentative: Scalars['Boolean']['output'];
  isShareholder: Scalars['Boolean']['output'];
  isSubsidiary: Scalars['Boolean']['output'];
  isThirdParty: Scalars['Boolean']['output'];
  totalShare?: Maybe<Scalars['Float']['output']>;
  totalVotingRights?: Maybe<Scalars['Float']['output']>;
  votingRightsBeneficiaryOwner: Scalars['Boolean']['output'];
};

export type FolderStakeholderWithDiffs = {
  __typename?: 'FolderStakeholderWithDiffs';
  externalData: Array<ExternalDataDiff>;
  folderStakeholder?: Maybe<FolderStakeholder>;
};

export enum FolderStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Lead = 'LEAD'
}

/** A page of folders to delete. */
export type FoldersToDeletePage = {
  __typename?: 'FoldersToDeletePage';
  pageInfo: PageInfo;
  summaries: Array<FoldersToDeleteSummary>;
};

/** Folders to delete summary. */
export type FoldersToDeleteSummary = {
  __typename?: 'FoldersToDeleteSummary';
  customer: RootEntity;
  customerFolder: CustomerFolder;
  lastClosedFile?: Maybe<FolderFile>;
};

/** Forced risk. */
export type ForcedRisk = {
  __typename?: 'ForcedRisk';
  level: RiskLevel;
  reason: StandardListElement;
};

/** ForceRiskLevelEvent. */
export type ForceRiskLevelEvent = AuditEvent & {
  __typename?: 'ForceRiskLevelEvent';
  date: Scalars['String']['output'];
  state: WorkflowState;
  type: EventType;
  user: User;
};

export enum FormatEnum {
  DjLegacyJson = 'DJ_LEGACY_JSON',
  DjLegacyXml = 'DJ_LEGACY_XML',
  DjV2 = 'DJ_V2',
  RefinitiveV1 = 'REFINITIVE_V1'
}

/** Person gender */
export enum Gender {
  /** Female */
  F = 'F',
  /** Male */
  M = 'M'
}

/** A configuration element belonging to a client configuration version */
export type HistorizedClientConfElement = {
  /** The code of the element. */
  code: Scalars['String']['output'];
  /** Has the element been disabled */
  disabled: Scalars['Boolean']['output'];
  /** A comment about element disabling */
  disabledComment?: Maybe<Scalars['String']['output']>;
  /** element type */
  elementType: Scalars['String']['output'];
  /** The id of the element. */
  id: Scalars['ID']['output'];
  /** The name of the element. */
  name: Scalars['String']['output'];
  /** The status of the element. */
  status: VersionStatus;
  /** The version code of the element. */
  versionCode: Scalars['String']['output'];
};

export type Html = Body & {
  __typename?: 'Html';
  html: Scalars['String']['output'];
  subject: Scalars['String']['output'];
  text: Scalars['String']['output'];
  variables: Array<Variable>;
};

export enum IdentifiersMatchStatus {
  BirthNameMatch = 'BirthNameMatch',
  FullMatch = 'FullMatch',
  Mismatch = 'Mismatch',
  NameOnlyMatch = 'NameOnlyMatch',
  NotEnoughData = 'NotEnoughData',
  PartialNameMatch = 'PartialNameMatch',
  PossibleNameMatch = 'PossibleNameMatch'
}

export type InactiveMissionsInLatestSnapshotOfCustomerFoldersPageSortingFieldInputType = {
  direction: SortingOrder;
  name: CustomerFoldersPageSortingFieldName;
};

/** INPI RBE provider specific data */
export type InpiData = ProviderData & {
  __typename?: 'InpiData';
  autre_moyen_controle?: Maybe<Scalars['Boolean']['output']>;
  benef_representant_legal?: Maybe<Scalars['Boolean']['output']>;
  code_greffe?: Maybe<Scalars['String']['output']>;
  date_benef?: Maybe<Scalars['String']['output']>;
  date_greffe_rbe?: Maybe<Scalars['String']['output']>;
  date_integration?: Maybe<Scalars['String']['output']>;
  date_suppression?: Maybe<Scalars['String']['output']>;
  domicile: Domicile;
  naissance: Naissance;
  nationalite_benef?: Maybe<Scalars['String']['output']>;
  nom: Nom;
  num_gestion?: Maybe<Scalars['String']['output']>;
  participation: Participation;
  pouvoir_decision_ag?: Maybe<Scalars['Boolean']['output']>;
  pouvoir_nommer_membre_ca?: Maybe<Scalars['Boolean']['output']>;
  providerType: Scalars['String']['output'];
  rep_legal_plac_sans_gest_delg?: Maybe<Scalars['Boolean']['output']>;
  siren?: Maybe<Scalars['String']['output']>;
  societeGestion: SocieteGestion;
  titu: Titu;
  type_entite?: Maybe<Scalars['String']['output']>;
  vote: Vote;
};

/** An entity with input values */
export type InputEntity = {
  /** Used inputValue by code */
  inputValue?: Maybe<InputValue>;
  /** Used inputValues by code */
  inputValues: Array<InputValue>;
};


/** An entity with input values */
export type InputEntityInputValueArgs = {
  fieldCode: Scalars['String']['input'];
};


/** An entity with input values */
export type InputEntityInputValuesArgs = {
  fieldCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** An input field */
export type InputField = {
  __typename?: 'InputField';
  /** @deprecated Use fieldCode instead */
  code: Scalars['String']['output'];
  constraints: Array<Constraint>;
  /** @deprecated Use fieldType instead */
  dataType: DataType;
  defaultElement?: Maybe<ClientConfElement>;
  fieldCode: Scalars['String']['output'];
  fieldType: DataType;
  formDisplay?: Maybe<Scalars['String']['output']>;
  /** If some inputValue is provided for this field, the linked field will be filled automatically by the back-end */
  linkedTo?: Maybe<Scalars['String']['output']>;
  list?: Maybe<Scalars['String']['output']>;
  listFormDisplay?: Maybe<Scalars['String']['output']>;
  usage: UsageLevel;
};

export type InputForm = {
  __typename?: 'InputForm';
  code: Scalars['String']['output'];
  content: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  status: VersionStatus;
  versionCode: Scalars['String']['output'];
};

export type InputParameter = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

/** An input value */
export type InputValue = {
  /** @deprecated Use inputField (fieldType) instead */
  dataType: DataType;
  /** @deprecated Use inputField (fieldCode) instead */
  fieldCode: Scalars['String']['output'];
  inputField: InputField;
  stringValue?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use stringValue instead */
  value?: Maybe<Scalars['String']['output']>;
};

export type InputValueInput = {
  dataType: DataType;
  fieldCode: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

/** An input value view as a result of graph comparison with an external dataset */
export type InputValueView = {
  __typename?: 'InputValueView';
  dataType: DataType;
  fieldCode: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export enum KycReviewStatus {
  Failure = 'FAILURE',
  None = 'NONE',
  Ongoing = 'ONGOING',
  Success = 'SUCCESS'
}

export type LanguageTexts = {
  __typename?: 'LanguageTexts';
  code: Scalars['String']['output'];
  content: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type LastModifiedFolderFilePerCurrentCustomerFolderPage = {
  __typename?: 'LastModifiedFolderFilePerCurrentCustomerFolderPage';
  content: Array<LastModifiedFolderFilePerCurrentCustomerFolderSummary>;
  pageInfo: PageInfo;
};

export type LastModifiedFolderFilePerCurrentCustomerFolderPageSortingFieldInputType = {
  direction: SortingOrder;
  name: LastModifiedFolderFilePerCurrentCustomerFolderPageSortingFieldName;
};

export enum LastModifiedFolderFilePerCurrentCustomerFolderPageSortingFieldName {
  LastModification = 'LastModification',
  RiskLevel = 'RiskLevel'
}

export type LastModifiedFolderFilePerCurrentCustomerFolderSummary = {
  __typename?: 'LastModifiedFolderFilePerCurrentCustomerFolderSummary';
  currentCustomer: RootEntity;
  currentCustomerFolder: CustomerFolder;
  lastModifiedFolderFile: FolderFile;
};

/** Last validated Ereputation of a stakeholder. */
export type LastValidatedEReputation = AbstractEreputation & {
  __typename?: 'LastValidatedEReputation';
  details?: Maybe<EReputationDetail>;
  entries: Array<EReputationEntry>;
  eReputationDate?: Maybe<Scalars['String']['output']>;
  idERep?: Maybe<Scalars['String']['output']>;
  isAdverseMedia: Scalars['Boolean']['output'];
  isComplete: Scalars['Boolean']['output'];
  isMonitored?: Maybe<Scalars['Boolean']['output']>;
  isPep: Scalars['Boolean']['output'];
  isSanction: Scalars['Boolean']['output'];
  isSpecialInterest: Scalars['Boolean']['output'];
  resultSelection?: Maybe<ResultSelection>;
};

/** A configuration element belonging to a list */
export type ListElement = {
  /** It always exists in the product types. It is optional for the other elements */
  category?: Maybe<Scalars['String']['output']>;
  /** The code of the element. */
  code: Scalars['String']['output'];
  /** Has the element been disabled */
  disabled: Scalars['Boolean']['output'];
  /** A comment about element disabling */
  disabledComment?: Maybe<Scalars['String']['output']>;
  /** element type */
  elementType: Scalars['String']['output'];
  /** The id of the element. */
  id: Scalars['ID']['output'];
  /** The name of the element. */
  name: Scalars['String']['output'];
  /** The status of the element. */
  status: VersionStatus;
  /** The version code of the element. */
  versionCode: Scalars['String']['output'];
};

/** A configuration element, belonging to a list, capable of being associated to a family */
export type ListElementWithFamily = {
  /** It always exists in the product types. It is optional for the other elements */
  category?: Maybe<Scalars['String']['output']>;
  /** The code of the element. */
  code: Scalars['String']['output'];
  /** Has the element been disabled */
  disabled: Scalars['Boolean']['output'];
  /** A comment about element disabling */
  disabledComment?: Maybe<Scalars['String']['output']>;
  /** element type */
  elementType: Scalars['String']['output'];
  family?: Maybe<Family>;
  /** The id of the element. */
  id: Scalars['ID']['output'];
  /** The name of the element. */
  name: Scalars['String']['output'];
  /** The status of the element. */
  status: VersionStatus;
  /** The version code of the element. */
  versionCode: Scalars['String']['output'];
};

/** A configuration element, belonging to a list, which is associated to a series of risks */
export type ListElementWithRisk = {
  /** It always exists in the product types. It is optional for the other elements */
  category?: Maybe<Scalars['String']['output']>;
  /** The code of the element. */
  code: Scalars['String']['output'];
  /** Has the element been disabled */
  disabled: Scalars['Boolean']['output'];
  /** A comment about element disabling */
  disabledComment?: Maybe<Scalars['String']['output']>;
  /** element type */
  elementType: Scalars['String']['output'];
  /** The id of the element. */
  id: Scalars['ID']['output'];
  /** The name of the element. */
  name: Scalars['String']['output'];
  /** It always contains at least one element */
  riskValues: Array<RiskValue>;
  /** The status of the element. */
  status: VersionStatus;
  /** The version code of the element. */
  versionCode: Scalars['String']['output'];
};

/** Document or reference to external document expected for this type of entity */
export type MainDocument = {
  /** Supporting document current version identifier */
  currentVersionId?: Maybe<Scalars['ID']['output']>;
  /** Document identifier */
  id: Scalars['ID']['output'];
  /** Supporting document status */
  status: DocumentStatus;
  /** Supporting document type */
  type: DocumentType;
};

/** Manager. */
export type Manager = {
  __typename?: 'Manager';
  entity: Entity;
  position: Scalars['String']['output'];
};

export enum ManualBeneficiaryOwnerIdentificationMode {
  Direct = 'DIRECT',
  Forced = 'FORCED'
}

/** Master corporation. */
export type MasterCorporation = MasterEntity & {
  __typename?: 'MasterCorporation';
  activity?: Maybe<StandardListElement>;
  alternateCode?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  creationDate: Scalars['String']['output'];
  grossAmount?: Maybe<Scalars['Float']['output']>;
  localMatches: Array<Corporation>;
  name: Scalars['String']['output'];
  registration: Scalars['String']['output'];
  registrationCountry?: Maybe<Country>;
};

/** Master entity. */
export type MasterEntity = {
  alternateCode?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  grossAmount?: Maybe<Scalars['Float']['output']>;
};

/** Master person. */
export type MasterPerson = MasterEntity & {
  __typename?: 'MasterPerson';
  alternateCode?: Maybe<Scalars['String']['output']>;
  birthCity?: Maybe<City>;
  birthCityCode?: Maybe<Scalars['String']['output']>;
  birthCountry?: Maybe<Country>;
  birthCountryCode: Scalars['String']['output'];
  birthDate: Scalars['String']['output'];
  birthName: Scalars['String']['output'];
  birthPlace: Scalars['String']['output'];
  code: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  grossAmount?: Maybe<Scalars['Float']['output']>;
  lastName: Scalars['String']['output'];
  localMatches: Array<Person>;
};

export type Message = {
  __typename?: 'Message';
  adminStatus: AdminStatus;
  content: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type MessageThread = {
  __typename?: 'MessageThread';
  adminStatus: AdminStatus;
  assignedGroups: Array<UserGroup>;
  discussants: Array<User>;
  id: Scalars['ID']['output'];
  messages: Array<Message>;
  title: Scalars['String']['output'];
  topics: Array<StandardListElement>;
  unreadMessages: Array<Message>;
};

export enum MessageThreadAction {
  AddMessage = 'ADD_MESSAGE',
  EditMessage = 'EDIT_MESSAGE'
}

export type MessageThreadEmail = {
  __typename?: 'MessageThreadEmail';
  emails: Array<MessageThreadEmailSubscription>;
  sender: Sender;
};

export type MessageThreadEmailSubscription = {
  __typename?: 'MessageThreadEmailSubscription';
  action: MessageThreadAction;
  body: Body;
};

/** A page of message threads and page info. */
export type MessageThreadPage = {
  __typename?: 'MessageThreadPage';
  messageThreads: Array<MessageThreadSummary>;
  pageInfo: PageInfo;
};

export type MessageThreadsConfiguration = ClientConfElement & {
  __typename?: 'MessageThreadsConfiguration';
  code: Scalars['String']['output'];
  content: MessageThreadsConfigurationContent;
  /** Has the element been disabled */
  disabled: Scalars['Boolean']['output'];
  /** A comment about element disabling */
  disabledComment?: Maybe<Scalars['String']['output']>;
  /** element type */
  elementType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type MessageThreadsConfigurationContent = {
  __typename?: 'MessageThreadsConfigurationContent';
  restrictedMessageThreadCreationGroup?: Maybe<Scalars['String']['output']>;
  subscriptions: MessageThreadSubscriptions;
};

export type MessageThreadSubscriptions = {
  __typename?: 'MessageThreadSubscriptions';
  email?: Maybe<MessageThreadEmail>;
};

/** A message thread summary. */
export type MessageThreadSummary = {
  __typename?: 'MessageThreadSummary';
  folderFileSummary: FolderFileSummary;
  lastMessage: Message;
  messageThread: MessageThread;
};

export type Mission = InputEntity & RiskEntity & {
  __typename?: 'Mission';
  adminStatus: AdminStatus;
  availableRequiredFields: Scalars['Int']['output'];
  currentVersionId?: Maybe<Scalars['ID']['output']>;
  disabledValues: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  /** Used inputValue by code */
  inputValue?: Maybe<InputValue>;
  /** Used inputValues by code */
  inputValues: Array<InputValue>;
  isClosable: Scalars['Boolean']['output'];
  isEditable: Scalars['Boolean']['output'];
  isReopenable: Scalars['Boolean']['output'];
  missionType: MissionType;
  renewDate?: Maybe<Scalars['String']['output']>;
  requiredFields: Scalars['Int']['output'];
  /**
   * Snapshot to which the object belongs.
   * Will be null if object is the current/main version and does not belong to a snapshot
   */
  snapshot?: Maybe<Snapshot>;
  status: MissionStatus;
  statusComment?: Maybe<Scalars['String']['output']>;
  /** Risk entity whatIf source identifier. */
  whatIfSourceId?: Maybe<Scalars['ID']['output']>;
};


export type MissionInputValueArgs = {
  fieldCode: Scalars['String']['input'];
};


export type MissionInputValuesArgs = {
  fieldCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum MissionStatus {
  Active = 'ACTIVE',
  Closed = 'CLOSED',
  Inactive = 'INACTIVE'
}

export enum MissionsUsageLevel {
  Forbidden = 'FORBIDDEN',
  Optional = 'OPTIONAL',
  Required = 'REQUIRED'
}

/** Mission type. */
export type MissionType = ClientConfElement & HistorizedClientConfElement & ListElement & ListElementWithFamily & ListElementWithRisk & {
  __typename?: 'MissionType';
  category?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  disabled: Scalars['Boolean']['output'];
  disabledComment?: Maybe<Scalars['String']['output']>;
  documentFilter?: Maybe<Scalars['String']['output']>;
  /** element type */
  elementType: Scalars['String']['output'];
  family?: Maybe<Family>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  ordinal: Scalars['Long']['output'];
  /** It always contains at least one element */
  riskValues: Array<RiskValue>;
  status: VersionStatus;
  versionCode: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addDiscussants?: Maybe<MessageThread>;
  addMessage?: Maybe<Message>;
  addNewCustomers: CustomerFolder;
  /** To create customer graph automatically by siren of a corporation or person with external data provider */
  autoCreateCustomerGraph: AutocreationCorporationResult;
  /** To create customer graph automatically by siren of a corporation or person with external data provider */
  autoCreatePersonCustomerGraph: AutocreationPersonResult;
  callEntityEreputation: Entity;
  callEreputation?: Maybe<FolderFile>;
  closeMission: Mission;
  /**
   * Attach file with id fileId to element with id elementId. Element must be a person, a corporation, a folder file, a CustomerFolder, a DccpAlert, a DccpAnalysis or a DccpFollowUp
   * @deprecated Use POST /documents/attachment/file and linkAttachment instead
   */
  createAttachment?: Maybe<Attachment>;
  /** Create a customer folder for co-customer. */
  createCoCustomerCustomerFolder?: Maybe<CustomerFolder>;
  createCorporation?: Maybe<Corporation>;
  /** Create a customer folder. The optionCustomerFolderTypeId is mandatory if there is more than one customerFolderType in the DB and no default customerFolderType has been set in the configuration */
  createCustomerFolder?: Maybe<CustomerFolder>;
  createDccpAlert?: Maybe<DccpAlert>;
  createDccpAnalysis?: Maybe<DccpAnalysis>;
  createDccpFollowUp?: Maybe<DccpFollowUp>;
  createDiligence: Diligence;
  createDiligences: Array<Diligence>;
  /** @deprecated Use POST /documents/file and linkOrReplaceDocument instead */
  createDocument?: Maybe<Document>;
  createDocumentFromPortal?: Maybe<Document>;
  createDocumentFromProvider?: Maybe<Document>;
  /** Create a new manual eReputationAlert, failing if an active alert already exists. */
  createEReputationAlert: EReputationAlert;
  createFolderFile?: Maybe<FolderFile>;
  createLinkedCorporation?: Maybe<Corporation>;
  createLinkedPerson?: Maybe<Person>;
  createMessageThread?: Maybe<MessageThread>;
  createMission: Mission;
  /** Create or replace external document */
  createOrReplaceExternalDocument?: Maybe<ExternalDocument>;
  /**
   * Attach file with id fileId to the OtherShareholders belonging to the corporation with id corporationId
   * @deprecated Use POST /documents/attachment/file and linkOtherShareholdersAttachment instead
   */
  createOtherShareholdersAttachment?: Maybe<Attachment>;
  createPepEReputationAnalysis: PepEReputationAnalysis;
  createPerson?: Maybe<Person>;
  /** Create a questionnaire */
  createQuestionnaire: Questionnaire;
  /** To import the questionnaire from portal and put its content */
  createQuestionnaireFromPortal: Questionnaire;
  createReinstructionFile: FolderFile;
  createRestrictedMessageThread?: Maybe<MessageThread>;
  createThirdPartyFolder?: Maybe<ThirdPartyFolder>;
  /** This will: 1) Delete an attachment. 2) This attachment must belong to current state and not to a non editable file. */
  deleteAttachment?: Maybe<Scalars['ID']['output']>;
  deleteContactPerson: Scalars['ID']['output'];
  /** This will: 1) Delete a corporation. 2) The corporation to delete must have no roles. 3) The corporation to delete must belong to current state and not to a non editable file. */
  deleteCorporation?: Maybe<Scalars['ID']['output']>;
  /** This will: 1) Delete the customerFolder and its folderFiles, attachments and dccpAlerts. 2) Customer and stakeholders will not be impacted. 3) All folderFiles of CustomerFolder must be in a deletable workflow state. 4) Only current customer folders can be deleted. */
  deleteCustomerFolder?: Maybe<Scalars['ID']['output']>;
  /** To delete the customer folders that should be deleted */
  deleteCustomerFoldersToDelete: Array<Scalars['ID']['output']>;
  /** If the dccpAnalysis is editable (its file is open and the Dccp approval is required), this will: 1) Delete the arc between the dccpAnalysis and its file. 2) Delete the dccpAnalysis node if there are no arcs left, or return an error otherwise. */
  deleteDccpAnalysis?: Maybe<Scalars['ID']['output']>;
  /** If the dccpFollowUp is editable (its file dccpFollowUp state is true), this will: 1) Delete the arc between the dccpFollowUp and its file. 2) Delete the dccpFollowUp node if there are no arcs left, or return an error otherwise. */
  deleteDccpFollowUp?: Maybe<Scalars['ID']['output']>;
  deleteDiligence: Scalars['ID']['output'];
  /** This will: 1) Delete a document. 2) Document must belong to current state and not to a non editable file. */
  deleteDocument?: Maybe<Scalars['ID']['output']>;
  deleteEReputationAlert: Scalars['ID']['output'];
  /** Delete external document */
  deleteExternalDocument?: Maybe<Scalars['ID']['output']>;
  /** If the file state is deletable, this will: 1) Delete the file, its documents, its events, its attachments, and the third party folders (and associated content). 2) This operation can only be performed on a files which are in editable state. */
  deleteFolderFile?: Maybe<Scalars['ID']['output']>;
  /** Delete a batch of folder files. Each file must be in a deletable state. All deletions run in a single transaction (all-or-nothing). */
  deleteFolderFiles: Array<Scalars['ID']['output']>;
  deleteMessageThread?: Maybe<Scalars['ID']['output']>;
  deleteMission: Scalars['ID']['output'];
  /** To delete the entities that are not linked to any customer folder */
  deleteOrphanEntities: Array<Scalars['ID']['output']>;
  /** This will: 1) Delete an attachment. 2) This attachment must belong to current state and not to a non editable file. */
  deleteOtherShareholdersAttachment?: Maybe<Scalars['ID']['output']>;
  /** This will: 1) Delete a person. 2) The Person to delete must have no roles. 3) The Person to delete must belong to current state and not to a non editable file. */
  deletePerson?: Maybe<Scalars['ID']['output']>;
  /** Delete Questionnaire */
  deleteQuestionnaire: Scalars['ID']['output'];
  /** Delete a particular role between two entities, if any. */
  deleteRole?: Maybe<Role>;
  deleteShareholder?: Maybe<Scalars['String']['output']>;
  /** This will: 1) Delete the ThirdPartyFolder, its documents and its attachments. 2) Third party entity and its stakeholders will not be impacted. 3) This operation can only be performed on a ThirdPartyFolder belonging to file which is in editable or deletable state. */
  deleteThirdPartyFolder?: Maybe<Scalars['ID']['output']>;
  disableDccpAlert?: Maybe<DccpAlert>;
  disableMonitoring: Entity;
  editMessage?: Maybe<Message>;
  /** To enable or disable the voting rights for a specific corporation */
  enableCustomVotingRights?: Maybe<Corporation>;
  executeEReputationAlertWorkflowAction?: Maybe<EReputationAlert>;
  executeWorkflowAction?: Maybe<FolderFile>;
  followFolder: CustomerFolder;
  forceRiskLevel: FolderFile;
  /** To ignore all the supporting documents of a corporation in the context of a customer folder. The corporation must be a subsidiary with a type containing an ignorableSupportingDocuments set to true. */
  ignoreSubsidiarySupportingDocuments: CustomerFolder;
  leaveMessageThread?: Maybe<MessageThread>;
  /** Attach file (id) to element (elementId). Element must be a person, a corporation, a folder file, a CustomerFolder, a ThirdPartyFolder, a DccpAlert, a DccpAnalysis or a DccpFollowUp */
  linkAttachment?: Maybe<Attachment>;
  linkCorporation?: Maybe<Corporation>;
  /** Link an existing document to a documentableEntity. WARNING: If a linked document (of the same type) already exists, the new document will replace the old one */
  linkOrReplaceDocument?: Maybe<Document>;
  /** Attach file (id) to the OtherShareholders belonging to the corporation with id corporationId */
  linkOtherShareholdersAttachment?: Maybe<Attachment>;
  linkPerson?: Maybe<Person>;
  mergeContactPerson: ContactPerson;
  /** To search for corporations using the given keys, and if exactly one is found, update it, otherwise we create a new one. The provided keys should exist amoing the given inputValues. */
  mergeCorporation?: Maybe<Corporation>;
  /** To search for customerFolders having the given customerFolderTypeCode, and if one is found, update it, otherwise we create a new one */
  mergeCustomerFolder?: Maybe<CustomerFolder>;
  /** To search for files using the given keys among the provided folder, and if exactly one is found, update it, otherwise we create a new one */
  mergeFolderFile?: Maybe<FolderFile>;
  /** Search for persons matching the keysExpression (a boolean AND/OR expression over field codes). If exactly one match is found, update it with inputValues; if none match, create a new person; if two or more distinct persons match, return an error. */
  mergePerson?: Maybe<Person>;
  mergeShareholder?: Maybe<Shareholder>;
  /** To create / override the questionnaire content */
  putQuestionnaireContent: Questionnaire;
  /** To replace the roles of the customer's current shareholding graph with the roles that existed at the time a file was closed. WARNING: If the active configuration does not allow the recreation of any of the roles that were allowed in the past, this role will simply be ignored */
  recreateCurrentStakeholderRoles: RecreateRolesResult;
  /** To refresh a document loaded from a provider */
  refreshDocumentFromProvider?: Maybe<DocumentRefreshResponse>;
  refreshLinkedCorporation?: Maybe<Corporation>;
  refreshLinkedPerson?: Maybe<Person>;
  removeExistingCustomers: CustomerFolder;
  /** Remove the owner of the current customerFolder. Flaminem Pro feature */
  removeOwner: CustomerFolder;
  reopenMission: Mission;
  /** To mark a questionnaire as editable. This does not destroy the copy that was made when validating it */
  reopenQuestionnaire: Questionnaire;
  /**
   * Delete an existing linked document and use a newly created document instead
   * @deprecated Use linkOrReplaceDocument instead
   */
  replaceDocument?: Maybe<Document>;
  /** To replace a person by another person, or a corporation by another corporation. DANGER: this operation is irreversible. All data of the entity to be replaced will be lost */
  replaceEntity?: Maybe<Entity>;
  replaceGroupsByCurrentUser?: Maybe<MessageThread>;
  /** Set external eReputation results */
  setExternalEReputationResults?: Maybe<FolderFile>;
  /** Set folder file tag */
  setFolderFileTag?: Maybe<FolderFile>;
  /** Set the given person as a forced beneficiary owner of given folder. Folder type must accept beneficiary owners. */
  setForcedBeneficiaryOwner: Folder;
  setManagerRole?: Maybe<Manager>;
  setOngoingKycReviewStatus: CustomerFolder;
  /** Create or update the owner of the current customerFolder. Flaminem Pro feature */
  setOwner: CustomerFolder;
  /** Set the primary validating user of the current user. Return the updated current user. */
  setPrimaryValidatingUser: User;
  setRelatedEntity?: Maybe<RelatedEntity>;
  setRole: Role;
  /** To transform an attachment into document and link it to an entity */
  transformAttachmentIntoDocument?: Maybe<Document>;
  /** Trigger an external file action */
  triggerExternalFolderFileAction?: Maybe<FolderFile>;
  unfollowFolder: CustomerFolder;
  unlinkCorporation?: Maybe<Corporation>;
  unlinkPerson?: Maybe<Person>;
  updateCorporation?: Maybe<Corporation>;
  updateCustomerFolder?: Maybe<CustomerFolder>;
  updateCustomerFolderAnalysis?: Maybe<CustomerFolder>;
  updateDccpAlert?: Maybe<DccpAlert>;
  updateDccpAnalysis?: Maybe<DccpAnalysis>;
  updateDccpFollowUp?: Maybe<DccpFollowUp>;
  updateDiligence: Diligence;
  updateDocument?: Maybe<Document>;
  updateDocumentFields: DocumentableEntity;
  updateEnclosingFoldersRiskStatus: Array<CustomerFolder>;
  updateEntityEreputation: Entity;
  updateEReputationAlert: EReputationAlert;
  updateExternalDocument?: Maybe<ExternalDocument>;
  updateFolderFile?: Maybe<FolderFile>;
  updateFolderFileAnalysis?: Maybe<FolderFile>;
  updateLastReadDate?: Maybe<MessageThread>;
  updateLinkedCorporation?: Maybe<Corporation>;
  updateLinkedPerson?: Maybe<Person>;
  updateMessageThread?: Maybe<MessageThread>;
  updateMission: Mission;
  updateOtherShareholders?: Maybe<Corporation>;
  updatePerson?: Maybe<Person>;
  updatePreferences?: Maybe<Preferenceable>;
  updateThirdPartyFolder?: Maybe<ThirdPartyFolder>;
  /** To validate the questionnaire so that it can no longer be edited (unless it is reopened), creating an immutable copy of it */
  validateQuestionnaire: Questionnaire;
};


export type MutationAddDiscussantsArgs = {
  discussantIds: Array<Scalars['String']['input']>;
  messageThreadId: Scalars['ID']['input'];
};


export type MutationAddMessageArgs = {
  content: Scalars['String']['input'];
  messageThreadId: Scalars['ID']['input'];
};


export type MutationAddNewCustomersArgs = {
  customerFolderId: Scalars['IdOrReference']['input'];
  customerIds: Array<Scalars['IdOrReference']['input']>;
};


export type MutationAutoCreateCustomerGraphArgs = {
  includeIntermediateLegalRepresentatives: Scalars['Boolean']['input'];
  siren: Scalars['String']['input'];
};


export type MutationAutoCreatePersonCustomerGraphArgs = {
  siren: Scalars['String']['input'];
};


export type MutationCallEntityEreputationArgs = {
  entityId: Scalars['ID']['input'];
};


export type MutationCallEreputationArgs = {
  folderFileId: Scalars['ID']['input'];
  force?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCloseMissionArgs = {
  missionId: Scalars['ID']['input'];
  statusComment: Scalars['String']['input'];
};


export type MutationCreateAttachmentArgs = {
  contentType?: InputMaybe<Scalars['String']['input']>;
  elementId: Scalars['IdOrReference']['input'];
  fileId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateCoCustomerCustomerFolderArgs = {
  customerIds: Array<Scalars['IdOrReference']['input']>;
  inputValues: Array<InputValueInput>;
  optionCustomerFolderTypeCode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateCorporationArgs = {
  inputValues: Array<InputValueInput>;
  reference?: InputMaybe<Scalars['Reference']['input']>;
};


export type MutationCreateCustomerFolderArgs = {
  entityId: Scalars['IdOrReference']['input'];
  inputValues: Array<InputValueInput>;
  optionCustomerFolderTypeCode?: InputMaybe<Scalars['String']['input']>;
  optionCustomerFolderTypeId?: InputMaybe<Scalars['ID']['input']>;
  reference?: InputMaybe<Scalars['Reference']['input']>;
};


export type MutationCreateDccpAlertArgs = {
  entityId: Scalars['IdOrReference']['input'];
  input: DccpAlertInputType;
  reference?: InputMaybe<Scalars['Reference']['input']>;
};


export type MutationCreateDccpAnalysisArgs = {
  folderFileId: Scalars['IdOrReference']['input'];
  inputValues: Array<InputValueInput>;
  reference?: InputMaybe<Scalars['Reference']['input']>;
};


export type MutationCreateDccpFollowUpArgs = {
  folderFileId: Scalars['IdOrReference']['input'];
  inputValues: Array<InputValueInput>;
  reference?: InputMaybe<Scalars['Reference']['input']>;
};


export type MutationCreateDiligenceArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  folderFileId: Scalars['ID']['input'];
  index?: InputMaybe<Scalars['Long']['input']>;
  name: Scalars['String']['input'];
  selected?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateDiligencesArgs = {
  folderFileId: Scalars['ID']['input'];
  selected?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateDocumentArgs = {
  contentType?: InputMaybe<Scalars['String']['input']>;
  documentTypeId: Scalars['ID']['input'];
  emissionDate?: InputMaybe<Scalars['String']['input']>;
  entityId: Scalars['IdOrReference']['input'];
  expirationDate?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  fileId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateDocumentFromPortalArgs = {
  documentTypeCode: Scalars['String']['input'];
  entityId: Scalars['IdOrReference']['input'];
  externalReference?: InputMaybe<Scalars['String']['input']>;
  parameters: Array<InputParameter>;
  validate?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateDocumentFromProviderArgs = {
  documentTypeCode: Scalars['String']['input'];
  externalReference?: InputMaybe<Scalars['String']['input']>;
  parameters: Array<InputParameter>;
};


export type MutationCreateEReputationAlertArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  entityId: Scalars['ID']['input'];
};


export type MutationCreateFolderFileArgs = {
  customerFolderId: Scalars['IdOrReference']['input'];
  inputValues: Array<InputValueInput>;
  isWhatIf?: InputMaybe<Scalars['Boolean']['input']>;
  reference?: InputMaybe<Scalars['Reference']['input']>;
};


export type MutationCreateLinkedCorporationArgs = {
  code: Scalars['String']['input'];
  inputValues: Array<InputValueInput>;
  reference?: InputMaybe<Scalars['Reference']['input']>;
};


export type MutationCreateLinkedPersonArgs = {
  code: Scalars['String']['input'];
  inputValues: Array<InputValueInput>;
  reference?: InputMaybe<Scalars['Reference']['input']>;
};


export type MutationCreateMessageThreadArgs = {
  discussantIds: Array<Scalars['String']['input']>;
  folderFileId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
  topicCodes: Array<Scalars['String']['input']>;
};


export type MutationCreateMissionArgs = {
  customerFolderId: Scalars['IdOrReference']['input'];
  inputValues: Array<InputValueInput>;
};


export type MutationCreateOrReplaceExternalDocumentArgs = {
  documentTypeCode: Scalars['String']['input'];
  entityId: Scalars['IdOrReference']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateOtherShareholdersAttachmentArgs = {
  contentType?: InputMaybe<Scalars['String']['input']>;
  corporationId: Scalars['IdOrReference']['input'];
  fileId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreatePepEReputationAnalysisArgs = {
  pepEReputationAnalysisInput: PepEReputationAnalysisInputType;
  personId: Scalars['ID']['input'];
};


export type MutationCreatePersonArgs = {
  inputValues: Array<InputValueInput>;
  reference?: InputMaybe<Scalars['Reference']['input']>;
};


export type MutationCreateQuestionnaireArgs = {
  questionnaireEntityId: Scalars['IdOrReference']['input'];
  questionnaireTypeCode: Scalars['String']['input'];
  reference?: InputMaybe<Scalars['Reference']['input']>;
};


export type MutationCreateQuestionnaireFromPortalArgs = {
  portalQuestionnaireId: Scalars['IdOrReference']['input'];
};


export type MutationCreateReinstructionFileArgs = {
  folderFileId: Scalars['ID']['input'];
  inputValues: Array<InputValueInput>;
};


export type MutationCreateRestrictedMessageThreadArgs = {
  folderFileId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
  topicCodes: Array<Scalars['String']['input']>;
};


export type MutationCreateThirdPartyFolderArgs = {
  entityId: Scalars['IdOrReference']['input'];
  folderFileId: Scalars['IdOrReference']['input'];
  inputValues: Array<InputValueInput>;
  reference?: InputMaybe<Scalars['Reference']['input']>;
};


export type MutationDeleteAttachmentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteContactPersonArgs = {
  contactPersonId: Scalars['ID']['input'];
};


export type MutationDeleteCorporationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCustomerFolderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCustomerFoldersToDeleteArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteDccpAnalysisArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDccpFollowUpArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDiligenceArgs = {
  diligenceId: Scalars['ID']['input'];
};


export type MutationDeleteDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteEReputationAlertArgs = {
  eReputationAlertId: Scalars['ID']['input'];
};


export type MutationDeleteExternalDocumentArgs = {
  externalDocumentId: Scalars['ID']['input'];
};


export type MutationDeleteFolderFileArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFolderFilesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteMessageThreadArgs = {
  messageThreadId: Scalars['ID']['input'];
};


export type MutationDeleteMissionArgs = {
  missionId: Scalars['ID']['input'];
};


export type MutationDeleteOrphanEntitiesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteOtherShareholdersAttachmentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePersonArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteQuestionnaireArgs = {
  questionnaireId: Scalars['ID']['input'];
};


export type MutationDeleteRoleArgs = {
  roleId?: InputMaybe<Scalars['ID']['input']>;
  roleTypeCode?: InputMaybe<Scalars['String']['input']>;
  sourceEntityId: Scalars['ID']['input'];
  targetEntityId: Scalars['ID']['input'];
};


export type MutationDeleteShareholderArgs = {
  corporationId: Scalars['ID']['input'];
  entityId: Scalars['ID']['input'];
};


export type MutationDeleteThirdPartyFolderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDisableDccpAlertArgs = {
  alertId: Scalars['ID']['input'];
};


export type MutationDisableMonitoringArgs = {
  entityId: Scalars['ID']['input'];
};


export type MutationEditMessageArgs = {
  content: Scalars['String']['input'];
  messageId: Scalars['ID']['input'];
};


export type MutationEnableCustomVotingRightsArgs = {
  corporationId: Scalars['IdOrReference']['input'];
  enabled: Scalars['Boolean']['input'];
};


export type MutationExecuteEReputationAlertWorkflowActionArgs = {
  actionId: Scalars['String']['input'];
  assignedUserId?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  eReputationAlertId: Scalars['ID']['input'];
};


export type MutationExecuteWorkflowActionArgs = {
  actionId: Scalars['String']['input'];
  assignedUserId?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  failedKycReviewReasonCode?: InputMaybe<Scalars['String']['input']>;
  folderFileId: Scalars['ID']['input'];
  terminatedDate?: InputMaybe<Scalars['String']['input']>;
};


export type MutationFollowFolderArgs = {
  customerFolderId: Scalars['IdOrReference']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationForceRiskLevelArgs = {
  folderFileId: Scalars['ID']['input'];
  forcedRiskReasonCode: Scalars['String']['input'];
  riskLevel: RiskLevel;
};


export type MutationIgnoreSubsidiarySupportingDocumentsArgs = {
  corporationId: Scalars['IdOrReference']['input'];
  customerFolderId: Scalars['IdOrReference']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['Boolean']['input'];
};


export type MutationLeaveMessageThreadArgs = {
  messageThreadId: Scalars['ID']['input'];
};


export type MutationLinkAttachmentArgs = {
  elementId: Scalars['IdOrReference']['input'];
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationLinkCorporationArgs = {
  code: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type MutationLinkOrReplaceDocumentArgs = {
  emissionDate?: InputMaybe<Scalars['String']['input']>;
  entityId: Scalars['IdOrReference']['input'];
  expirationDate?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  shared?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationLinkOtherShareholdersAttachmentArgs = {
  corporationId: Scalars['IdOrReference']['input'];
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationLinkPersonArgs = {
  code: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type MutationMergeContactPersonArgs = {
  customerFolderId: Scalars['IdOrReference']['input'];
  inputValues: Array<InputValueInput>;
};


export type MutationMergeCorporationArgs = {
  inputValues: Array<InputValueInput>;
  keys: Array<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['Reference']['input']>;
};


export type MutationMergeCustomerFolderArgs = {
  customerFolderTypeCode: Scalars['String']['input'];
  entityId: Scalars['IdOrReference']['input'];
  inputValues: Array<InputValueInput>;
  reference?: InputMaybe<Scalars['Reference']['input']>;
};


export type MutationMergeFolderFileArgs = {
  customerFolderId: Scalars['IdOrReference']['input'];
  inputValues: Array<InputValueInput>;
  isWhatIf?: InputMaybe<Scalars['Boolean']['input']>;
  keys: Array<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['Reference']['input']>;
};


export type MutationMergePersonArgs = {
  inputValues: Array<InputValueInput>;
  keysExpression: Scalars['String']['input'];
  reference?: InputMaybe<Scalars['Reference']['input']>;
};


export type MutationMergeShareholderArgs = {
  corporationId: Scalars['IdOrReference']['input'];
  customVotingRights?: InputMaybe<Scalars['Float']['input']>;
  entityId: Scalars['IdOrReference']['input'];
  share: Scalars['Float']['input'];
};


export type MutationPutQuestionnaireContentArgs = {
  content: Scalars['String']['input'];
  questionnaireId: Scalars['IdOrReference']['input'];
};


export type MutationRecreateCurrentStakeholderRolesArgs = {
  folderFileId: Scalars['ID']['input'];
};


export type MutationRefreshDocumentFromProviderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRefreshLinkedCorporationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRefreshLinkedPersonArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveExistingCustomersArgs = {
  customerFolderId: Scalars['ID']['input'];
  customerIds: Array<Scalars['ID']['input']>;
};


export type MutationRemoveOwnerArgs = {
  customerFolderId: Scalars['ID']['input'];
};


export type MutationReopenMissionArgs = {
  missionId: Scalars['ID']['input'];
};


export type MutationReopenQuestionnaireArgs = {
  questionnaireId: Scalars['ID']['input'];
};


export type MutationReplaceDocumentArgs = {
  documentToDeleteId: Scalars['ID']['input'];
  emissionDate?: InputMaybe<Scalars['String']['input']>;
  entityId: Scalars['IdOrReference']['input'];
  expirationDate?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationReplaceEntityArgs = {
  idToDelete: Scalars['ID']['input'];
  replacementId: Scalars['ID']['input'];
};


export type MutationReplaceGroupsByCurrentUserArgs = {
  messageThreadId: Scalars['ID']['input'];
};


export type MutationSetExternalEReputationResultsArgs = {
  folderFileId: Scalars['ID']['input'];
  result: Scalars['Boolean']['input'];
};


export type MutationSetFolderFileTagArgs = {
  folderFileId: Scalars['IdOrReference']['input'];
  tag?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetForcedBeneficiaryOwnerArgs = {
  folderId: Scalars['ID']['input'];
  personId: Scalars['IdOrReference']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['Boolean']['input'];
};


export type MutationSetManagerRoleArgs = {
  corporationId: Scalars['IdOrReference']['input'];
  entityId: Scalars['IdOrReference']['input'];
  position?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetOngoingKycReviewStatusArgs = {
  customerFolderId: Scalars['ID']['input'];
};


export type MutationSetOwnerArgs = {
  customerFolderId: Scalars['IdOrReference']['input'];
  userId: Scalars['String']['input'];
};


export type MutationSetPrimaryValidatingUserArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetRelatedEntityArgs = {
  relatedEntityIdOrRef: Scalars['IdOrReference']['input'];
  relatedEntityTypeCode?: InputMaybe<Scalars['String']['input']>;
  relatedEntityTypeId?: InputMaybe<Scalars['ID']['input']>;
  relationDescription?: InputMaybe<Scalars['String']['input']>;
  sourceEntityIdOrRef: Scalars['IdOrReference']['input'];
};


export type MutationSetRoleArgs = {
  roleInput: RoleInputType;
  sourceEntityId: Scalars['IdOrReference']['input'];
  targetEntityId: Scalars['IdOrReference']['input'];
};


export type MutationTransformAttachmentIntoDocumentArgs = {
  attachmentId: Scalars['ID']['input'];
  documentTypeCode: Scalars['String']['input'];
  emissionDate?: InputMaybe<Scalars['String']['input']>;
  entityId: Scalars['IdOrReference']['input'];
  expirationDate?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  validate?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationTriggerExternalFolderFileActionArgs = {
  folderFileId: Scalars['ID']['input'];
};


export type MutationUnfollowFolderArgs = {
  customerFolderId: Scalars['ID']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUnlinkCorporationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUnlinkPersonArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUpdateCorporationArgs = {
  id: Scalars['ID']['input'];
  inputValues: Array<InputValueInput>;
};


export type MutationUpdateCustomerFolderArgs = {
  id: Scalars['ID']['input'];
  inputValues: Array<InputValueInput>;
};


export type MutationUpdateCustomerFolderAnalysisArgs = {
  analysis?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationUpdateDccpAlertArgs = {
  alertId: Scalars['ID']['input'];
  input: DccpAlertInputType;
};


export type MutationUpdateDccpAnalysisArgs = {
  id: Scalars['ID']['input'];
  inputValues: Array<InputValueInput>;
};


export type MutationUpdateDccpFollowUpArgs = {
  id: Scalars['ID']['input'];
  inputValues: Array<InputValueInput>;
};


export type MutationUpdateDiligenceArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  diligenceId: Scalars['ID']['input'];
  index?: InputMaybe<Scalars['Long']['input']>;
  name: Scalars['String']['input'];
  selected?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateDocumentArgs = {
  contentType?: InputMaybe<Scalars['String']['input']>;
  emissionDate?: InputMaybe<Scalars['String']['input']>;
  expirationDate?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  shared?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateDocumentFieldsArgs = {
  entityId: Scalars['IdOrReference']['input'];
  input: DocumentFieldsInputType;
};


export type MutationUpdateEnclosingFoldersRiskStatusArgs = {
  eReputationAlertId: Scalars['ID']['input'];
};


export type MutationUpdateEntityEreputationArgs = {
  entityId: Scalars['ID']['input'];
  eReputationComment?: InputMaybe<Scalars['String']['input']>;
  inputs: Array<EReputationInputType>;
  resultSelection?: InputMaybe<ERepResultSelectionInputType>;
};


export type MutationUpdateEReputationAlertArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  eReputationAlertId: Scalars['ID']['input'];
};


export type MutationUpdateExternalDocumentArgs = {
  externalDocumentId: Scalars['ID']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateFolderFileArgs = {
  id: Scalars['ID']['input'];
  inputValues: Array<InputValueInput>;
};


export type MutationUpdateFolderFileAnalysisArgs = {
  analysis?: InputMaybe<Scalars['String']['input']>;
  analysisId?: FolderFileAnalysisId;
  id: Scalars['ID']['input'];
};


export type MutationUpdateLastReadDateArgs = {
  lastReadDate: Scalars['String']['input'];
  messageThreadId: Scalars['ID']['input'];
};


export type MutationUpdateLinkedCorporationArgs = {
  forceUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  inputValues: Array<InputValueInput>;
};


export type MutationUpdateLinkedPersonArgs = {
  forceUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  inputValues: Array<InputValueInput>;
};


export type MutationUpdateMessageThreadArgs = {
  messageThreadId: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  topicCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationUpdateMissionArgs = {
  inputValues: Array<InputValueInput>;
  missionId: Scalars['ID']['input'];
};


export type MutationUpdateOtherShareholdersArgs = {
  corporationId: Scalars['IdOrReference']['input'];
  otherShareholdersInput?: InputMaybe<OtherShareholdersInputType>;
};


export type MutationUpdatePersonArgs = {
  id: Scalars['ID']['input'];
  inputValues: Array<InputValueInput>;
};


export type MutationUpdatePreferencesArgs = {
  id: Scalars['ID']['input'];
  preferencesContent: Scalars['String']['input'];
};


export type MutationUpdateThirdPartyFolderArgs = {
  id: Scalars['ID']['input'];
  inputValues: Array<InputValueInput>;
};


export type MutationValidateQuestionnaireArgs = {
  questionnaireId: Scalars['IdOrReference']['input'];
};

/** Naissance */
export type Naissance = {
  __typename?: 'Naissance';
  date_naissance_benef?: Maybe<Scalars['String']['output']>;
  depart_naissance_benef?: Maybe<Scalars['String']['output']>;
  pays_naissance_benef?: Maybe<Scalars['String']['output']>;
  ville_naissance_benef?: Maybe<Scalars['String']['output']>;
};

export enum NewValidatedEReputationAlerts {
  AutoHandling = 'AUTO_HANDLING',
  ManualHandling = 'MANUAL_HANDLING',
  None = 'NONE'
}

/** Nom */
export type Nom = {
  __typename?: 'Nom';
  nom_naissance_benef?: Maybe<Scalars['String']['output']>;
  nom_usage_benef?: Maybe<Scalars['String']['output']>;
  prenoms_benef?: Maybe<Scalars['String']['output']>;
  pseudo_benef?: Maybe<Scalars['String']['output']>;
};

/** Relationships that could not be restored due to active configuration changes. This includes both roles in the strict sense, as well as elements that the front-end represents as if they were roles */
export type NonCreatedRole = {
  target: Entity;
};

export type NonCreatedStandardRole = NonCreatedRole & {
  __typename?: 'NonCreatedStandardRole';
  roleTypeCode: Scalars['String']['output'];
  source: Entity;
  target: Entity;
};

export type NonUpdatedOtherShareholders = NonCreatedRole & {
  __typename?: 'NonUpdatedOtherShareholders';
  target: Corporation;
};

export type OccupiedPepPosition = {
  __typename?: 'OccupiedPepPosition';
  endDate?: Maybe<Scalars['String']['output']>;
  pepPosition: StandardListElement;
  rcaCategory?: Maybe<StandardListElement>;
  startDate: Scalars['String']['output'];
};

/** Occupied pep position input. */
export type OccupiedPepPositionInputType = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  pepPositionCode: Scalars['String']['input'];
  rcaCategoryCode?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['String']['input'];
};

/** Other minor shareholders group */
export type OtherShareholders = {
  __typename?: 'OtherShareholders';
  attachments: Array<Attachment>;
  comment?: Maybe<Scalars['String']['output']>;
  corporationId: Scalars['ID']['output'];
  customVotingRights?: Maybe<Scalars['Float']['output']>;
  nbCorporations: Scalars['Int']['output'];
  nbPersons: Scalars['Int']['output'];
  share: Scalars['Float']['output'];
  votingRights: Scalars['Float']['output'];
};

/** Other shareholders input. */
export type OtherShareholdersInputType = {
  comment?: InputMaybe<Scalars['String']['input']>;
  customVotingRights?: InputMaybe<Scalars['Float']['input']>;
  nbCorporations: Scalars['Int']['input'];
  nbPersons: Scalars['Int']['input'];
  share: Scalars['Float']['input'];
};

export type OverloadedProperties = {
  __typename?: 'OverloadedProperties';
  filter: Filter;
  properties: Properties;
};

/** Page info. */
export type PageInfo = {
  __typename?: 'PageInfo';
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type Parameters = {
  __typename?: 'Parameters';
  beneficiaryOwnerThreshold: Scalars['String']['output'];
  capitalizationTolerance: Scalars['Float']['output'];
  complexShareholderPathThreshold: Scalars['Long']['output'];
  corpShareholderDocumentsThreshold: Scalars['Float']['output'];
  dccpApprovalRequiredLevel?: Maybe<RiskLevel>;
  documentationUrl?: Maybe<Scalars['String']['output']>;
  eReputationProvider: EReputationProvider;
  formatLanguageTag: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  languageTexts: LanguageTexts;
  missingRegistration: Scalars['String']['output'];
  personShareholderDocumentsThreshold: Scalars['Float']['output'];
  status: VersionStatus;
  textsLanguageTag: Scalars['String']['output'];
  useCountryForCorporationEReputation: Scalars['Boolean']['output'];
  useCountryForPersonEReputation: Scalars['Boolean']['output'];
  useDateOfBirthInEReputation: Scalars['Boolean']['output'];
  versionCode: Scalars['String']['output'];
  votingRightsThreshold: Scalars['String']['output'];
};

/** Participation */
export type Participation = {
  __typename?: 'Participation';
  part_directe?: Maybe<Scalars['Float']['output']>;
  part_directe_nue_prop?: Maybe<Scalars['Float']['output']>;
  part_directe_plein_prop?: Maybe<Scalars['Float']['output']>;
  part_indirect_ind_nue_prop?: Maybe<Scalars['Float']['output']>;
  part_indirect_ind_plein_prop?: Maybe<Scalars['Float']['output']>;
  part_indirect_pmor?: Maybe<Scalars['Float']['output']>;
  part_indirect_pmor_nue_prop?: Maybe<Scalars['Float']['output']>;
  part_indirect_pmor_plein_prop?: Maybe<Scalars['Float']['output']>;
  part_indirecte?: Maybe<Scalars['Float']['output']>;
  part_indirecte_ind?: Maybe<Scalars['Float']['output']>;
  part_totale?: Maybe<Scalars['Float']['output']>;
};

/** PendingStatusUpdate. Exposed for debugging purposes (internal graphql only) */
export type PendingStatusUpdate = {
  __typename?: 'PendingStatusUpdate';
  pendingLastModification: Scalars['String']['output'];
  pendingLastModifiedBy: Scalars['String']['output'];
};

/** PepEReputationAnalysis. */
export type PepEReputationAnalysis = {
  __typename?: 'PepEReputationAnalysis';
  comment?: Maybe<Scalars['String']['output']>;
  creationDate: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  occupiedPositions: Array<OccupiedPepPosition>;
};

/** Pep eReputation analysis input. */
export type PepEReputationAnalysisInputType = {
  comment?: InputMaybe<Scalars['String']['input']>;
  occupiedPositions: Array<OccupiedPepPositionInputType>;
};

/** Person. */
export type Person = DocumentableEntity & Entity & InputEntity & RiskEntity & RootEntity & SingleRootEntity & {
  __typename?: 'Person';
  adminStatus: EntityAdminStatus;
  /** Returns all documents associated with this entity */
  allDocuments: Array<Document>;
  attachments: Array<Attachment>;
  /** RootEntity content. Only if we are dealing with a customer which is a group of persons can there be more than one Entity. */
  content: Array<Entity>;
  /** The identifier of the entity in the current state. It will return its own id if this entity is not a snapshot */
  currentEntityId: Scalars['ID']['output'];
  currentVersionId?: Maybe<Scalars['ID']['output']>;
  /** RootEntity customer folders */
  customerFolders: Array<CustomerFolder>;
  dccp: Scalars['Boolean']['output'];
  /** Entity dccp alerts */
  dccpAlerts: Array<DccpAlert>;
  documentComment?: Maybe<Scalars['String']['output']>;
  /** Customer has refused to provide some supporting documents */
  documentRefusal: Scalars['Boolean']['output'];
  /** Returns all documents associated with this entity, except those that are specific to a folder or file */
  documents: Array<Document>;
  eReputation?: Maybe<Ereputation>;
  /** Entity eReputation alerts */
  eReputationAlerts: Array<EReputationAlert>;
  eReputationComment?: Maybe<Scalars['String']['output']>;
  hasAlert: Scalars['Boolean']['output'];
  historizedStakeholderProperties?: Maybe<FolderStakeholderProperties>;
  /** The id (or sharedId) of the entity. */
  id: Scalars['ID']['output'];
  /** Used inputValue by code */
  inputValue?: Maybe<InputValue>;
  /** Used inputValues by code */
  inputValues: Array<InputValue>;
  /** Person is the customer of a folder */
  isCustomer: Scalars['Boolean']['output'];
  /** isPerson flag */
  isPerson: Scalars['Boolean']['output'];
  lastValidatedEReputation?: Maybe<LastValidatedEReputation>;
  /** Person is linked to a master person */
  linked: Scalars['Boolean']['output'];
  relatedEntities: Array<RelatedEntity>;
  roles: Array<Role>;
  /**
   * Snapshot to which the object belongs.
   * Will be null if object is the current/main version and does not belong to a snapshot
   */
  snapshot?: Maybe<Snapshot>;
  /** Entity type. */
  type: EntityType;
  /** The real id of the entity (so, never a sharedId). For debugging purposes */
  underlyingId: Scalars['ID']['output'];
  whatIfSourceId?: Maybe<Scalars['ID']['output']>;
};


/** Person. */
export type PersonAllDocumentsArgs = {
  displayDocsSharingType?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Person. */
export type PersonDccpAlertsArgs = {
  onlyActiveAlerts?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Person. */
export type PersonDocumentsArgs = {
  displayDocsSharingType?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Person. */
export type PersonEReputationAlertsArgs = {
  onlyActiveAlerts?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Person. */
export type PersonInputValueArgs = {
  fieldCode: Scalars['String']['input'];
};


/** Person. */
export type PersonInputValuesArgs = {
  fieldCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Person. */
export type PersonRolesArgs = {
  direction?: InputMaybe<RoleDirection>;
};

/** A group of persons which are the co-customers of the folder. */
export type PersonGroup = InputEntity & RootEntity & {
  __typename?: 'PersonGroup';
  content: Array<Person>;
  /**
   * Id of the current version of the object.
   * Will be null if object itself is the current/main version and does not belong to a snapshot
   */
  currentVersionId?: Maybe<Scalars['ID']['output']>;
  /** RootEntity customer folders */
  customerFolders: Array<CustomerFolder>;
  /** RootEntity identifier. */
  id: Scalars['ID']['output'];
  /** Used inputValue by code */
  inputValue?: Maybe<InputValue>;
  /** Used inputValues by code */
  inputValues: Array<InputValue>;
  /** isPerson flag */
  isPerson: Scalars['Boolean']['output'];
  /** Entity type. */
  type: EntityType;
};


/** A group of persons which are the co-customers of the folder. */
export type PersonGroupInputValueArgs = {
  fieldCode: Scalars['String']['input'];
};


/** A group of persons which are the co-customers of the folder. */
export type PersonGroupInputValuesArgs = {
  fieldCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** A page of persons and page info. */
export type PersonPage = {
  __typename?: 'PersonPage';
  pageInfo: PageInfo;
  persons: Array<Person>;
};

/** A succession of Person IDs */
export type PersonsInputValue = InputValue & {
  __typename?: 'PersonsInputValue';
  /** @deprecated Use inputField (fieldType) instead */
  dataType: DataType;
  entities: Array<Person>;
  /** @deprecated Use inputField (fieldCode) instead */
  fieldCode: Scalars['String']['output'];
  inputField: InputField;
  stringValue?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use stringValue instead */
  value?: Maybe<Scalars['String']['output']>;
};

/** Any object capable of saving preferences (such as a Folder or a FolderFile) */
export type Preferenceable = {
  /** Preferenceable system identifier */
  id: Scalars['ID']['output'];
  preferences?: Maybe<Scalars['String']['output']>;
};

export type ProgressBar = {
  __typename?: 'ProgressBar';
  comment: Scalars['String']['output'];
  folderFileTypes?: Maybe<Array<Scalars['String']['output']>>;
  steps: Array<Step>;
};

export type Properties = {
  __typename?: 'Properties';
  acceptSubsidiaries?: Maybe<Scalars['Boolean']['output']>;
  requiresBeneficiaryOwner?: Maybe<Scalars['Boolean']['output']>;
  shareholding?: Maybe<Shareholding>;
};

/** RBE provider specific data */
export type ProviderData = {
  providerType: Scalars['String']['output'];
};

export type ProviderField = {
  __typename?: 'ProviderField';
  fieldCode: Scalars['String']['output'];
  key: Scalars['String']['output'];
  regexConstraint?: Maybe<RegexConstraint>;
};

/** provider information. */
export type ProviderInformation = {
  __typename?: 'ProviderInformation';
  lastInterrogationDate?: Maybe<Scalars['String']['output']>;
  providerId: Scalars['String']['output'];
  sourceId: Scalars['String']['output'];
};

/** A page of folder files tagged for purge. */
export type PurgeableFolderFilesPage = {
  __typename?: 'PurgeableFolderFilesPage';
  pageInfo: PageInfo;
  summaries: Array<PurgeableFolderFileSummary>;
};

/** Purgeable folder file summary. */
export type PurgeableFolderFileSummary = {
  __typename?: 'PurgeableFolderFileSummary';
  customer: RootEntity;
  customerFolder: CustomerFolder;
  folderFile: FolderFile;
};

export type Query = {
  __typename?: 'Query';
  /** Get list of active diligence definitions */
  activeDiligenceDefinitions: Array<DiligenceDefinition>;
  /** Searches current corporations with a search query. Search query format: '(field(<fieldCode>) : {0} and field(<fieldCode>) : {1}) or field(<fieldCode>) : {2}. <fieldCode> must be the code of an indexed field. {<index>} must be the 0-based index of the value in the values list. The list of values may contain empty strings "". In such a case, the search will look for corporations containing empty or null values. For date type fields, 4 different formats are accepted: 2021-02-25T09:50:32.230Z (the hour will be ignored), 2021-02-25, 2021-02 or 2021. */
  advancedCorporationSearch: CorporationPage;
  /** Search folder files by CP, external references and workflow status */
  advancedFolderFilesSearch: Array<FolderFile>;
  /** Searches current persons with a search query. Search query format: '(field(<fieldCode>) : {0} and field(<fieldCode>) : {1}) or field(<fieldCode>) : {2}. <fieldCode> must be the code of an indexed field. {<index>} must be the 0-based index of the value in the values list. The list of values may contain empty strings "". In such a case, the search will look for persons containing empty or null values. For date type fields, 4 different formats are accepted: 2021-02-25T09:50:32.230Z (the hour will be ignored), 2021-02-25, 2021-02 or 2021. */
  advancedPersonSearch: PersonPage;
  /** Get the assigned files of the user */
  assignedFolderFiles: FolderFilesPage;
  /** Get a attachment */
  attachment?: Maybe<Attachment>;
  /** Get city by code */
  city: City;
  /** Get a client conf element by id */
  clientConfElement: ClientConfElement;
  /** Get a client conf element by code and elementType (of the active client configuration) */
  clientConfElementByCode: ClientConfElement;
  compareCustomerGraphWithExternalData: CustomerGraphComparisonResult;
  /** Get a corporation */
  corporation?: Maybe<Corporation>;
  /** Get list of countries */
  countries: Array<Country>;
  /** Get the country risk map configuration */
  countryRiskMap: CountryRiskMapConfiguration;
  /** Get current user */
  currentUser: User;
  /** Get a customer folder */
  customerFolder?: Maybe<CustomerFolder>;
  /** Get current customerFolders: 1) containing only snapshotted files, 2) that do not have only closed missions in the current state, 3) and the latest snapshot must have at least one inactive mission. NOTE: Only the customerFolders which are visible for the the logged-in user will be returned */
  customerFoldersHavingAtLeastOneInactiveMissionInLatestSnapshot: CustomerFoldersPage;
  /** Get the customerFolders having the provided type and coCustomers. Since snapshots do not share IDs with their sources, this function should only return at most one result (more than one is forbidden). */
  customerFoldersHavingSameTypeAndCoCustomers: Array<CustomerFolder>;
  /** Get all customer folders */
  customerFoldersPage: CustomerFoldersPage;
  /** Get the customer folder types */
  customerFolderTypes: Array<CustomerFolderType>;
  /** Get list of DCCP alert types */
  dccpAlertTypes: Array<DccpAlertType>;
  /** Get the Dccp Analysis type */
  dccpAnalysisType: DccpAnalysisType;
  /** Get the Dccp FollowUp type */
  dccpFollowUpType: DccpFollowUpType;
  /** Get a document */
  document?: Maybe<Document>;
  /** Get list of document types */
  documentTypes: Array<DocumentType>;
  /** Get elementList by listElements type */
  elementList?: Maybe<ElementList>;
  /** Get an entity */
  entity?: Maybe<Entity>;
  /** Get list of entity types */
  entityTypes: Array<EntityType>;
  /** To find out how an entity is used within a customerFolder */
  entityUsageDetails: UsageDetailPage;
  /** Get an EReputationAlert */
  eReputationAlert?: Maybe<EReputationAlert>;
  /** Get all eReputation alerts and their associated entity */
  eReputationAlertsPage: EntityAndAlertPage;
  /** Get the eReputationAlert workflow configuration */
  eReputationAlertWorkflow: Workflow;
  /** Get list of eReputation analyses */
  eReputationAnalyses: Array<EReputationAnalysis>;
  /** Get external beneficial owners for RBE provider */
  externalBeneficialOwners: Array<ExternalBeneficialOwner>;
  externalDataProvidersConfiguration: ExternalDataProvidersConfiguration;
  /** Get an external document */
  externalDocument?: Maybe<ExternalDocument>;
  /** Get list of features */
  features: Features;
  /** Get Dccp Analysis by file id */
  fileDccpAnalysis?: Maybe<DccpAnalysis>;
  /** Get Dccp FollowUp by file id */
  fileDccpFollowUp?: Maybe<DccpFollowUp>;
  /** Get the file purge configuration */
  filePurgeConfig: FilePurgeConfig;
  /** To find the files in which a person or corporation has been selected in a DccpAnalysis or DccpFollowUp */
  findDccpModuleReferences: FolderFilesPage;
  /** Search for persons having the same first name, last name and birth date */
  findDuplicatedPersons: Array<Person>;
  /**
   *
   *          Search entities with given cps in current state.
   *          Returns an error if any of the cps is not unique in the database.
   *          Do not use it if cp field is not used in your configuration
   *
   */
  findEntitiesByCp: Array<Entity>;
  /**
   *
   *          Search entity with given cp in current state.
   *          Returns an error if the cp is not unique in the database.
   *          Do not use it if cp field is not used in your configuration
   *
   */
  findEntityByCp?: Maybe<Entity>;
  /**
   *
   *          Search entity with given cp2 in current state.
   *          Returns an error if the cp2 is not unique in the database.
   *          WARNING: This field is customer specific, do not use without explicit agreement of Flaminem
   *
   */
  findEntityByCp2?: Maybe<Entity>;
  /** Get a folder file */
  folderFile?: Maybe<FolderFile>;
  /** Get user scopes on file resources */
  folderFilePermissions: Array<Scope>;
  /** Get list of folderFileResources from the client's database */
  folderFileResources: Array<FolderFileResource>;
  /** Get all folder files, sorting fields only work when the search string is empty */
  folderFilesPage: FolderFilesPage;
  /** Get the files by their ids */
  folderFileSummaries: Array<FolderFileSummary>;
  /** Get list of folder file types */
  folderFileTypes: Array<FolderFileType>;
  /** To find the folders that should be deleted to fulfill RGPD requirements */
  foldersToDelete: FoldersToDeletePage;
  /** To find the customerFolders in which a person or corporation has been used (including third party folders) */
  foldersUsingEntity: CustomerFoldersPage;
  /** Get a corporation from an external data provider */
  getExternalCorporation?: Maybe<ExternalCorporation>;
  /** Get directors from an external data provider */
  getExternalDirectors?: Maybe<Array<ExternalDirector>>;
  /** Get shareholders from an external data provider */
  getExternalShareholders?: Maybe<Array<ExternalShareholder>>;
  /** Get subsidiaries from an external data provider */
  getExternalSubsidiaries?: Maybe<Array<ExternalSubsidiary>>;
  /** Get the last modified file for each current customerFolder, filtering by customerFolderType and file state (if provided) */
  lastModifiedFolderFilePerCurrentCustomerFolder: LastModifiedFolderFilePerCurrentCustomerFolderPage;
  /** Get a list of elements by elementType (InputField list), with optional searchString and familyCode. If some familyCode is provided, elements containing a different one will be excluded */
  listElements: Array<ListElement>;
  /** Get a master corporation. Possible parameters are: 'code', 'registration' */
  masterCorporation?: Maybe<MasterCorporation>;
  /** Get a master person. Possible parameters are: 'code' */
  masterPerson?: Maybe<MasterPerson>;
  /** Get all open message threads */
  openMessageThreads: MessageThreadPage;
  /** Get all open message threads assigned to groups */
  openMessageThreadsAssignedToGroups: MessageThreadPage;
  /** To find the corporations that are not linked to any customer folder */
  orphanCorporations: EntityPage;
  /** To find the persons that are not linked to any customer folder */
  orphanPersons: EntityPage;
  /** Get the customerFolders needing status update or migration, that after a configurable time (default is 12 hours) have not yet been refreshed */
  outdatedCustomerFoldersNeedingStatusUpdate: Array<CustomerFolder>;
  /** Get list of parameters */
  parameters: Parameters;
  /** Get user permissions on resource */
  permissions: Array<Scope>;
  /** Get a person */
  person?: Maybe<Person>;
  /** To list folder files tagged for purge (requires GDPR:VIEW permission) */
  purgeableFolderFiles: PurgeableFolderFilesPage;
  /** Get a Questionnaire */
  questionnaire?: Maybe<Questionnaire>;
  /** Get list of questionnaire types */
  questionnaireTypes: Array<QuestionnaireType>;
  /** Get the recent folders of the user */
  recentUserCustomerFolders: Array<CustomerFolderSummary>;
  /** Get the recent files of the user */
  recentUserFolderFiles: Array<FolderFileSummary>;
  /** Get list of related entity types */
  relatedEntityTypes: Array<RelatedEntityType>;
  /** Get the configuration of risk level colors */
  riskLevelColors: RiskLevelColorsConfiguration;
  /** Get list of role types */
  roleTypes: Array<RoleType>;
  /** Searches no-snapshotted corporations containing a given string, without specifying the search fields. In this context, exactMatch only means no wildcards. In other words, the order does not matter: Flaminem 1234 returns the same as 1234 Flaminem. Accents, capital letters and special characters are ignored in any case */
  searchCorporations: Array<Corporation>;
  /** Searches no-snapshotted entities by code field, always with exactMatch. In this context, exactMatch means that tokens belonging to a precise property must be found whole and in the same order, but additional words may exist. For example, if a person's full name is Miguel de Cervantes Saavedra, you may find him looking for Miguel as firstName and Cervantes as lastName. However, Saavedra Cervantes will return nothing, as the order is not correct. Accents, capital letters and special characters are ignored. When setting the limit, keep in mind that persons are searched first, and then corporations. Therefore, if you set a limit of 10 entities and 9 persons are found, only 1 corporation will be searched */
  searchEntitiesByFields: Array<Entity>;
  /** Searches no-snapshotted persons containing a given string, without specifying the search fields. In this context, exactMatch only means no wildcards. In other words, the order does not matter: Juan Pérez returns the same as Pérez Juan. Accents, capital letters and special characters are ignored in any case */
  searchPersons: Array<Person>;
  /** Search users */
  searchUsers: Array<User>;
  /** Get a third party folder */
  thirdPartyFolder?: Maybe<ThirdPartyFolder>;
  /** Get list of third party folder types */
  thirdPartyFolderTypes: Array<ThirdPartyFolderType>;
  /** Get the number of unread messages */
  unreadMessagesCount: Scalars['Int']['output'];
  /** Get list of user group definitions */
  userGroupDefinitions: Array<UserGroupDefinition>;
  /** Get the folderFile workflow configuration */
  workflow: Workflow;
};


export type QueryActiveDiligenceDefinitionsArgs = {
  fileTypeFilter?: InputMaybe<Scalars['String']['input']>;
  includePepOnly?: InputMaybe<Scalars['Boolean']['input']>;
  inputValuesContentFilter?: InputMaybe<Array<ConfInputValueContent>>;
  riskLevelFilter?: InputMaybe<RiskLevel>;
};


export type QueryAdvancedCorporationSearchArgs = {
  limit: Scalars['Int']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
  values: Array<Scalars['String']['input']>;
};


export type QueryAdvancedFolderFilesSearchArgs = {
  cp: Scalars['String']['input'];
  externalReference?: InputMaybe<Scalars['String']['input']>;
  stateId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdvancedPersonSearchArgs = {
  limit: Scalars['Int']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
  values: Array<Scalars['String']['input']>;
};


export type QueryAssignedFolderFilesArgs = {
  includePeerFiles?: InputMaybe<Scalars['Boolean']['input']>;
  limit: Scalars['Int']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAttachmentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCityArgs = {
  code: Scalars['String']['input'];
};


export type QueryClientConfElementArgs = {
  id: Scalars['ID']['input'];
};


export type QueryClientConfElementByCodeArgs = {
  code: Scalars['String']['input'];
  elementType: Scalars['String']['input'];
  versionCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCompareCustomerGraphWithExternalDataArgs = {
  customerFolderId: Scalars['ID']['input'];
};


export type QueryCorporationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCountriesArgs = {
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCustomerFolderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCustomerFoldersHavingAtLeastOneInactiveMissionInLatestSnapshotArgs = {
  customerFolderTypeCodesFilter?: InputMaybe<Array<Scalars['String']['input']>>;
  followedByUserIdFilter?: InputMaybe<Scalars['String']['input']>;
  lastModifierUserIdFilter?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  ownerUserIdFilter?: InputMaybe<Scalars['String']['input']>;
  sortInactiveMissionsInLatestSnapshotOfCustomerFoldersPage?: InputMaybe<Array<InactiveMissionsInLatestSnapshotOfCustomerFoldersPageSortingFieldInputType>>;
};


export type QueryCustomerFoldersHavingSameTypeAndCoCustomersArgs = {
  customerFolderTypeCode: Scalars['String']['input'];
  customerIds: Array<Scalars['ID']['input']>;
};


export type QueryCustomerFoldersPageArgs = {
  customerFolderTypeCodesFilter?: InputMaybe<Array<Scalars['String']['input']>>;
  displayOnlyFoldersNeedingUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  displayOnlyUserFolders?: InputMaybe<Scalars['Boolean']['input']>;
  limit: Scalars['Int']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchStringForCusFolder?: InputMaybe<Scalars['String']['input']>;
  sortingOrder?: InputMaybe<SortingOrder>;
};


export type QueryCustomerFolderTypesArgs = {
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDccpAlertTypesArgs = {
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDocumentTypesArgs = {
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QueryElementListArgs = {
  listElementsType: Scalars['String']['input'];
};


export type QueryEntityArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEntityTypesArgs = {
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEntityUsageDetailsArgs = {
  currentFolderId: Scalars['ID']['input'];
  entityId: Scalars['ID']['input'];
  limit: Scalars['Int']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryEReputationAlertArgs = {
  eReputationAlertId: Scalars['ID']['input'];
};


export type QueryEReputationAlertsPageArgs = {
  creationEndDate?: InputMaybe<Scalars['String']['input']>;
  creationStartDate?: InputMaybe<Scalars['String']['input']>;
  displayOnlyUserAlerts?: Scalars['Boolean']['input'];
  limit: Scalars['Int']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  origin?: InputMaybe<EReputationAlertOrigin>;
  sortingOrder?: InputMaybe<SortingOrder>;
  stateIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryEReputationAnalysesArgs = {
  categoryCode?: InputMaybe<Scalars['String']['input']>;
  providerResult?: InputMaybe<Scalars['Boolean']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QueryExternalBeneficialOwnersArgs = {
  id: Scalars['ID']['input'];
};


export type QueryExternalDocumentArgs = {
  externalDocumentId: Scalars['ID']['input'];
};


export type QueryFileDccpAnalysisArgs = {
  folderFileId: Scalars['ID']['input'];
};


export type QueryFileDccpFollowUpArgs = {
  folderFileId: Scalars['ID']['input'];
};


export type QueryFindDccpModuleReferencesArgs = {
  entityId: Scalars['ID']['input'];
  limit: Scalars['Int']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFindDuplicatedPersonsArgs = {
  birthDate: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
};


export type QueryFindEntitiesByCpArgs = {
  cps: Array<Scalars['String']['input']>;
};


export type QueryFindEntityByCpArgs = {
  cp: Scalars['String']['input'];
};


export type QueryFindEntityByCp2Args = {
  cp2: Scalars['String']['input'];
};


export type QueryFolderFileArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFolderFilesPageArgs = {
  displayOnlyUserFiles?: InputMaybe<Scalars['Boolean']['input']>;
  folderFileTypeCodesFilter?: InputMaybe<Array<Scalars['String']['input']>>;
  followedByUserIdFilter?: InputMaybe<Scalars['String']['input']>;
  lastModifierUserIdFilter?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  ownerUserIdFilter?: InputMaybe<Scalars['String']['input']>;
  searchOnFileNames?: InputMaybe<Scalars['Boolean']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  sortFolderFilesPage?: InputMaybe<Array<FolderFilesPageSortingFieldInputType>>;
  stateIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryFolderFileSummariesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryFolderFileTypesArgs = {
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFoldersToDeleteArgs = {
  limit: Scalars['Int']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFoldersUsingEntityArgs = {
  entityId: Scalars['ID']['input'];
  limit: Scalars['Int']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetExternalCorporationArgs = {
  parameters: Array<InputParameter>;
  providerId: Scalars['String']['input'];
};


export type QueryGetExternalDirectorsArgs = {
  parameters: Array<InputParameter>;
  providerId: Scalars['String']['input'];
};


export type QueryGetExternalShareholdersArgs = {
  parameters: Array<InputParameter>;
  providerId: Scalars['String']['input'];
};


export type QueryGetExternalSubsidiariesArgs = {
  parameters: Array<InputParameter>;
  providerId: Scalars['String']['input'];
};


export type QueryLastModifiedFolderFilePerCurrentCustomerFolderArgs = {
  customerFolderTypeCodesFilter?: InputMaybe<Array<Scalars['String']['input']>>;
  fileLastModifierUserIdFilter?: InputMaybe<Scalars['String']['input']>;
  fileStateIds?: InputMaybe<Array<Scalars['String']['input']>>;
  followedByUserIdFilter?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  ownerUserIdFilter?: InputMaybe<Scalars['String']['input']>;
  sortLastModifiedFolderFilePerCurrentCustomerFolderPage?: InputMaybe<Array<LastModifiedFolderFilePerCurrentCustomerFolderPageSortingFieldInputType>>;
};


export type QueryListElementsArgs = {
  elementType: Scalars['String']['input'];
  familyCode?: InputMaybe<Scalars['String']['input']>;
  includeDisabledElements?: InputMaybe<Scalars['Boolean']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMasterCorporationArgs = {
  parameters: Array<InputParameter>;
};


export type QueryMasterPersonArgs = {
  parameters: Array<InputParameter>;
};


export type QueryOpenMessageThreadsArgs = {
  displayOnlyWhenUnreadMessage: Scalars['Boolean']['input'];
  limit: Scalars['Int']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOpenMessageThreadsAssignedToGroupsArgs = {
  limit: Scalars['Int']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOrphanCorporationsArgs = {
  includeEntitiesHavingDccpAlerts?: InputMaybe<Scalars['Boolean']['input']>;
  limit: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  olderThan?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrphanPersonsArgs = {
  includeEntitiesHavingDccpAlerts?: InputMaybe<Scalars['Boolean']['input']>;
  limit: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  olderThan?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOutdatedCustomerFoldersNeedingStatusUpdateArgs = {
  limit: Scalars['Int']['input'];
  sortingOrder?: InputMaybe<SortingOrder>;
};


export type QueryPermissionsArgs = {
  resource: Resource;
};


export type QueryPersonArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPurgeableFolderFilesArgs = {
  limit: Scalars['Int']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryQuestionnaireArgs = {
  questionnaireId: Scalars['ID']['input'];
};


export type QueryQuestionnaireTypesArgs = {
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRecentUserCustomerFoldersArgs = {
  limit: Scalars['Int']['input'];
};


export type QueryRecentUserFolderFilesArgs = {
  limit: Scalars['Int']['input'];
};


export type QueryRelatedEntityTypesArgs = {
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchCorporationsArgs = {
  exactMatch?: InputMaybe<Scalars['Boolean']['input']>;
  limit: Scalars['Int']['input'];
  string: Scalars['String']['input'];
};


export type QuerySearchEntitiesByFieldsArgs = {
  input: SearchInputType;
  limit: Scalars['Int']['input'];
};


export type QuerySearchPersonsArgs = {
  exactMatch?: InputMaybe<Scalars['Boolean']['input']>;
  limit: Scalars['Int']['input'];
  string: Scalars['String']['input'];
};


export type QuerySearchUsersArgs = {
  allowedGroups?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  string?: InputMaybe<Scalars['String']['input']>;
};


export type QueryThirdPartyFolderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryThirdPartyFolderTypesArgs = {
  searchString?: InputMaybe<Scalars['String']['input']>;
};

export type QuestAxisStatus = {
  __typename?: 'QuestAxisStatus';
  axisName: Scalars['String']['output'];
  dccpApprovalRequired: Scalars['Boolean']['output'];
  itemCounts: Scalars['Int']['output'];
  risks: Array<QuestRisk>;
  score: Scalars['Int']['output'];
  weight: Scalars['Float']['output'];
};

/** Questionnaire. */
export type Questionnaire = RiskEntity & {
  __typename?: 'Questionnaire';
  adminStatus: AdminStatus;
  content?: Maybe<Scalars['String']['output']>;
  currentVersionId?: Maybe<Scalars['ID']['output']>;
  hasContent: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isEditable: Scalars['Boolean']['output'];
  isLinkedToPerson: Scalars['Boolean']['output'];
  lastReopenBy?: Maybe<User>;
  lastReopenDate?: Maybe<Scalars['String']['output']>;
  previousVersions: Array<Questionnaire>;
  /** This field has been added for debugging purposes and will be deleted one day, so do not use it in your code */
  rawContent?: Maybe<Scalars['String']['output']>;
  riskStatus?: Maybe<QuestRiskStatus>;
  /**
   * Snapshot to which the object belongs.
   * Will be null if object is the current/main version and does not belong to a snapshot
   */
  snapshot?: Maybe<Snapshot>;
  type: QuestionnaireType;
  validatedBy?: Maybe<User>;
  validationDate?: Maybe<Scalars['String']['output']>;
  /** Risk entity whatIf source identifier. */
  whatIfSourceId?: Maybe<Scalars['ID']['output']>;
};

/** Any object capable of having questionnaires (such as a Folder or a FolderFile) */
export type Questionnaireable = {
  /** Used inputValue by code */
  inputValue?: Maybe<InputValue>;
  /** Used inputValues by code */
  inputValues: Array<InputValue>;
  questionnaires: Array<Questionnaire>;
};


/** Any object capable of having questionnaires (such as a Folder or a FolderFile) */
export type QuestionnaireableInputValueArgs = {
  fieldCode: Scalars['String']['input'];
};


/** Any object capable of having questionnaires (such as a Folder or a FolderFile) */
export type QuestionnaireableInputValuesArgs = {
  fieldCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type QuestionnaireType = ClientConfElement & HistorizedClientConfElement & ListElement & {
  __typename?: 'QuestionnaireType';
  category?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  corpRiskConfiguration?: Maybe<Scalars['String']['output']>;
  corpSchema: Scalars['String']['output'];
  disabled: Scalars['Boolean']['output'];
  disabledComment?: Maybe<Scalars['String']['output']>;
  documentFilter?: Maybe<Scalars['String']['output']>;
  /** element type */
  elementType: Scalars['String']['output'];
  excludeFromPortal: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  ordinal: Scalars['Long']['output'];
  personRiskConfiguration?: Maybe<Scalars['String']['output']>;
  personSchema: Scalars['String']['output'];
  status: VersionStatus;
  uiCorpSchema: Scalars['String']['output'];
  uiPersonSchema: Scalars['String']['output'];
  versionCode: Scalars['String']['output'];
};

/** QuestRisk */
export type QuestRisk = {
  __typename?: 'QuestRisk';
  dccpApprovalRequired: Scalars['Boolean']['output'];
  item: QuestRiskItem;
  score: Scalars['Int']['output'];
};

export type QuestRiskDetail = {
  __typename?: 'QuestRiskDetail';
  axesStatus: Array<QuestAxisStatus>;
};

export type QuestRiskItem = {
  __typename?: 'QuestRiskItem';
  path: Scalars['String']['output'];
};

/** QuestRiskStatus */
export type QuestRiskStatus = {
  __typename?: 'QuestRiskStatus';
  dccpApprovalRequired: Scalars['Boolean']['output'];
  globalScore: Scalars['Int']['output'];
  jsonRiskDetail?: Maybe<Scalars['String']['output']>;
  riskDetail: QuestRiskDetail;
};

export type RecreateRolesResult = {
  __typename?: 'RecreateRolesResult';
  currentCustomerFolder: CustomerFolder;
  nonCreatedRoles: Array<NonCreatedRole>;
};

export type RegexConstraint = {
  __typename?: 'RegexConstraint';
  languageTextKey?: Maybe<Scalars['String']['output']>;
  pattern: Scalars['String']['output'];
};

/** RelatedEntity. */
export type RelatedEntity = {
  __typename?: 'RelatedEntity';
  entity: Entity;
  relationDescription?: Maybe<Scalars['String']['output']>;
  type?: Maybe<RelatedEntityType>;
};

export type RelatedEntityType = ClientConfElement & HistorizedClientConfElement & ListElement & {
  __typename?: 'RelatedEntityType';
  category?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  disabled: Scalars['Boolean']['output'];
  disabledComment?: Maybe<Scalars['String']['output']>;
  documentFilter?: Maybe<Scalars['String']['output']>;
  /** element type */
  elementType: Scalars['String']['output'];
  iconName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  ordinal: Scalars['Long']['output'];
  requiresDescription: Scalars['Boolean']['output'];
  status: VersionStatus;
  versionCode: Scalars['String']['output'];
};

export enum Resource {
  AlternateFolderFiles1 = 'AlternateFolderFiles1',
  AlternateFolderFiles10 = 'AlternateFolderFiles10',
  AlternateFolderFiles2 = 'AlternateFolderFiles2',
  AlternateFolderFiles3 = 'AlternateFolderFiles3',
  AlternateFolderFiles4 = 'AlternateFolderFiles4',
  AlternateFolderFiles5 = 'AlternateFolderFiles5',
  AlternateFolderFiles6 = 'AlternateFolderFiles6',
  AlternateFolderFiles7 = 'AlternateFolderFiles7',
  AlternateFolderFiles8 = 'AlternateFolderFiles8',
  AlternateFolderFiles9 = 'AlternateFolderFiles9',
  ClientConfiguration = 'ClientConfiguration',
  CustomerFolder = 'CustomerFolder',
  DataFile = 'DataFile',
  Dccp = 'Dccp',
  DocumentsStorage = 'DocumentsStorage',
  EReputation = 'EReputation',
  EReputationAlerts = 'EReputationAlerts',
  Gdpr = 'GDPR',
  ImportExport = 'ImportExport',
  PepEReputationAnalysis = 'PepEReputationAnalysis',
  Questionnaire = 'Questionnaire',
  Reporting = 'Reporting',
  Stakeholders = 'Stakeholders'
}

export type ResultSelection = {
  __typename?: 'ResultSelection';
  noResult: Scalars['Boolean']['output'];
  resultId?: Maybe<Scalars['String']['output']>;
};

/** Risk */
export type Risk = {
  __typename?: 'Risk';
  dccpApprovalRequired: Scalars['Boolean']['output'];
  element?: Maybe<ClientConfElement>;
  entity: RiskEntity;
  item: RiskItem;
  score: Scalars['Int']['output'];
};

export enum RiskCategory {
  Category1 = 'Category1',
  Category2 = 'Category2',
  Category3 = 'Category3',
  Category4 = 'Category4',
  Category5 = 'Category5',
  CriticalAxis = 'CriticalAxis',
  CriticalGlobal = 'CriticalGlobal',
  HighAxis = 'HighAxis',
  HighGlobal = 'HighGlobal',
  NormalAxis = 'NormalAxis',
  NormalGlobal = 'NormalGlobal',
  VeryHighAxis = 'VeryHighAxis',
  VeryHighGlobal = 'VeryHighGlobal'
}

export enum RiskChangeOrigin {
  AutomaticEreputationAlert = 'AUTOMATIC_EREPUTATION_ALERT',
  FileValidation = 'FILE_VALIDATION',
  ManualEreputationAlert = 'MANUAL_EREPUTATION_ALERT',
  OperationTerminated = 'OPERATION_TERMINATED',
  PublishRequest = 'PUBLISH_REQUEST',
  Reopen = 'REOPEN'
}

export type RiskDetail = {
  __typename?: 'RiskDetail';
  axesStatus: Array<AxisStatus>;
  criticalRiskLevelThreshold?: Maybe<Scalars['Int']['output']>;
  highRiskLevelThreshold?: Maybe<Scalars['Int']['output']>;
  /** Not used for risk calculation */
  maxRiskLevelThreshold: Scalars['Int']['output'];
  normalRiskLevelThreshold: Scalars['Int']['output'];
  veryHighRiskLevelThreshold?: Maybe<Scalars['Int']['output']>;
};

/** An entity which can have risk attached */
export type RiskEntity = {
  /** Risk entity current version identifier. */
  currentVersionId?: Maybe<Scalars['ID']['output']>;
  /** The id of the entity. */
  id: Scalars['ID']['output'];
  /** Risk entity whatIf source identifier. */
  whatIfSourceId?: Maybe<Scalars['ID']['output']>;
};

export enum RiskEntityType {
  Customer = 'CUSTOMER',
  CustomerFolder = 'CUSTOMER_FOLDER',
  Folder = 'FOLDER',
  FolderFile = 'FOLDER_FILE',
  Stakeholder = 'STAKEHOLDER'
}

export enum RiskItem {
  Activity = 'Activity',
  ActivityArea = 'ActivityArea',
  AdverseMedia = 'AdverseMedia',
  CitizenshipCountry = 'CitizenshipCountry',
  ComplexShareholding = 'ComplexShareholding',
  ConnectionChannel = 'ConnectionChannel',
  ConnectionDate = 'ConnectionDate',
  CorporationLegalForm = 'CorporationLegalForm',
  CorporationLifeStatus = 'CorporationLifeStatus',
  CustomBoolean1 = 'CustomBoolean1',
  CustomBoolean10 = 'CustomBoolean10',
  CustomBoolean2 = 'CustomBoolean2',
  CustomBoolean3 = 'CustomBoolean3',
  CustomBoolean4 = 'CustomBoolean4',
  CustomBoolean5 = 'CustomBoolean5',
  CustomBoolean6 = 'CustomBoolean6',
  CustomBoolean7 = 'CustomBoolean7',
  CustomBoolean8 = 'CustomBoolean8',
  CustomBoolean9 = 'CustomBoolean9',
  CustomCountries1 = 'CustomCountries1',
  CustomCountries10 = 'CustomCountries10',
  CustomCountries2 = 'CustomCountries2',
  CustomCountries3 = 'CustomCountries3',
  CustomCountries4 = 'CustomCountries4',
  CustomCountries5 = 'CustomCountries5',
  CustomCountries6 = 'CustomCountries6',
  CustomCountries7 = 'CustomCountries7',
  CustomCountries8 = 'CustomCountries8',
  CustomCountries9 = 'CustomCountries9',
  CustomCountry1 = 'CustomCountry1',
  CustomCountry10 = 'CustomCountry10',
  CustomCountry2 = 'CustomCountry2',
  CustomCountry3 = 'CustomCountry3',
  CustomCountry4 = 'CustomCountry4',
  CustomCountry5 = 'CustomCountry5',
  CustomCountry6 = 'CustomCountry6',
  CustomCountry7 = 'CustomCountry7',
  CustomCountry8 = 'CustomCountry8',
  CustomCountry9 = 'CustomCountry9',
  CustomerCreationDate = 'CustomerCreationDate',
  CustomerFolderQuestionnaire = 'CustomerFolderQuestionnaire',
  CustomInt = 'CustomInt',
  CustomListElement1 = 'CustomListElement1',
  CustomListElement10 = 'CustomListElement10',
  CustomListElement11 = 'CustomListElement11',
  CustomListElement12 = 'CustomListElement12',
  CustomListElement13 = 'CustomListElement13',
  CustomListElement14 = 'CustomListElement14',
  CustomListElement15 = 'CustomListElement15',
  CustomListElement16 = 'CustomListElement16',
  CustomListElement17 = 'CustomListElement17',
  CustomListElement18 = 'CustomListElement18',
  CustomListElement19 = 'CustomListElement19',
  CustomListElement2 = 'CustomListElement2',
  CustomListElement20 = 'CustomListElement20',
  CustomListElement21 = 'CustomListElement21',
  CustomListElement22 = 'CustomListElement22',
  CustomListElement23 = 'CustomListElement23',
  CustomListElement24 = 'CustomListElement24',
  CustomListElement25 = 'CustomListElement25',
  CustomListElement26 = 'CustomListElement26',
  CustomListElement27 = 'CustomListElement27',
  CustomListElement28 = 'CustomListElement28',
  CustomListElement29 = 'CustomListElement29',
  CustomListElement3 = 'CustomListElement3',
  CustomListElement30 = 'CustomListElement30',
  CustomListElement31 = 'CustomListElement31',
  CustomListElement32 = 'CustomListElement32',
  CustomListElement33 = 'CustomListElement33',
  CustomListElement34 = 'CustomListElement34',
  CustomListElement35 = 'CustomListElement35',
  CustomListElement36 = 'CustomListElement36',
  CustomListElement37 = 'CustomListElement37',
  CustomListElement38 = 'CustomListElement38',
  CustomListElement39 = 'CustomListElement39',
  CustomListElement4 = 'CustomListElement4',
  CustomListElement40 = 'CustomListElement40',
  CustomListElement5 = 'CustomListElement5',
  CustomListElement6 = 'CustomListElement6',
  CustomListElement7 = 'CustomListElement7',
  CustomListElement8 = 'CustomListElement8',
  CustomListElement9 = 'CustomListElement9',
  CustomListElements1 = 'CustomListElements1',
  CustomListElements10 = 'CustomListElements10',
  CustomListElements11 = 'CustomListElements11',
  CustomListElements12 = 'CustomListElements12',
  CustomListElements13 = 'CustomListElements13',
  CustomListElements14 = 'CustomListElements14',
  CustomListElements15 = 'CustomListElements15',
  CustomListElements16 = 'CustomListElements16',
  CustomListElements17 = 'CustomListElements17',
  CustomListElements18 = 'CustomListElements18',
  CustomListElements19 = 'CustomListElements19',
  CustomListElements1Bis = 'CustomListElements1Bis',
  CustomListElements2 = 'CustomListElements2',
  CustomListElements20 = 'CustomListElements20',
  CustomListElements21 = 'CustomListElements21',
  CustomListElements22 = 'CustomListElements22',
  CustomListElements23 = 'CustomListElements23',
  CustomListElements24 = 'CustomListElements24',
  CustomListElements25 = 'CustomListElements25',
  CustomListElements26 = 'CustomListElements26',
  CustomListElements27 = 'CustomListElements27',
  CustomListElements28 = 'CustomListElements28',
  CustomListElements29 = 'CustomListElements29',
  CustomListElements3 = 'CustomListElements3',
  CustomListElements30 = 'CustomListElements30',
  CustomListElements31 = 'CustomListElements31',
  CustomListElements32 = 'CustomListElements32',
  CustomListElements33 = 'CustomListElements33',
  CustomListElements34 = 'CustomListElements34',
  CustomListElements35 = 'CustomListElements35',
  CustomListElements36 = 'CustomListElements36',
  CustomListElements37 = 'CustomListElements37',
  CustomListElements38 = 'CustomListElements38',
  CustomListElements39 = 'CustomListElements39',
  CustomListElements4 = 'CustomListElements4',
  CustomListElements40 = 'CustomListElements40',
  CustomListElements5 = 'CustomListElements5',
  CustomListElements6 = 'CustomListElements6',
  CustomListElements7 = 'CustomListElements7',
  CustomListElements8 = 'CustomListElements8',
  CustomListElements9 = 'CustomListElements9',
  Dccp = 'dccp',
  DocumentMissing = 'DocumentMissing',
  DocumentRefusal = 'DocumentRefusal',
  EntityType = 'EntityType',
  EReputation = 'EReputation',
  FolderFileQuestionnaire = 'FolderFileQuestionnaire',
  FolderFileType = 'FolderFileType',
  FolderUpdateFileDocumentMissing = 'FolderUpdateFileDocumentMissing',
  FolderUpdateFileDocumentRefusal = 'FolderUpdateFileDocumentRefusal',
  Fund = 'Fund',
  FundingAmount = 'FundingAmount',
  FundingCountries = 'FundingCountries',
  FundingCurrency = 'FundingCurrency',
  FundingFileDocumentMissing = 'FundingFileDocumentMissing',
  FundingFileDocumentRefusal = 'FundingFileDocumentRefusal',
  FundingProductType = 'FundingProductType',
  FundingProductTypes = 'FundingProductTypes',
  FundingPurpose = 'FundingPurpose',
  FundingPurposes = 'FundingPurposes',
  FundOrigin = 'FundOrigin',
  FundOrigin2 = 'FundOrigin2',
  Funds = 'Funds',
  GlobalPatrimony = 'GlobalPatrimony',
  GrossAmount = 'GrossAmount',
  KycReviewIsFailure = 'KycReviewIsFailure',
  MidifStatus = 'MidifStatus',
  MissionType = 'MissionType',
  NetIncome = 'NetIncome',
  OperationAmount = 'OperationAmount',
  OperationCountries = 'OperationCountries',
  OperationFileDocumentMissing = 'OperationFileDocumentMissing',
  OperationFileDocumentRefusal = 'OperationFileDocumentRefusal',
  OperationPurpose = 'OperationPurpose',
  OperationPurposes = 'OperationPurposes',
  OtherIncome = 'OtherIncome',
  OutstandingAmount = 'OutstandingAmount',
  PatrimonyOrigin = 'PatrimonyOrigin',
  PatrimonyOrigin2 = 'PatrimonyOrigin2',
  PaymentMethod = 'PaymentMethod',
  Pep = 'PEP',
  PersonCustomer = 'PersonCustomer',
  PersonLegalForm = 'PersonLegalForm',
  ProductType = 'ProductType',
  ProductTypes = 'ProductTypes',
  Profession = 'Profession',
  RegistrationCountry = 'RegistrationCountry',
  ResidenceCountry = 'ResidenceCountry',
  Sanction = 'Sanction',
  SinglePatrimonyOrigin = 'SinglePatrimonyOrigin',
  SinglePatrimonyOrigin2 = 'SinglePatrimonyOrigin2',
  SpecialFolderFileCases = 'SpecialFolderFileCases',
  SpecialInterest = 'SpecialInterest',
  SpecialShareHoldingCases = 'SpecialShareHoldingCases',
  ThirdPartyFunding = 'ThirdPartyFunding'
}

export type RiskItemCount = {
  __typename?: 'RiskItemCount';
  count: Scalars['Int']['output'];
  riskEntityType: RiskEntityType;
};

export enum RiskLevel {
  Critical = 'CRITICAL',
  High = 'HIGH',
  Low = 'LOW',
  Normal = 'NORMAL',
  Veryhigh = 'VERYHIGH'
}

export type RiskLevelColorsConfiguration = ClientConfElement & {
  __typename?: 'RiskLevelColorsConfiguration';
  code: Scalars['String']['output'];
  criticalLevelColor: Scalars['String']['output'];
  /** Has the element been disabled */
  disabled: Scalars['Boolean']['output'];
  /** A comment about element disabling */
  disabledComment?: Maybe<Scalars['String']['output']>;
  /** element type */
  elementType: Scalars['String']['output'];
  highLevelColor: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lowLevelColor: Scalars['String']['output'];
  name: Scalars['String']['output'];
  normalLevelColor: Scalars['String']['output'];
  veryHighLevelColor: Scalars['String']['output'];
};

/** Folder or file risk status */
export type RiskStatus = {
  dccpApprovalRequired: Scalars['Boolean']['output'];
  forcedRisk?: Maybe<ForcedRisk>;
  globalRiskLevel: RiskLevel;
  globalScore: Scalars['Int']['output'];
  riskDetail: RiskDetail;
  standardRiskLevel: RiskLevel;
};

export type RiskValue = {
  __typename?: 'RiskValue';
  dccp: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  riskCategory: RiskCategory;
};

export type RiskValueDisplay = {
  __typename?: 'RiskValueDisplay';
  displays: Array<Display>;
  name: Scalars['String']['output'];
  resource: Resource;
  riskValueKey: Scalars['String']['output'];
};

/** Role between two entities, regardless of their folders. */
export type Role = AbstractRole & {
  __typename?: 'Role';
  customVotingRights?: Maybe<Scalars['Float']['output']>;
  directBeneficiaryOwner?: Maybe<DirectBeneficiaryOwner>;
  /** Relation entity type */
  relatedEntityType?: Maybe<RelatedEntityType>;
  relationDescription?: Maybe<Scalars['String']['output']>;
  /** Role type */
  roleType: RoleType;
  share?: Maybe<Scalars['Float']['output']>;
  /** Source entity */
  sourceEntity?: Maybe<Entity>;
  subsidiaryTotalShare?: Maybe<Scalars['Float']['output']>;
  /** Subsidiary type */
  subsidiaryType?: Maybe<SubsidiaryType>;
  /** Target entity */
  targetEntity?: Maybe<Entity>;
  /** Voting rights */
  votingRights?: Maybe<Scalars['Float']['output']>;
};

export enum RoleDirection {
  In = 'IN',
  Out = 'OUT'
}

/** Role input. */
export type RoleInputType = {
  customVotingRights?: InputMaybe<Scalars['Float']['input']>;
  directBeneficiaryOwnerInput?: InputMaybe<DirectBeneficiaryOwnerInput>;
  relatedEntityTypeCode?: InputMaybe<Scalars['String']['input']>;
  relatedEntityTypeId?: InputMaybe<Scalars['ID']['input']>;
  relationDescription?: InputMaybe<Scalars['String']['input']>;
  share?: InputMaybe<Scalars['Float']['input']>;
  subsidiaryTotalShare?: InputMaybe<Scalars['Float']['input']>;
  subsidiaryTypeCode?: InputMaybe<Scalars['String']['input']>;
  subsidiaryTypeId?: InputMaybe<Scalars['ID']['input']>;
  typeCode?: InputMaybe<Scalars['String']['input']>;
  typeId?: InputMaybe<Scalars['ID']['input']>;
};

/** Role input type. */
export type RoleInputView = {
  __typename?: 'RoleInputView';
  customVotingRights?: Maybe<Scalars['Float']['output']>;
  directBeneficiaryOwnerInput?: Maybe<DirectBeneficiaryOwnerInputType>;
  relatedEntityTypeCode?: Maybe<Scalars['String']['output']>;
  relatedEntityTypeId?: Maybe<Scalars['ID']['output']>;
  relationDescription?: Maybe<Scalars['String']['output']>;
  share?: Maybe<Scalars['Float']['output']>;
  typeCode?: Maybe<Scalars['String']['output']>;
  typeId?: Maybe<Scalars['ID']['output']>;
};

export type RoleType = {
  __typename?: 'RoleType';
  code: Scalars['String']['output'];
  disabled: Scalars['Boolean']['output'];
  disabledComment?: Maybe<Scalars['String']['output']>;
  help?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** The customer or the thirdParty of some folder, in other words, the root of a stakeholders graph. */
export type RootEntity = {
  /** RootEntity content. Only if we are dealing with a customer which is a group of persons can there be more than one Entity. */
  content: Array<Entity>;
  /**
   * Id of the current version of the object.
   * Will be null if object itself is the current/main version and does not belong to a snapshot
   */
  currentVersionId?: Maybe<Scalars['ID']['output']>;
  /** RootEntity customer folders */
  customerFolders: Array<CustomerFolder>;
  /** RootEntity identifier. */
  id: Scalars['ID']['output'];
  /** Used inputValue by code */
  inputValue?: Maybe<InputValue>;
  /** Used inputValues by code */
  inputValues: Array<InputValue>;
  /** isPerson flag */
  isPerson: Scalars['Boolean']['output'];
  /** Entity type. */
  type: EntityType;
};


/** The customer or the thirdParty of some folder, in other words, the root of a stakeholders graph. */
export type RootEntityInputValueArgs = {
  fieldCode: Scalars['String']['input'];
};


/** The customer or the thirdParty of some folder, in other words, the root of a stakeholders graph. */
export type RootEntityInputValuesArgs = {
  fieldCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** A scalar input value */
export type ScalarInputValue = InputValue & {
  __typename?: 'ScalarInputValue';
  /** @deprecated Use inputField (fieldType) instead */
  dataType: DataType;
  /** @deprecated Use inputField (fieldCode) instead */
  fieldCode: Scalars['String']['output'];
  inputField: InputField;
  stringValue?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use stringValue instead */
  value?: Maybe<Scalars['String']['output']>;
};

export enum Scope {
  Action1 = 'action1',
  Action2 = 'action2',
  Action3 = 'action3',
  Create = 'create',
  CreateRestrictedThread = 'create_restricted_thread',
  CreateThread = 'create_thread',
  Dccp = 'dccp',
  Delete = 'delete',
  Disable = 'disable',
  Edit = 'edit',
  ForceLinked = 'forceLinked',
  ForceMalwareDownload = 'forceMalwareDownload',
  ForceRiskLevel = 'forceRiskLevel',
  Reinstruction = 'reinstruction',
  Reopen = 'reopen',
  Replace = 'replace',
  Run = 'run',
  Terminate = 'terminate',
  UpdateFolderRisk = 'update_folder_risk',
  Usage = 'usage',
  UsageDocuments = 'usage_documents',
  Validate = 'validate',
  View = 'view',
  ViewFactivaContent = 'viewFactivaContent'
}

/** Input to search for Persons and Corporations (by specifying the value of their properties). */
export type SearchInputType = {
  searchValues: Array<SearchValueInputType>;
};

export type SearchValueInputType = {
  field: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type Sender = {
  __typename?: 'Sender';
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** Shareholder. */
export type Shareholder = {
  __typename?: 'Shareholder';
  customVotingRights?: Maybe<Scalars['Float']['output']>;
  entity: Entity;
  share: Scalars['Float']['output'];
  votingRights: Scalars['Float']['output'];
};

export enum Shareholding {
  Forbidden = 'Forbidden',
  Optional = 'Optional',
  Required = 'Required'
}

/** A rootEntity consisting of a single entity */
export type SingleRootEntity = {
  /** RootEntity content. Only if we are dealing with a customer which is a group of persons can there be more than one Entity. */
  content: Array<Entity>;
  /**
   * Id of the current version of the object.
   * Will be null if object itself is the current/main version and does not belong to a snapshot
   */
  currentVersionId?: Maybe<Scalars['ID']['output']>;
  /** RootEntity customer folders */
  customerFolders: Array<CustomerFolder>;
  /** RootEntity identifier. */
  id: Scalars['ID']['output'];
  /** Used inputValue by code */
  inputValue?: Maybe<InputValue>;
  /** Used inputValues by code */
  inputValues: Array<InputValue>;
  /** isPerson flag */
  isPerson: Scalars['Boolean']['output'];
  /** Entity type. */
  type: EntityType;
};


/** A rootEntity consisting of a single entity */
export type SingleRootEntityInputValueArgs = {
  fieldCode: Scalars['String']['input'];
};


/** A rootEntity consisting of a single entity */
export type SingleRootEntityInputValuesArgs = {
  fieldCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum SingleUserAssignment {
  Mandatory = 'MANDATORY',
  No = 'NO',
  Optional = 'OPTIONAL'
}

/** Snapshot of a customer folder and all its content */
export type Snapshot = {
  __typename?: 'Snapshot';
  folderFile: FolderFile;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/** Société de gestion */
export type SocieteGestion = {
  __typename?: 'SocieteGestion';
  adresse_siege_societe_gestion?: Maybe<Scalars['String']['output']>;
  code_postal_societe_gestion?: Maybe<Scalars['String']['output']>;
  greffe_societe_gestion?: Maybe<Scalars['String']['output']>;
  nom_societe_gestion?: Maybe<Scalars['String']['output']>;
  siren_societe_gestion?: Maybe<Scalars['String']['output']>;
  ville_societe_gestion?: Maybe<Scalars['String']['output']>;
};

export enum SortingOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum StakeholdersIdentification {
  Forbidden = 'FORBIDDEN',
  Optional = 'OPTIONAL',
  Required = 'REQUIRED'
}

/** Standard list element. */
export type StandardListElement = ClientConfElement & HistorizedClientConfElement & ListElement & ListElementWithFamily & ListElementWithRisk & {
  __typename?: 'StandardListElement';
  category?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  disabled: Scalars['Boolean']['output'];
  disabledComment?: Maybe<Scalars['String']['output']>;
  documentFilter?: Maybe<Scalars['String']['output']>;
  /** element type */
  elementType: Scalars['String']['output'];
  family?: Maybe<Family>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  ordinal: Scalars['Long']['output'];
  /** It always contains at least one element */
  riskValues: Array<RiskValue>;
  status: VersionStatus;
  versionCode: Scalars['String']['output'];
};

/** Folder file workflow state */
export type State = WorkflowState & {
  __typename?: 'State';
  allowForcingRisk: Scalars['Boolean']['output'];
  assignableUserGroups: Array<Scalars['String']['output']>;
  automaticDccpAnalysis?: Maybe<AutomaticDccpAnalysis>;
  canceled: Scalars['Boolean']['output'];
  closed: Scalars['Boolean']['output'];
  code: Scalars['String']['output'];
  dccpFollowUp: Scalars['Boolean']['output'];
  editable: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  kycReviewStatus: KycReviewStatus;
  name: Scalars['String']['output'];
  singleUserAssignment: SingleUserAssignment;
  terminated: Scalars['Boolean']['output'];
  updateFolderRiskStatus: Scalars['Boolean']['output'];
};

export type Step = {
  __typename?: 'Step';
  dccpApprovalRequired?: Maybe<Scalars['Boolean']['output']>;
  states: Array<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

/**
 * Used to describe the relationship between a customer and its subsidiaries, as well as the subsidiaries of these subsidiaries.
 *                       This is not the same as a ThirdPartyFolderType with the boolean subsidiary set to true.
 */
export type SubsidiaryType = ClientConfElement & HistorizedClientConfElement & ListElement & {
  __typename?: 'SubsidiaryType';
  category?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  disabled: Scalars['Boolean']['output'];
  disabledComment?: Maybe<Scalars['String']['output']>;
  documentFilter?: Maybe<Scalars['String']['output']>;
  /** element type */
  elementType: Scalars['String']['output'];
  iconName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  ignorableSupportingDocuments: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  ordinal: Scalars['Long']['output'];
  status: VersionStatus;
  versionCode: Scalars['String']['output'];
};

export type SubTotal = {
  __typename?: 'SubTotal';
  name: Scalars['String']['output'];
  riskLevel: RiskLevel;
  /** All risks except those with a score of 0 */
  risks: Array<WeightedRisk>;
  score: Scalars['Int']['output'];
};

/** Questionnaire expected for this type of inputEntity, as well as the saved questionnaire if any */
export type SupportingQuestionnaire = {
  __typename?: 'SupportingQuestionnaire';
  questionnaire?: Maybe<Questionnaire>;
  type: QuestionnaireType;
};

export type TemplateId = Body & {
  __typename?: 'TemplateId';
  id: Scalars['Long']['output'];
  variables: Array<Variable>;
};

/** Third party folder. */
export type ThirdPartyFolder = DocumentableEntity & FieldCompletion & FileFolder & Folder & InputEntity & Preferenceable & RiskEntity & {
  __typename?: 'ThirdPartyFolder';
  adminStatus: AdminStatus;
  /** Returns all documents associated with this entity */
  allDocuments: Array<Document>;
  attachments: Array<Attachment>;
  availableRequiredFields: Scalars['Int']['output'];
  /** beneficial owners provider link */
  beneficialOwnersProviderLink?: Maybe<BeneficialOwnersProviderLink>;
  completionStatus: FolderCompletionStatus;
  complexShareholding: Scalars['Boolean']['output'];
  /** The mode by which beneficiary owners that are not automatically computed by the application can be selected. This depends on both the folderType and the fileType, if any */
  contextualManualBeneficiaryOwnerIdentificationMode: ManualBeneficiaryOwnerIdentificationMode;
  /** All the corporations linked to the Customer (of the CustomerFolder) or the ThirdParty (of the ThirdPartyFolder) */
  corporations: Array<Corporation>;
  currentVersionId?: Maybe<Scalars['ID']['output']>;
  disabledValues: Scalars['Int']['output'];
  documentComment?: Maybe<Scalars['String']['output']>;
  documentRefusal: Scalars['Boolean']['output'];
  /** Returns all documents associated with this entity, except those that are specific to a folder or file */
  documents: Array<Document>;
  file: FolderFile;
  /** The file linked to the folder */
  folderFile: FolderFile;
  /** All the files linked to the customer folder */
  folderFiles: CustomerFolderFilesPage;
  id: Scalars['ID']['output'];
  /** Used inputValue by code */
  inputValue?: Maybe<InputValue>;
  /** Used inputValues by code */
  inputValues: Array<InputValue>;
  /** All the persons linked to the Customer (of the CustomerFolder) or the ThirdParty (of the ThirdPartyFolder) */
  persons: Array<Person>;
  preferences?: Maybe<Scalars['String']['output']>;
  requiredFields: Scalars['Int']['output'];
  /** The Customer (of the CustomerFolder) or the ThirdParty (of the ThirdPartyFolder) */
  rootEntity: RootEntity;
  /**
   * Snapshot to which the object belongs.
   * Will be null if object is the current/main version and does not belong to a snapshot
   */
  snapshot?: Maybe<Snapshot>;
  /** All the stakeholders linked to the Customer (of the CustomerFolder) or the ThirdParty (of the ThirdPartyFolder) */
  stakeholders: Array<FolderStakeholder>;
  stakeholdersWithName: Array<FolderStakeholder>;
  supportingDocuments: Array<ExpectedDocument>;
  thirdParty: SingleRootEntity;
  thirdPartyFolderType: ThirdPartyFolderType;
  /** Risk entity whatIf source identifier. */
  whatIfSourceId?: Maybe<Scalars['ID']['output']>;
};


/** Third party folder. */
export type ThirdPartyFolderAllDocumentsArgs = {
  displayDocsSharingType?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Third party folder. */
export type ThirdPartyFolderDocumentsArgs = {
  displayDocsSharingType?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Third party folder. */
export type ThirdPartyFolderFolderFilesArgs = {
  limit: Scalars['Int']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


/** Third party folder. */
export type ThirdPartyFolderInputValueArgs = {
  fieldCode: Scalars['String']['input'];
};


/** Third party folder. */
export type ThirdPartyFolderInputValuesArgs = {
  fieldCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Third party folder. */
export type ThirdPartyFolderStakeholdersWithNameArgs = {
  name: Scalars['String']['input'];
};

/** Third party folder. */
export type ThirdPartyFolderType = ClientConfElement & HistorizedClientConfElement & ListElement & {
  __typename?: 'ThirdPartyFolderType';
  acceptWhatIf: Scalars['Boolean']['output'];
  category?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  disabled: Scalars['Boolean']['output'];
  disabledComment?: Maybe<Scalars['String']['output']>;
  documentFilter?: Maybe<Scalars['String']['output']>;
  /** element type */
  elementType: Scalars['String']['output'];
  iconName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  ignoreSupportingDocuments: Scalars['Boolean']['output'];
  includeShareholders: Scalars['Boolean']['output'];
  inputFields: Array<InputField>;
  inputForm?: Maybe<InputForm>;
  manualBeneficiaryOwnerIdentificationMode: ManualBeneficiaryOwnerIdentificationMode;
  name: Scalars['String']['output'];
  ordinal: Scalars['Long']['output'];
  stakeholdersIdentification: StakeholdersIdentification;
  status: VersionStatus;
  subsidiary: Scalars['Boolean']['output'];
  versionCode: Scalars['String']['output'];
};


/** Third party folder. */
export type ThirdPartyFolderTypeInputFormArgs = {
  key: Scalars['String']['input'];
};

/** Titulaire */
export type Titu = {
  __typename?: 'Titu';
  titu_direct_nue_prop?: Maybe<Scalars['Float']['output']>;
  titu_direct_plein_prop?: Maybe<Scalars['Float']['output']>;
  titu_indirect_ind?: Maybe<Scalars['Float']['output']>;
  titu_indirect_nue_prop?: Maybe<Scalars['Float']['output']>;
  titu_indirect_plein_prop?: Maybe<Scalars['Float']['output']>;
  titu_indirect_pmor?: Maybe<Scalars['Float']['output']>;
  titu_indirect_pmor_nue_prop?: Maybe<Scalars['Float']['output']>;
  titu_indirect_pmor_plein_prop?: Maybe<Scalars['Float']['output']>;
};

/** Workflow transition */
export type Transition = {
  __typename?: 'Transition';
  action: WorkflowAction;
  sourceState: WorkflowState;
  targetState: WorkflowState;
};

/** UpdateEvent. */
export type UpdateEvent = AuditEvent & {
  __typename?: 'UpdateEvent';
  date: Scalars['String']['output'];
  state: WorkflowState;
  type: EventType;
  user: User;
};

/** Usage details page and page info. */
export type UsageDetailPage = {
  __typename?: 'UsageDetailPage';
  fileUsageDetails: Array<FileUsageDetail>;
  pageInfo: PageInfo;
  usedInCurrentFolder: Scalars['Boolean']['output'];
};

export enum UsageLevel {
  Mandatory = 'MANDATORY',
  NotUsed = 'NOT_USED',
  Optional = 'OPTIONAL',
  Required = 'REQUIRED',
  RequiredForCustomer = 'REQUIRED_FOR_CUSTOMER'
}

/** User. */
export type User = {
  __typename?: 'User';
  /** User email */
  email: Scalars['String']['output'];
  /** User first name */
  firstName: Scalars['String']['output'];
  groups: Array<UserGroup>;
  hasGroupMessageThreads: Scalars['Boolean']['output'];
  /** User system identifier */
  id: Scalars['String']['output'];
  /** User last name */
  lastName: Scalars['String']['output'];
  /** User name */
  name: Scalars['String']['output'];
  /** User who will by default validate current user folder files (this can be changed for each folder file) */
  primaryValidatingUser?: Maybe<User>;
};

/** UserGroup. */
export type UserGroup = {
  __typename?: 'UserGroup';
  definition: UserGroupDefinition;
  id: Scalars['ID']['output'];
};

export type UserGroupDefinition = ClientConfElement & {
  __typename?: 'UserGroupDefinition';
  code: Scalars['String']['output'];
  disabled: Scalars['Boolean']['output'];
  disabledComment?: Maybe<Scalars['String']['output']>;
  /** element type */
  elementType: Scalars['String']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  userGroupGeneratorProperties: Array<UserGroupGeneratorProperty>;
  userGroupGeneratorType: UserGroupGeneratorType;
};

export type UserGroupGeneratorProperty = {
  __typename?: 'UserGroupGeneratorProperty';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export enum UserGroupGeneratorType {
  KeycloakAttributes = 'KeycloakAttributes',
  KeycloakGroup = 'KeycloakGroup',
  KeycloakRole = 'KeycloakRole'
}

export type ValidationResponse = {
  __typename?: 'ValidationResponse';
  emissionDate?: Maybe<Scalars['String']['output']>;
  entity?: Maybe<ExternalEntity>;
  expirationDate?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  status?: Maybe<DocumentValidationStatus>;
};

export type Variable = {
  name: Scalars['String']['output'];
};

export enum VersionStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Draft = 'DRAFT'
}

/** Vote */
export type Vote = {
  __typename?: 'Vote';
  vote_direct?: Maybe<Scalars['Float']['output']>;
  vote_direct_nue_prop?: Maybe<Scalars['Float']['output']>;
  vote_direct_plein_prop?: Maybe<Scalars['Float']['output']>;
  vote_direct_usufruit?: Maybe<Scalars['Float']['output']>;
  vote_indirect?: Maybe<Scalars['Float']['output']>;
  vote_indirect_ind?: Maybe<Scalars['Float']['output']>;
  vote_indirect_ind_nue_prop?: Maybe<Scalars['Float']['output']>;
  vote_indirect_ind_plein_prop?: Maybe<Scalars['Float']['output']>;
  vote_indirect_ind_usufruit?: Maybe<Scalars['Float']['output']>;
  vote_indirect_pmor?: Maybe<Scalars['Float']['output']>;
  vote_indirect_pmor_nue_prop?: Maybe<Scalars['Float']['output']>;
  vote_indirect_pmor_plein_prop?: Maybe<Scalars['Float']['output']>;
  vote_indirect_pmor_usufruit?: Maybe<Scalars['Float']['output']>;
  vote_total?: Maybe<Scalars['Float']['output']>;
};

export type WeightedRisk = {
  __typename?: 'WeightedRisk';
  axisWeight: Scalars['Float']['output'];
  risk: Risk;
  weightedScore: Scalars['Int']['output'];
};

/** Workflow configuration */
export type Workflow = {
  __typename?: 'Workflow';
  actions: Array<WorkflowAction>;
  initialState: WorkflowState;
  progressBars: Array<ProgressBar>;
  states: Array<WorkflowState>;
};

/** A workflow action */
export type WorkflowAction = {
  /** The backward field of a workflow action. */
  backward: Scalars['Boolean']['output'];
  /** The code of a workflow action. */
  code: Scalars['String']['output'];
  /** The confirmation message of a workflow action. */
  confirmationMessage?: Maybe<Scalars['String']['output']>;
  /** The description of a workflow action. */
  description?: Maybe<Scalars['String']['output']>;
  /** The id of a workflow action. */
  id: Scalars['String']['output'];
  /** The name of a workflow action */
  name: Scalars['String']['output'];
};

/** WorkflowEvent. */
export type WorkflowEvent = AuditEvent & {
  __typename?: 'WorkflowEvent';
  action: WorkflowAction;
  /** The user assigned during file submission, if any. */
  assignedUser?: Maybe<User>;
  comment?: Maybe<Scalars['String']['output']>;
  date: Scalars['String']['output'];
  state: WorkflowState;
  type: EventType;
  user: User;
};

export type WorkflowInputValue = {
  __typename?: 'WorkflowInputValue';
  dataType: DataType;
  fieldCode: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** A workflow state */
export type WorkflowState = {
  assignableUserGroups: Array<Scalars['String']['output']>;
  /** The canceled field of a workflow state. */
  canceled: Scalars['Boolean']['output'];
  /** The closed field of a workflow state. */
  closed: Scalars['Boolean']['output'];
  /** The code of a workflow state. */
  code: Scalars['String']['output'];
  /** The editable field of a workflow state. */
  editable: Scalars['Boolean']['output'];
  /** The id of a workflow state. */
  id: Scalars['String']['output'];
  /** The name of a workflow state */
  name: Scalars['String']['output'];
  /** The user assignment a workflow state. */
  singleUserAssignment: SingleUserAssignment;
};

/** A workflow status */
export type WorkflowStatus = {
  /** The user who is assigned to workflow state. */
  assignedUser?: Maybe<User>;
  /** The lastModification field of a workflow status. */
  lastModification: Scalars['String']['output'];
  /** The user who modified status last. */
  lastModifier: User;
  /** The state of a workflow. */
  state: WorkflowState;
};

export type ContactPersonFieldsFragment = { __typename?: 'ContactPerson', id: string, inputValues: Array<{ __typename?: 'CorporationsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'PersonsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ScalarInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } }> };

export type FolderFileDeletionFragment = { __typename?: 'FolderFile', id: string, workflowStatus: { __typename?: 'FolderFileWorkflowStatus', state: { __typename?: 'State', code: string } }, currentCustomerFolder: { __typename?: 'CustomerFolder', id: string, folderFiles: { __typename?: 'CustomerFolderFilesPage', summaries: Array<{ __typename?: 'FolderFile', id: string }> } }, fileCustomerFolder: { __typename?: 'FileCustomerFolder', customer: { __typename?: 'Corporation', id: string, isPerson: boolean, allInputValues: Array<{ __typename?: 'CorporationsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'PersonsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ScalarInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } }> } | { __typename?: 'Person', id: string, isPerson: boolean, allInputValues: Array<{ __typename?: 'CorporationsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'PersonsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ScalarInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } }> } | { __typename?: 'PersonGroup', id: string, isPerson: boolean, allInputValues: Array<{ __typename?: 'CorporationsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'PersonsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ScalarInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } }> } } };

export type FolderFilesPageInfoFragment = { __typename?: 'FolderFilesPage', pageInfo: { __typename?: 'PageInfo', totalCount: number } };

export type OwnerFieldsFragment = { __typename?: 'User', id: string, firstName: string, lastName: string };

export type UserWithRolesFieldsFragment = { __typename?: 'User', id: string, firstName: string, lastName: string, email: string, groups: Array<{ __typename?: 'UserGroup', definition: { __typename?: 'UserGroupDefinition', name: string, code: string } }> };

export type AddMessageMutationVariables = Exact<{
  messageThreadId: Scalars['ID']['input'];
  content: Scalars['String']['input'];
}>;


export type AddMessageMutation = { __typename?: 'Mutation', addMessage?: { __typename?: 'Message', id: string } | null };

export type AddStakeholderMutationVariables = Exact<{
  reference_0?: InputMaybe<Scalars['Reference']['input']>;
  inputValues_0: Array<InputValueInput> | InputValueInput;
  inputRole_1: RoleInputType;
  corporationId_1: Scalars['IdOrReference']['input'];
  entityId_1: Scalars['IdOrReference']['input'];
  inputRole_2: RoleInputType;
  includeLegalRep?: Scalars['Boolean']['input'];
  includeDirectBO?: Scalars['Boolean']['input'];
}>;


export type AddStakeholderMutation = { __typename?: 'Mutation', createPerson_0?: { __typename: 'Person', id: string } | null, setLegalRepresentativeRole_1?: { __typename: 'Role' }, setDirectBORole_2?: { __typename: 'Role' } };

export type AutoCreateCustomerGraphMutationVariables = Exact<{
  siren: Scalars['String']['input'];
  includeIntermediateLegalRepresentatives: Scalars['Boolean']['input'];
}>;


export type AutoCreateCustomerGraphMutation = { __typename?: 'Mutation', autoCreateCustomerGraph: { __typename?: 'AutocreationCorporationResult', customer?: { __typename?: 'Corporation', id: string } | null, errors: Array<{ __typename?: 'AutocreationFailure', identifier: string, message: string }> } };

export type AutoCreatePersonCustomerGraphMutationVariables = Exact<{
  siren: Scalars['String']['input'];
}>;


export type AutoCreatePersonCustomerGraphMutation = { __typename?: 'Mutation', autoCreatePersonCustomerGraph: { __typename?: 'AutocreationPersonResult', customer?: { __typename?: 'Person', id: string } | null, errors: Array<{ __typename?: 'AutocreationFailure', identifier: string, message: string }> } };

export type CallEReputationMutationVariables = Exact<{
  folderFileId: Scalars['ID']['input'];
  force?: Scalars['Boolean']['input'];
}>;


export type CallEReputationMutation = { __typename?: 'Mutation', callEreputation?: { __typename?: 'FolderFile', id: string, fileCustomerFolder: { __typename?: 'FileCustomerFolder', stakeholders: Array<{ __typename?: 'FolderStakeholder', entity: { __typename?: 'Corporation', id: string, eReputation?: { __typename?: 'Ereputation', isPep: boolean, isSanction: boolean, entries: Array<{ __typename?: 'EReputationEntry', providerResult: boolean, category: { __typename?: 'EReputationCategory', code: string, name: string } }> } | null } | { __typename?: 'Person', id: string, eReputation?: { __typename?: 'Ereputation', isPep: boolean, isSanction: boolean, entries: Array<{ __typename?: 'EReputationEntry', providerResult: boolean, category: { __typename?: 'EReputationCategory', code: string, name: string } }> } | null } }> } } | null };

export type CloseMissionMutationVariables = Exact<{
  missionId: Scalars['ID']['input'];
  statusComment: Scalars['String']['input'];
}>;


export type CloseMissionMutation = { __typename?: 'Mutation', closeMission: { __typename?: 'Mission', id: string } };

export type CreateClientByCorporationIdMutationVariables = Exact<{
  isOwner?: Scalars['Boolean']['input'];
  ownerId: Scalars['String']['input'];
  isContact?: Scalars['Boolean']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  corporationId: Scalars['IdOrReference']['input'];
  isFolderFile?: Scalars['Boolean']['input'];
  optionCustomerFolderTypeCode?: Scalars['String']['input'];
}>;


export type CreateClientByCorporationIdMutation = { __typename?: 'Mutation', createCustomerFolder?: { __typename?: 'CustomerFolder', id: string } | null, createFolderFile?: { __typename?: 'FolderFile', id: string } | null, setOwner?: { __typename?: 'CustomerFolder', id: string }, mergeContactPerson?: { __typename?: 'ContactPerson', id: string } };

export type CreateClientByRaisonSocialeMutationVariables = Exact<{
  isOwner?: Scalars['Boolean']['input'];
  ownerId: Scalars['String']['input'];
  isContact?: Scalars['Boolean']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  inputValues: Array<InputValueInput> | InputValueInput;
  isFolderFile?: Scalars['Boolean']['input'];
}>;


export type CreateClientByRaisonSocialeMutation = { __typename?: 'Mutation', createCorporation?: { __typename?: 'Corporation', id: string, inputValues: Array<{ __typename?: 'CorporationsInputValue', stringValue?: string | null } | { __typename?: 'ElementInputValue', stringValue?: string | null } | { __typename?: 'ElementsInputValue', stringValue?: string | null } | { __typename?: 'PersonsInputValue', stringValue?: string | null } | { __typename?: 'ScalarInputValue', stringValue?: string | null }> } | null, createCustomerFolder?: { __typename?: 'CustomerFolder', id: string } | null, createFolderFile?: { __typename?: 'FolderFile', id: string } | null, setOwner?: { __typename?: 'CustomerFolder', id: string }, mergeContactPerson?: { __typename?: 'ContactPerson', id: string } };

export type CreateClientPphMutationVariables = Exact<{
  isOwner?: Scalars['Boolean']['input'];
  ownerId: Scalars['String']['input'];
  isContact?: Scalars['Boolean']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  inputValues: Array<InputValueInput> | InputValueInput;
  isFolderFile?: Scalars['Boolean']['input'];
}>;


export type CreateClientPphMutation = { __typename?: 'Mutation', createPerson?: { __typename?: 'Person', id: string } | null, createCustomerFolder?: { __typename?: 'CustomerFolder', id: string } | null, createFolderFile?: { __typename?: 'FolderFile', id: string } | null, setOwner?: { __typename?: 'CustomerFolder', id: string }, mergeContactPerson?: { __typename?: 'ContactPerson', id: string } };

export type CreateClientPphByPersonIdMutationVariables = Exact<{
  personId: Scalars['IdOrReference']['input'];
  isOwner?: Scalars['Boolean']['input'];
  ownerId: Scalars['String']['input'];
  isContact?: Scalars['Boolean']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  isFolderFile?: Scalars['Boolean']['input'];
}>;


export type CreateClientPphByPersonIdMutation = { __typename?: 'Mutation', createCustomerFolder?: { __typename?: 'CustomerFolder', id: string } | null, createFolderFile?: { __typename?: 'FolderFile', id: string } | null, setOwner?: { __typename?: 'CustomerFolder', id: string }, mergeContactPerson?: { __typename?: 'ContactPerson', id: string } };

export type CreateDiligenceMutationVariables = Exact<{
  folderFileId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  selected?: Scalars['Boolean']['input'];
  category?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateDiligenceMutation = { __typename?: 'Mutation', createDiligence: { __typename?: 'Diligence', id: string } };

export type CreateDiligencesMutationVariables = Exact<{
  folderFileId: Scalars['ID']['input'];
}>;


export type CreateDiligencesMutation = { __typename?: 'Mutation', createDiligences: Array<{ __typename?: 'Diligence', id: string }> };

export type CreateFolderFileMutationVariables = Exact<{
  customerFolderId: Scalars['IdOrReference']['input'];
  folderFileTypeCode?: Scalars['String']['input'];
}>;


export type CreateFolderFileMutation = { __typename?: 'Mutation', createFolderFile?: { __typename?: 'FolderFile', id: string, fileCustomerFolder: { __typename?: 'FileCustomerFolder', stakeholders: Array<{ __typename?: 'FolderStakeholder', isFolderCustomer: boolean, entity: { __typename: 'Corporation', id: string } | { __typename: 'Person', id: string } }> } } | null };

export type CreateMessageThreadMutationVariables = Exact<{
  folderFileId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
  topicCodes: Array<Scalars['String']['input']> | Scalars['String']['input'];
  discussantIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type CreateMessageThreadMutation = { __typename?: 'Mutation', createMessageThread?: { __typename?: 'MessageThread', id: string } | null };

export type CreateMissionMutationVariables = Exact<{
  customerFolderId: Scalars['IdOrReference']['input'];
  missionTypeCode: Scalars['String']['input'];
  renewDate: Scalars['String']['input'];
}>;


export type CreateMissionMutation = { __typename?: 'Mutation', createMission: { __typename?: 'Mission', id: string } };

export type CreateOrReplaceExternalDocumentMutationVariables = Exact<{
  entityId: Scalars['IdOrReference']['input'];
  documentTypeCode: Scalars['String']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateOrReplaceExternalDocumentMutation = { __typename?: 'Mutation', createOrReplaceExternalDocument?: { __typename?: 'ExternalDocument', id: string } | null };

export type CreateQuestionnaireMutationVariables = Exact<{
  questionnaireEntityId: Scalars['IdOrReference']['input'];
  questionnaireTypeCode: Scalars['String']['input'];
}>;


export type CreateQuestionnaireMutation = { __typename?: 'Mutation', createQuestionnaire: { __typename?: 'Questionnaire', id: string } };

export type DeleteDiligenceMutationVariables = Exact<{
  diligenceId: Scalars['ID']['input'];
}>;


export type DeleteDiligenceMutation = { __typename?: 'Mutation', deleteDiligence: string };

export type DeleteDocumentMutationVariables = Exact<{
  documentId: Scalars['ID']['input'];
}>;


export type DeleteDocumentMutation = { __typename?: 'Mutation', deleteDocument?: string | null };

export type DeleteExternalDocumentMutationVariables = Exact<{
  documentId: Scalars['ID']['input'];
}>;


export type DeleteExternalDocumentMutation = { __typename?: 'Mutation', deleteExternalDocument?: string | null };

export type DeleteFolderEiMutationVariables = Exact<{
  customerFolderId: Scalars['ID']['input'];
  personId: Scalars['ID']['input'];
  folderFileId: Scalars['ID']['input'];
  deleteCustomerFolder: Scalars['Boolean']['input'];
  deleteFolderFile: Scalars['Boolean']['input'];
}>;


export type DeleteFolderEiMutation = { __typename?: 'Mutation', deleteCustomerFolder?: string | null, deleteFolderFile?: string | null, updatePerson?: { __typename?: 'Person', id: string } | null };

export type DeleteFolderEntityMutationVariables = Exact<{
  customerFolderId: Scalars['ID']['input'];
  corporationId: Scalars['ID']['input'];
  folderFileId: Scalars['ID']['input'];
  deleteCustomerFolder: Scalars['Boolean']['input'];
  deleteFolderFile: Scalars['Boolean']['input'];
  newCorporationName: Scalars['String']['input'];
}>;


export type DeleteFolderEntityMutation = { __typename?: 'Mutation', deleteCustomerFolder?: string | null, deleteFolderFile?: string | null, updateCorporation?: { __typename?: 'Corporation', id: string } | null };

export type DeleteMissionMutationVariables = Exact<{
  missionId: Scalars['ID']['input'];
}>;


export type DeleteMissionMutation = { __typename?: 'Mutation', deleteMission: string };

export type DeleteStakeholderMutationVariables = Exact<{
  sourceEntityId: Scalars['ID']['input'];
  targetEntityId: Scalars['ID']['input'];
  isLegalRep?: Scalars['Boolean']['input'];
  isDirectBO?: Scalars['Boolean']['input'];
  roleTypeCode_1?: InputMaybe<Scalars['String']['input']>;
  roleTypeCode_2?: InputMaybe<Scalars['String']['input']>;
}>;


export type DeleteStakeholderMutation = { __typename?: 'Mutation', deleteRole_1?: { __typename: 'Role' } | null, deleteRole_2?: { __typename: 'Role' } | null };

export type EditMessageMutationVariables = Exact<{
  messageId: Scalars['ID']['input'];
  content: Scalars['String']['input'];
}>;


export type EditMessageMutation = { __typename?: 'Mutation', editMessage?: { __typename?: 'Message', id: string, content: string } | null };

export type ExecuteWorkflowActionMutationVariables = Exact<{
  actionId: Scalars['String']['input'];
  folderFileId: Scalars['ID']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
}>;


export type ExecuteWorkflowActionMutation = { __typename?: 'Mutation', executeWorkflowAction?: { __typename?: 'FolderFile', id: string } | null };

export type FollowFolderMutationVariables = Exact<{
  customerFolderId: Scalars['IdOrReference']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
}>;


export type FollowFolderMutation = { __typename?: 'Mutation', followFolder: { __typename?: 'CustomerFolder', id: string } };

export type ForceRiskLevelMutationVariables = Exact<{
  folderFileId: Scalars['ID']['input'];
  riskLevel: RiskLevel;
  forcedRiskReasonCode: Scalars['String']['input'];
}>;


export type ForceRiskLevelMutation = { __typename?: 'Mutation', forceRiskLevel: { __typename?: 'FolderFile', id: string } };

export type ReplaceEntityMutationVariables = Exact<{
  idToDelete: Scalars['ID']['input'];
  replacementId: Scalars['ID']['input'];
}>;


export type ReplaceEntityMutation = { __typename?: 'Mutation', replaceEntity?: { __typename?: 'Corporation', id: string } | { __typename?: 'Person', id: string } | null };

export type UnfollowFolderMutationVariables = Exact<{
  customerFolderId: Scalars['ID']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UnfollowFolderMutation = { __typename?: 'Mutation', unfollowFolder: { __typename?: 'CustomerFolder', id: string } };

export type UpdateAndValidateQuestionnaireMutationVariables = Exact<{
  questionnaireId: Scalars['ID']['input'];
  questionnaireIdOrReference: Scalars['IdOrReference']['input'];
  data: Scalars['String']['input'];
  shouldReopen: Scalars['Boolean']['input'];
  shouldValidate: Scalars['Boolean']['input'];
}>;


export type UpdateAndValidateQuestionnaireMutation = { __typename?: 'Mutation', reopenQuestionnaire?: { __typename?: 'Questionnaire', id: string }, putQuestionnaireContent: { __typename?: 'Questionnaire', id: string, content?: string | null }, validateQuestionnaire?: { __typename?: 'Questionnaire', id: string } };

export type UpdateContactsMutationVariables = Exact<{
  setOwner?: InputMaybe<Scalars['Boolean']['input']>;
  removeOwner?: InputMaybe<Scalars['Boolean']['input']>;
  mergeContactPerson?: InputMaybe<Scalars['Boolean']['input']>;
  deleteContactPerson?: InputMaybe<Scalars['Boolean']['input']>;
  customerFolderId: Scalars['IdOrReference']['input'];
  customerFolderId_2: Scalars['ID']['input'];
  userId: Scalars['String']['input'];
  inputValues: Array<InputValueInput> | InputValueInput;
  contactPersonId: Scalars['ID']['input'];
}>;


export type UpdateContactsMutation = { __typename?: 'Mutation', deleteContactPerson?: string, setOwner?: { __typename: 'CustomerFolder', id: string }, removeOwner?: { __typename: 'CustomerFolder' }, mergeContactPerson?: { __typename?: 'ContactPerson', id: string } };

export type UpdateCorporationMutationVariables = Exact<{
  corporationId: Scalars['ID']['input'];
  inputValues: Array<InputValueInput> | InputValueInput;
}>;


export type UpdateCorporationMutation = { __typename?: 'Mutation', updateCorporation?: { __typename?: 'Corporation', id: string } | null };

export type UpdateDiligenceMutationVariables = Exact<{
  diligenceId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  selected?: InputMaybe<Scalars['Boolean']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateDiligenceMutation = { __typename?: 'Mutation', updateDiligence: { __typename?: 'Diligence', id: string } };

export type UpdateDocumentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  expirationDate?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateDocumentMutation = { __typename?: 'Mutation', updateDocument?: { __typename?: 'Document', id: string, expirationDate?: string | null } | null };

export type UpdateEntityEReputationMutationVariables = Exact<{
  entityId: Scalars['ID']['input'];
  inputs: Array<EReputationInputType> | EReputationInputType;
}>;


export type UpdateEntityEReputationMutation = { __typename?: 'Mutation', updateEntityEreputation: { __typename?: 'Corporation', id: string } | { __typename?: 'Person', id: string } };

export type UpdateMissionMutationVariables = Exact<{
  missionId: Scalars['ID']['input'];
  inputValues: Array<InputValueInput> | InputValueInput;
  shouldReopen: Scalars['Boolean']['input'];
}>;


export type UpdateMissionMutation = { __typename?: 'Mutation', reopenMission?: { __typename?: 'Mission', id: string }, updateMission: { __typename?: 'Mission', id: string } };

export type UpdatePersonDuplicateCheckDoneMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  duplicateCheckDone?: Scalars['String']['input'];
}>;


export type UpdatePersonDuplicateCheckDoneMutation = { __typename?: 'Mutation', updatePerson_0?: { __typename?: 'Person', id: string } | null };

export type UpdateQuestionnaireMutationVariables = Exact<{
  questionnaireId: Scalars['IdOrReference']['input'];
  data: Scalars['String']['input'];
}>;


export type UpdateQuestionnaireMutation = { __typename?: 'Mutation', putQuestionnaireContent: { __typename?: 'Questionnaire', id: string, content?: string | null } };

export type UpdateStakeholderMutationVariables = Exact<{
  id_0: Scalars['ID']['input'];
  inputValues_0: Array<InputValueInput> | InputValueInput;
  inputRole_1: RoleInputType;
  corporationId_1: Scalars['IdOrReference']['input'];
  entityId_1: Scalars['IdOrReference']['input'];
  inputRole_2: RoleInputType;
  addLegalRep?: Scalars['Boolean']['input'];
  addDirectBO?: Scalars['Boolean']['input'];
  corporationId_2: Scalars['ID']['input'];
  entityId_2: Scalars['ID']['input'];
  deleteLegalRep?: Scalars['Boolean']['input'];
  deleteDirectBO?: Scalars['Boolean']['input'];
}>;


export type UpdateStakeholderMutation = { __typename?: 'Mutation', updatePerson_0?: { __typename: 'Person', id: string } | null, setLegalRepresentativeRole_1?: { __typename: 'Role' }, setDirectBORole2?: { __typename: 'Role' }, deleteRole_LegalRepresentative?: { __typename: 'Role' } | null, deleteRole_DirectBO?: { __typename: 'Role' } | null };

export type ActivitiesWithRiskListQueryVariables = Exact<{ [key: string]: never; }>;


export type ActivitiesWithRiskListQuery = { __typename?: 'Query', listElements: Array<{ __typename?: 'ContactPersonType' } | { __typename?: 'Country' } | { __typename?: 'CustomerFolderType' } | { __typename?: 'DccpAlertType' } | { __typename?: 'DiligenceDefinition' } | { __typename?: 'DocumentType' } | { __typename?: 'DocumentTypeGroup' } | { __typename?: 'EntityType' } | { __typename?: 'EReputationAnalysis' } | { __typename?: 'EReputationCategory' } | { __typename?: 'Family' } | { __typename?: 'FolderFileType' } | { __typename?: 'MissionType' } | { __typename?: 'QuestionnaireType' } | { __typename?: 'RelatedEntityType' } | { __typename?: 'StandardListElement', id: string, code: string, name: string, riskValues: Array<{ __typename?: 'RiskValue', description?: string | null, riskCategory: RiskCategory, key: string }> } | { __typename?: 'SubsidiaryType' } | { __typename?: 'ThirdPartyFolderType' }> };

export type AdvancedCorporationAndPersonSearchQueryVariables = Exact<{
  values: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type AdvancedCorporationAndPersonSearchQuery = { __typename?: 'Query', advancedCorporationSearch: { __typename?: 'CorporationPage', corporations: Array<{ __typename?: 'Corporation', isCustomer: boolean, id: string, name?: { __typename?: 'CorporationsInputValue', stringValue?: string | null } | { __typename?: 'ElementInputValue', stringValue?: string | null } | { __typename?: 'ElementsInputValue', stringValue?: string | null } | { __typename?: 'PersonsInputValue', stringValue?: string | null } | { __typename?: 'ScalarInputValue', stringValue?: string | null } | null, siren?: { __typename?: 'CorporationsInputValue', stringValue?: string | null } | { __typename?: 'ElementInputValue', stringValue?: string | null } | { __typename?: 'ElementsInputValue', stringValue?: string | null } | { __typename?: 'PersonsInputValue', stringValue?: string | null } | { __typename?: 'ScalarInputValue', stringValue?: string | null } | null, customerFolders: Array<{ __typename?: 'CustomerFolder', folderFiles: { __typename?: 'CustomerFolderFilesPage', summaries: Array<{ __typename?: 'FolderFile', id: string }> } }> }> }, advancedPersonSearch: { __typename?: 'PersonPage', persons: Array<{ __typename?: 'Person', id: string, firstName?: { __typename?: 'CorporationsInputValue', stringValue?: string | null } | { __typename?: 'ElementInputValue', stringValue?: string | null } | { __typename?: 'ElementsInputValue', stringValue?: string | null } | { __typename?: 'PersonsInputValue', stringValue?: string | null } | { __typename?: 'ScalarInputValue', stringValue?: string | null } | null, lastName?: { __typename?: 'CorporationsInputValue', stringValue?: string | null } | { __typename?: 'ElementInputValue', stringValue?: string | null } | { __typename?: 'ElementsInputValue', stringValue?: string | null } | { __typename?: 'PersonsInputValue', stringValue?: string | null } | { __typename?: 'ScalarInputValue', stringValue?: string | null } | null, siren?: { __typename?: 'CorporationsInputValue', stringValue?: string | null } | { __typename?: 'ElementInputValue', stringValue?: string | null } | { __typename?: 'ElementsInputValue', stringValue?: string | null } | { __typename?: 'PersonsInputValue', stringValue?: string | null } | { __typename?: 'ScalarInputValue', stringValue?: string | null } | null, customerFolders: Array<{ __typename?: 'CustomerFolder', folderFiles: { __typename?: 'CustomerFolderFilesPage', summaries: Array<{ __typename?: 'FolderFile', id: string }> } }> }> } };

export type AdvancedCorporationSearchQueryVariables = Exact<{
  values: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type AdvancedCorporationSearchQuery = { __typename?: 'Query', advancedCorporationSearch: { __typename?: 'CorporationPage', corporations: Array<{ __typename?: 'Corporation', isCustomer: boolean, id: string, name?: { __typename?: 'CorporationsInputValue', stringValue?: string | null } | { __typename?: 'ElementInputValue', stringValue?: string | null } | { __typename?: 'ElementsInputValue', stringValue?: string | null } | { __typename?: 'PersonsInputValue', stringValue?: string | null } | { __typename?: 'ScalarInputValue', stringValue?: string | null } | null, siren?: { __typename?: 'CorporationsInputValue', stringValue?: string | null } | { __typename?: 'ElementInputValue', stringValue?: string | null } | { __typename?: 'ElementsInputValue', stringValue?: string | null } | { __typename?: 'PersonsInputValue', stringValue?: string | null } | { __typename?: 'ScalarInputValue', stringValue?: string | null } | null, customerFolders: Array<{ __typename?: 'CustomerFolder', folderFiles: { __typename?: 'CustomerFolderFilesPage', summaries: Array<{ __typename?: 'FolderFile', id: string }> } }> }> } };

export type AdvancedPersonSearchQueryVariables = Exact<{
  values: Array<Scalars['String']['input']> | Scalars['String']['input'];
  limit?: Scalars['Int']['input'];
}>;


export type AdvancedPersonSearchQuery = { __typename?: 'Query', advancedPersonSearch: { __typename?: 'PersonPage', persons: Array<{ __typename?: 'Person', id: string, isCustomer: boolean, isPerson: boolean, title?: { __typename?: 'CorporationsInputValue', stringValue?: string | null } | { __typename?: 'ElementInputValue', stringValue?: string | null } | { __typename?: 'ElementsInputValue', stringValue?: string | null } | { __typename?: 'PersonsInputValue', stringValue?: string | null } | { __typename?: 'ScalarInputValue', stringValue?: string | null } | null, firstName?: { __typename?: 'CorporationsInputValue', stringValue?: string | null } | { __typename?: 'ElementInputValue', stringValue?: string | null } | { __typename?: 'ElementsInputValue', stringValue?: string | null } | { __typename?: 'PersonsInputValue', stringValue?: string | null } | { __typename?: 'ScalarInputValue', stringValue?: string | null } | null, lastName?: { __typename?: 'CorporationsInputValue', stringValue?: string | null } | { __typename?: 'ElementInputValue', stringValue?: string | null } | { __typename?: 'ElementsInputValue', stringValue?: string | null } | { __typename?: 'PersonsInputValue', stringValue?: string | null } | { __typename?: 'ScalarInputValue', stringValue?: string | null } | null, birthName?: { __typename?: 'CorporationsInputValue', stringValue?: string | null } | { __typename?: 'ElementInputValue', stringValue?: string | null } | { __typename?: 'ElementsInputValue', stringValue?: string | null } | { __typename?: 'PersonsInputValue', stringValue?: string | null } | { __typename?: 'ScalarInputValue', stringValue?: string | null } | null, birthDate?: { __typename?: 'CorporationsInputValue', stringValue?: string | null } | { __typename?: 'ElementInputValue', stringValue?: string | null } | { __typename?: 'ElementsInputValue', stringValue?: string | null } | { __typename?: 'PersonsInputValue', stringValue?: string | null } | { __typename?: 'ScalarInputValue', stringValue?: string | null } | null, citizenshipCountryCode?: { __typename?: 'CorporationsInputValue', stringValue?: string | null } | { __typename?: 'ElementInputValue', stringValue?: string | null } | { __typename?: 'ElementsInputValue', stringValue?: string | null } | { __typename?: 'PersonsInputValue', stringValue?: string | null } | { __typename?: 'ScalarInputValue', stringValue?: string | null } | null, residenceCountryCode?: { __typename?: 'CorporationsInputValue', stringValue?: string | null } | { __typename?: 'ElementInputValue', stringValue?: string | null } | { __typename?: 'ElementsInputValue', stringValue?: string | null } | { __typename?: 'PersonsInputValue', stringValue?: string | null } | { __typename?: 'ScalarInputValue', stringValue?: string | null } | null, birthCountryCode?: { __typename?: 'CorporationsInputValue', stringValue?: string | null } | { __typename?: 'ElementInputValue', stringValue?: string | null } | { __typename?: 'ElementsInputValue', stringValue?: string | null } | { __typename?: 'PersonsInputValue', stringValue?: string | null } | { __typename?: 'ScalarInputValue', stringValue?: string | null } | null, eReputation?: { __typename?: 'Ereputation', entries: Array<{ __typename?: 'EReputationEntry', providerResult: boolean, category: { __typename?: 'EReputationCategory', code: string }, analysis?: { __typename?: 'EReputationAnalysis', name: string } | null }> } | null }> } };

export type CompareCustomerGraphWithExternalDataQueryVariables = Exact<{
  customerFolderId: Scalars['ID']['input'];
}>;


export type CompareCustomerGraphWithExternalDataQuery = { __typename?: 'Query', compareCustomerGraphWithExternalData: { __typename?: 'CustomerGraphComparisonResult', errors: Array<{ __typename?: 'AutocreationFailure', identifier: string, message: string }>, stakeholdersWithDiffs: Array<{ __typename?: 'FolderStakeholderWithDiffs', folderStakeholder?: { __typename?: 'FolderStakeholder', beneficiaryOwner: boolean, isFolderCustomer: boolean, isLegalRepresentative: boolean, entity: { __typename?: 'Corporation', id: string } | { __typename?: 'Person', id: string }, inputValues: Array<{ __typename?: 'CorporationsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'PersonsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ScalarInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } }> } | null, externalData: Array<{ __typename?: 'ExternalDataDiff', identifiersMatchStatus: IdentifiersMatchStatus, isPerson: boolean, rolesToDelete: Array<string>, isCorporation: boolean, diffInputValues: Array<{ __typename?: 'InputValueView', fieldCode: string, dataType: DataType, value?: string | null }>, fullInputValues: Array<{ __typename?: 'InputValueView', fieldCode: string, dataType: DataType, value?: string | null }>, rolesToAdd: Array<{ __typename?: 'RoleInputView', typeCode?: string | null }> }> }> } };

export type CountriesListQueryVariables = Exact<{ [key: string]: never; }>;


export type CountriesListQuery = { __typename?: 'Query', listElements: Array<{ __typename?: 'ContactPersonType' } | { __typename?: 'Country', id: string, code: string, name: string, alpha3: string } | { __typename?: 'CustomerFolderType' } | { __typename?: 'DccpAlertType' } | { __typename?: 'DiligenceDefinition' } | { __typename?: 'DocumentType' } | { __typename?: 'DocumentTypeGroup' } | { __typename?: 'EntityType' } | { __typename?: 'EReputationAnalysis' } | { __typename?: 'EReputationCategory' } | { __typename?: 'Family' } | { __typename?: 'FolderFileType' } | { __typename?: 'MissionType' } | { __typename?: 'QuestionnaireType' } | { __typename?: 'RelatedEntityType' } | { __typename?: 'StandardListElement' } | { __typename?: 'SubsidiaryType' } | { __typename?: 'ThirdPartyFolderType' }> };

export type CountriesWithRiskListQueryVariables = Exact<{ [key: string]: never; }>;


export type CountriesWithRiskListQuery = { __typename?: 'Query', listElements: Array<{ __typename?: 'ContactPersonType' } | { __typename?: 'Country', id: string, code: string, name: string, riskValues: Array<{ __typename?: 'RiskValue', description?: string | null, riskCategory: RiskCategory, key: string }> } | { __typename?: 'CustomerFolderType' } | { __typename?: 'DccpAlertType' } | { __typename?: 'DiligenceDefinition' } | { __typename?: 'DocumentType' } | { __typename?: 'DocumentTypeGroup' } | { __typename?: 'EntityType' } | { __typename?: 'EReputationAnalysis' } | { __typename?: 'EReputationCategory' } | { __typename?: 'Family' } | { __typename?: 'FolderFileType' } | { __typename?: 'MissionType' } | { __typename?: 'QuestionnaireType' } | { __typename?: 'RelatedEntityType' } | { __typename?: 'StandardListElement' } | { __typename?: 'SubsidiaryType' } | { __typename?: 'ThirdPartyFolderType' }> };

export type CurrentUserWithRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserWithRolesQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string, groups: Array<{ __typename?: 'UserGroup', definition: { __typename?: 'UserGroupDefinition', name: string, code: string } }> } };

export type CustomerFoldersHavingAtLeastOneInactiveMissionInLatestSnapshotQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  ownerUserIdFilter?: InputMaybe<Scalars['String']['input']>;
  followedByUserIdFilter?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InactiveMissionsInLatestSnapshotOfCustomerFoldersPageSortingFieldInputType> | InactiveMissionsInLatestSnapshotOfCustomerFoldersPageSortingFieldInputType>;
}>;


export type CustomerFoldersHavingAtLeastOneInactiveMissionInLatestSnapshotQuery = { __typename?: 'Query', customerFoldersHavingAtLeastOneInactiveMissionInLatestSnapshot: { __typename?: 'CustomerFoldersPage', summaries: Array<{ __typename?: 'CustomerFolderSummary', mission?: { __typename?: 'Mission', renewDate?: string | null } | null, customer: { __typename?: 'Corporation', id: string, allInputValues: Array<{ __typename?: 'CorporationsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'PersonsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ScalarInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } }> } | { __typename?: 'Person', id: string, allInputValues: Array<{ __typename?: 'CorporationsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'PersonsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ScalarInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } }> } | { __typename?: 'PersonGroup', id: string, allInputValues: Array<{ __typename?: 'CorporationsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'PersonsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ScalarInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } }> }, file?: { __typename?: 'FolderFile', riskStatus: { __typename?: 'FileRiskStatus', globalRiskLevel: RiskLevel, riskDetail: { __typename?: 'RiskDetail', axesStatus: Array<{ __typename?: 'AxisStatus', riskLevel: RiskLevel, axisName: string, risks: Array<{ __typename?: 'Risk', item: RiskItem }> }> } } } | null, customerFolder: { __typename?: 'CustomerFolder', id: string, followedByCurrentUser: boolean, owner?: { __typename?: 'User', firstName: string, lastName: string } | null, folderFiles: { __typename?: 'CustomerFolderFilesPage', summaries: Array<{ __typename?: 'FolderFile', id: string }> }, adminStatus: { __typename?: 'AdminStatus', lastModification: string, lastModifier: { __typename?: 'User', name: string } }, followingUsers: Array<{ __typename?: 'User', firstName: string, lastName: string, id: string }>, customerFolderType: { __typename?: 'CustomerFolderType', code: string } } }>, pageInfo: { __typename?: 'PageInfo', totalCount: number } } };

export type FolderFileQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FolderFileQuery = { __typename?: 'Query', folderFile?: { __typename?: 'FolderFile', id: string, adminStatus: { __typename?: 'AdminStatus', creation: string, lastModification: string, author: { __typename?: 'User', id: string } }, messageThreads: Array<{ __typename?: 'MessageThread', id: string, title: string, messages: Array<{ __typename?: 'Message', id: string, content: string, adminStatus: { __typename?: 'AdminStatus', creation: string, lastModification: string, author: { __typename?: 'User', lastName: string, firstName: string, id: string }, lastModifier: { __typename?: 'User', lastName: string, firstName: string, id: string } } }>, unreadMessages: Array<{ __typename?: 'Message', id: string, content: string, adminStatus: { __typename?: 'AdminStatus', creation: string, lastModification: string, author: { __typename?: 'User', lastName: string, firstName: string, id: string }, lastModifier: { __typename?: 'User', lastName: string, firstName: string, id: string } } }> }>, riskStatus: { __typename?: 'FileRiskStatus', standardRiskLevel: RiskLevel, globalRiskLevel: RiskLevel, forcedRisk?: { __typename?: 'ForcedRisk', level: RiskLevel, reason: { __typename?: 'StandardListElement', id: string, name: string, code: string } } | null }, completionStatus: { __typename?: 'FileCompletionStatus', complete: boolean, requiredFieldsMissing: boolean }, workflowStatus: { __typename?: 'FolderFileWorkflowStatus', lastModification: string, state: { __typename?: 'State', code: string } }, allowedTransitions: Array<{ __typename?: 'Transition', action: { __typename?: 'Action', code: string } | { __typename?: 'EreputationAlertAction', code: string } }>, auditEvents: Array<{ __typename?: 'CreationEvent' } | { __typename?: 'DccpEvent' } | { __typename?: 'EReputationEvent' } | { __typename?: 'ForceRiskLevelEvent' } | { __typename?: 'UpdateEvent' } | { __typename?: 'WorkflowEvent', comment?: string | null, date: string, state: { __typename?: 'EreputationAlertState', code: string } | { __typename?: 'State', code: string }, user: { __typename?: 'User', name: string } }>, currentCustomerFolder: { __typename?: 'CustomerFolder', id: string, followedByCurrentUser: boolean, customerFolderType: { __typename?: 'CustomerFolderType', code: string }, contactPerson?: { __typename?: 'ContactPerson', id: string, inputValues: Array<{ __typename?: 'CorporationsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'PersonsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ScalarInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } }> } | null, owner?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null, folderFiles: { __typename?: 'CustomerFolderFilesPage', summaries: Array<{ __typename?: 'FolderFile', id: string, workflowStatus: { __typename?: 'FolderFileWorkflowStatus', lastModification: string, state: { __typename?: 'State', code: string } }, riskStatus: { __typename?: 'FileRiskStatus', standardRiskLevel: RiskLevel, globalRiskLevel: RiskLevel, forcedRisk?: { __typename?: 'ForcedRisk', level: RiskLevel, reason: { __typename?: 'StandardListElement', id: string, name: string, code: string } } | null }, currentCustomerFolder: { __typename?: 'CustomerFolder', missions: Array<{ __typename?: 'Mission', id: string, isEditable: boolean, isClosable: boolean, adminStatus: { __typename?: 'AdminStatus', lastModification: string, creation: string } }> } }> }, missions: Array<{ __typename?: 'Mission', id: string, isEditable: boolean, isClosable: boolean, isReopenable: boolean, status: MissionStatus, statusComment?: string | null, adminStatus: { __typename?: 'AdminStatus', lastModification: string, creation: string }, inputValues: Array<{ __typename?: 'CorporationsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'PersonsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ScalarInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } }> }>, followingUsers: Array<{ __typename?: 'User', id: string, firstName: string, lastName: string }> }, fileCustomerFolder: { __typename?: 'FileCustomerFolder', id: string, missions: Array<{ __typename?: 'Mission', id: string, isEditable: boolean, isClosable: boolean, isReopenable: boolean, status: MissionStatus, statusComment?: string | null, adminStatus: { __typename?: 'AdminStatus', lastModification: string, creation: string }, inputValues: Array<{ __typename?: 'CorporationsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'PersonsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ScalarInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } }> }>, customer: { __typename?: 'Corporation', id: string, isPerson: boolean, allInputValues: Array<{ __typename?: 'CorporationsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'PersonsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ScalarInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } }> } | { __typename?: 'Person', id: string, isPerson: boolean, allInputValues: Array<{ __typename?: 'CorporationsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'PersonsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ScalarInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } }> } | { __typename?: 'PersonGroup', id: string, isPerson: boolean, allInputValues: Array<{ __typename?: 'CorporationsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'PersonsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ScalarInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } }> }, stakeholders: Array<{ __typename?: 'FolderStakeholder', beneficiaryOwner: boolean, isFolderCustomer: boolean, isLegalRepresentative: boolean, entity: { __typename?: 'Corporation', id: string, eReputation?: { __typename?: 'Ereputation', entries: Array<{ __typename?: 'EReputationEntry', providerResult: boolean, category: { __typename?: 'EReputationCategory', code: string }, analysis?: { __typename?: 'EReputationAnalysis', name: string } | null }> } | null } | { __typename?: 'Person', id: string, eReputation?: { __typename?: 'Ereputation', entries: Array<{ __typename?: 'EReputationEntry', providerResult: boolean, category: { __typename?: 'EReputationCategory', code: string }, analysis?: { __typename?: 'EReputationAnalysis', name: string } | null }> } | null }, inputValues: Array<{ __typename?: 'CorporationsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'PersonsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ScalarInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } }>, supportingDocuments: Array<{ __typename?: 'ExpectedDocument', abstractDocumentType: { __typename?: 'DocumentType', code: string, name: string } | { __typename?: 'DocumentTypeGroup', code: string, name: string }, mainDocument?: { __typename: 'Document', id: string, status: DocumentStatus, name?: string | null, expirationDate?: string | null, type: { __typename?: 'DocumentType', name: string, code: string } } | { __typename: 'ExternalDocument', id: string, type: { __typename?: 'DocumentType', name: string, code: string } } | null }> }>, supportingQuestionnaires: Array<{ __typename?: 'SupportingQuestionnaire', questionnaire?: { __typename?: 'Questionnaire', id: string, isEditable: boolean, content?: string | null, type: { __typename?: 'QuestionnaireType', id: string, code: string, corpSchema: string } } | null }> }, diligences: Array<{ __typename?: 'Diligence', id: string, name: string, selected: boolean, code?: string | null, category?: string | null }> } | null };

export type FolderFileSummaryNotaireQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FolderFileSummaryNotaireQuery = { __typename?: 'Query', folderFile?: { __typename?: 'FolderFile', id: string, currentCustomerFolder: { __typename?: 'CustomerFolder', id: string, contactPerson?: { __typename?: 'ContactPerson', id: string, inputValues: Array<{ __typename?: 'CorporationsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'PersonsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ScalarInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } }> } | null, owner?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null, customer: { __typename?: 'Corporation', id: string, isPerson: boolean, inputValues: Array<{ __typename?: 'CorporationsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'PersonsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ScalarInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } }> } | { __typename?: 'Person', id: string, isPerson: boolean, inputValues: Array<{ __typename?: 'CorporationsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'PersonsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ScalarInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } }> } | { __typename?: 'PersonGroup', id: string, isPerson: boolean, inputValues: Array<{ __typename?: 'CorporationsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'PersonsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ScalarInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } }> }, folderFiles: { __typename?: 'CustomerFolderFilesPage', summaries: Array<{ __typename?: 'FolderFile', id: string, workflowStatus: { __typename?: 'FolderFileWorkflowStatus', state: { __typename?: 'State', code: string } }, inputValues: Array<{ __typename?: 'CorporationsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'PersonsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ScalarInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } }>, adminStatus: { __typename?: 'AdminStatus', creation: string }, riskStatus: { __typename?: 'FileRiskStatus', globalRiskLevel: RiskLevel } }> } } } | null };

export type FolderFilesCountQueryVariables = Exact<{
  draftState: Array<Scalars['String']['input']> | Scalars['String']['input'];
  validationPendingState: Array<Scalars['String']['input']> | Scalars['String']['input'];
  validationPendingHrState: Array<Scalars['String']['input']> | Scalars['String']['input'];
  missionCreation: Array<Scalars['String']['input']> | Scalars['String']['input'];
  validatedState: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type FolderFilesCountQuery = { __typename?: 'Query', draft: { __typename?: 'FolderFilesPage', pageInfo: { __typename?: 'PageInfo', totalCount: number } }, validationPending: { __typename?: 'FolderFilesPage', pageInfo: { __typename?: 'PageInfo', totalCount: number } }, validationPendingHr: { __typename?: 'FolderFilesPage', pageInfo: { __typename?: 'PageInfo', totalCount: number } }, renewal: { __typename?: 'CustomerFoldersPage', pageInfo: { __typename?: 'PageInfo', totalCount: number } }, validated: { __typename?: 'LastModifiedFolderFilePerCurrentCustomerFolderPage', pageInfo: { __typename?: 'PageInfo', totalCount: number } } };

export type FolderFilesPageNotaireQueryVariables = Exact<{
  stateIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  folderFileType?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  sort?: InputMaybe<Array<FolderFilesPageSortingFieldInputType> | FolderFilesPageSortingFieldInputType>;
  offset: Scalars['Int']['input'];
}>;


export type FolderFilesPageNotaireQuery = { __typename?: 'Query', folderFilesPage: { __typename?: 'FolderFilesPage', summaries: Array<{ __typename?: 'FolderFileSummary', customer: { __typename?: 'Corporation', isPerson: boolean, allInputValues: Array<{ __typename?: 'CorporationsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'PersonsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ScalarInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } }> } | { __typename?: 'Person', isPerson: boolean, allInputValues: Array<{ __typename?: 'CorporationsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'PersonsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ScalarInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } }> } | { __typename?: 'PersonGroup', isPerson: boolean, allInputValues: Array<{ __typename?: 'CorporationsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'PersonsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ScalarInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } }> }, folderFile: { __typename?: 'FolderFile', id: string, currentCustomerFolder: { __typename?: 'CustomerFolder', owner?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null, folderFiles: { __typename?: 'CustomerFolderFilesPage', pageInfo: { __typename?: 'PageInfo', totalCount: number } } }, riskStatus: { __typename?: 'FileRiskStatus', globalRiskLevel: RiskLevel }, adminStatus: { __typename?: 'AdminStatus', lastModification: string, author: { __typename?: 'User', name: string } } } }>, pageInfo: { __typename?: 'PageInfo', totalCount: number } } };

export type FolderFilesPageQueryVariables = Exact<{
  stateIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  folderFileType?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  ownerUserIdFilter?: InputMaybe<Scalars['String']['input']>;
  followedByUserIdFilter?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<FolderFilesPageSortingFieldInputType> | FolderFilesPageSortingFieldInputType>;
}>;


export type FolderFilesPageQuery = { __typename?: 'Query', folderFilesPage: { __typename?: 'FolderFilesPage', summaries: Array<{ __typename?: 'FolderFileSummary', customer: { __typename?: 'Corporation', allInputValues: Array<{ __typename?: 'CorporationsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'PersonsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ScalarInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } }> } | { __typename?: 'Person', allInputValues: Array<{ __typename?: 'CorporationsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'PersonsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ScalarInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } }> } | { __typename?: 'PersonGroup', allInputValues: Array<{ __typename?: 'CorporationsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'PersonsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ScalarInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } }> }, folderFile: { __typename?: 'FolderFile', id: string, currentCustomerFolder: { __typename?: 'CustomerFolder', followedByCurrentUser: boolean, owner?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null, followingUsers: Array<{ __typename?: 'User', id: string, firstName: string, lastName: string }>, customerFolderType: { __typename?: 'CustomerFolderType', code: string } }, riskStatus: { __typename?: 'FileRiskStatus', globalRiskLevel: RiskLevel, riskDetail: { __typename?: 'RiskDetail', axesStatus: Array<{ __typename?: 'AxisStatus', riskLevel: RiskLevel, axisName: string, risks: Array<{ __typename?: 'Risk', item: RiskItem }> }> } }, adminStatus: { __typename?: 'AdminStatus', lastModification: string, lastModifier: { __typename?: 'User', name: string } } } }>, pageInfo: { __typename?: 'PageInfo', totalCount: number } } };

export type FolderFilesPageNotaireHrQueryVariables = Exact<{
  stateIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  folderFileType?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  sort?: InputMaybe<Array<FolderFilesPageSortingFieldInputType> | FolderFilesPageSortingFieldInputType>;
  offset: Scalars['Int']['input'];
}>;


export type FolderFilesPageNotaireHrQuery = { __typename?: 'Query', folderFilesPage: { __typename?: 'FolderFilesPage', summaries: Array<{ __typename?: 'FolderFileSummary', customer: { __typename?: 'Corporation', isPerson: boolean, allInputValues: Array<{ __typename?: 'CorporationsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'PersonsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ScalarInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } }> } | { __typename?: 'Person', isPerson: boolean, allInputValues: Array<{ __typename?: 'CorporationsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'PersonsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ScalarInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } }> } | { __typename?: 'PersonGroup', isPerson: boolean, allInputValues: Array<{ __typename?: 'CorporationsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'PersonsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ScalarInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } }> }, folderFile: { __typename?: 'FolderFile', id: string, currentCustomerFolder: { __typename?: 'CustomerFolder', owner?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null, folderFiles: { __typename?: 'CustomerFolderFilesPage', pageInfo: { __typename?: 'PageInfo', totalCount: number } } }, riskStatus: { __typename?: 'FileRiskStatus', globalRiskLevel: RiskLevel, riskDetail: { __typename?: 'RiskDetail', axesStatus: Array<{ __typename?: 'AxisStatus', riskLevel: RiskLevel, axisName: string, risks: Array<{ __typename?: 'Risk', item: RiskItem }> }> } }, adminStatus: { __typename?: 'AdminStatus', lastModification: string, author: { __typename?: 'User', name: string } } } }>, pageInfo: { __typename?: 'PageInfo', totalCount: number } } };

export type FolderFilesPageHrQueryVariables = Exact<{
  stateIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  folderFileType?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  sort?: InputMaybe<Array<FolderFilesPageSortingFieldInputType> | FolderFilesPageSortingFieldInputType>;
  offset: Scalars['Int']['input'];
  ownerUserIdFilter?: InputMaybe<Scalars['String']['input']>;
  followedByUserIdFilter?: InputMaybe<Scalars['String']['input']>;
}>;


export type FolderFilesPageHrQuery = { __typename?: 'Query', folderFilesPage: { __typename?: 'FolderFilesPage', summaries: Array<{ __typename?: 'FolderFileSummary', customer: { __typename?: 'Corporation', allInputValues: Array<{ __typename?: 'CorporationsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'PersonsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ScalarInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } }> } | { __typename?: 'Person', allInputValues: Array<{ __typename?: 'CorporationsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'PersonsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ScalarInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } }> } | { __typename?: 'PersonGroup', allInputValues: Array<{ __typename?: 'CorporationsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'PersonsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ScalarInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } }> }, folderFile: { __typename?: 'FolderFile', id: string, currentCustomerFolder: { __typename?: 'CustomerFolder', followedByCurrentUser: boolean, owner?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null, followingUsers: Array<{ __typename?: 'User', id: string, firstName: string, lastName: string }>, customerFolderType: { __typename?: 'CustomerFolderType', code: string } }, riskStatus: { __typename?: 'FileRiskStatus', globalRiskLevel: RiskLevel, riskDetail: { __typename?: 'RiskDetail', axesStatus: Array<{ __typename?: 'AxisStatus', riskLevel: RiskLevel, axisName: string, risks: Array<{ __typename?: 'Risk', item: RiskItem }> }> } }, adminStatus: { __typename?: 'AdminStatus', lastModification: string, lastModifier: { __typename?: 'User', name: string } } } }>, pageInfo: { __typename?: 'PageInfo', totalCount: number } } };

export type FolderFilesPageWithRiskDetailsNotaireQueryVariables = Exact<{
  stateIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  folderFileType?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  sort?: InputMaybe<Array<FolderFilesPageSortingFieldInputType> | FolderFilesPageSortingFieldInputType>;
}>;


export type FolderFilesPageWithRiskDetailsNotaireQuery = { __typename?: 'Query', folderFilesPage: { __typename?: 'FolderFilesPage', summaries: Array<{ __typename?: 'FolderFileSummary', customer: { __typename?: 'Corporation', isPerson: boolean, allInputValues: Array<{ __typename?: 'CorporationsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'PersonsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ScalarInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } }> } | { __typename?: 'Person', isPerson: boolean, allInputValues: Array<{ __typename?: 'CorporationsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'PersonsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ScalarInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } }> } | { __typename?: 'PersonGroup', isPerson: boolean, allInputValues: Array<{ __typename?: 'CorporationsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'PersonsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ScalarInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } }> }, folderFile: { __typename?: 'FolderFile', id: string, currentCustomerFolder: { __typename?: 'CustomerFolder', owner?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null, folderFiles: { __typename?: 'CustomerFolderFilesPage', pageInfo: { __typename?: 'PageInfo', totalCount: number } } }, riskStatus: { __typename?: 'FileRiskStatus', globalRiskLevel: RiskLevel, riskDetail: { __typename?: 'RiskDetail', axesStatus: Array<{ __typename?: 'AxisStatus', axisName: string, riskLevel: RiskLevel }> } }, adminStatus: { __typename?: 'AdminStatus', lastModification: string, author: { __typename?: 'User', name: string } } } }>, pageInfo: { __typename?: 'PageInfo', totalCount: number } } };

export type FolderFilesPageWithRiskDetailsQueryVariables = Exact<{
  stateIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  folderFileType?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  sort?: InputMaybe<Array<FolderFilesPageSortingFieldInputType> | FolderFilesPageSortingFieldInputType>;
  offset: Scalars['Int']['input'];
  ownerUserIdFilter?: InputMaybe<Scalars['String']['input']>;
  followedByUserIdFilter?: InputMaybe<Scalars['String']['input']>;
}>;


export type FolderFilesPageWithRiskDetailsQuery = { __typename?: 'Query', folderFilesPage: { __typename?: 'FolderFilesPage', summaries: Array<{ __typename?: 'FolderFileSummary', customer: { __typename?: 'Corporation', allInputValues: Array<{ __typename?: 'CorporationsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'PersonsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ScalarInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } }> } | { __typename?: 'Person', allInputValues: Array<{ __typename?: 'CorporationsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'PersonsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ScalarInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } }> } | { __typename?: 'PersonGroup', allInputValues: Array<{ __typename?: 'CorporationsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'PersonsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ScalarInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } }> }, folderFile: { __typename?: 'FolderFile', id: string, currentCustomerFolder: { __typename?: 'CustomerFolder', followedByCurrentUser: boolean, owner?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null, followingUsers: Array<{ __typename?: 'User', id: string, firstName: string, lastName: string }> }, riskStatus: { __typename?: 'FileRiskStatus', globalRiskLevel: RiskLevel, riskDetail: { __typename?: 'RiskDetail', axesStatus: Array<{ __typename?: 'AxisStatus', axisName: string, riskLevel: RiskLevel }> } }, adminStatus: { __typename?: 'AdminStatus', lastModification: string, lastModifier: { __typename?: 'User', name: string } } } }>, pageInfo: { __typename?: 'PageInfo', totalCount: number } } };

export type FoldersUsingEntityQueryVariables = Exact<{
  entityId: Scalars['ID']['input'];
  limit?: Scalars['Int']['input'];
}>;


export type FoldersUsingEntityQuery = { __typename?: 'Query', foldersUsingEntity: { __typename?: 'CustomerFoldersPage', summaries: Array<{ __typename?: 'CustomerFolderSummary', customerFolder: { __typename?: 'CustomerFolder', id: string, customer: { __typename?: 'Corporation', id: string, name?: { __typename?: 'CorporationsInputValue', stringValue?: string | null } | { __typename?: 'ElementInputValue', stringValue?: string | null } | { __typename?: 'ElementsInputValue', stringValue?: string | null } | { __typename?: 'PersonsInputValue', stringValue?: string | null } | { __typename?: 'ScalarInputValue', stringValue?: string | null } | null } | { __typename?: 'Person', id: string, name?: { __typename?: 'CorporationsInputValue', stringValue?: string | null } | { __typename?: 'ElementInputValue', stringValue?: string | null } | { __typename?: 'ElementsInputValue', stringValue?: string | null } | { __typename?: 'PersonsInputValue', stringValue?: string | null } | { __typename?: 'ScalarInputValue', stringValue?: string | null } | null } | { __typename?: 'PersonGroup', id: string, name?: { __typename?: 'CorporationsInputValue', stringValue?: string | null } | { __typename?: 'ElementInputValue', stringValue?: string | null } | { __typename?: 'ElementsInputValue', stringValue?: string | null } | { __typename?: 'PersonsInputValue', stringValue?: string | null } | { __typename?: 'ScalarInputValue', stringValue?: string | null } | null } } }> } };

export type ForcedRiskReasonListQueryVariables = Exact<{ [key: string]: never; }>;


export type ForcedRiskReasonListQuery = { __typename?: 'Query', listElements: Array<{ __typename?: 'ContactPersonType', id: string, code: string, name: string } | { __typename?: 'Country', id: string, code: string, name: string } | { __typename?: 'CustomerFolderType', id: string, code: string, name: string } | { __typename?: 'DccpAlertType', id: string, code: string, name: string } | { __typename?: 'DiligenceDefinition', id: string, code: string, name: string } | { __typename?: 'DocumentType', id: string, code: string, name: string } | { __typename?: 'DocumentTypeGroup', id: string, code: string, name: string } | { __typename?: 'EntityType', id: string, code: string, name: string } | { __typename?: 'EReputationAnalysis', id: string, code: string, name: string } | { __typename?: 'EReputationCategory', id: string, code: string, name: string } | { __typename?: 'Family', id: string, code: string, name: string } | { __typename?: 'FolderFileType', id: string, code: string, name: string } | { __typename?: 'MissionType', id: string, code: string, name: string } | { __typename?: 'QuestionnaireType', id: string, code: string, name: string } | { __typename?: 'RelatedEntityType', id: string, code: string, name: string } | { __typename?: 'StandardListElement', id: string, code: string, name: string } | { __typename?: 'SubsidiaryType', id: string, code: string, name: string } | { __typename?: 'ThirdPartyFolderType', id: string, code: string, name: string }> };

export type GetContactsQueryVariables = Exact<{
  customerFolderId: Scalars['ID']['input'];
}>;


export type GetContactsQuery = { __typename?: 'Query', customerFolder?: { __typename?: 'CustomerFolder', owner?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null, contactPerson?: { __typename?: 'ContactPerson', id: string, inputValues: Array<{ __typename?: 'CorporationsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'PersonsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ScalarInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } }> } | null } | null };

export type GetFeaturesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFeaturesQuery = { __typename?: 'Query', features: { __typename?: 'Features', flaminemPro: boolean, notary: boolean } };

export type GetUsersQueryVariables = Exact<{
  string?: Scalars['String']['input'];
  allowedGroups?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetUsersQuery = { __typename?: 'Query', searchUsers: Array<{ __typename?: 'User', id: string, firstName: string, lastName: string, email: string, groups: Array<{ __typename?: 'UserGroup', definition: { __typename?: 'UserGroupDefinition', name: string, code: string } }> }> };

export type LastModifiedFolderFilePerCurrentCustomerFolderQueryVariables = Exact<{
  fileStateIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  customerFolderTypeCodesFilter?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  sort?: InputMaybe<Array<LastModifiedFolderFilePerCurrentCustomerFolderPageSortingFieldInputType> | LastModifiedFolderFilePerCurrentCustomerFolderPageSortingFieldInputType>;
  offset: Scalars['Int']['input'];
  ownerUserIdFilter?: InputMaybe<Scalars['String']['input']>;
  followedByUserIdFilter?: InputMaybe<Scalars['String']['input']>;
}>;


export type LastModifiedFolderFilePerCurrentCustomerFolderQuery = { __typename?: 'Query', lastModifiedFolderFilePerCurrentCustomerFolder: { __typename?: 'LastModifiedFolderFilePerCurrentCustomerFolderPage', content: Array<{ __typename?: 'LastModifiedFolderFilePerCurrentCustomerFolderSummary', currentCustomer: { __typename?: 'Corporation', allInputValues: Array<{ __typename?: 'CorporationsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'PersonsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ScalarInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } }> } | { __typename?: 'Person', allInputValues: Array<{ __typename?: 'CorporationsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'PersonsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ScalarInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } }> } | { __typename?: 'PersonGroup', allInputValues: Array<{ __typename?: 'CorporationsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'PersonsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ScalarInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } }> }, lastModifiedFolderFile: { __typename?: 'FolderFile', id: string, currentCustomerFolder: { __typename?: 'CustomerFolder', followedByCurrentUser: boolean, owner?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null, followingUsers: Array<{ __typename?: 'User', id: string, firstName: string, lastName: string }>, customerFolderType: { __typename?: 'CustomerFolderType', code: string } }, riskStatus: { __typename?: 'FileRiskStatus', globalRiskLevel: RiskLevel, riskDetail: { __typename?: 'RiskDetail', axesStatus: Array<{ __typename?: 'AxisStatus', axisName: string, riskLevel: RiskLevel }> } }, adminStatus: { __typename?: 'AdminStatus', lastModification: string, lastModifier: { __typename?: 'User', name: string } } } }>, pageInfo: { __typename?: 'PageInfo', totalCount: number } } };

export type LastModifiedFolderFilePerCurrentCustomerFolderCountQueryVariables = Exact<{ [key: string]: never; }>;


export type LastModifiedFolderFilePerCurrentCustomerFolderCountQuery = { __typename?: 'Query', validated: { __typename?: 'LastModifiedFolderFilePerCurrentCustomerFolderPage', pageInfo: { __typename?: 'PageInfo', totalCount: number } } };

export type LastModifiedFolderFilePerCurrentCustomerFolderExtractQueryVariables = Exact<{
  offset: Scalars['Int']['input'];
}>;


export type LastModifiedFolderFilePerCurrentCustomerFolderExtractQuery = { __typename?: 'Query', lastModifiedFolderFilePerCurrentCustomerFolder: { __typename?: 'LastModifiedFolderFilePerCurrentCustomerFolderPage', content: Array<{ __typename?: 'LastModifiedFolderFilePerCurrentCustomerFolderSummary', currentCustomer: { __typename?: 'Corporation', isPerson: boolean, name?: { __typename?: 'CorporationsInputValue', stringValue?: string | null } | { __typename?: 'ElementInputValue', stringValue?: string | null } | { __typename?: 'ElementsInputValue', stringValue?: string | null } | { __typename?: 'PersonsInputValue', stringValue?: string | null } | { __typename?: 'ScalarInputValue', stringValue?: string | null } | null, firstName?: { __typename?: 'CorporationsInputValue', stringValue?: string | null } | { __typename?: 'ElementInputValue', stringValue?: string | null } | { __typename?: 'ElementsInputValue', stringValue?: string | null } | { __typename?: 'PersonsInputValue', stringValue?: string | null } | { __typename?: 'ScalarInputValue', stringValue?: string | null } | null, lastName?: { __typename?: 'CorporationsInputValue', stringValue?: string | null } | { __typename?: 'ElementInputValue', stringValue?: string | null } | { __typename?: 'ElementsInputValue', stringValue?: string | null } | { __typename?: 'PersonsInputValue', stringValue?: string | null } | { __typename?: 'ScalarInputValue', stringValue?: string | null } | null, registrationCountryCode?: { __typename?: 'CorporationsInputValue', stringValue?: string | null } | { __typename?: 'ElementInputValue', stringValue?: string | null } | { __typename?: 'ElementsInputValue', stringValue?: string | null } | { __typename?: 'PersonsInputValue', stringValue?: string | null } | { __typename?: 'ScalarInputValue', stringValue?: string | null } | null } | { __typename?: 'Person', isPerson: boolean, name?: { __typename?: 'CorporationsInputValue', stringValue?: string | null } | { __typename?: 'ElementInputValue', stringValue?: string | null } | { __typename?: 'ElementsInputValue', stringValue?: string | null } | { __typename?: 'PersonsInputValue', stringValue?: string | null } | { __typename?: 'ScalarInputValue', stringValue?: string | null } | null, firstName?: { __typename?: 'CorporationsInputValue', stringValue?: string | null } | { __typename?: 'ElementInputValue', stringValue?: string | null } | { __typename?: 'ElementsInputValue', stringValue?: string | null } | { __typename?: 'PersonsInputValue', stringValue?: string | null } | { __typename?: 'ScalarInputValue', stringValue?: string | null } | null, lastName?: { __typename?: 'CorporationsInputValue', stringValue?: string | null } | { __typename?: 'ElementInputValue', stringValue?: string | null } | { __typename?: 'ElementsInputValue', stringValue?: string | null } | { __typename?: 'PersonsInputValue', stringValue?: string | null } | { __typename?: 'ScalarInputValue', stringValue?: string | null } | null, registrationCountryCode?: { __typename?: 'CorporationsInputValue', stringValue?: string | null } | { __typename?: 'ElementInputValue', stringValue?: string | null } | { __typename?: 'ElementsInputValue', stringValue?: string | null } | { __typename?: 'PersonsInputValue', stringValue?: string | null } | { __typename?: 'ScalarInputValue', stringValue?: string | null } | null } | { __typename?: 'PersonGroup', isPerson: boolean, name?: { __typename?: 'CorporationsInputValue', stringValue?: string | null } | { __typename?: 'ElementInputValue', stringValue?: string | null } | { __typename?: 'ElementsInputValue', stringValue?: string | null } | { __typename?: 'PersonsInputValue', stringValue?: string | null } | { __typename?: 'ScalarInputValue', stringValue?: string | null } | null, firstName?: { __typename?: 'CorporationsInputValue', stringValue?: string | null } | { __typename?: 'ElementInputValue', stringValue?: string | null } | { __typename?: 'ElementsInputValue', stringValue?: string | null } | { __typename?: 'PersonsInputValue', stringValue?: string | null } | { __typename?: 'ScalarInputValue', stringValue?: string | null } | null, lastName?: { __typename?: 'CorporationsInputValue', stringValue?: string | null } | { __typename?: 'ElementInputValue', stringValue?: string | null } | { __typename?: 'ElementsInputValue', stringValue?: string | null } | { __typename?: 'PersonsInputValue', stringValue?: string | null } | { __typename?: 'ScalarInputValue', stringValue?: string | null } | null, registrationCountryCode?: { __typename?: 'CorporationsInputValue', stringValue?: string | null } | { __typename?: 'ElementInputValue', stringValue?: string | null } | { __typename?: 'ElementsInputValue', stringValue?: string | null } | { __typename?: 'PersonsInputValue', stringValue?: string | null } | { __typename?: 'ScalarInputValue', stringValue?: string | null } | null }, lastModifiedFolderFile: { __typename?: 'FolderFile', id: string, currentCustomerFolder: { __typename?: 'CustomerFolder', owner?: { __typename?: 'User', firstName: string, lastName: string } | null }, fileCustomerFolder: { __typename?: 'FileCustomerFolder', stakeholders: Array<{ __typename?: 'FolderStakeholder', residenceCountryCode?: { __typename?: 'CorporationsInputValue', stringValue?: string | null } | { __typename?: 'ElementInputValue', stringValue?: string | null } | { __typename?: 'ElementsInputValue', stringValue?: string | null } | { __typename?: 'PersonsInputValue', stringValue?: string | null } | { __typename?: 'ScalarInputValue', stringValue?: string | null } | null }> }, riskStatus: { __typename?: 'FileRiskStatus', globalRiskLevel: RiskLevel, forcedRisk?: { __typename?: 'ForcedRisk', reason: { __typename?: 'StandardListElement', name: string } } | null, riskDetail: { __typename?: 'RiskDetail', axesStatus: Array<{ __typename?: 'AxisStatus', axisName: string, riskLevel: RiskLevel, risks: Array<{ __typename?: 'Risk', item: RiskItem }> }> } }, adminStatus: { __typename?: 'AdminStatus', lastModification: string } } }> } };

export type LegalStatusListQueryVariables = Exact<{ [key: string]: never; }>;


export type LegalStatusListQuery = { __typename?: 'Query', listElements: Array<{ __typename?: 'ContactPersonType', id: string, code: string, name: string } | { __typename?: 'Country', id: string, code: string, name: string } | { __typename?: 'CustomerFolderType', id: string, code: string, name: string } | { __typename?: 'DccpAlertType', id: string, code: string, name: string } | { __typename?: 'DiligenceDefinition', id: string, code: string, name: string } | { __typename?: 'DocumentType', id: string, code: string, name: string } | { __typename?: 'DocumentTypeGroup', id: string, code: string, name: string } | { __typename?: 'EntityType', id: string, code: string, name: string } | { __typename?: 'EReputationAnalysis', id: string, code: string, name: string } | { __typename?: 'EReputationCategory', id: string, code: string, name: string } | { __typename?: 'Family', id: string, code: string, name: string } | { __typename?: 'FolderFileType', id: string, code: string, name: string } | { __typename?: 'MissionType', id: string, code: string, name: string } | { __typename?: 'QuestionnaireType', id: string, code: string, name: string } | { __typename?: 'RelatedEntityType', id: string, code: string, name: string } | { __typename?: 'StandardListElement', id: string, code: string, name: string } | { __typename?: 'SubsidiaryType', id: string, code: string, name: string } | { __typename?: 'ThirdPartyFolderType', id: string, code: string, name: string }> };

export type LegalStatusListPphQueryVariables = Exact<{ [key: string]: never; }>;


export type LegalStatusListPphQuery = { __typename?: 'Query', listElements: Array<{ __typename?: 'ContactPersonType', id: string, code: string, name: string } | { __typename?: 'Country', id: string, code: string, name: string } | { __typename?: 'CustomerFolderType', id: string, code: string, name: string } | { __typename?: 'DccpAlertType', id: string, code: string, name: string } | { __typename?: 'DiligenceDefinition', id: string, code: string, name: string } | { __typename?: 'DocumentType', id: string, code: string, name: string } | { __typename?: 'DocumentTypeGroup', id: string, code: string, name: string } | { __typename?: 'EntityType', id: string, code: string, name: string } | { __typename?: 'EReputationAnalysis', id: string, code: string, name: string } | { __typename?: 'EReputationCategory', id: string, code: string, name: string } | { __typename?: 'Family', id: string, code: string, name: string } | { __typename?: 'FolderFileType', id: string, code: string, name: string } | { __typename?: 'MissionType', id: string, code: string, name: string } | { __typename?: 'QuestionnaireType', id: string, code: string, name: string } | { __typename?: 'RelatedEntityType', id: string, code: string, name: string } | { __typename?: 'StandardListElement', id: string, code: string, name: string } | { __typename?: 'SubsidiaryType', id: string, code: string, name: string } | { __typename?: 'ThirdPartyFolderType', id: string, code: string, name: string }> };

export type LegalTypesWithRiskListQueryVariables = Exact<{ [key: string]: never; }>;


export type LegalTypesWithRiskListQuery = { __typename?: 'Query', listElements: Array<{ __typename?: 'ContactPersonType' } | { __typename?: 'Country' } | { __typename?: 'CustomerFolderType' } | { __typename?: 'DccpAlertType' } | { __typename?: 'DiligenceDefinition' } | { __typename?: 'DocumentType' } | { __typename?: 'DocumentTypeGroup' } | { __typename?: 'EntityType', id: string, code: string, name: string, riskValues: Array<{ __typename?: 'RiskValue', description?: string | null, riskCategory: RiskCategory, key: string }> } | { __typename?: 'EReputationAnalysis' } | { __typename?: 'EReputationCategory' } | { __typename?: 'Family' } | { __typename?: 'FolderFileType' } | { __typename?: 'MissionType' } | { __typename?: 'QuestionnaireType' } | { __typename?: 'RelatedEntityType' } | { __typename?: 'StandardListElement' } | { __typename?: 'SubsidiaryType' } | { __typename?: 'ThirdPartyFolderType' }> };

export type MissionsListQueryVariables = Exact<{ [key: string]: never; }>;


export type MissionsListQuery = { __typename?: 'Query', listElements: Array<{ __typename?: 'ContactPersonType' } | { __typename?: 'Country' } | { __typename?: 'CustomerFolderType' } | { __typename?: 'DccpAlertType' } | { __typename?: 'DiligenceDefinition' } | { __typename?: 'DocumentType' } | { __typename?: 'DocumentTypeGroup' } | { __typename?: 'EntityType' } | { __typename?: 'EReputationAnalysis' } | { __typename?: 'EReputationCategory' } | { __typename?: 'Family' } | { __typename?: 'FolderFileType' } | { __typename?: 'MissionType', id: string, code: string, name: string, riskValues: Array<{ __typename?: 'RiskValue', description?: string | null, riskCategory: RiskCategory, key: string }> } | { __typename?: 'QuestionnaireType' } | { __typename?: 'RelatedEntityType' } | { __typename?: 'StandardListElement' } | { __typename?: 'SubsidiaryType' } | { __typename?: 'ThirdPartyFolderType' }> };

export type PersonEReputationDjDetailsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PersonEReputationDjDetailsQuery = { __typename?: 'Query', entity?: { __typename?: 'Corporation', id: string, eReputation?: { __typename?: 'Ereputation', details?: { __typename?: 'EReputationDetail', idERep: string, format: FormatEnum, searchResults: string, detailedResults: Array<{ __typename?: 'DetailedResult', positionInSearchResults: number, content: string }> } | null } | null } | { __typename?: 'Person', id: string, eReputation?: { __typename?: 'Ereputation', details?: { __typename?: 'EReputationDetail', idERep: string, format: FormatEnum, searchResults: string, detailedResults: Array<{ __typename?: 'DetailedResult', positionInSearchResults: number, content: string }> } | null } | null } | null };

export type SearchClientByStringQueryVariables = Exact<{
  searchString: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchClientByStringQuery = { __typename?: 'Query', folderFilesPage: { __typename?: 'FolderFilesPage', summaries: Array<{ __typename?: 'FolderFileSummary', customer: { __typename?: 'Corporation', inputValues: Array<{ __typename?: 'CorporationsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'PersonsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ScalarInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } }> } | { __typename?: 'Person', inputValues: Array<{ __typename?: 'CorporationsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'PersonsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ScalarInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } }> } | { __typename?: 'PersonGroup', inputValues: Array<{ __typename?: 'CorporationsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'PersonsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ScalarInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } }> }, folderFile: { __typename?: 'FolderFile', id: string } }>, pageInfo: { __typename?: 'PageInfo', totalCount: number } } };

export type SearchCustomerFolderByStringQueryVariables = Exact<{
  searchString: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  displayOnlyUserFolders?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SearchCustomerFolderByStringQuery = { __typename?: 'Query', customerFoldersPage: { __typename?: 'CustomerFoldersPage', pageInfo: { __typename?: 'PageInfo', totalCount: number }, summaries: Array<{ __typename?: 'CustomerFolderSummary', customer: { __typename?: 'Corporation', isPerson: boolean, inputValues: Array<{ __typename?: 'CorporationsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'PersonsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ScalarInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } }> } | { __typename?: 'Person', isPerson: boolean, inputValues: Array<{ __typename?: 'CorporationsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'PersonsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ScalarInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } }> } | { __typename?: 'PersonGroup', isPerson: boolean, inputValues: Array<{ __typename?: 'CorporationsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'PersonsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ScalarInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } }> }, customerFolder: { __typename?: 'CustomerFolder', folderFiles: { __typename?: 'CustomerFolderFilesPage', summaries: Array<{ __typename?: 'FolderFile', id: string, isEditable: boolean, currentCustomerFolder: { __typename?: 'CustomerFolder', stakeholders: Array<{ __typename?: 'FolderStakeholder', inputValues: Array<{ __typename?: 'CorporationsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ElementsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'PersonsInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } } | { __typename?: 'ScalarInputValue', stringValue?: string | null, inputField: { __typename?: 'InputField', fieldCode: string } }> }> } }> } } }> } };

export type SearchPersonByFirstNameAndLastNameQueryVariables = Exact<{
  values: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type SearchPersonByFirstNameAndLastNameQuery = { __typename?: 'Query', advancedPersonSearch: { __typename?: 'PersonPage', persons: Array<{ __typename?: 'Person', id: string, isCustomer: boolean, firstName?: { __typename?: 'CorporationsInputValue', stringValue?: string | null } | { __typename?: 'ElementInputValue', stringValue?: string | null } | { __typename?: 'ElementsInputValue', stringValue?: string | null } | { __typename?: 'PersonsInputValue', stringValue?: string | null } | { __typename?: 'ScalarInputValue', stringValue?: string | null } | null, lastName?: { __typename?: 'CorporationsInputValue', stringValue?: string | null } | { __typename?: 'ElementInputValue', stringValue?: string | null } | { __typename?: 'ElementsInputValue', stringValue?: string | null } | { __typename?: 'PersonsInputValue', stringValue?: string | null } | { __typename?: 'ScalarInputValue', stringValue?: string | null } | null, birthDate?: { __typename?: 'CorporationsInputValue', stringValue?: string | null } | { __typename?: 'ElementInputValue', stringValue?: string | null } | { __typename?: 'ElementsInputValue', stringValue?: string | null } | { __typename?: 'PersonsInputValue', stringValue?: string | null } | { __typename?: 'ScalarInputValue', stringValue?: string | null } | null, customerFolders: Array<{ __typename?: 'CustomerFolder', folderFiles: { __typename?: 'CustomerFolderFilesPage', summaries: Array<{ __typename?: 'FolderFile', id: string }> } }> }> } };

export type SearchPersonByFirstNameAndLastNameAndBirthdateQueryVariables = Exact<{
  values: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type SearchPersonByFirstNameAndLastNameAndBirthdateQuery = { __typename?: 'Query', advancedPersonSearch: { __typename?: 'PersonPage', persons: Array<{ __typename?: 'Person', id: string, isCustomer: boolean, firstName?: { __typename?: 'CorporationsInputValue', stringValue?: string | null } | { __typename?: 'ElementInputValue', stringValue?: string | null } | { __typename?: 'ElementsInputValue', stringValue?: string | null } | { __typename?: 'PersonsInputValue', stringValue?: string | null } | { __typename?: 'ScalarInputValue', stringValue?: string | null } | null, lastName?: { __typename?: 'CorporationsInputValue', stringValue?: string | null } | { __typename?: 'ElementInputValue', stringValue?: string | null } | { __typename?: 'ElementsInputValue', stringValue?: string | null } | { __typename?: 'PersonsInputValue', stringValue?: string | null } | { __typename?: 'ScalarInputValue', stringValue?: string | null } | null, birthDate?: { __typename?: 'CorporationsInputValue', stringValue?: string | null } | { __typename?: 'ElementInputValue', stringValue?: string | null } | { __typename?: 'ElementsInputValue', stringValue?: string | null } | { __typename?: 'PersonsInputValue', stringValue?: string | null } | { __typename?: 'ScalarInputValue', stringValue?: string | null } | null, customerFolders: Array<{ __typename?: 'CustomerFolder', folderFiles: { __typename?: 'CustomerFolderFilesPage', summaries: Array<{ __typename?: 'FolderFile', id: string }> } }> }> } };

export type SearchPersonByRegistrationQueryVariables = Exact<{
  values: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type SearchPersonByRegistrationQuery = { __typename?: 'Query', advancedPersonSearch: { __typename?: 'PersonPage', persons: Array<{ __typename?: 'Person', id: string, siren?: { __typename?: 'CorporationsInputValue', stringValue?: string | null } | { __typename?: 'ElementInputValue', stringValue?: string | null } | { __typename?: 'ElementsInputValue', stringValue?: string | null } | { __typename?: 'PersonsInputValue', stringValue?: string | null } | { __typename?: 'ScalarInputValue', stringValue?: string | null } | null }> } };

export const ContactPersonFieldsFragmentDoc = gql`
    fragment ContactPersonFields on ContactPerson {
  id
  inputValues {
    inputField {
      fieldCode
    }
    stringValue
  }
}
    `;
export const FolderFileDeletionFragmentDoc = gql`
    fragment FolderFileDeletion on FolderFile {
  id
  workflowStatus {
    state {
      code
    }
  }
  currentCustomerFolder {
    id
    folderFiles(limit: 2) {
      summaries {
        id
      }
    }
  }
  fileCustomerFolder {
    customer {
      id
      isPerson
      allInputValues: inputValues {
        inputField {
          fieldCode
        }
        stringValue
      }
    }
  }
}
    `;
export const FolderFilesPageInfoFragmentDoc = gql`
    fragment FolderFilesPageInfo on FolderFilesPage {
  pageInfo {
    totalCount
  }
}
    `;
export const OwnerFieldsFragmentDoc = gql`
    fragment OwnerFields on User {
  id
  firstName
  lastName
}
    `;
export const UserWithRolesFieldsFragmentDoc = gql`
    fragment UserWithRolesFields on User {
  id
  firstName
  lastName
  email
  groups {
    definition {
      name
      code
    }
  }
}
    `;
export const AddMessageDocument = gql`
    mutation addMessage($messageThreadId: ID!, $content: String!) {
  addMessage(messageThreadId: $messageThreadId, content: $content) {
    id
  }
}
    `;
export type AddMessageMutationFn = Apollo.MutationFunction<AddMessageMutation, AddMessageMutationVariables>;

/**
 * __useAddMessageMutation__
 *
 * To run a mutation, you first call `useAddMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMessageMutation, { data, loading, error }] = useAddMessageMutation({
 *   variables: {
 *      messageThreadId: // value for 'messageThreadId'
 *      content: // value for 'content'
 *   },
 * });
 */
export function useAddMessageMutation(baseOptions?: Apollo.MutationHookOptions<AddMessageMutation, AddMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddMessageMutation, AddMessageMutationVariables>(AddMessageDocument, options);
      }
export type AddMessageMutationHookResult = ReturnType<typeof useAddMessageMutation>;
export type AddMessageMutationResult = Apollo.MutationResult<AddMessageMutation>;
export type AddMessageMutationOptions = Apollo.BaseMutationOptions<AddMessageMutation, AddMessageMutationVariables>;
export const AddStakeholderDocument = gql`
    mutation addStakeholder($reference_0: Reference, $inputValues_0: [InputValueInput!]!, $inputRole_1: RoleInputType!, $corporationId_1: IdOrReference!, $entityId_1: IdOrReference!, $inputRole_2: RoleInputType!, $includeLegalRep: Boolean! = false, $includeDirectBO: Boolean! = false) {
  createPerson_0: createPerson(inputValues: $inputValues_0, reference: $reference_0) {
    id
    __typename
  }
  setLegalRepresentativeRole_1: setRole(roleInput: $inputRole_1, targetEntityId: $corporationId_1, sourceEntityId: $entityId_1) @include(if: $includeLegalRep) {
    __typename
  }
  setDirectBORole_2: setRole(roleInput: $inputRole_2, targetEntityId: $corporationId_1, sourceEntityId: $entityId_1) @include(if: $includeDirectBO) {
    __typename
  }
}
    `;
export type AddStakeholderMutationFn = Apollo.MutationFunction<AddStakeholderMutation, AddStakeholderMutationVariables>;

/**
 * __useAddStakeholderMutation__
 *
 * To run a mutation, you first call `useAddStakeholderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddStakeholderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addStakeholderMutation, { data, loading, error }] = useAddStakeholderMutation({
 *   variables: {
 *      reference_0: // value for 'reference_0'
 *      inputValues_0: // value for 'inputValues_0'
 *      inputRole_1: // value for 'inputRole_1'
 *      corporationId_1: // value for 'corporationId_1'
 *      entityId_1: // value for 'entityId_1'
 *      inputRole_2: // value for 'inputRole_2'
 *      includeLegalRep: // value for 'includeLegalRep'
 *      includeDirectBO: // value for 'includeDirectBO'
 *   },
 * });
 */
export function useAddStakeholderMutation(baseOptions?: Apollo.MutationHookOptions<AddStakeholderMutation, AddStakeholderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddStakeholderMutation, AddStakeholderMutationVariables>(AddStakeholderDocument, options);
      }
export type AddStakeholderMutationHookResult = ReturnType<typeof useAddStakeholderMutation>;
export type AddStakeholderMutationResult = Apollo.MutationResult<AddStakeholderMutation>;
export type AddStakeholderMutationOptions = Apollo.BaseMutationOptions<AddStakeholderMutation, AddStakeholderMutationVariables>;
export const AutoCreateCustomerGraphDocument = gql`
    mutation autoCreateCustomerGraph($siren: String!, $includeIntermediateLegalRepresentatives: Boolean!) {
  autoCreateCustomerGraph(siren: $siren, includeIntermediateLegalRepresentatives: $includeIntermediateLegalRepresentatives) {
    customer {
      id
    }
    errors {
      identifier
      message
    }
  }
}
    `;
export type AutoCreateCustomerGraphMutationFn = Apollo.MutationFunction<AutoCreateCustomerGraphMutation, AutoCreateCustomerGraphMutationVariables>;

/**
 * __useAutoCreateCustomerGraphMutation__
 *
 * To run a mutation, you first call `useAutoCreateCustomerGraphMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAutoCreateCustomerGraphMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [autoCreateCustomerGraphMutation, { data, loading, error }] = useAutoCreateCustomerGraphMutation({
 *   variables: {
 *      siren: // value for 'siren'
 *      includeIntermediateLegalRepresentatives: // value for 'includeIntermediateLegalRepresentatives'
 *   },
 * });
 */
export function useAutoCreateCustomerGraphMutation(baseOptions?: Apollo.MutationHookOptions<AutoCreateCustomerGraphMutation, AutoCreateCustomerGraphMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AutoCreateCustomerGraphMutation, AutoCreateCustomerGraphMutationVariables>(AutoCreateCustomerGraphDocument, options);
      }
export type AutoCreateCustomerGraphMutationHookResult = ReturnType<typeof useAutoCreateCustomerGraphMutation>;
export type AutoCreateCustomerGraphMutationResult = Apollo.MutationResult<AutoCreateCustomerGraphMutation>;
export type AutoCreateCustomerGraphMutationOptions = Apollo.BaseMutationOptions<AutoCreateCustomerGraphMutation, AutoCreateCustomerGraphMutationVariables>;
export const AutoCreatePersonCustomerGraphDocument = gql`
    mutation autoCreatePersonCustomerGraph($siren: String!) {
  autoCreatePersonCustomerGraph(siren: $siren) {
    customer {
      id
    }
    errors {
      identifier
      message
    }
  }
}
    `;
export type AutoCreatePersonCustomerGraphMutationFn = Apollo.MutationFunction<AutoCreatePersonCustomerGraphMutation, AutoCreatePersonCustomerGraphMutationVariables>;

/**
 * __useAutoCreatePersonCustomerGraphMutation__
 *
 * To run a mutation, you first call `useAutoCreatePersonCustomerGraphMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAutoCreatePersonCustomerGraphMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [autoCreatePersonCustomerGraphMutation, { data, loading, error }] = useAutoCreatePersonCustomerGraphMutation({
 *   variables: {
 *      siren: // value for 'siren'
 *   },
 * });
 */
export function useAutoCreatePersonCustomerGraphMutation(baseOptions?: Apollo.MutationHookOptions<AutoCreatePersonCustomerGraphMutation, AutoCreatePersonCustomerGraphMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AutoCreatePersonCustomerGraphMutation, AutoCreatePersonCustomerGraphMutationVariables>(AutoCreatePersonCustomerGraphDocument, options);
      }
export type AutoCreatePersonCustomerGraphMutationHookResult = ReturnType<typeof useAutoCreatePersonCustomerGraphMutation>;
export type AutoCreatePersonCustomerGraphMutationResult = Apollo.MutationResult<AutoCreatePersonCustomerGraphMutation>;
export type AutoCreatePersonCustomerGraphMutationOptions = Apollo.BaseMutationOptions<AutoCreatePersonCustomerGraphMutation, AutoCreatePersonCustomerGraphMutationVariables>;
export const CallEReputationDocument = gql`
    mutation CallEReputation($folderFileId: ID!, $force: Boolean! = false) {
  callEreputation(folderFileId: $folderFileId, force: $force) {
    id
    fileCustomerFolder {
      stakeholders {
        entity {
          id
          eReputation {
            isPep
            isSanction
            entries {
              category {
                code
                name
              }
              providerResult
            }
          }
        }
      }
    }
  }
}
    `;
export type CallEReputationMutationFn = Apollo.MutationFunction<CallEReputationMutation, CallEReputationMutationVariables>;

/**
 * __useCallEReputationMutation__
 *
 * To run a mutation, you first call `useCallEReputationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCallEReputationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [callEReputationMutation, { data, loading, error }] = useCallEReputationMutation({
 *   variables: {
 *      folderFileId: // value for 'folderFileId'
 *      force: // value for 'force'
 *   },
 * });
 */
export function useCallEReputationMutation(baseOptions?: Apollo.MutationHookOptions<CallEReputationMutation, CallEReputationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CallEReputationMutation, CallEReputationMutationVariables>(CallEReputationDocument, options);
      }
export type CallEReputationMutationHookResult = ReturnType<typeof useCallEReputationMutation>;
export type CallEReputationMutationResult = Apollo.MutationResult<CallEReputationMutation>;
export type CallEReputationMutationOptions = Apollo.BaseMutationOptions<CallEReputationMutation, CallEReputationMutationVariables>;
export const CloseMissionDocument = gql`
    mutation CloseMission($missionId: ID!, $statusComment: String!) {
  closeMission(missionId: $missionId, statusComment: $statusComment) {
    id
  }
}
    `;
export type CloseMissionMutationFn = Apollo.MutationFunction<CloseMissionMutation, CloseMissionMutationVariables>;

/**
 * __useCloseMissionMutation__
 *
 * To run a mutation, you first call `useCloseMissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloseMissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closeMissionMutation, { data, loading, error }] = useCloseMissionMutation({
 *   variables: {
 *      missionId: // value for 'missionId'
 *      statusComment: // value for 'statusComment'
 *   },
 * });
 */
export function useCloseMissionMutation(baseOptions?: Apollo.MutationHookOptions<CloseMissionMutation, CloseMissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloseMissionMutation, CloseMissionMutationVariables>(CloseMissionDocument, options);
      }
export type CloseMissionMutationHookResult = ReturnType<typeof useCloseMissionMutation>;
export type CloseMissionMutationResult = Apollo.MutationResult<CloseMissionMutation>;
export type CloseMissionMutationOptions = Apollo.BaseMutationOptions<CloseMissionMutation, CloseMissionMutationVariables>;
export const CreateClientByCorporationIdDocument = gql`
    mutation createClientByCorporationId($isOwner: Boolean! = false, $ownerId: String!, $isContact: Boolean! = false, $firstName: String, $lastName: String, $email: String, $phoneNumber: String, $corporationId: IdOrReference!, $isFolderFile: Boolean! = true, $optionCustomerFolderTypeCode: String! = "accountant_folder") {
  createCustomerFolder(reference: "<FOLDER_ID>", entityId: $corporationId, inputValues: [], optionCustomerFolderTypeCode: $optionCustomerFolderTypeCode) {
    id
  }
  createFolderFile(customerFolderId: "<FOLDER_ID>", inputValues: [{fieldCode: "name", value: "test", dataType: String}, {fieldCode: "folderFileTypeCode", value: "mission_file", dataType: Code}]) @include(if: $isFolderFile) {
    id
  }
  setOwner(customerFolderId: "<FOLDER_ID>", userId: $ownerId) @include(if: $isOwner) {
    id
  }
  mergeContactPerson(customerFolderId: "<FOLDER_ID>", inputValues: [{fieldCode: "firstName", dataType: String, value: $firstName}, {fieldCode: "lastName", dataType: String, value: $lastName}, {fieldCode: "email", dataType: String, value: $email}, {fieldCode: "phoneNumber", dataType: String, value: $phoneNumber}]) @include(if: $isContact) {
    id
  }
}
    `;
export type CreateClientByCorporationIdMutationFn = Apollo.MutationFunction<CreateClientByCorporationIdMutation, CreateClientByCorporationIdMutationVariables>;

/**
 * __useCreateClientByCorporationIdMutation__
 *
 * To run a mutation, you first call `useCreateClientByCorporationIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClientByCorporationIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClientByCorporationIdMutation, { data, loading, error }] = useCreateClientByCorporationIdMutation({
 *   variables: {
 *      isOwner: // value for 'isOwner'
 *      ownerId: // value for 'ownerId'
 *      isContact: // value for 'isContact'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *      phoneNumber: // value for 'phoneNumber'
 *      corporationId: // value for 'corporationId'
 *      isFolderFile: // value for 'isFolderFile'
 *      optionCustomerFolderTypeCode: // value for 'optionCustomerFolderTypeCode'
 *   },
 * });
 */
export function useCreateClientByCorporationIdMutation(baseOptions?: Apollo.MutationHookOptions<CreateClientByCorporationIdMutation, CreateClientByCorporationIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClientByCorporationIdMutation, CreateClientByCorporationIdMutationVariables>(CreateClientByCorporationIdDocument, options);
      }
export type CreateClientByCorporationIdMutationHookResult = ReturnType<typeof useCreateClientByCorporationIdMutation>;
export type CreateClientByCorporationIdMutationResult = Apollo.MutationResult<CreateClientByCorporationIdMutation>;
export type CreateClientByCorporationIdMutationOptions = Apollo.BaseMutationOptions<CreateClientByCorporationIdMutation, CreateClientByCorporationIdMutationVariables>;
export const CreateClientByRaisonSocialeDocument = gql`
    mutation createClientByRaisonSociale($isOwner: Boolean! = false, $ownerId: String!, $isContact: Boolean! = false, $firstName: String, $lastName: String, $email: String, $phoneNumber: String, $inputValues: [InputValueInput!]!, $isFolderFile: Boolean! = true) {
  createCorporation(reference: "<CORPORATION_ID>", inputValues: $inputValues) {
    id
    inputValues(fieldCodes: ["name"]) {
      stringValue
    }
  }
  createCustomerFolder(reference: "<FOLDER_ID>", entityId: "<CORPORATION_ID>", inputValues: [], optionCustomerFolderTypeCode: "accountant_folder") {
    id
  }
  createFolderFile(customerFolderId: "<FOLDER_ID>", inputValues: [{fieldCode: "name", value: "test", dataType: String}, {fieldCode: "folderFileTypeCode", value: "mission_file", dataType: Code}]) @include(if: $isFolderFile) {
    id
  }
  setOwner(customerFolderId: "<FOLDER_ID>", userId: $ownerId) @include(if: $isOwner) {
    id
  }
  mergeContactPerson(customerFolderId: "<FOLDER_ID>", inputValues: [{fieldCode: "firstName", dataType: String, value: $firstName}, {fieldCode: "lastName", dataType: String, value: $lastName}, {fieldCode: "email", dataType: String, value: $email}, {fieldCode: "phoneNumber", dataType: String, value: $phoneNumber}]) @include(if: $isContact) {
    id
  }
}
    `;
export type CreateClientByRaisonSocialeMutationFn = Apollo.MutationFunction<CreateClientByRaisonSocialeMutation, CreateClientByRaisonSocialeMutationVariables>;

/**
 * __useCreateClientByRaisonSocialeMutation__
 *
 * To run a mutation, you first call `useCreateClientByRaisonSocialeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClientByRaisonSocialeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClientByRaisonSocialeMutation, { data, loading, error }] = useCreateClientByRaisonSocialeMutation({
 *   variables: {
 *      isOwner: // value for 'isOwner'
 *      ownerId: // value for 'ownerId'
 *      isContact: // value for 'isContact'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *      phoneNumber: // value for 'phoneNumber'
 *      inputValues: // value for 'inputValues'
 *      isFolderFile: // value for 'isFolderFile'
 *   },
 * });
 */
export function useCreateClientByRaisonSocialeMutation(baseOptions?: Apollo.MutationHookOptions<CreateClientByRaisonSocialeMutation, CreateClientByRaisonSocialeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClientByRaisonSocialeMutation, CreateClientByRaisonSocialeMutationVariables>(CreateClientByRaisonSocialeDocument, options);
      }
export type CreateClientByRaisonSocialeMutationHookResult = ReturnType<typeof useCreateClientByRaisonSocialeMutation>;
export type CreateClientByRaisonSocialeMutationResult = Apollo.MutationResult<CreateClientByRaisonSocialeMutation>;
export type CreateClientByRaisonSocialeMutationOptions = Apollo.BaseMutationOptions<CreateClientByRaisonSocialeMutation, CreateClientByRaisonSocialeMutationVariables>;
export const CreateClientPphDocument = gql`
    mutation createClientPPH($isOwner: Boolean! = false, $ownerId: String!, $isContact: Boolean! = false, $firstName: String, $lastName: String, $email: String, $phoneNumber: String, $inputValues: [InputValueInput!]!, $isFolderFile: Boolean! = true) {
  createPerson(inputValues: $inputValues, reference: "<PERSON_ID>") {
    id
  }
  createCustomerFolder(reference: "<FOLDER_ID>", entityId: "<PERSON_ID>", inputValues: [], optionCustomerFolderTypeCode: "accountant_folder_pph") {
    id
  }
  createFolderFile(customerFolderId: "<FOLDER_ID>", inputValues: [{fieldCode: "name", value: "test", dataType: String}, {fieldCode: "folderFileTypeCode", value: "mission_file_pph", dataType: Code}]) @include(if: $isFolderFile) {
    id
  }
  setOwner(customerFolderId: "<FOLDER_ID>", userId: $ownerId) @include(if: $isOwner) {
    id
  }
  mergeContactPerson(customerFolderId: "<FOLDER_ID>", inputValues: [{fieldCode: "firstName", dataType: String, value: $firstName}, {fieldCode: "lastName", dataType: String, value: $lastName}, {fieldCode: "email", dataType: String, value: $email}, {fieldCode: "phoneNumber", dataType: String, value: $phoneNumber}]) @include(if: $isContact) {
    id
  }
}
    `;
export type CreateClientPphMutationFn = Apollo.MutationFunction<CreateClientPphMutation, CreateClientPphMutationVariables>;

/**
 * __useCreateClientPphMutation__
 *
 * To run a mutation, you first call `useCreateClientPphMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClientPphMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClientPphMutation, { data, loading, error }] = useCreateClientPphMutation({
 *   variables: {
 *      isOwner: // value for 'isOwner'
 *      ownerId: // value for 'ownerId'
 *      isContact: // value for 'isContact'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *      phoneNumber: // value for 'phoneNumber'
 *      inputValues: // value for 'inputValues'
 *      isFolderFile: // value for 'isFolderFile'
 *   },
 * });
 */
export function useCreateClientPphMutation(baseOptions?: Apollo.MutationHookOptions<CreateClientPphMutation, CreateClientPphMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClientPphMutation, CreateClientPphMutationVariables>(CreateClientPphDocument, options);
      }
export type CreateClientPphMutationHookResult = ReturnType<typeof useCreateClientPphMutation>;
export type CreateClientPphMutationResult = Apollo.MutationResult<CreateClientPphMutation>;
export type CreateClientPphMutationOptions = Apollo.BaseMutationOptions<CreateClientPphMutation, CreateClientPphMutationVariables>;
export const CreateClientPphByPersonIdDocument = gql`
    mutation createClientPPHByPersonId($personId: IdOrReference!, $isOwner: Boolean! = false, $ownerId: String!, $isContact: Boolean! = false, $firstName: String, $lastName: String, $email: String, $phoneNumber: String, $isFolderFile: Boolean! = true) {
  createCustomerFolder(reference: "<FOLDER_ID>", entityId: $personId, inputValues: [], optionCustomerFolderTypeCode: "accountant_folder_pph") {
    id
  }
  createFolderFile(customerFolderId: "<FOLDER_ID>", inputValues: [{fieldCode: "name", value: "test", dataType: String}, {fieldCode: "folderFileTypeCode", value: "mission_file_pph", dataType: Code}]) @include(if: $isFolderFile) {
    id
  }
  setOwner(customerFolderId: "<FOLDER_ID>", userId: $ownerId) @include(if: $isOwner) {
    id
  }
  mergeContactPerson(customerFolderId: "<FOLDER_ID>", inputValues: [{fieldCode: "firstName", dataType: String, value: $firstName}, {fieldCode: "lastName", dataType: String, value: $lastName}, {fieldCode: "email", dataType: String, value: $email}, {fieldCode: "phoneNumber", dataType: String, value: $phoneNumber}]) @include(if: $isContact) {
    id
  }
}
    `;
export type CreateClientPphByPersonIdMutationFn = Apollo.MutationFunction<CreateClientPphByPersonIdMutation, CreateClientPphByPersonIdMutationVariables>;

/**
 * __useCreateClientPphByPersonIdMutation__
 *
 * To run a mutation, you first call `useCreateClientPphByPersonIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClientPphByPersonIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClientPphByPersonIdMutation, { data, loading, error }] = useCreateClientPphByPersonIdMutation({
 *   variables: {
 *      personId: // value for 'personId'
 *      isOwner: // value for 'isOwner'
 *      ownerId: // value for 'ownerId'
 *      isContact: // value for 'isContact'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *      phoneNumber: // value for 'phoneNumber'
 *      isFolderFile: // value for 'isFolderFile'
 *   },
 * });
 */
export function useCreateClientPphByPersonIdMutation(baseOptions?: Apollo.MutationHookOptions<CreateClientPphByPersonIdMutation, CreateClientPphByPersonIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClientPphByPersonIdMutation, CreateClientPphByPersonIdMutationVariables>(CreateClientPphByPersonIdDocument, options);
      }
export type CreateClientPphByPersonIdMutationHookResult = ReturnType<typeof useCreateClientPphByPersonIdMutation>;
export type CreateClientPphByPersonIdMutationResult = Apollo.MutationResult<CreateClientPphByPersonIdMutation>;
export type CreateClientPphByPersonIdMutationOptions = Apollo.BaseMutationOptions<CreateClientPphByPersonIdMutation, CreateClientPphByPersonIdMutationVariables>;
export const CreateDiligenceDocument = gql`
    mutation createDiligence($folderFileId: ID!, $name: String!, $selected: Boolean! = false, $category: String) {
  createDiligence(folderFileId: $folderFileId, name: $name, selected: $selected, category: $category) {
    id
  }
}
    `;
export type CreateDiligenceMutationFn = Apollo.MutationFunction<CreateDiligenceMutation, CreateDiligenceMutationVariables>;

/**
 * __useCreateDiligenceMutation__
 *
 * To run a mutation, you first call `useCreateDiligenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDiligenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDiligenceMutation, { data, loading, error }] = useCreateDiligenceMutation({
 *   variables: {
 *      folderFileId: // value for 'folderFileId'
 *      name: // value for 'name'
 *      selected: // value for 'selected'
 *      category: // value for 'category'
 *   },
 * });
 */
export function useCreateDiligenceMutation(baseOptions?: Apollo.MutationHookOptions<CreateDiligenceMutation, CreateDiligenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDiligenceMutation, CreateDiligenceMutationVariables>(CreateDiligenceDocument, options);
      }
export type CreateDiligenceMutationHookResult = ReturnType<typeof useCreateDiligenceMutation>;
export type CreateDiligenceMutationResult = Apollo.MutationResult<CreateDiligenceMutation>;
export type CreateDiligenceMutationOptions = Apollo.BaseMutationOptions<CreateDiligenceMutation, CreateDiligenceMutationVariables>;
export const CreateDiligencesDocument = gql`
    mutation CreateDiligences($folderFileId: ID!) {
  createDiligences(folderFileId: $folderFileId) {
    id
  }
}
    `;
export type CreateDiligencesMutationFn = Apollo.MutationFunction<CreateDiligencesMutation, CreateDiligencesMutationVariables>;

/**
 * __useCreateDiligencesMutation__
 *
 * To run a mutation, you first call `useCreateDiligencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDiligencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDiligencesMutation, { data, loading, error }] = useCreateDiligencesMutation({
 *   variables: {
 *      folderFileId: // value for 'folderFileId'
 *   },
 * });
 */
export function useCreateDiligencesMutation(baseOptions?: Apollo.MutationHookOptions<CreateDiligencesMutation, CreateDiligencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDiligencesMutation, CreateDiligencesMutationVariables>(CreateDiligencesDocument, options);
      }
export type CreateDiligencesMutationHookResult = ReturnType<typeof useCreateDiligencesMutation>;
export type CreateDiligencesMutationResult = Apollo.MutationResult<CreateDiligencesMutation>;
export type CreateDiligencesMutationOptions = Apollo.BaseMutationOptions<CreateDiligencesMutation, CreateDiligencesMutationVariables>;
export const CreateFolderFileDocument = gql`
    mutation createFolderFile($customerFolderId: IdOrReference!, $folderFileTypeCode: String! = "mission_file") {
  createFolderFile(customerFolderId: $customerFolderId, inputValues: [{fieldCode: "name", value: "test", dataType: String}, {fieldCode: "folderFileTypeCode", value: $folderFileTypeCode, dataType: Code}]) {
    id
    fileCustomerFolder {
      stakeholders {
        isFolderCustomer
        entity {
          id
          __typename
        }
      }
    }
  }
}
    `;
export type CreateFolderFileMutationFn = Apollo.MutationFunction<CreateFolderFileMutation, CreateFolderFileMutationVariables>;

/**
 * __useCreateFolderFileMutation__
 *
 * To run a mutation, you first call `useCreateFolderFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFolderFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFolderFileMutation, { data, loading, error }] = useCreateFolderFileMutation({
 *   variables: {
 *      customerFolderId: // value for 'customerFolderId'
 *      folderFileTypeCode: // value for 'folderFileTypeCode'
 *   },
 * });
 */
export function useCreateFolderFileMutation(baseOptions?: Apollo.MutationHookOptions<CreateFolderFileMutation, CreateFolderFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFolderFileMutation, CreateFolderFileMutationVariables>(CreateFolderFileDocument, options);
      }
export type CreateFolderFileMutationHookResult = ReturnType<typeof useCreateFolderFileMutation>;
export type CreateFolderFileMutationResult = Apollo.MutationResult<CreateFolderFileMutation>;
export type CreateFolderFileMutationOptions = Apollo.BaseMutationOptions<CreateFolderFileMutation, CreateFolderFileMutationVariables>;
export const CreateMessageThreadDocument = gql`
    mutation createMessageThread($folderFileId: ID!, $title: String!, $topicCodes: [String!]!, $discussantIds: [String!]!) {
  createMessageThread(folderFileId: $folderFileId, title: $title, topicCodes: $topicCodes, discussantIds: $discussantIds) {
    id
  }
}
    `;
export type CreateMessageThreadMutationFn = Apollo.MutationFunction<CreateMessageThreadMutation, CreateMessageThreadMutationVariables>;

/**
 * __useCreateMessageThreadMutation__
 *
 * To run a mutation, you first call `useCreateMessageThreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMessageThreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMessageThreadMutation, { data, loading, error }] = useCreateMessageThreadMutation({
 *   variables: {
 *      folderFileId: // value for 'folderFileId'
 *      title: // value for 'title'
 *      topicCodes: // value for 'topicCodes'
 *      discussantIds: // value for 'discussantIds'
 *   },
 * });
 */
export function useCreateMessageThreadMutation(baseOptions?: Apollo.MutationHookOptions<CreateMessageThreadMutation, CreateMessageThreadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMessageThreadMutation, CreateMessageThreadMutationVariables>(CreateMessageThreadDocument, options);
      }
export type CreateMessageThreadMutationHookResult = ReturnType<typeof useCreateMessageThreadMutation>;
export type CreateMessageThreadMutationResult = Apollo.MutationResult<CreateMessageThreadMutation>;
export type CreateMessageThreadMutationOptions = Apollo.BaseMutationOptions<CreateMessageThreadMutation, CreateMessageThreadMutationVariables>;
export const CreateMissionDocument = gql`
    mutation createMission($customerFolderId: IdOrReference!, $missionTypeCode: String!, $renewDate: String!) {
  createMission(customerFolderId: $customerFolderId, inputValues: [{fieldCode: "missionTypeCode", value: $missionTypeCode, dataType: Code}, {fieldCode: "renewDate", value: $renewDate, dataType: Timestamp}]) {
    id
  }
}
    `;
export type CreateMissionMutationFn = Apollo.MutationFunction<CreateMissionMutation, CreateMissionMutationVariables>;

/**
 * __useCreateMissionMutation__
 *
 * To run a mutation, you first call `useCreateMissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMissionMutation, { data, loading, error }] = useCreateMissionMutation({
 *   variables: {
 *      customerFolderId: // value for 'customerFolderId'
 *      missionTypeCode: // value for 'missionTypeCode'
 *      renewDate: // value for 'renewDate'
 *   },
 * });
 */
export function useCreateMissionMutation(baseOptions?: Apollo.MutationHookOptions<CreateMissionMutation, CreateMissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMissionMutation, CreateMissionMutationVariables>(CreateMissionDocument, options);
      }
export type CreateMissionMutationHookResult = ReturnType<typeof useCreateMissionMutation>;
export type CreateMissionMutationResult = Apollo.MutationResult<CreateMissionMutation>;
export type CreateMissionMutationOptions = Apollo.BaseMutationOptions<CreateMissionMutation, CreateMissionMutationVariables>;
export const CreateOrReplaceExternalDocumentDocument = gql`
    mutation createOrReplaceExternalDocument($entityId: IdOrReference!, $documentTypeCode: String!, $url: String) {
  createOrReplaceExternalDocument(entityId: $entityId, documentTypeCode: $documentTypeCode, url: $url) {
    id
  }
}
    `;
export type CreateOrReplaceExternalDocumentMutationFn = Apollo.MutationFunction<CreateOrReplaceExternalDocumentMutation, CreateOrReplaceExternalDocumentMutationVariables>;

/**
 * __useCreateOrReplaceExternalDocumentMutation__
 *
 * To run a mutation, you first call `useCreateOrReplaceExternalDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrReplaceExternalDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrReplaceExternalDocumentMutation, { data, loading, error }] = useCreateOrReplaceExternalDocumentMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      documentTypeCode: // value for 'documentTypeCode'
 *      url: // value for 'url'
 *   },
 * });
 */
export function useCreateOrReplaceExternalDocumentMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrReplaceExternalDocumentMutation, CreateOrReplaceExternalDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrReplaceExternalDocumentMutation, CreateOrReplaceExternalDocumentMutationVariables>(CreateOrReplaceExternalDocumentDocument, options);
      }
export type CreateOrReplaceExternalDocumentMutationHookResult = ReturnType<typeof useCreateOrReplaceExternalDocumentMutation>;
export type CreateOrReplaceExternalDocumentMutationResult = Apollo.MutationResult<CreateOrReplaceExternalDocumentMutation>;
export type CreateOrReplaceExternalDocumentMutationOptions = Apollo.BaseMutationOptions<CreateOrReplaceExternalDocumentMutation, CreateOrReplaceExternalDocumentMutationVariables>;
export const CreateQuestionnaireDocument = gql`
    mutation CreateQuestionnaire($questionnaireEntityId: IdOrReference!, $questionnaireTypeCode: String!) {
  createQuestionnaire(questionnaireEntityId: $questionnaireEntityId, questionnaireTypeCode: $questionnaireTypeCode) {
    id
  }
}
    `;
export type CreateQuestionnaireMutationFn = Apollo.MutationFunction<CreateQuestionnaireMutation, CreateQuestionnaireMutationVariables>;

/**
 * __useCreateQuestionnaireMutation__
 *
 * To run a mutation, you first call `useCreateQuestionnaireMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuestionnaireMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQuestionnaireMutation, { data, loading, error }] = useCreateQuestionnaireMutation({
 *   variables: {
 *      questionnaireEntityId: // value for 'questionnaireEntityId'
 *      questionnaireTypeCode: // value for 'questionnaireTypeCode'
 *   },
 * });
 */
export function useCreateQuestionnaireMutation(baseOptions?: Apollo.MutationHookOptions<CreateQuestionnaireMutation, CreateQuestionnaireMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQuestionnaireMutation, CreateQuestionnaireMutationVariables>(CreateQuestionnaireDocument, options);
      }
export type CreateQuestionnaireMutationHookResult = ReturnType<typeof useCreateQuestionnaireMutation>;
export type CreateQuestionnaireMutationResult = Apollo.MutationResult<CreateQuestionnaireMutation>;
export type CreateQuestionnaireMutationOptions = Apollo.BaseMutationOptions<CreateQuestionnaireMutation, CreateQuestionnaireMutationVariables>;
export const DeleteDiligenceDocument = gql`
    mutation DeleteDiligence($diligenceId: ID!) {
  deleteDiligence(diligenceId: $diligenceId)
}
    `;
export type DeleteDiligenceMutationFn = Apollo.MutationFunction<DeleteDiligenceMutation, DeleteDiligenceMutationVariables>;

/**
 * __useDeleteDiligenceMutation__
 *
 * To run a mutation, you first call `useDeleteDiligenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDiligenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDiligenceMutation, { data, loading, error }] = useDeleteDiligenceMutation({
 *   variables: {
 *      diligenceId: // value for 'diligenceId'
 *   },
 * });
 */
export function useDeleteDiligenceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDiligenceMutation, DeleteDiligenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDiligenceMutation, DeleteDiligenceMutationVariables>(DeleteDiligenceDocument, options);
      }
export type DeleteDiligenceMutationHookResult = ReturnType<typeof useDeleteDiligenceMutation>;
export type DeleteDiligenceMutationResult = Apollo.MutationResult<DeleteDiligenceMutation>;
export type DeleteDiligenceMutationOptions = Apollo.BaseMutationOptions<DeleteDiligenceMutation, DeleteDiligenceMutationVariables>;
export const DeleteDocumentDocument = gql`
    mutation DeleteDocument($documentId: ID!) {
  deleteDocument(id: $documentId)
}
    `;
export type DeleteDocumentMutationFn = Apollo.MutationFunction<DeleteDocumentMutation, DeleteDocumentMutationVariables>;

/**
 * __useDeleteDocumentMutation__
 *
 * To run a mutation, you first call `useDeleteDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDocumentMutation, { data, loading, error }] = useDeleteDocumentMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useDeleteDocumentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDocumentMutation, DeleteDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDocumentMutation, DeleteDocumentMutationVariables>(DeleteDocumentDocument, options);
      }
export type DeleteDocumentMutationHookResult = ReturnType<typeof useDeleteDocumentMutation>;
export type DeleteDocumentMutationResult = Apollo.MutationResult<DeleteDocumentMutation>;
export type DeleteDocumentMutationOptions = Apollo.BaseMutationOptions<DeleteDocumentMutation, DeleteDocumentMutationVariables>;
export const DeleteExternalDocumentDocument = gql`
    mutation DeleteExternalDocument($documentId: ID!) {
  deleteExternalDocument(externalDocumentId: $documentId)
}
    `;
export type DeleteExternalDocumentMutationFn = Apollo.MutationFunction<DeleteExternalDocumentMutation, DeleteExternalDocumentMutationVariables>;

/**
 * __useDeleteExternalDocumentMutation__
 *
 * To run a mutation, you first call `useDeleteExternalDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteExternalDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteExternalDocumentMutation, { data, loading, error }] = useDeleteExternalDocumentMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useDeleteExternalDocumentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteExternalDocumentMutation, DeleteExternalDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteExternalDocumentMutation, DeleteExternalDocumentMutationVariables>(DeleteExternalDocumentDocument, options);
      }
export type DeleteExternalDocumentMutationHookResult = ReturnType<typeof useDeleteExternalDocumentMutation>;
export type DeleteExternalDocumentMutationResult = Apollo.MutationResult<DeleteExternalDocumentMutation>;
export type DeleteExternalDocumentMutationOptions = Apollo.BaseMutationOptions<DeleteExternalDocumentMutation, DeleteExternalDocumentMutationVariables>;
export const DeleteFolderEiDocument = gql`
    mutation DeleteFolderEI($customerFolderId: ID!, $personId: ID!, $folderFileId: ID!, $deleteCustomerFolder: Boolean!, $deleteFolderFile: Boolean!) {
  deleteCustomerFolder(id: $customerFolderId) @include(if: $deleteCustomerFolder)
  updatePerson(id: $personId, inputValues: [{fieldCode: "registration", dataType: String}]) @include(if: $deleteCustomerFolder) {
    id
  }
  deleteFolderFile(id: $folderFileId) @include(if: $deleteFolderFile)
}
    `;
export type DeleteFolderEiMutationFn = Apollo.MutationFunction<DeleteFolderEiMutation, DeleteFolderEiMutationVariables>;

/**
 * __useDeleteFolderEiMutation__
 *
 * To run a mutation, you first call `useDeleteFolderEiMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFolderEiMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFolderEiMutation, { data, loading, error }] = useDeleteFolderEiMutation({
 *   variables: {
 *      customerFolderId: // value for 'customerFolderId'
 *      personId: // value for 'personId'
 *      folderFileId: // value for 'folderFileId'
 *      deleteCustomerFolder: // value for 'deleteCustomerFolder'
 *      deleteFolderFile: // value for 'deleteFolderFile'
 *   },
 * });
 */
export function useDeleteFolderEiMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFolderEiMutation, DeleteFolderEiMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFolderEiMutation, DeleteFolderEiMutationVariables>(DeleteFolderEiDocument, options);
      }
export type DeleteFolderEiMutationHookResult = ReturnType<typeof useDeleteFolderEiMutation>;
export type DeleteFolderEiMutationResult = Apollo.MutationResult<DeleteFolderEiMutation>;
export type DeleteFolderEiMutationOptions = Apollo.BaseMutationOptions<DeleteFolderEiMutation, DeleteFolderEiMutationVariables>;
export const DeleteFolderEntityDocument = gql`
    mutation DeleteFolderEntity($customerFolderId: ID!, $corporationId: ID!, $folderFileId: ID!, $deleteCustomerFolder: Boolean!, $deleteFolderFile: Boolean!, $newCorporationName: String!) {
  deleteCustomerFolder(id: $customerFolderId) @include(if: $deleteCustomerFolder)
  updateCorporation(id: $corporationId, inputValues: [{fieldCode: "name", value: $newCorporationName, dataType: String}, {fieldCode: "registration", dataType: String}]) @include(if: $deleteCustomerFolder) {
    id
  }
  deleteFolderFile(id: $folderFileId) @include(if: $deleteFolderFile)
}
    `;
export type DeleteFolderEntityMutationFn = Apollo.MutationFunction<DeleteFolderEntityMutation, DeleteFolderEntityMutationVariables>;

/**
 * __useDeleteFolderEntityMutation__
 *
 * To run a mutation, you first call `useDeleteFolderEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFolderEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFolderEntityMutation, { data, loading, error }] = useDeleteFolderEntityMutation({
 *   variables: {
 *      customerFolderId: // value for 'customerFolderId'
 *      corporationId: // value for 'corporationId'
 *      folderFileId: // value for 'folderFileId'
 *      deleteCustomerFolder: // value for 'deleteCustomerFolder'
 *      deleteFolderFile: // value for 'deleteFolderFile'
 *      newCorporationName: // value for 'newCorporationName'
 *   },
 * });
 */
export function useDeleteFolderEntityMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFolderEntityMutation, DeleteFolderEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFolderEntityMutation, DeleteFolderEntityMutationVariables>(DeleteFolderEntityDocument, options);
      }
export type DeleteFolderEntityMutationHookResult = ReturnType<typeof useDeleteFolderEntityMutation>;
export type DeleteFolderEntityMutationResult = Apollo.MutationResult<DeleteFolderEntityMutation>;
export type DeleteFolderEntityMutationOptions = Apollo.BaseMutationOptions<DeleteFolderEntityMutation, DeleteFolderEntityMutationVariables>;
export const DeleteMissionDocument = gql`
    mutation DeleteMission($missionId: ID!) {
  deleteMission(missionId: $missionId)
}
    `;
export type DeleteMissionMutationFn = Apollo.MutationFunction<DeleteMissionMutation, DeleteMissionMutationVariables>;

/**
 * __useDeleteMissionMutation__
 *
 * To run a mutation, you first call `useDeleteMissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMissionMutation, { data, loading, error }] = useDeleteMissionMutation({
 *   variables: {
 *      missionId: // value for 'missionId'
 *   },
 * });
 */
export function useDeleteMissionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMissionMutation, DeleteMissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMissionMutation, DeleteMissionMutationVariables>(DeleteMissionDocument, options);
      }
export type DeleteMissionMutationHookResult = ReturnType<typeof useDeleteMissionMutation>;
export type DeleteMissionMutationResult = Apollo.MutationResult<DeleteMissionMutation>;
export type DeleteMissionMutationOptions = Apollo.BaseMutationOptions<DeleteMissionMutation, DeleteMissionMutationVariables>;
export const DeleteStakeholderDocument = gql`
    mutation deleteStakeholder($sourceEntityId: ID!, $targetEntityId: ID!, $isLegalRep: Boolean! = false, $isDirectBO: Boolean! = false, $roleTypeCode_1: String, $roleTypeCode_2: String) {
  deleteRole_1: deleteRole(sourceEntityId: $sourceEntityId, targetEntityId: $targetEntityId, roleTypeCode: $roleTypeCode_1) @include(if: $isLegalRep) {
    __typename
  }
  deleteRole_2: deleteRole(sourceEntityId: $sourceEntityId, targetEntityId: $targetEntityId, roleTypeCode: $roleTypeCode_2) @include(if: $isDirectBO) {
    __typename
  }
}
    `;
export type DeleteStakeholderMutationFn = Apollo.MutationFunction<DeleteStakeholderMutation, DeleteStakeholderMutationVariables>;

/**
 * __useDeleteStakeholderMutation__
 *
 * To run a mutation, you first call `useDeleteStakeholderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStakeholderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStakeholderMutation, { data, loading, error }] = useDeleteStakeholderMutation({
 *   variables: {
 *      sourceEntityId: // value for 'sourceEntityId'
 *      targetEntityId: // value for 'targetEntityId'
 *      isLegalRep: // value for 'isLegalRep'
 *      isDirectBO: // value for 'isDirectBO'
 *      roleTypeCode_1: // value for 'roleTypeCode_1'
 *      roleTypeCode_2: // value for 'roleTypeCode_2'
 *   },
 * });
 */
export function useDeleteStakeholderMutation(baseOptions?: Apollo.MutationHookOptions<DeleteStakeholderMutation, DeleteStakeholderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteStakeholderMutation, DeleteStakeholderMutationVariables>(DeleteStakeholderDocument, options);
      }
export type DeleteStakeholderMutationHookResult = ReturnType<typeof useDeleteStakeholderMutation>;
export type DeleteStakeholderMutationResult = Apollo.MutationResult<DeleteStakeholderMutation>;
export type DeleteStakeholderMutationOptions = Apollo.BaseMutationOptions<DeleteStakeholderMutation, DeleteStakeholderMutationVariables>;
export const EditMessageDocument = gql`
    mutation editMessage($messageId: ID!, $content: String!) {
  editMessage(messageId: $messageId, content: $content) {
    id
    content
  }
}
    `;
export type EditMessageMutationFn = Apollo.MutationFunction<EditMessageMutation, EditMessageMutationVariables>;

/**
 * __useEditMessageMutation__
 *
 * To run a mutation, you first call `useEditMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editMessageMutation, { data, loading, error }] = useEditMessageMutation({
 *   variables: {
 *      messageId: // value for 'messageId'
 *      content: // value for 'content'
 *   },
 * });
 */
export function useEditMessageMutation(baseOptions?: Apollo.MutationHookOptions<EditMessageMutation, EditMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditMessageMutation, EditMessageMutationVariables>(EditMessageDocument, options);
      }
export type EditMessageMutationHookResult = ReturnType<typeof useEditMessageMutation>;
export type EditMessageMutationResult = Apollo.MutationResult<EditMessageMutation>;
export type EditMessageMutationOptions = Apollo.BaseMutationOptions<EditMessageMutation, EditMessageMutationVariables>;
export const ExecuteWorkflowActionDocument = gql`
    mutation ExecuteWorkflowAction($actionId: String!, $folderFileId: ID!, $comment: String) {
  executeWorkflowAction(actionId: $actionId, folderFileId: $folderFileId, comment: $comment) {
    id
  }
}
    `;
export type ExecuteWorkflowActionMutationFn = Apollo.MutationFunction<ExecuteWorkflowActionMutation, ExecuteWorkflowActionMutationVariables>;

/**
 * __useExecuteWorkflowActionMutation__
 *
 * To run a mutation, you first call `useExecuteWorkflowActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExecuteWorkflowActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [executeWorkflowActionMutation, { data, loading, error }] = useExecuteWorkflowActionMutation({
 *   variables: {
 *      actionId: // value for 'actionId'
 *      folderFileId: // value for 'folderFileId'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useExecuteWorkflowActionMutation(baseOptions?: Apollo.MutationHookOptions<ExecuteWorkflowActionMutation, ExecuteWorkflowActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExecuteWorkflowActionMutation, ExecuteWorkflowActionMutationVariables>(ExecuteWorkflowActionDocument, options);
      }
export type ExecuteWorkflowActionMutationHookResult = ReturnType<typeof useExecuteWorkflowActionMutation>;
export type ExecuteWorkflowActionMutationResult = Apollo.MutationResult<ExecuteWorkflowActionMutation>;
export type ExecuteWorkflowActionMutationOptions = Apollo.BaseMutationOptions<ExecuteWorkflowActionMutation, ExecuteWorkflowActionMutationVariables>;
export const FollowFolderDocument = gql`
    mutation followFolder($customerFolderId: IdOrReference!, $userId: String) {
  followFolder(customerFolderId: $customerFolderId, userId: $userId) {
    id
  }
}
    `;
export type FollowFolderMutationFn = Apollo.MutationFunction<FollowFolderMutation, FollowFolderMutationVariables>;

/**
 * __useFollowFolderMutation__
 *
 * To run a mutation, you first call `useFollowFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFollowFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [followFolderMutation, { data, loading, error }] = useFollowFolderMutation({
 *   variables: {
 *      customerFolderId: // value for 'customerFolderId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useFollowFolderMutation(baseOptions?: Apollo.MutationHookOptions<FollowFolderMutation, FollowFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FollowFolderMutation, FollowFolderMutationVariables>(FollowFolderDocument, options);
      }
export type FollowFolderMutationHookResult = ReturnType<typeof useFollowFolderMutation>;
export type FollowFolderMutationResult = Apollo.MutationResult<FollowFolderMutation>;
export type FollowFolderMutationOptions = Apollo.BaseMutationOptions<FollowFolderMutation, FollowFolderMutationVariables>;
export const ForceRiskLevelDocument = gql`
    mutation forceRiskLevel($folderFileId: ID!, $riskLevel: RiskLevel!, $forcedRiskReasonCode: String!) {
  forceRiskLevel(folderFileId: $folderFileId, riskLevel: $riskLevel, forcedRiskReasonCode: $forcedRiskReasonCode) {
    id
  }
}
    `;
export type ForceRiskLevelMutationFn = Apollo.MutationFunction<ForceRiskLevelMutation, ForceRiskLevelMutationVariables>;

/**
 * __useForceRiskLevelMutation__
 *
 * To run a mutation, you first call `useForceRiskLevelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForceRiskLevelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forceRiskLevelMutation, { data, loading, error }] = useForceRiskLevelMutation({
 *   variables: {
 *      folderFileId: // value for 'folderFileId'
 *      riskLevel: // value for 'riskLevel'
 *      forcedRiskReasonCode: // value for 'forcedRiskReasonCode'
 *   },
 * });
 */
export function useForceRiskLevelMutation(baseOptions?: Apollo.MutationHookOptions<ForceRiskLevelMutation, ForceRiskLevelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForceRiskLevelMutation, ForceRiskLevelMutationVariables>(ForceRiskLevelDocument, options);
      }
export type ForceRiskLevelMutationHookResult = ReturnType<typeof useForceRiskLevelMutation>;
export type ForceRiskLevelMutationResult = Apollo.MutationResult<ForceRiskLevelMutation>;
export type ForceRiskLevelMutationOptions = Apollo.BaseMutationOptions<ForceRiskLevelMutation, ForceRiskLevelMutationVariables>;
export const ReplaceEntityDocument = gql`
    mutation replaceEntity($idToDelete: ID!, $replacementId: ID!) {
  replaceEntity(idToDelete: $idToDelete, replacementId: $replacementId) {
    id
  }
}
    `;
export type ReplaceEntityMutationFn = Apollo.MutationFunction<ReplaceEntityMutation, ReplaceEntityMutationVariables>;

/**
 * __useReplaceEntityMutation__
 *
 * To run a mutation, you first call `useReplaceEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReplaceEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [replaceEntityMutation, { data, loading, error }] = useReplaceEntityMutation({
 *   variables: {
 *      idToDelete: // value for 'idToDelete'
 *      replacementId: // value for 'replacementId'
 *   },
 * });
 */
export function useReplaceEntityMutation(baseOptions?: Apollo.MutationHookOptions<ReplaceEntityMutation, ReplaceEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReplaceEntityMutation, ReplaceEntityMutationVariables>(ReplaceEntityDocument, options);
      }
export type ReplaceEntityMutationHookResult = ReturnType<typeof useReplaceEntityMutation>;
export type ReplaceEntityMutationResult = Apollo.MutationResult<ReplaceEntityMutation>;
export type ReplaceEntityMutationOptions = Apollo.BaseMutationOptions<ReplaceEntityMutation, ReplaceEntityMutationVariables>;
export const UnfollowFolderDocument = gql`
    mutation unfollowFolder($customerFolderId: ID!, $userId: String) {
  unfollowFolder(customerFolderId: $customerFolderId, userId: $userId) {
    id
  }
}
    `;
export type UnfollowFolderMutationFn = Apollo.MutationFunction<UnfollowFolderMutation, UnfollowFolderMutationVariables>;

/**
 * __useUnfollowFolderMutation__
 *
 * To run a mutation, you first call `useUnfollowFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnfollowFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unfollowFolderMutation, { data, loading, error }] = useUnfollowFolderMutation({
 *   variables: {
 *      customerFolderId: // value for 'customerFolderId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUnfollowFolderMutation(baseOptions?: Apollo.MutationHookOptions<UnfollowFolderMutation, UnfollowFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnfollowFolderMutation, UnfollowFolderMutationVariables>(UnfollowFolderDocument, options);
      }
export type UnfollowFolderMutationHookResult = ReturnType<typeof useUnfollowFolderMutation>;
export type UnfollowFolderMutationResult = Apollo.MutationResult<UnfollowFolderMutation>;
export type UnfollowFolderMutationOptions = Apollo.BaseMutationOptions<UnfollowFolderMutation, UnfollowFolderMutationVariables>;
export const UpdateAndValidateQuestionnaireDocument = gql`
    mutation updateAndValidateQuestionnaire($questionnaireId: ID!, $questionnaireIdOrReference: IdOrReference!, $data: String!, $shouldReopen: Boolean!, $shouldValidate: Boolean!) {
  reopenQuestionnaire(questionnaireId: $questionnaireId) @include(if: $shouldReopen) {
    id
  }
  putQuestionnaireContent(questionnaireId: $questionnaireIdOrReference, content: $data) {
    id
    content
  }
  validateQuestionnaire(questionnaireId: $questionnaireIdOrReference) @include(if: $shouldValidate) {
    id
  }
}
    `;
export type UpdateAndValidateQuestionnaireMutationFn = Apollo.MutationFunction<UpdateAndValidateQuestionnaireMutation, UpdateAndValidateQuestionnaireMutationVariables>;

/**
 * __useUpdateAndValidateQuestionnaireMutation__
 *
 * To run a mutation, you first call `useUpdateAndValidateQuestionnaireMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAndValidateQuestionnaireMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAndValidateQuestionnaireMutation, { data, loading, error }] = useUpdateAndValidateQuestionnaireMutation({
 *   variables: {
 *      questionnaireId: // value for 'questionnaireId'
 *      questionnaireIdOrReference: // value for 'questionnaireIdOrReference'
 *      data: // value for 'data'
 *      shouldReopen: // value for 'shouldReopen'
 *      shouldValidate: // value for 'shouldValidate'
 *   },
 * });
 */
export function useUpdateAndValidateQuestionnaireMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAndValidateQuestionnaireMutation, UpdateAndValidateQuestionnaireMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAndValidateQuestionnaireMutation, UpdateAndValidateQuestionnaireMutationVariables>(UpdateAndValidateQuestionnaireDocument, options);
      }
export type UpdateAndValidateQuestionnaireMutationHookResult = ReturnType<typeof useUpdateAndValidateQuestionnaireMutation>;
export type UpdateAndValidateQuestionnaireMutationResult = Apollo.MutationResult<UpdateAndValidateQuestionnaireMutation>;
export type UpdateAndValidateQuestionnaireMutationOptions = Apollo.BaseMutationOptions<UpdateAndValidateQuestionnaireMutation, UpdateAndValidateQuestionnaireMutationVariables>;
export const UpdateContactsDocument = gql`
    mutation updateContacts($setOwner: Boolean = false, $removeOwner: Boolean = false, $mergeContactPerson: Boolean = false, $deleteContactPerson: Boolean = false, $customerFolderId: IdOrReference!, $customerFolderId_2: ID!, $userId: String!, $inputValues: [InputValueInput!]!, $contactPersonId: ID!) {
  setOwner(customerFolderId: $customerFolderId, userId: $userId) @include(if: $setOwner) {
    id
    __typename
  }
  removeOwner(customerFolderId: $customerFolderId_2) @include(if: $removeOwner) {
    __typename
  }
  mergeContactPerson(customerFolderId: $customerFolderId, inputValues: $inputValues) @include(if: $mergeContactPerson) {
    id
  }
  deleteContactPerson(contactPersonId: $contactPersonId) @include(if: $deleteContactPerson)
}
    `;
export type UpdateContactsMutationFn = Apollo.MutationFunction<UpdateContactsMutation, UpdateContactsMutationVariables>;

/**
 * __useUpdateContactsMutation__
 *
 * To run a mutation, you first call `useUpdateContactsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactsMutation, { data, loading, error }] = useUpdateContactsMutation({
 *   variables: {
 *      setOwner: // value for 'setOwner'
 *      removeOwner: // value for 'removeOwner'
 *      mergeContactPerson: // value for 'mergeContactPerson'
 *      deleteContactPerson: // value for 'deleteContactPerson'
 *      customerFolderId: // value for 'customerFolderId'
 *      customerFolderId_2: // value for 'customerFolderId_2'
 *      userId: // value for 'userId'
 *      inputValues: // value for 'inputValues'
 *      contactPersonId: // value for 'contactPersonId'
 *   },
 * });
 */
export function useUpdateContactsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContactsMutation, UpdateContactsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContactsMutation, UpdateContactsMutationVariables>(UpdateContactsDocument, options);
      }
export type UpdateContactsMutationHookResult = ReturnType<typeof useUpdateContactsMutation>;
export type UpdateContactsMutationResult = Apollo.MutationResult<UpdateContactsMutation>;
export type UpdateContactsMutationOptions = Apollo.BaseMutationOptions<UpdateContactsMutation, UpdateContactsMutationVariables>;
export const UpdateCorporationDocument = gql`
    mutation UpdateCorporation($corporationId: ID!, $inputValues: [InputValueInput!]!) {
  updateCorporation(id: $corporationId, inputValues: $inputValues) {
    id
  }
}
    `;
export type UpdateCorporationMutationFn = Apollo.MutationFunction<UpdateCorporationMutation, UpdateCorporationMutationVariables>;

/**
 * __useUpdateCorporationMutation__
 *
 * To run a mutation, you first call `useUpdateCorporationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCorporationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCorporationMutation, { data, loading, error }] = useUpdateCorporationMutation({
 *   variables: {
 *      corporationId: // value for 'corporationId'
 *      inputValues: // value for 'inputValues'
 *   },
 * });
 */
export function useUpdateCorporationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCorporationMutation, UpdateCorporationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCorporationMutation, UpdateCorporationMutationVariables>(UpdateCorporationDocument, options);
      }
export type UpdateCorporationMutationHookResult = ReturnType<typeof useUpdateCorporationMutation>;
export type UpdateCorporationMutationResult = Apollo.MutationResult<UpdateCorporationMutation>;
export type UpdateCorporationMutationOptions = Apollo.BaseMutationOptions<UpdateCorporationMutation, UpdateCorporationMutationVariables>;
export const UpdateDiligenceDocument = gql`
    mutation UpdateDiligence($diligenceId: ID!, $name: String!, $selected: Boolean, $category: String) {
  updateDiligence(diligenceId: $diligenceId, name: $name, selected: $selected, category: $category) {
    id
  }
}
    `;
export type UpdateDiligenceMutationFn = Apollo.MutationFunction<UpdateDiligenceMutation, UpdateDiligenceMutationVariables>;

/**
 * __useUpdateDiligenceMutation__
 *
 * To run a mutation, you first call `useUpdateDiligenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDiligenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDiligenceMutation, { data, loading, error }] = useUpdateDiligenceMutation({
 *   variables: {
 *      diligenceId: // value for 'diligenceId'
 *      name: // value for 'name'
 *      selected: // value for 'selected'
 *      category: // value for 'category'
 *   },
 * });
 */
export function useUpdateDiligenceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDiligenceMutation, UpdateDiligenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDiligenceMutation, UpdateDiligenceMutationVariables>(UpdateDiligenceDocument, options);
      }
export type UpdateDiligenceMutationHookResult = ReturnType<typeof useUpdateDiligenceMutation>;
export type UpdateDiligenceMutationResult = Apollo.MutationResult<UpdateDiligenceMutation>;
export type UpdateDiligenceMutationOptions = Apollo.BaseMutationOptions<UpdateDiligenceMutation, UpdateDiligenceMutationVariables>;
export const UpdateDocumentDocument = gql`
    mutation updateDocument($id: ID!, $expirationDate: String) {
  updateDocument(id: $id, expirationDate: $expirationDate) {
    id
    expirationDate
  }
}
    `;
export type UpdateDocumentMutationFn = Apollo.MutationFunction<UpdateDocumentMutation, UpdateDocumentMutationVariables>;

/**
 * __useUpdateDocumentMutation__
 *
 * To run a mutation, you first call `useUpdateDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDocumentMutation, { data, loading, error }] = useUpdateDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      expirationDate: // value for 'expirationDate'
 *   },
 * });
 */
export function useUpdateDocumentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDocumentMutation, UpdateDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDocumentMutation, UpdateDocumentMutationVariables>(UpdateDocumentDocument, options);
      }
export type UpdateDocumentMutationHookResult = ReturnType<typeof useUpdateDocumentMutation>;
export type UpdateDocumentMutationResult = Apollo.MutationResult<UpdateDocumentMutation>;
export type UpdateDocumentMutationOptions = Apollo.BaseMutationOptions<UpdateDocumentMutation, UpdateDocumentMutationVariables>;
export const UpdateEntityEReputationDocument = gql`
    mutation UpdateEntityEReputation($entityId: ID!, $inputs: [EReputationInputType!]!) {
  updateEntityEreputation(entityId: $entityId, inputs: $inputs) {
    id
  }
}
    `;
export type UpdateEntityEReputationMutationFn = Apollo.MutationFunction<UpdateEntityEReputationMutation, UpdateEntityEReputationMutationVariables>;

/**
 * __useUpdateEntityEReputationMutation__
 *
 * To run a mutation, you first call `useUpdateEntityEReputationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEntityEReputationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEntityEReputationMutation, { data, loading, error }] = useUpdateEntityEReputationMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useUpdateEntityEReputationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEntityEReputationMutation, UpdateEntityEReputationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEntityEReputationMutation, UpdateEntityEReputationMutationVariables>(UpdateEntityEReputationDocument, options);
      }
export type UpdateEntityEReputationMutationHookResult = ReturnType<typeof useUpdateEntityEReputationMutation>;
export type UpdateEntityEReputationMutationResult = Apollo.MutationResult<UpdateEntityEReputationMutation>;
export type UpdateEntityEReputationMutationOptions = Apollo.BaseMutationOptions<UpdateEntityEReputationMutation, UpdateEntityEReputationMutationVariables>;
export const UpdateMissionDocument = gql`
    mutation UpdateMission($missionId: ID!, $inputValues: [InputValueInput!]!, $shouldReopen: Boolean!) {
  reopenMission(missionId: $missionId) @include(if: $shouldReopen) {
    id
  }
  updateMission(missionId: $missionId, inputValues: $inputValues) {
    id
  }
}
    `;
export type UpdateMissionMutationFn = Apollo.MutationFunction<UpdateMissionMutation, UpdateMissionMutationVariables>;

/**
 * __useUpdateMissionMutation__
 *
 * To run a mutation, you first call `useUpdateMissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMissionMutation, { data, loading, error }] = useUpdateMissionMutation({
 *   variables: {
 *      missionId: // value for 'missionId'
 *      inputValues: // value for 'inputValues'
 *      shouldReopen: // value for 'shouldReopen'
 *   },
 * });
 */
export function useUpdateMissionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMissionMutation, UpdateMissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMissionMutation, UpdateMissionMutationVariables>(UpdateMissionDocument, options);
      }
export type UpdateMissionMutationHookResult = ReturnType<typeof useUpdateMissionMutation>;
export type UpdateMissionMutationResult = Apollo.MutationResult<UpdateMissionMutation>;
export type UpdateMissionMutationOptions = Apollo.BaseMutationOptions<UpdateMissionMutation, UpdateMissionMutationVariables>;
export const UpdatePersonDuplicateCheckDoneDocument = gql`
    mutation updatePersonDuplicateCheckDone($id: ID!, $duplicateCheckDone: String! = "false") {
  updatePerson_0: updatePerson(id: $id, inputValues: [{fieldCode: "customBoolean1", dataType: Boolean, value: $duplicateCheckDone}]) {
    id
  }
}
    `;
export type UpdatePersonDuplicateCheckDoneMutationFn = Apollo.MutationFunction<UpdatePersonDuplicateCheckDoneMutation, UpdatePersonDuplicateCheckDoneMutationVariables>;

/**
 * __useUpdatePersonDuplicateCheckDoneMutation__
 *
 * To run a mutation, you first call `useUpdatePersonDuplicateCheckDoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePersonDuplicateCheckDoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePersonDuplicateCheckDoneMutation, { data, loading, error }] = useUpdatePersonDuplicateCheckDoneMutation({
 *   variables: {
 *      id: // value for 'id'
 *      duplicateCheckDone: // value for 'duplicateCheckDone'
 *   },
 * });
 */
export function useUpdatePersonDuplicateCheckDoneMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePersonDuplicateCheckDoneMutation, UpdatePersonDuplicateCheckDoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePersonDuplicateCheckDoneMutation, UpdatePersonDuplicateCheckDoneMutationVariables>(UpdatePersonDuplicateCheckDoneDocument, options);
      }
export type UpdatePersonDuplicateCheckDoneMutationHookResult = ReturnType<typeof useUpdatePersonDuplicateCheckDoneMutation>;
export type UpdatePersonDuplicateCheckDoneMutationResult = Apollo.MutationResult<UpdatePersonDuplicateCheckDoneMutation>;
export type UpdatePersonDuplicateCheckDoneMutationOptions = Apollo.BaseMutationOptions<UpdatePersonDuplicateCheckDoneMutation, UpdatePersonDuplicateCheckDoneMutationVariables>;
export const UpdateQuestionnaireDocument = gql`
    mutation UpdateQuestionnaire($questionnaireId: IdOrReference!, $data: String!) {
  putQuestionnaireContent(questionnaireId: $questionnaireId, content: $data) {
    id
    content
  }
}
    `;
export type UpdateQuestionnaireMutationFn = Apollo.MutationFunction<UpdateQuestionnaireMutation, UpdateQuestionnaireMutationVariables>;

/**
 * __useUpdateQuestionnaireMutation__
 *
 * To run a mutation, you first call `useUpdateQuestionnaireMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuestionnaireMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuestionnaireMutation, { data, loading, error }] = useUpdateQuestionnaireMutation({
 *   variables: {
 *      questionnaireId: // value for 'questionnaireId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateQuestionnaireMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQuestionnaireMutation, UpdateQuestionnaireMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQuestionnaireMutation, UpdateQuestionnaireMutationVariables>(UpdateQuestionnaireDocument, options);
      }
export type UpdateQuestionnaireMutationHookResult = ReturnType<typeof useUpdateQuestionnaireMutation>;
export type UpdateQuestionnaireMutationResult = Apollo.MutationResult<UpdateQuestionnaireMutation>;
export type UpdateQuestionnaireMutationOptions = Apollo.BaseMutationOptions<UpdateQuestionnaireMutation, UpdateQuestionnaireMutationVariables>;
export const UpdateStakeholderDocument = gql`
    mutation updateStakeholder($id_0: ID!, $inputValues_0: [InputValueInput!]!, $inputRole_1: RoleInputType!, $corporationId_1: IdOrReference!, $entityId_1: IdOrReference!, $inputRole_2: RoleInputType!, $addLegalRep: Boolean! = false, $addDirectBO: Boolean! = false, $corporationId_2: ID!, $entityId_2: ID!, $deleteLegalRep: Boolean! = false, $deleteDirectBO: Boolean! = false) {
  updatePerson_0: updatePerson(id: $id_0, inputValues: $inputValues_0) {
    id
    __typename
  }
  setLegalRepresentativeRole_1: setRole(roleInput: $inputRole_1, targetEntityId: $corporationId_1, sourceEntityId: $entityId_1) @include(if: $addLegalRep) {
    __typename
  }
  setDirectBORole2: setRole(roleInput: $inputRole_2, targetEntityId: $corporationId_1, sourceEntityId: $entityId_1) @include(if: $addDirectBO) {
    __typename
  }
  deleteRole_LegalRepresentative: deleteRole(roleTypeCode: "legal_representative", targetEntityId: $corporationId_2, sourceEntityId: $entityId_2) @include(if: $deleteLegalRep) {
    __typename
  }
  deleteRole_DirectBO: deleteRole(roleTypeCode: "direct_beneficiary_owner", targetEntityId: $corporationId_2, sourceEntityId: $entityId_2) @include(if: $deleteDirectBO) {
    __typename
  }
}
    `;
export type UpdateStakeholderMutationFn = Apollo.MutationFunction<UpdateStakeholderMutation, UpdateStakeholderMutationVariables>;

/**
 * __useUpdateStakeholderMutation__
 *
 * To run a mutation, you first call `useUpdateStakeholderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStakeholderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStakeholderMutation, { data, loading, error }] = useUpdateStakeholderMutation({
 *   variables: {
 *      id_0: // value for 'id_0'
 *      inputValues_0: // value for 'inputValues_0'
 *      inputRole_1: // value for 'inputRole_1'
 *      corporationId_1: // value for 'corporationId_1'
 *      entityId_1: // value for 'entityId_1'
 *      inputRole_2: // value for 'inputRole_2'
 *      addLegalRep: // value for 'addLegalRep'
 *      addDirectBO: // value for 'addDirectBO'
 *      corporationId_2: // value for 'corporationId_2'
 *      entityId_2: // value for 'entityId_2'
 *      deleteLegalRep: // value for 'deleteLegalRep'
 *      deleteDirectBO: // value for 'deleteDirectBO'
 *   },
 * });
 */
export function useUpdateStakeholderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStakeholderMutation, UpdateStakeholderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStakeholderMutation, UpdateStakeholderMutationVariables>(UpdateStakeholderDocument, options);
      }
export type UpdateStakeholderMutationHookResult = ReturnType<typeof useUpdateStakeholderMutation>;
export type UpdateStakeholderMutationResult = Apollo.MutationResult<UpdateStakeholderMutation>;
export type UpdateStakeholderMutationOptions = Apollo.BaseMutationOptions<UpdateStakeholderMutation, UpdateStakeholderMutationVariables>;
export const ActivitiesWithRiskListDocument = gql`
    query activitiesWithRiskList {
  listElements(elementType: "Activity") {
    ... on StandardListElement {
      id
      code
      name
      riskValues {
        description
        riskCategory
        key
      }
    }
  }
}
    `;

/**
 * __useActivitiesWithRiskListQuery__
 *
 * To run a query within a React component, call `useActivitiesWithRiskListQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivitiesWithRiskListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivitiesWithRiskListQuery({
 *   variables: {
 *   },
 * });
 */
export function useActivitiesWithRiskListQuery(baseOptions?: Apollo.QueryHookOptions<ActivitiesWithRiskListQuery, ActivitiesWithRiskListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivitiesWithRiskListQuery, ActivitiesWithRiskListQueryVariables>(ActivitiesWithRiskListDocument, options);
      }
export function useActivitiesWithRiskListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivitiesWithRiskListQuery, ActivitiesWithRiskListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivitiesWithRiskListQuery, ActivitiesWithRiskListQueryVariables>(ActivitiesWithRiskListDocument, options);
        }
export function useActivitiesWithRiskListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ActivitiesWithRiskListQuery, ActivitiesWithRiskListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ActivitiesWithRiskListQuery, ActivitiesWithRiskListQueryVariables>(ActivitiesWithRiskListDocument, options);
        }
export type ActivitiesWithRiskListQueryHookResult = ReturnType<typeof useActivitiesWithRiskListQuery>;
export type ActivitiesWithRiskListLazyQueryHookResult = ReturnType<typeof useActivitiesWithRiskListLazyQuery>;
export type ActivitiesWithRiskListSuspenseQueryHookResult = ReturnType<typeof useActivitiesWithRiskListSuspenseQuery>;
export type ActivitiesWithRiskListQueryResult = Apollo.QueryResult<ActivitiesWithRiskListQuery, ActivitiesWithRiskListQueryVariables>;
export const AdvancedCorporationAndPersonSearchDocument = gql`
    query advancedCorporationAndPersonSearch($values: [String!]!) {
  advancedCorporationSearch(query: "(field(registration) : {0})", values: $values, limit: 1) {
    corporations {
      name: inputValue(fieldCode: "name") {
        stringValue
      }
      siren: inputValue(fieldCode: "registration") {
        stringValue
      }
      isCustomer
      id
      customerFolders {
        folderFiles(limit: 1) {
          summaries {
            id
          }
        }
      }
    }
  }
  advancedPersonSearch(query: "(field(registration) : {0})", values: $values, limit: 1) {
    persons {
      firstName: inputValue(fieldCode: "firstName") {
        stringValue
      }
      lastName: inputValue(fieldCode: "lastName") {
        stringValue
      }
      siren: inputValue(fieldCode: "registration") {
        stringValue
      }
      id
      customerFolders {
        folderFiles(limit: 1) {
          summaries {
            id
          }
        }
      }
    }
  }
}
    `;

/**
 * __useAdvancedCorporationAndPersonSearchQuery__
 *
 * To run a query within a React component, call `useAdvancedCorporationAndPersonSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdvancedCorporationAndPersonSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdvancedCorporationAndPersonSearchQuery({
 *   variables: {
 *      values: // value for 'values'
 *   },
 * });
 */
export function useAdvancedCorporationAndPersonSearchQuery(baseOptions: Apollo.QueryHookOptions<AdvancedCorporationAndPersonSearchQuery, AdvancedCorporationAndPersonSearchQueryVariables> & ({ variables: AdvancedCorporationAndPersonSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdvancedCorporationAndPersonSearchQuery, AdvancedCorporationAndPersonSearchQueryVariables>(AdvancedCorporationAndPersonSearchDocument, options);
      }
export function useAdvancedCorporationAndPersonSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdvancedCorporationAndPersonSearchQuery, AdvancedCorporationAndPersonSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdvancedCorporationAndPersonSearchQuery, AdvancedCorporationAndPersonSearchQueryVariables>(AdvancedCorporationAndPersonSearchDocument, options);
        }
export function useAdvancedCorporationAndPersonSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdvancedCorporationAndPersonSearchQuery, AdvancedCorporationAndPersonSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdvancedCorporationAndPersonSearchQuery, AdvancedCorporationAndPersonSearchQueryVariables>(AdvancedCorporationAndPersonSearchDocument, options);
        }
export type AdvancedCorporationAndPersonSearchQueryHookResult = ReturnType<typeof useAdvancedCorporationAndPersonSearchQuery>;
export type AdvancedCorporationAndPersonSearchLazyQueryHookResult = ReturnType<typeof useAdvancedCorporationAndPersonSearchLazyQuery>;
export type AdvancedCorporationAndPersonSearchSuspenseQueryHookResult = ReturnType<typeof useAdvancedCorporationAndPersonSearchSuspenseQuery>;
export type AdvancedCorporationAndPersonSearchQueryResult = Apollo.QueryResult<AdvancedCorporationAndPersonSearchQuery, AdvancedCorporationAndPersonSearchQueryVariables>;
export const AdvancedCorporationSearchDocument = gql`
    query advancedCorporationSearch($values: [String!]!) {
  advancedCorporationSearch(query: "(field(registration) : {0})", values: $values, limit: 1) {
    corporations {
      name: inputValue(fieldCode: "name") {
        stringValue
      }
      siren: inputValue(fieldCode: "registration") {
        stringValue
      }
      isCustomer
      id
      customerFolders {
        folderFiles(limit: 1) {
          summaries {
            id
          }
        }
      }
    }
  }
}
    `;

/**
 * __useAdvancedCorporationSearchQuery__
 *
 * To run a query within a React component, call `useAdvancedCorporationSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdvancedCorporationSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdvancedCorporationSearchQuery({
 *   variables: {
 *      values: // value for 'values'
 *   },
 * });
 */
export function useAdvancedCorporationSearchQuery(baseOptions: Apollo.QueryHookOptions<AdvancedCorporationSearchQuery, AdvancedCorporationSearchQueryVariables> & ({ variables: AdvancedCorporationSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdvancedCorporationSearchQuery, AdvancedCorporationSearchQueryVariables>(AdvancedCorporationSearchDocument, options);
      }
export function useAdvancedCorporationSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdvancedCorporationSearchQuery, AdvancedCorporationSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdvancedCorporationSearchQuery, AdvancedCorporationSearchQueryVariables>(AdvancedCorporationSearchDocument, options);
        }
export function useAdvancedCorporationSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdvancedCorporationSearchQuery, AdvancedCorporationSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdvancedCorporationSearchQuery, AdvancedCorporationSearchQueryVariables>(AdvancedCorporationSearchDocument, options);
        }
export type AdvancedCorporationSearchQueryHookResult = ReturnType<typeof useAdvancedCorporationSearchQuery>;
export type AdvancedCorporationSearchLazyQueryHookResult = ReturnType<typeof useAdvancedCorporationSearchLazyQuery>;
export type AdvancedCorporationSearchSuspenseQueryHookResult = ReturnType<typeof useAdvancedCorporationSearchSuspenseQuery>;
export type AdvancedCorporationSearchQueryResult = Apollo.QueryResult<AdvancedCorporationSearchQuery, AdvancedCorporationSearchQueryVariables>;
export const AdvancedPersonSearchDocument = gql`
    query advancedPersonSearch($values: [String!]!, $limit: Int! = 50) {
  advancedPersonSearch(query: "(field(firstName):{0} AND field(lastName):{1}) OR (field(firstName):{0} AND field(birthDate):{2}) OR (field(lastName):{1} AND field(birthDate):{2})", values: $values, limit: $limit) {
    persons {
      id
      isCustomer
      isPerson
      title: inputValue(fieldCode: "title") {
        stringValue
      }
      firstName: inputValue(fieldCode: "firstName") {
        stringValue
      }
      lastName: inputValue(fieldCode: "lastName") {
        stringValue
      }
      birthName: inputValue(fieldCode: "birthName") {
        stringValue
      }
      birthDate: inputValue(fieldCode: "birthDate") {
        stringValue
      }
      citizenshipCountryCode: inputValue(fieldCode: "citizenshipCountryCode") {
        stringValue
      }
      residenceCountryCode: inputValue(fieldCode: "residenceCountryCode") {
        stringValue
      }
      birthCountryCode: inputValue(fieldCode: "birthCountryCode") {
        stringValue
      }
      eReputation {
        entries {
          category {
            code
          }
          providerResult
          analysis {
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useAdvancedPersonSearchQuery__
 *
 * To run a query within a React component, call `useAdvancedPersonSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdvancedPersonSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdvancedPersonSearchQuery({
 *   variables: {
 *      values: // value for 'values'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useAdvancedPersonSearchQuery(baseOptions: Apollo.QueryHookOptions<AdvancedPersonSearchQuery, AdvancedPersonSearchQueryVariables> & ({ variables: AdvancedPersonSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdvancedPersonSearchQuery, AdvancedPersonSearchQueryVariables>(AdvancedPersonSearchDocument, options);
      }
export function useAdvancedPersonSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdvancedPersonSearchQuery, AdvancedPersonSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdvancedPersonSearchQuery, AdvancedPersonSearchQueryVariables>(AdvancedPersonSearchDocument, options);
        }
export function useAdvancedPersonSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdvancedPersonSearchQuery, AdvancedPersonSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdvancedPersonSearchQuery, AdvancedPersonSearchQueryVariables>(AdvancedPersonSearchDocument, options);
        }
export type AdvancedPersonSearchQueryHookResult = ReturnType<typeof useAdvancedPersonSearchQuery>;
export type AdvancedPersonSearchLazyQueryHookResult = ReturnType<typeof useAdvancedPersonSearchLazyQuery>;
export type AdvancedPersonSearchSuspenseQueryHookResult = ReturnType<typeof useAdvancedPersonSearchSuspenseQuery>;
export type AdvancedPersonSearchQueryResult = Apollo.QueryResult<AdvancedPersonSearchQuery, AdvancedPersonSearchQueryVariables>;
export const CompareCustomerGraphWithExternalDataDocument = gql`
    query CompareCustomerGraphWithExternalData($customerFolderId: ID!) {
  compareCustomerGraphWithExternalData(customerFolderId: $customerFolderId) {
    errors {
      identifier
      message
    }
    stakeholdersWithDiffs {
      folderStakeholder {
        entity {
          id
        }
        beneficiaryOwner
        isFolderCustomer
        isLegalRepresentative
        inputValues {
          inputField {
            fieldCode
          }
          stringValue
        }
      }
      externalData {
        identifiersMatchStatus
        diffInputValues {
          fieldCode
          dataType
          value
        }
        isPerson
        fullInputValues {
          fieldCode
          dataType
          value
        }
        rolesToAdd {
          typeCode
        }
        rolesToDelete
        isCorporation
      }
    }
  }
}
    `;

/**
 * __useCompareCustomerGraphWithExternalDataQuery__
 *
 * To run a query within a React component, call `useCompareCustomerGraphWithExternalDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompareCustomerGraphWithExternalDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompareCustomerGraphWithExternalDataQuery({
 *   variables: {
 *      customerFolderId: // value for 'customerFolderId'
 *   },
 * });
 */
export function useCompareCustomerGraphWithExternalDataQuery(baseOptions: Apollo.QueryHookOptions<CompareCustomerGraphWithExternalDataQuery, CompareCustomerGraphWithExternalDataQueryVariables> & ({ variables: CompareCustomerGraphWithExternalDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompareCustomerGraphWithExternalDataQuery, CompareCustomerGraphWithExternalDataQueryVariables>(CompareCustomerGraphWithExternalDataDocument, options);
      }
export function useCompareCustomerGraphWithExternalDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompareCustomerGraphWithExternalDataQuery, CompareCustomerGraphWithExternalDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompareCustomerGraphWithExternalDataQuery, CompareCustomerGraphWithExternalDataQueryVariables>(CompareCustomerGraphWithExternalDataDocument, options);
        }
export function useCompareCustomerGraphWithExternalDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompareCustomerGraphWithExternalDataQuery, CompareCustomerGraphWithExternalDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompareCustomerGraphWithExternalDataQuery, CompareCustomerGraphWithExternalDataQueryVariables>(CompareCustomerGraphWithExternalDataDocument, options);
        }
export type CompareCustomerGraphWithExternalDataQueryHookResult = ReturnType<typeof useCompareCustomerGraphWithExternalDataQuery>;
export type CompareCustomerGraphWithExternalDataLazyQueryHookResult = ReturnType<typeof useCompareCustomerGraphWithExternalDataLazyQuery>;
export type CompareCustomerGraphWithExternalDataSuspenseQueryHookResult = ReturnType<typeof useCompareCustomerGraphWithExternalDataSuspenseQuery>;
export type CompareCustomerGraphWithExternalDataQueryResult = Apollo.QueryResult<CompareCustomerGraphWithExternalDataQuery, CompareCustomerGraphWithExternalDataQueryVariables>;
export const CountriesListDocument = gql`
    query countriesList {
  listElements(elementType: "Country") {
    ... on Country {
      id
      code
      name
      alpha3
    }
  }
}
    `;

/**
 * __useCountriesListQuery__
 *
 * To run a query within a React component, call `useCountriesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountriesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountriesListQuery({
 *   variables: {
 *   },
 * });
 */
export function useCountriesListQuery(baseOptions?: Apollo.QueryHookOptions<CountriesListQuery, CountriesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountriesListQuery, CountriesListQueryVariables>(CountriesListDocument, options);
      }
export function useCountriesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountriesListQuery, CountriesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountriesListQuery, CountriesListQueryVariables>(CountriesListDocument, options);
        }
export function useCountriesListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CountriesListQuery, CountriesListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountriesListQuery, CountriesListQueryVariables>(CountriesListDocument, options);
        }
export type CountriesListQueryHookResult = ReturnType<typeof useCountriesListQuery>;
export type CountriesListLazyQueryHookResult = ReturnType<typeof useCountriesListLazyQuery>;
export type CountriesListSuspenseQueryHookResult = ReturnType<typeof useCountriesListSuspenseQuery>;
export type CountriesListQueryResult = Apollo.QueryResult<CountriesListQuery, CountriesListQueryVariables>;
export const CountriesWithRiskListDocument = gql`
    query countriesWithRiskList {
  listElements(elementType: "Country") {
    ... on Country {
      id
      code
      name
      riskValues {
        description
        riskCategory
        key
      }
    }
  }
}
    `;

/**
 * __useCountriesWithRiskListQuery__
 *
 * To run a query within a React component, call `useCountriesWithRiskListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountriesWithRiskListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountriesWithRiskListQuery({
 *   variables: {
 *   },
 * });
 */
export function useCountriesWithRiskListQuery(baseOptions?: Apollo.QueryHookOptions<CountriesWithRiskListQuery, CountriesWithRiskListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountriesWithRiskListQuery, CountriesWithRiskListQueryVariables>(CountriesWithRiskListDocument, options);
      }
export function useCountriesWithRiskListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountriesWithRiskListQuery, CountriesWithRiskListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountriesWithRiskListQuery, CountriesWithRiskListQueryVariables>(CountriesWithRiskListDocument, options);
        }
export function useCountriesWithRiskListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CountriesWithRiskListQuery, CountriesWithRiskListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountriesWithRiskListQuery, CountriesWithRiskListQueryVariables>(CountriesWithRiskListDocument, options);
        }
export type CountriesWithRiskListQueryHookResult = ReturnType<typeof useCountriesWithRiskListQuery>;
export type CountriesWithRiskListLazyQueryHookResult = ReturnType<typeof useCountriesWithRiskListLazyQuery>;
export type CountriesWithRiskListSuspenseQueryHookResult = ReturnType<typeof useCountriesWithRiskListSuspenseQuery>;
export type CountriesWithRiskListQueryResult = Apollo.QueryResult<CountriesWithRiskListQuery, CountriesWithRiskListQueryVariables>;
export const CurrentUserWithRolesDocument = gql`
    query currentUserWithRoles {
  currentUser {
    ...UserWithRolesFields
  }
}
    ${UserWithRolesFieldsFragmentDoc}`;

/**
 * __useCurrentUserWithRolesQuery__
 *
 * To run a query within a React component, call `useCurrentUserWithRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserWithRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserWithRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserWithRolesQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserWithRolesQuery, CurrentUserWithRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserWithRolesQuery, CurrentUserWithRolesQueryVariables>(CurrentUserWithRolesDocument, options);
      }
export function useCurrentUserWithRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserWithRolesQuery, CurrentUserWithRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserWithRolesQuery, CurrentUserWithRolesQueryVariables>(CurrentUserWithRolesDocument, options);
        }
export function useCurrentUserWithRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserWithRolesQuery, CurrentUserWithRolesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserWithRolesQuery, CurrentUserWithRolesQueryVariables>(CurrentUserWithRolesDocument, options);
        }
export type CurrentUserWithRolesQueryHookResult = ReturnType<typeof useCurrentUserWithRolesQuery>;
export type CurrentUserWithRolesLazyQueryHookResult = ReturnType<typeof useCurrentUserWithRolesLazyQuery>;
export type CurrentUserWithRolesSuspenseQueryHookResult = ReturnType<typeof useCurrentUserWithRolesSuspenseQuery>;
export type CurrentUserWithRolesQueryResult = Apollo.QueryResult<CurrentUserWithRolesQuery, CurrentUserWithRolesQueryVariables>;
export const CustomerFoldersHavingAtLeastOneInactiveMissionInLatestSnapshotDocument = gql`
    query customerFoldersHavingAtLeastOneInactiveMissionInLatestSnapshot($limit: Int!, $ownerUserIdFilter: String, $followedByUserIdFilter: String, $sort: [InactiveMissionsInLatestSnapshotOfCustomerFoldersPageSortingFieldInputType!] = [{name: RiskLevel, direction: DESC}, {name: RenewDate, direction: DESC}]) {
  customerFoldersHavingAtLeastOneInactiveMissionInLatestSnapshot(limit: $limit, ownerUserIdFilter: $ownerUserIdFilter, followedByUserIdFilter: $followedByUserIdFilter, sortInactiveMissionsInLatestSnapshotOfCustomerFoldersPage: $sort) {
    summaries {
      mission {
        renewDate
      }
      customer {
        id
        allInputValues: inputValues {
          inputField {
            fieldCode
          }
          stringValue
        }
      }
      file {
        riskStatus {
          globalRiskLevel
          riskDetail {
            axesStatus {
              riskLevel
              axisName
              risks {
                item
              }
            }
          }
        }
      }
      customerFolder {
        id
        owner {
          firstName
          lastName
        }
        folderFiles(limit: 1) {
          summaries {
            id
          }
        }
        adminStatus {
          lastModification
          lastModifier {
            name
          }
        }
        followedByCurrentUser
        followingUsers {
          firstName
          lastName
          id
        }
        customerFolderType {
          code
        }
      }
    }
    pageInfo {
      totalCount
    }
  }
}
    `;

/**
 * __useCustomerFoldersHavingAtLeastOneInactiveMissionInLatestSnapshotQuery__
 *
 * To run a query within a React component, call `useCustomerFoldersHavingAtLeastOneInactiveMissionInLatestSnapshotQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerFoldersHavingAtLeastOneInactiveMissionInLatestSnapshotQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerFoldersHavingAtLeastOneInactiveMissionInLatestSnapshotQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      ownerUserIdFilter: // value for 'ownerUserIdFilter'
 *      followedByUserIdFilter: // value for 'followedByUserIdFilter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useCustomerFoldersHavingAtLeastOneInactiveMissionInLatestSnapshotQuery(baseOptions: Apollo.QueryHookOptions<CustomerFoldersHavingAtLeastOneInactiveMissionInLatestSnapshotQuery, CustomerFoldersHavingAtLeastOneInactiveMissionInLatestSnapshotQueryVariables> & ({ variables: CustomerFoldersHavingAtLeastOneInactiveMissionInLatestSnapshotQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerFoldersHavingAtLeastOneInactiveMissionInLatestSnapshotQuery, CustomerFoldersHavingAtLeastOneInactiveMissionInLatestSnapshotQueryVariables>(CustomerFoldersHavingAtLeastOneInactiveMissionInLatestSnapshotDocument, options);
      }
export function useCustomerFoldersHavingAtLeastOneInactiveMissionInLatestSnapshotLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerFoldersHavingAtLeastOneInactiveMissionInLatestSnapshotQuery, CustomerFoldersHavingAtLeastOneInactiveMissionInLatestSnapshotQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerFoldersHavingAtLeastOneInactiveMissionInLatestSnapshotQuery, CustomerFoldersHavingAtLeastOneInactiveMissionInLatestSnapshotQueryVariables>(CustomerFoldersHavingAtLeastOneInactiveMissionInLatestSnapshotDocument, options);
        }
export function useCustomerFoldersHavingAtLeastOneInactiveMissionInLatestSnapshotSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CustomerFoldersHavingAtLeastOneInactiveMissionInLatestSnapshotQuery, CustomerFoldersHavingAtLeastOneInactiveMissionInLatestSnapshotQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CustomerFoldersHavingAtLeastOneInactiveMissionInLatestSnapshotQuery, CustomerFoldersHavingAtLeastOneInactiveMissionInLatestSnapshotQueryVariables>(CustomerFoldersHavingAtLeastOneInactiveMissionInLatestSnapshotDocument, options);
        }
export type CustomerFoldersHavingAtLeastOneInactiveMissionInLatestSnapshotQueryHookResult = ReturnType<typeof useCustomerFoldersHavingAtLeastOneInactiveMissionInLatestSnapshotQuery>;
export type CustomerFoldersHavingAtLeastOneInactiveMissionInLatestSnapshotLazyQueryHookResult = ReturnType<typeof useCustomerFoldersHavingAtLeastOneInactiveMissionInLatestSnapshotLazyQuery>;
export type CustomerFoldersHavingAtLeastOneInactiveMissionInLatestSnapshotSuspenseQueryHookResult = ReturnType<typeof useCustomerFoldersHavingAtLeastOneInactiveMissionInLatestSnapshotSuspenseQuery>;
export type CustomerFoldersHavingAtLeastOneInactiveMissionInLatestSnapshotQueryResult = Apollo.QueryResult<CustomerFoldersHavingAtLeastOneInactiveMissionInLatestSnapshotQuery, CustomerFoldersHavingAtLeastOneInactiveMissionInLatestSnapshotQueryVariables>;
export const FolderFileDocument = gql`
    query FolderFile($id: ID!) {
  folderFile(id: $id) {
    id
    adminStatus {
      author {
        id
      }
      creation
      lastModification
    }
    messageThreads {
      id
      title
      messages {
        id
        content
        adminStatus {
          author {
            lastName
            firstName
            id
          }
          creation
          lastModification
          lastModifier {
            lastName
            firstName
            id
          }
        }
      }
      unreadMessages {
        id
        content
        adminStatus {
          author {
            lastName
            firstName
            id
          }
          creation
          lastModification
          lastModifier {
            lastName
            firstName
            id
          }
        }
      }
    }
    riskStatus {
      standardRiskLevel
      globalRiskLevel
      forcedRisk {
        level
        reason {
          id
          name
          code
        }
      }
    }
    completionStatus {
      complete
      requiredFieldsMissing
    }
    workflowStatus {
      state {
        code
      }
      lastModification
    }
    allowedTransitions {
      action {
        code
      }
    }
    auditEvents {
      ... on WorkflowEvent {
        comment
        date
        state {
          code
        }
        user {
          name
        }
      }
    }
    currentCustomerFolder {
      id
      customerFolderType {
        code
      }
      contactPerson {
        ...ContactPersonFields
      }
      owner {
        ...OwnerFields
      }
      folderFiles(limit: 50) {
        summaries {
          id
          workflowStatus {
            state {
              code
            }
            lastModification
          }
          riskStatus {
            standardRiskLevel
            globalRiskLevel
            forcedRisk {
              level
              reason {
                id
                name
                code
              }
            }
          }
          currentCustomerFolder {
            missions {
              id
              adminStatus {
                lastModification
                creation
              }
              isEditable
              isClosable
            }
          }
        }
      }
      missions {
        id
        isEditable
        isClosable
        isReopenable
        status
        statusComment
        adminStatus {
          lastModification
          creation
        }
        inputValues {
          inputField {
            fieldCode
          }
          stringValue
        }
      }
      followingUsers {
        ...OwnerFields
      }
      followedByCurrentUser
    }
    fileCustomerFolder {
      id
      missions {
        id
        isEditable
        isClosable
        isReopenable
        status
        statusComment
        adminStatus {
          lastModification
          creation
        }
        inputValues {
          inputField {
            fieldCode
          }
          stringValue
        }
      }
      customer {
        id
        isPerson
        allInputValues: inputValues {
          inputField {
            fieldCode
          }
          stringValue
        }
      }
      stakeholders {
        entity {
          id
          eReputation {
            entries {
              category {
                code
              }
              providerResult
              analysis {
                name
              }
            }
          }
        }
        beneficiaryOwner
        isFolderCustomer
        isLegalRepresentative
        inputValues {
          inputField {
            fieldCode
          }
          stringValue
        }
        supportingDocuments {
          abstractDocumentType {
            code
            name
          }
          mainDocument {
            ... on Document {
              id
              status
              name
              type {
                name
                code
              }
              expirationDate
              __typename
            }
            ... on ExternalDocument {
              id
              type {
                name
                code
              }
              __typename
            }
          }
        }
      }
      supportingQuestionnaires {
        questionnaire {
          id
          isEditable
          content
          type {
            id
            code
            corpSchema
          }
        }
      }
    }
    diligences {
      id
      name
      selected
      code
      category
    }
  }
}
    ${ContactPersonFieldsFragmentDoc}
${OwnerFieldsFragmentDoc}`;

/**
 * __useFolderFileQuery__
 *
 * To run a query within a React component, call `useFolderFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useFolderFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFolderFileQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFolderFileQuery(baseOptions: Apollo.QueryHookOptions<FolderFileQuery, FolderFileQueryVariables> & ({ variables: FolderFileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FolderFileQuery, FolderFileQueryVariables>(FolderFileDocument, options);
      }
export function useFolderFileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FolderFileQuery, FolderFileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FolderFileQuery, FolderFileQueryVariables>(FolderFileDocument, options);
        }
export function useFolderFileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FolderFileQuery, FolderFileQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FolderFileQuery, FolderFileQueryVariables>(FolderFileDocument, options);
        }
export type FolderFileQueryHookResult = ReturnType<typeof useFolderFileQuery>;
export type FolderFileLazyQueryHookResult = ReturnType<typeof useFolderFileLazyQuery>;
export type FolderFileSuspenseQueryHookResult = ReturnType<typeof useFolderFileSuspenseQuery>;
export type FolderFileQueryResult = Apollo.QueryResult<FolderFileQuery, FolderFileQueryVariables>;
export const FolderFileSummaryNotaireDocument = gql`
    query FolderFileSummaryNotaire($id: ID!) {
  folderFile(id: $id) {
    id
    currentCustomerFolder {
      id
      contactPerson {
        id
        inputValues {
          inputField {
            fieldCode
          }
          stringValue
        }
      }
      owner {
        id
        firstName
        lastName
      }
      customer {
        id
        isPerson
        inputValues(fieldCodes: ["name", "registration", "registrationCountryCode"]) {
          inputField {
            fieldCode
          }
          stringValue
        }
      }
      folderFiles(limit: 50) {
        summaries {
          id
          workflowStatus {
            state {
              code
            }
          }
          inputValues(fieldCodes: ["name"]) {
            inputField {
              fieldCode
            }
            stringValue
          }
          adminStatus {
            creation
          }
          riskStatus {
            globalRiskLevel
          }
        }
      }
    }
  }
}
    `;

/**
 * __useFolderFileSummaryNotaireQuery__
 *
 * To run a query within a React component, call `useFolderFileSummaryNotaireQuery` and pass it any options that fit your needs.
 * When your component renders, `useFolderFileSummaryNotaireQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFolderFileSummaryNotaireQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFolderFileSummaryNotaireQuery(baseOptions: Apollo.QueryHookOptions<FolderFileSummaryNotaireQuery, FolderFileSummaryNotaireQueryVariables> & ({ variables: FolderFileSummaryNotaireQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FolderFileSummaryNotaireQuery, FolderFileSummaryNotaireQueryVariables>(FolderFileSummaryNotaireDocument, options);
      }
export function useFolderFileSummaryNotaireLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FolderFileSummaryNotaireQuery, FolderFileSummaryNotaireQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FolderFileSummaryNotaireQuery, FolderFileSummaryNotaireQueryVariables>(FolderFileSummaryNotaireDocument, options);
        }
export function useFolderFileSummaryNotaireSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FolderFileSummaryNotaireQuery, FolderFileSummaryNotaireQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FolderFileSummaryNotaireQuery, FolderFileSummaryNotaireQueryVariables>(FolderFileSummaryNotaireDocument, options);
        }
export type FolderFileSummaryNotaireQueryHookResult = ReturnType<typeof useFolderFileSummaryNotaireQuery>;
export type FolderFileSummaryNotaireLazyQueryHookResult = ReturnType<typeof useFolderFileSummaryNotaireLazyQuery>;
export type FolderFileSummaryNotaireSuspenseQueryHookResult = ReturnType<typeof useFolderFileSummaryNotaireSuspenseQuery>;
export type FolderFileSummaryNotaireQueryResult = Apollo.QueryResult<FolderFileSummaryNotaireQuery, FolderFileSummaryNotaireQueryVariables>;
export const FolderFilesCountDocument = gql`
    query FolderFilesCount($draftState: [String!]!, $validationPendingState: [String!]!, $validationPendingHrState: [String!]!, $missionCreation: [String!]!, $validatedState: [String!]!) {
  draft: folderFilesPage(stateIds: $draftState, folderFileTypeCodesFilter: $missionCreation, limit: 1, displayOnlyUserFiles: false) {
    ...FolderFilesPageInfo
  }
  validationPending: folderFilesPage(stateIds: $validationPendingState, limit: 1, displayOnlyUserFiles: false) {
    ...FolderFilesPageInfo
  }
  validationPendingHr: folderFilesPage(stateIds: $validationPendingHrState, limit: 1, displayOnlyUserFiles: false) {
    ...FolderFilesPageInfo
  }
  renewal: customerFoldersHavingAtLeastOneInactiveMissionInLatestSnapshot(limit: 1) {
    pageInfo {
      totalCount
    }
  }
  validated: lastModifiedFolderFilePerCurrentCustomerFolder(fileStateIds: $validatedState, limit: 1) {
    pageInfo {
      totalCount
    }
  }
}
    ${FolderFilesPageInfoFragmentDoc}`;

/**
 * __useFolderFilesCountQuery__
 *
 * To run a query within a React component, call `useFolderFilesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useFolderFilesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFolderFilesCountQuery({
 *   variables: {
 *      draftState: // value for 'draftState'
 *      validationPendingState: // value for 'validationPendingState'
 *      validationPendingHrState: // value for 'validationPendingHrState'
 *      missionCreation: // value for 'missionCreation'
 *      validatedState: // value for 'validatedState'
 *   },
 * });
 */
export function useFolderFilesCountQuery(baseOptions: Apollo.QueryHookOptions<FolderFilesCountQuery, FolderFilesCountQueryVariables> & ({ variables: FolderFilesCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FolderFilesCountQuery, FolderFilesCountQueryVariables>(FolderFilesCountDocument, options);
      }
export function useFolderFilesCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FolderFilesCountQuery, FolderFilesCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FolderFilesCountQuery, FolderFilesCountQueryVariables>(FolderFilesCountDocument, options);
        }
export function useFolderFilesCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FolderFilesCountQuery, FolderFilesCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FolderFilesCountQuery, FolderFilesCountQueryVariables>(FolderFilesCountDocument, options);
        }
export type FolderFilesCountQueryHookResult = ReturnType<typeof useFolderFilesCountQuery>;
export type FolderFilesCountLazyQueryHookResult = ReturnType<typeof useFolderFilesCountLazyQuery>;
export type FolderFilesCountSuspenseQueryHookResult = ReturnType<typeof useFolderFilesCountSuspenseQuery>;
export type FolderFilesCountQueryResult = Apollo.QueryResult<FolderFilesCountQuery, FolderFilesCountQueryVariables>;
export const FolderFilesPageNotaireDocument = gql`
    query folderFilesPageNotaire($stateIds: [String!], $folderFileType: [String!], $limit: Int!, $sort: [FolderFilesPageSortingFieldInputType!] = [{name: RiskLevel, direction: DESC}, {name: LastModification, direction: DESC}], $offset: Int!) {
  folderFilesPage(stateIds: $stateIds, folderFileTypeCodesFilter: $folderFileType, limit: $limit, offset: $offset, sortFolderFilesPage: $sort, displayOnlyUserFiles: false) {
    summaries {
      customer {
        allInputValues: inputValues(fieldCodes: ["name"]) {
          inputField {
            fieldCode
          }
          stringValue
        }
        isPerson
      }
      folderFile {
        id
        currentCustomerFolder {
          owner {
            id
            firstName
            lastName
          }
          folderFiles(limit: 1) {
            pageInfo {
              totalCount
            }
          }
        }
        riskStatus {
          globalRiskLevel
        }
        adminStatus {
          lastModification
          author {
            name
          }
        }
      }
    }
    pageInfo {
      totalCount
    }
  }
}
    `;

/**
 * __useFolderFilesPageNotaireQuery__
 *
 * To run a query within a React component, call `useFolderFilesPageNotaireQuery` and pass it any options that fit your needs.
 * When your component renders, `useFolderFilesPageNotaireQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFolderFilesPageNotaireQuery({
 *   variables: {
 *      stateIds: // value for 'stateIds'
 *      folderFileType: // value for 'folderFileType'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useFolderFilesPageNotaireQuery(baseOptions: Apollo.QueryHookOptions<FolderFilesPageNotaireQuery, FolderFilesPageNotaireQueryVariables> & ({ variables: FolderFilesPageNotaireQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FolderFilesPageNotaireQuery, FolderFilesPageNotaireQueryVariables>(FolderFilesPageNotaireDocument, options);
      }
export function useFolderFilesPageNotaireLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FolderFilesPageNotaireQuery, FolderFilesPageNotaireQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FolderFilesPageNotaireQuery, FolderFilesPageNotaireQueryVariables>(FolderFilesPageNotaireDocument, options);
        }
export function useFolderFilesPageNotaireSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FolderFilesPageNotaireQuery, FolderFilesPageNotaireQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FolderFilesPageNotaireQuery, FolderFilesPageNotaireQueryVariables>(FolderFilesPageNotaireDocument, options);
        }
export type FolderFilesPageNotaireQueryHookResult = ReturnType<typeof useFolderFilesPageNotaireQuery>;
export type FolderFilesPageNotaireLazyQueryHookResult = ReturnType<typeof useFolderFilesPageNotaireLazyQuery>;
export type FolderFilesPageNotaireSuspenseQueryHookResult = ReturnType<typeof useFolderFilesPageNotaireSuspenseQuery>;
export type FolderFilesPageNotaireQueryResult = Apollo.QueryResult<FolderFilesPageNotaireQuery, FolderFilesPageNotaireQueryVariables>;
export const FolderFilesPageDocument = gql`
    query folderFilesPage($stateIds: [String!], $folderFileType: [String!], $limit: Int!, $offset: Int!, $ownerUserIdFilter: String, $followedByUserIdFilter: String, $sort: [FolderFilesPageSortingFieldInputType!] = [{name: RiskLevel, direction: DESC}, {name: LastModification, direction: DESC}]) {
  folderFilesPage(stateIds: $stateIds, folderFileTypeCodesFilter: $folderFileType, limit: $limit, offset: $offset, displayOnlyUserFiles: false, ownerUserIdFilter: $ownerUserIdFilter, followedByUserIdFilter: $followedByUserIdFilter, sortFolderFilesPage: $sort) {
    summaries {
      customer {
        allInputValues: inputValues(fieldCodes: ["name", "registration", "lastName", "firstName"]) {
          inputField {
            fieldCode
          }
          stringValue
        }
      }
      folderFile {
        id
        currentCustomerFolder {
          owner {
            id
            firstName
            lastName
          }
          followingUsers {
            id
            firstName
            lastName
          }
          followedByCurrentUser
          customerFolderType {
            code
          }
        }
        riskStatus {
          globalRiskLevel
          riskDetail {
            axesStatus {
              riskLevel
              axisName
              risks {
                item
              }
            }
          }
        }
        adminStatus {
          lastModification
          lastModifier {
            name
          }
        }
      }
    }
    pageInfo {
      totalCount
    }
  }
}
    `;

/**
 * __useFolderFilesPageQuery__
 *
 * To run a query within a React component, call `useFolderFilesPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useFolderFilesPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFolderFilesPageQuery({
 *   variables: {
 *      stateIds: // value for 'stateIds'
 *      folderFileType: // value for 'folderFileType'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      ownerUserIdFilter: // value for 'ownerUserIdFilter'
 *      followedByUserIdFilter: // value for 'followedByUserIdFilter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useFolderFilesPageQuery(baseOptions: Apollo.QueryHookOptions<FolderFilesPageQuery, FolderFilesPageQueryVariables> & ({ variables: FolderFilesPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FolderFilesPageQuery, FolderFilesPageQueryVariables>(FolderFilesPageDocument, options);
      }
export function useFolderFilesPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FolderFilesPageQuery, FolderFilesPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FolderFilesPageQuery, FolderFilesPageQueryVariables>(FolderFilesPageDocument, options);
        }
export function useFolderFilesPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FolderFilesPageQuery, FolderFilesPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FolderFilesPageQuery, FolderFilesPageQueryVariables>(FolderFilesPageDocument, options);
        }
export type FolderFilesPageQueryHookResult = ReturnType<typeof useFolderFilesPageQuery>;
export type FolderFilesPageLazyQueryHookResult = ReturnType<typeof useFolderFilesPageLazyQuery>;
export type FolderFilesPageSuspenseQueryHookResult = ReturnType<typeof useFolderFilesPageSuspenseQuery>;
export type FolderFilesPageQueryResult = Apollo.QueryResult<FolderFilesPageQuery, FolderFilesPageQueryVariables>;
export const FolderFilesPageNotaireHrDocument = gql`
    query folderFilesPageNotaireHr($stateIds: [String!], $folderFileType: [String!], $limit: Int!, $sort: [FolderFilesPageSortingFieldInputType!] = [{name: RiskLevel, direction: DESC}, {name: LastModification, direction: DESC}], $offset: Int!) {
  folderFilesPage(stateIds: $stateIds, folderFileTypeCodesFilter: $folderFileType, limit: $limit, offset: $offset, sortFolderFilesPage: $sort, displayOnlyUserFiles: false) {
    summaries {
      customer {
        allInputValues: inputValues(fieldCodes: ["name"]) {
          inputField {
            fieldCode
          }
          stringValue
        }
        isPerson
      }
      folderFile {
        id
        currentCustomerFolder {
          owner {
            id
            firstName
            lastName
          }
          folderFiles(limit: 1) {
            pageInfo {
              totalCount
            }
          }
        }
        riskStatus {
          globalRiskLevel
          riskDetail {
            axesStatus {
              riskLevel
              axisName
              risks {
                item
              }
            }
          }
        }
        adminStatus {
          lastModification
          author {
            name
          }
        }
      }
    }
    pageInfo {
      totalCount
    }
  }
}
    `;

/**
 * __useFolderFilesPageNotaireHrQuery__
 *
 * To run a query within a React component, call `useFolderFilesPageNotaireHrQuery` and pass it any options that fit your needs.
 * When your component renders, `useFolderFilesPageNotaireHrQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFolderFilesPageNotaireHrQuery({
 *   variables: {
 *      stateIds: // value for 'stateIds'
 *      folderFileType: // value for 'folderFileType'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useFolderFilesPageNotaireHrQuery(baseOptions: Apollo.QueryHookOptions<FolderFilesPageNotaireHrQuery, FolderFilesPageNotaireHrQueryVariables> & ({ variables: FolderFilesPageNotaireHrQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FolderFilesPageNotaireHrQuery, FolderFilesPageNotaireHrQueryVariables>(FolderFilesPageNotaireHrDocument, options);
      }
export function useFolderFilesPageNotaireHrLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FolderFilesPageNotaireHrQuery, FolderFilesPageNotaireHrQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FolderFilesPageNotaireHrQuery, FolderFilesPageNotaireHrQueryVariables>(FolderFilesPageNotaireHrDocument, options);
        }
export function useFolderFilesPageNotaireHrSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FolderFilesPageNotaireHrQuery, FolderFilesPageNotaireHrQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FolderFilesPageNotaireHrQuery, FolderFilesPageNotaireHrQueryVariables>(FolderFilesPageNotaireHrDocument, options);
        }
export type FolderFilesPageNotaireHrQueryHookResult = ReturnType<typeof useFolderFilesPageNotaireHrQuery>;
export type FolderFilesPageNotaireHrLazyQueryHookResult = ReturnType<typeof useFolderFilesPageNotaireHrLazyQuery>;
export type FolderFilesPageNotaireHrSuspenseQueryHookResult = ReturnType<typeof useFolderFilesPageNotaireHrSuspenseQuery>;
export type FolderFilesPageNotaireHrQueryResult = Apollo.QueryResult<FolderFilesPageNotaireHrQuery, FolderFilesPageNotaireHrQueryVariables>;
export const FolderFilesPageHrDocument = gql`
    query folderFilesPageHr($stateIds: [String!], $folderFileType: [String!], $limit: Int!, $sort: [FolderFilesPageSortingFieldInputType!] = [{name: RiskLevel, direction: DESC}, {name: LastModification, direction: DESC}], $offset: Int!, $ownerUserIdFilter: String, $followedByUserIdFilter: String) {
  folderFilesPage(stateIds: $stateIds, folderFileTypeCodesFilter: $folderFileType, limit: $limit, offset: $offset, sortFolderFilesPage: $sort, displayOnlyUserFiles: false, ownerUserIdFilter: $ownerUserIdFilter, followedByUserIdFilter: $followedByUserIdFilter) {
    summaries {
      customer {
        allInputValues: inputValues(fieldCodes: ["name", "registration", "lastName", "firstName"]) {
          inputField {
            fieldCode
          }
          stringValue
        }
      }
      folderFile {
        id
        currentCustomerFolder {
          owner {
            id
            firstName
            lastName
          }
          followingUsers {
            id
            firstName
            lastName
          }
          followedByCurrentUser
          customerFolderType {
            code
          }
        }
        riskStatus {
          globalRiskLevel
          riskDetail {
            axesStatus {
              riskLevel
              axisName
              risks {
                item
              }
            }
          }
        }
        adminStatus {
          lastModification
          lastModifier {
            name
          }
        }
      }
    }
    pageInfo {
      totalCount
    }
  }
}
    `;

/**
 * __useFolderFilesPageHrQuery__
 *
 * To run a query within a React component, call `useFolderFilesPageHrQuery` and pass it any options that fit your needs.
 * When your component renders, `useFolderFilesPageHrQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFolderFilesPageHrQuery({
 *   variables: {
 *      stateIds: // value for 'stateIds'
 *      folderFileType: // value for 'folderFileType'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      offset: // value for 'offset'
 *      ownerUserIdFilter: // value for 'ownerUserIdFilter'
 *      followedByUserIdFilter: // value for 'followedByUserIdFilter'
 *   },
 * });
 */
export function useFolderFilesPageHrQuery(baseOptions: Apollo.QueryHookOptions<FolderFilesPageHrQuery, FolderFilesPageHrQueryVariables> & ({ variables: FolderFilesPageHrQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FolderFilesPageHrQuery, FolderFilesPageHrQueryVariables>(FolderFilesPageHrDocument, options);
      }
export function useFolderFilesPageHrLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FolderFilesPageHrQuery, FolderFilesPageHrQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FolderFilesPageHrQuery, FolderFilesPageHrQueryVariables>(FolderFilesPageHrDocument, options);
        }
export function useFolderFilesPageHrSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FolderFilesPageHrQuery, FolderFilesPageHrQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FolderFilesPageHrQuery, FolderFilesPageHrQueryVariables>(FolderFilesPageHrDocument, options);
        }
export type FolderFilesPageHrQueryHookResult = ReturnType<typeof useFolderFilesPageHrQuery>;
export type FolderFilesPageHrLazyQueryHookResult = ReturnType<typeof useFolderFilesPageHrLazyQuery>;
export type FolderFilesPageHrSuspenseQueryHookResult = ReturnType<typeof useFolderFilesPageHrSuspenseQuery>;
export type FolderFilesPageHrQueryResult = Apollo.QueryResult<FolderFilesPageHrQuery, FolderFilesPageHrQueryVariables>;
export const FolderFilesPageWithRiskDetailsNotaireDocument = gql`
    query folderFilesPageWithRiskDetailsNotaire($stateIds: [String!], $folderFileType: [String!], $limit: Int!, $sort: [FolderFilesPageSortingFieldInputType!] = [{name: RiskLevel, direction: DESC}, {name: LastModification, direction: DESC}]) {
  folderFilesPage(stateIds: $stateIds, folderFileTypeCodesFilter: $folderFileType, limit: $limit, sortFolderFilesPage: $sort, displayOnlyUserFiles: false) {
    summaries {
      customer {
        allInputValues: inputValues(fieldCodes: ["name"]) {
          inputField {
            fieldCode
          }
          stringValue
        }
        isPerson
      }
      folderFile {
        id
        currentCustomerFolder {
          owner {
            id
            firstName
            lastName
          }
          folderFiles(limit: 1) {
            pageInfo {
              totalCount
            }
          }
        }
        riskStatus {
          globalRiskLevel
          riskDetail {
            axesStatus {
              axisName
              riskLevel
            }
          }
        }
        adminStatus {
          lastModification
          author {
            name
          }
        }
      }
    }
    pageInfo {
      totalCount
    }
  }
}
    `;

/**
 * __useFolderFilesPageWithRiskDetailsNotaireQuery__
 *
 * To run a query within a React component, call `useFolderFilesPageWithRiskDetailsNotaireQuery` and pass it any options that fit your needs.
 * When your component renders, `useFolderFilesPageWithRiskDetailsNotaireQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFolderFilesPageWithRiskDetailsNotaireQuery({
 *   variables: {
 *      stateIds: // value for 'stateIds'
 *      folderFileType: // value for 'folderFileType'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useFolderFilesPageWithRiskDetailsNotaireQuery(baseOptions: Apollo.QueryHookOptions<FolderFilesPageWithRiskDetailsNotaireQuery, FolderFilesPageWithRiskDetailsNotaireQueryVariables> & ({ variables: FolderFilesPageWithRiskDetailsNotaireQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FolderFilesPageWithRiskDetailsNotaireQuery, FolderFilesPageWithRiskDetailsNotaireQueryVariables>(FolderFilesPageWithRiskDetailsNotaireDocument, options);
      }
export function useFolderFilesPageWithRiskDetailsNotaireLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FolderFilesPageWithRiskDetailsNotaireQuery, FolderFilesPageWithRiskDetailsNotaireQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FolderFilesPageWithRiskDetailsNotaireQuery, FolderFilesPageWithRiskDetailsNotaireQueryVariables>(FolderFilesPageWithRiskDetailsNotaireDocument, options);
        }
export function useFolderFilesPageWithRiskDetailsNotaireSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FolderFilesPageWithRiskDetailsNotaireQuery, FolderFilesPageWithRiskDetailsNotaireQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FolderFilesPageWithRiskDetailsNotaireQuery, FolderFilesPageWithRiskDetailsNotaireQueryVariables>(FolderFilesPageWithRiskDetailsNotaireDocument, options);
        }
export type FolderFilesPageWithRiskDetailsNotaireQueryHookResult = ReturnType<typeof useFolderFilesPageWithRiskDetailsNotaireQuery>;
export type FolderFilesPageWithRiskDetailsNotaireLazyQueryHookResult = ReturnType<typeof useFolderFilesPageWithRiskDetailsNotaireLazyQuery>;
export type FolderFilesPageWithRiskDetailsNotaireSuspenseQueryHookResult = ReturnType<typeof useFolderFilesPageWithRiskDetailsNotaireSuspenseQuery>;
export type FolderFilesPageWithRiskDetailsNotaireQueryResult = Apollo.QueryResult<FolderFilesPageWithRiskDetailsNotaireQuery, FolderFilesPageWithRiskDetailsNotaireQueryVariables>;
export const FolderFilesPageWithRiskDetailsDocument = gql`
    query folderFilesPageWithRiskDetails($stateIds: [String!], $folderFileType: [String!], $limit: Int!, $sort: [FolderFilesPageSortingFieldInputType!] = [{name: RiskLevel, direction: DESC}, {name: LastModification, direction: DESC}], $offset: Int!, $ownerUserIdFilter: String, $followedByUserIdFilter: String) {
  folderFilesPage(stateIds: $stateIds, folderFileTypeCodesFilter: $folderFileType, limit: $limit, offset: $offset, sortFolderFilesPage: $sort, displayOnlyUserFiles: false, ownerUserIdFilter: $ownerUserIdFilter, followedByUserIdFilter: $followedByUserIdFilter) {
    summaries {
      customer {
        allInputValues: inputValues(fieldCodes: ["name", "registration"]) {
          inputField {
            fieldCode
          }
          stringValue
        }
      }
      folderFile {
        id
        currentCustomerFolder {
          owner {
            id
            firstName
            lastName
          }
          followingUsers {
            id
            firstName
            lastName
          }
          followedByCurrentUser
        }
        riskStatus {
          globalRiskLevel
          riskDetail {
            axesStatus {
              axisName
              riskLevel
            }
          }
        }
        adminStatus {
          lastModification
          lastModifier {
            name
          }
        }
      }
    }
    pageInfo {
      totalCount
    }
  }
}
    `;

/**
 * __useFolderFilesPageWithRiskDetailsQuery__
 *
 * To run a query within a React component, call `useFolderFilesPageWithRiskDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFolderFilesPageWithRiskDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFolderFilesPageWithRiskDetailsQuery({
 *   variables: {
 *      stateIds: // value for 'stateIds'
 *      folderFileType: // value for 'folderFileType'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      offset: // value for 'offset'
 *      ownerUserIdFilter: // value for 'ownerUserIdFilter'
 *      followedByUserIdFilter: // value for 'followedByUserIdFilter'
 *   },
 * });
 */
export function useFolderFilesPageWithRiskDetailsQuery(baseOptions: Apollo.QueryHookOptions<FolderFilesPageWithRiskDetailsQuery, FolderFilesPageWithRiskDetailsQueryVariables> & ({ variables: FolderFilesPageWithRiskDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FolderFilesPageWithRiskDetailsQuery, FolderFilesPageWithRiskDetailsQueryVariables>(FolderFilesPageWithRiskDetailsDocument, options);
      }
export function useFolderFilesPageWithRiskDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FolderFilesPageWithRiskDetailsQuery, FolderFilesPageWithRiskDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FolderFilesPageWithRiskDetailsQuery, FolderFilesPageWithRiskDetailsQueryVariables>(FolderFilesPageWithRiskDetailsDocument, options);
        }
export function useFolderFilesPageWithRiskDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FolderFilesPageWithRiskDetailsQuery, FolderFilesPageWithRiskDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FolderFilesPageWithRiskDetailsQuery, FolderFilesPageWithRiskDetailsQueryVariables>(FolderFilesPageWithRiskDetailsDocument, options);
        }
export type FolderFilesPageWithRiskDetailsQueryHookResult = ReturnType<typeof useFolderFilesPageWithRiskDetailsQuery>;
export type FolderFilesPageWithRiskDetailsLazyQueryHookResult = ReturnType<typeof useFolderFilesPageWithRiskDetailsLazyQuery>;
export type FolderFilesPageWithRiskDetailsSuspenseQueryHookResult = ReturnType<typeof useFolderFilesPageWithRiskDetailsSuspenseQuery>;
export type FolderFilesPageWithRiskDetailsQueryResult = Apollo.QueryResult<FolderFilesPageWithRiskDetailsQuery, FolderFilesPageWithRiskDetailsQueryVariables>;
export const FoldersUsingEntityDocument = gql`
    query foldersUsingEntity($entityId: ID!, $limit: Int! = 50) {
  foldersUsingEntity(entityId: $entityId, limit: $limit) {
    summaries {
      customerFolder {
        id
        customer {
          id
          name: inputValue(fieldCode: "name") {
            stringValue
          }
        }
      }
    }
  }
}
    `;

/**
 * __useFoldersUsingEntityQuery__
 *
 * To run a query within a React component, call `useFoldersUsingEntityQuery` and pass it any options that fit your needs.
 * When your component renders, `useFoldersUsingEntityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFoldersUsingEntityQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useFoldersUsingEntityQuery(baseOptions: Apollo.QueryHookOptions<FoldersUsingEntityQuery, FoldersUsingEntityQueryVariables> & ({ variables: FoldersUsingEntityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FoldersUsingEntityQuery, FoldersUsingEntityQueryVariables>(FoldersUsingEntityDocument, options);
      }
export function useFoldersUsingEntityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FoldersUsingEntityQuery, FoldersUsingEntityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FoldersUsingEntityQuery, FoldersUsingEntityQueryVariables>(FoldersUsingEntityDocument, options);
        }
export function useFoldersUsingEntitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FoldersUsingEntityQuery, FoldersUsingEntityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FoldersUsingEntityQuery, FoldersUsingEntityQueryVariables>(FoldersUsingEntityDocument, options);
        }
export type FoldersUsingEntityQueryHookResult = ReturnType<typeof useFoldersUsingEntityQuery>;
export type FoldersUsingEntityLazyQueryHookResult = ReturnType<typeof useFoldersUsingEntityLazyQuery>;
export type FoldersUsingEntitySuspenseQueryHookResult = ReturnType<typeof useFoldersUsingEntitySuspenseQuery>;
export type FoldersUsingEntityQueryResult = Apollo.QueryResult<FoldersUsingEntityQuery, FoldersUsingEntityQueryVariables>;
export const ForcedRiskReasonListDocument = gql`
    query forcedRiskReasonList {
  listElements(elementType: "ForcedRiskReason") {
    id
    code
    name
  }
}
    `;

/**
 * __useForcedRiskReasonListQuery__
 *
 * To run a query within a React component, call `useForcedRiskReasonListQuery` and pass it any options that fit your needs.
 * When your component renders, `useForcedRiskReasonListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useForcedRiskReasonListQuery({
 *   variables: {
 *   },
 * });
 */
export function useForcedRiskReasonListQuery(baseOptions?: Apollo.QueryHookOptions<ForcedRiskReasonListQuery, ForcedRiskReasonListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ForcedRiskReasonListQuery, ForcedRiskReasonListQueryVariables>(ForcedRiskReasonListDocument, options);
      }
export function useForcedRiskReasonListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ForcedRiskReasonListQuery, ForcedRiskReasonListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ForcedRiskReasonListQuery, ForcedRiskReasonListQueryVariables>(ForcedRiskReasonListDocument, options);
        }
export function useForcedRiskReasonListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ForcedRiskReasonListQuery, ForcedRiskReasonListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ForcedRiskReasonListQuery, ForcedRiskReasonListQueryVariables>(ForcedRiskReasonListDocument, options);
        }
export type ForcedRiskReasonListQueryHookResult = ReturnType<typeof useForcedRiskReasonListQuery>;
export type ForcedRiskReasonListLazyQueryHookResult = ReturnType<typeof useForcedRiskReasonListLazyQuery>;
export type ForcedRiskReasonListSuspenseQueryHookResult = ReturnType<typeof useForcedRiskReasonListSuspenseQuery>;
export type ForcedRiskReasonListQueryResult = Apollo.QueryResult<ForcedRiskReasonListQuery, ForcedRiskReasonListQueryVariables>;
export const GetContactsDocument = gql`
    query getContacts($customerFolderId: ID!) {
  customerFolder(id: $customerFolderId) {
    owner {
      ...OwnerFields
    }
    contactPerson {
      ...ContactPersonFields
    }
  }
}
    ${OwnerFieldsFragmentDoc}
${ContactPersonFieldsFragmentDoc}`;

/**
 * __useGetContactsQuery__
 *
 * To run a query within a React component, call `useGetContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactsQuery({
 *   variables: {
 *      customerFolderId: // value for 'customerFolderId'
 *   },
 * });
 */
export function useGetContactsQuery(baseOptions: Apollo.QueryHookOptions<GetContactsQuery, GetContactsQueryVariables> & ({ variables: GetContactsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactsQuery, GetContactsQueryVariables>(GetContactsDocument, options);
      }
export function useGetContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactsQuery, GetContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactsQuery, GetContactsQueryVariables>(GetContactsDocument, options);
        }
export function useGetContactsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContactsQuery, GetContactsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContactsQuery, GetContactsQueryVariables>(GetContactsDocument, options);
        }
export type GetContactsQueryHookResult = ReturnType<typeof useGetContactsQuery>;
export type GetContactsLazyQueryHookResult = ReturnType<typeof useGetContactsLazyQuery>;
export type GetContactsSuspenseQueryHookResult = ReturnType<typeof useGetContactsSuspenseQuery>;
export type GetContactsQueryResult = Apollo.QueryResult<GetContactsQuery, GetContactsQueryVariables>;
export const GetFeaturesDocument = gql`
    query getFeatures {
  features {
    flaminemPro
    notary
  }
}
    `;

/**
 * __useGetFeaturesQuery__
 *
 * To run a query within a React component, call `useGetFeaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeaturesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFeaturesQuery(baseOptions?: Apollo.QueryHookOptions<GetFeaturesQuery, GetFeaturesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeaturesQuery, GetFeaturesQueryVariables>(GetFeaturesDocument, options);
      }
export function useGetFeaturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeaturesQuery, GetFeaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeaturesQuery, GetFeaturesQueryVariables>(GetFeaturesDocument, options);
        }
export function useGetFeaturesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFeaturesQuery, GetFeaturesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFeaturesQuery, GetFeaturesQueryVariables>(GetFeaturesDocument, options);
        }
export type GetFeaturesQueryHookResult = ReturnType<typeof useGetFeaturesQuery>;
export type GetFeaturesLazyQueryHookResult = ReturnType<typeof useGetFeaturesLazyQuery>;
export type GetFeaturesSuspenseQueryHookResult = ReturnType<typeof useGetFeaturesSuspenseQuery>;
export type GetFeaturesQueryResult = Apollo.QueryResult<GetFeaturesQuery, GetFeaturesQueryVariables>;
export const GetUsersDocument = gql`
    query getUsers($string: String! = "@", $allowedGroups: [String!] = ["expert_comptable", "associe", "administrateur"], $limit: Int = 50) {
  searchUsers(string: $string, allowedGroups: $allowedGroups, limit: $limit) {
    ...UserWithRolesFields
  }
}
    ${UserWithRolesFieldsFragmentDoc}`;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *      string: // value for 'string'
 *      allowedGroups: // value for 'allowedGroups'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
      }
export function useGetUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
export function useGetUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<typeof useGetUsersLazyQuery>;
export type GetUsersSuspenseQueryHookResult = ReturnType<typeof useGetUsersSuspenseQuery>;
export type GetUsersQueryResult = Apollo.QueryResult<GetUsersQuery, GetUsersQueryVariables>;
export const LastModifiedFolderFilePerCurrentCustomerFolderDocument = gql`
    query lastModifiedFolderFilePerCurrentCustomerFolder($fileStateIds: [String!], $customerFolderTypeCodesFilter: [String!], $limit: Int!, $sort: [LastModifiedFolderFilePerCurrentCustomerFolderPageSortingFieldInputType!] = [{name: RiskLevel, direction: DESC}, {name: LastModification, direction: DESC}], $offset: Int!, $ownerUserIdFilter: String, $followedByUserIdFilter: String) {
  lastModifiedFolderFilePerCurrentCustomerFolder(fileStateIds: $fileStateIds, customerFolderTypeCodesFilter: $customerFolderTypeCodesFilter, limit: $limit, offset: $offset, sortLastModifiedFolderFilePerCurrentCustomerFolderPage: $sort, ownerUserIdFilter: $ownerUserIdFilter, followedByUserIdFilter: $followedByUserIdFilter) {
    content {
      currentCustomer {
        allInputValues: inputValues(fieldCodes: ["name", "registration", "lastName", "firstName"]) {
          inputField {
            fieldCode
          }
          stringValue
        }
      }
      lastModifiedFolderFile {
        id
        currentCustomerFolder {
          owner {
            id
            firstName
            lastName
          }
          followingUsers {
            id
            firstName
            lastName
          }
          followedByCurrentUser
          customerFolderType {
            code
          }
        }
        riskStatus {
          globalRiskLevel
          riskDetail {
            axesStatus {
              axisName
              riskLevel
            }
          }
        }
        adminStatus {
          lastModification
          lastModifier {
            name
          }
        }
      }
    }
    pageInfo {
      totalCount
    }
  }
}
    `;

/**
 * __useLastModifiedFolderFilePerCurrentCustomerFolderQuery__
 *
 * To run a query within a React component, call `useLastModifiedFolderFilePerCurrentCustomerFolderQuery` and pass it any options that fit your needs.
 * When your component renders, `useLastModifiedFolderFilePerCurrentCustomerFolderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLastModifiedFolderFilePerCurrentCustomerFolderQuery({
 *   variables: {
 *      fileStateIds: // value for 'fileStateIds'
 *      customerFolderTypeCodesFilter: // value for 'customerFolderTypeCodesFilter'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      offset: // value for 'offset'
 *      ownerUserIdFilter: // value for 'ownerUserIdFilter'
 *      followedByUserIdFilter: // value for 'followedByUserIdFilter'
 *   },
 * });
 */
export function useLastModifiedFolderFilePerCurrentCustomerFolderQuery(baseOptions: Apollo.QueryHookOptions<LastModifiedFolderFilePerCurrentCustomerFolderQuery, LastModifiedFolderFilePerCurrentCustomerFolderQueryVariables> & ({ variables: LastModifiedFolderFilePerCurrentCustomerFolderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LastModifiedFolderFilePerCurrentCustomerFolderQuery, LastModifiedFolderFilePerCurrentCustomerFolderQueryVariables>(LastModifiedFolderFilePerCurrentCustomerFolderDocument, options);
      }
export function useLastModifiedFolderFilePerCurrentCustomerFolderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LastModifiedFolderFilePerCurrentCustomerFolderQuery, LastModifiedFolderFilePerCurrentCustomerFolderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LastModifiedFolderFilePerCurrentCustomerFolderQuery, LastModifiedFolderFilePerCurrentCustomerFolderQueryVariables>(LastModifiedFolderFilePerCurrentCustomerFolderDocument, options);
        }
export function useLastModifiedFolderFilePerCurrentCustomerFolderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LastModifiedFolderFilePerCurrentCustomerFolderQuery, LastModifiedFolderFilePerCurrentCustomerFolderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LastModifiedFolderFilePerCurrentCustomerFolderQuery, LastModifiedFolderFilePerCurrentCustomerFolderQueryVariables>(LastModifiedFolderFilePerCurrentCustomerFolderDocument, options);
        }
export type LastModifiedFolderFilePerCurrentCustomerFolderQueryHookResult = ReturnType<typeof useLastModifiedFolderFilePerCurrentCustomerFolderQuery>;
export type LastModifiedFolderFilePerCurrentCustomerFolderLazyQueryHookResult = ReturnType<typeof useLastModifiedFolderFilePerCurrentCustomerFolderLazyQuery>;
export type LastModifiedFolderFilePerCurrentCustomerFolderSuspenseQueryHookResult = ReturnType<typeof useLastModifiedFolderFilePerCurrentCustomerFolderSuspenseQuery>;
export type LastModifiedFolderFilePerCurrentCustomerFolderQueryResult = Apollo.QueryResult<LastModifiedFolderFilePerCurrentCustomerFolderQuery, LastModifiedFolderFilePerCurrentCustomerFolderQueryVariables>;
export const LastModifiedFolderFilePerCurrentCustomerFolderCountDocument = gql`
    query LastModifiedFolderFilePerCurrentCustomerFolderCount {
  validated: lastModifiedFolderFilePerCurrentCustomerFolder(fileStateIds: ["VALIDATED"], limit: 1) {
    pageInfo {
      totalCount
    }
  }
}
    `;

/**
 * __useLastModifiedFolderFilePerCurrentCustomerFolderCountQuery__
 *
 * To run a query within a React component, call `useLastModifiedFolderFilePerCurrentCustomerFolderCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useLastModifiedFolderFilePerCurrentCustomerFolderCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLastModifiedFolderFilePerCurrentCustomerFolderCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useLastModifiedFolderFilePerCurrentCustomerFolderCountQuery(baseOptions?: Apollo.QueryHookOptions<LastModifiedFolderFilePerCurrentCustomerFolderCountQuery, LastModifiedFolderFilePerCurrentCustomerFolderCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LastModifiedFolderFilePerCurrentCustomerFolderCountQuery, LastModifiedFolderFilePerCurrentCustomerFolderCountQueryVariables>(LastModifiedFolderFilePerCurrentCustomerFolderCountDocument, options);
      }
export function useLastModifiedFolderFilePerCurrentCustomerFolderCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LastModifiedFolderFilePerCurrentCustomerFolderCountQuery, LastModifiedFolderFilePerCurrentCustomerFolderCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LastModifiedFolderFilePerCurrentCustomerFolderCountQuery, LastModifiedFolderFilePerCurrentCustomerFolderCountQueryVariables>(LastModifiedFolderFilePerCurrentCustomerFolderCountDocument, options);
        }
export function useLastModifiedFolderFilePerCurrentCustomerFolderCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LastModifiedFolderFilePerCurrentCustomerFolderCountQuery, LastModifiedFolderFilePerCurrentCustomerFolderCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LastModifiedFolderFilePerCurrentCustomerFolderCountQuery, LastModifiedFolderFilePerCurrentCustomerFolderCountQueryVariables>(LastModifiedFolderFilePerCurrentCustomerFolderCountDocument, options);
        }
export type LastModifiedFolderFilePerCurrentCustomerFolderCountQueryHookResult = ReturnType<typeof useLastModifiedFolderFilePerCurrentCustomerFolderCountQuery>;
export type LastModifiedFolderFilePerCurrentCustomerFolderCountLazyQueryHookResult = ReturnType<typeof useLastModifiedFolderFilePerCurrentCustomerFolderCountLazyQuery>;
export type LastModifiedFolderFilePerCurrentCustomerFolderCountSuspenseQueryHookResult = ReturnType<typeof useLastModifiedFolderFilePerCurrentCustomerFolderCountSuspenseQuery>;
export type LastModifiedFolderFilePerCurrentCustomerFolderCountQueryResult = Apollo.QueryResult<LastModifiedFolderFilePerCurrentCustomerFolderCountQuery, LastModifiedFolderFilePerCurrentCustomerFolderCountQueryVariables>;
export const LastModifiedFolderFilePerCurrentCustomerFolderExtractDocument = gql`
    query lastModifiedFolderFilePerCurrentCustomerFolderExtract($offset: Int!) {
  lastModifiedFolderFilePerCurrentCustomerFolder(fileStateIds: ["VALIDATED"], limit: 50, offset: $offset) {
    content {
      currentCustomer {
        isPerson
        name: inputValue(fieldCode: "name") {
          stringValue
        }
        firstName: inputValue(fieldCode: "firstName") {
          stringValue
        }
        lastName: inputValue(fieldCode: "lastName") {
          stringValue
        }
        registrationCountryCode: inputValue(fieldCode: "registrationCountryCode") {
          stringValue
        }
      }
      lastModifiedFolderFile {
        id
        currentCustomerFolder {
          owner {
            firstName
            lastName
          }
        }
        fileCustomerFolder {
          stakeholders {
            residenceCountryCode: inputValue(fieldCode: "residenceCountryCode") {
              stringValue
            }
          }
        }
        riskStatus {
          globalRiskLevel
          forcedRisk {
            reason {
              name
            }
          }
          riskDetail {
            axesStatus {
              axisName
              riskLevel
              risks {
                item
              }
            }
          }
        }
        adminStatus {
          lastModification
        }
      }
    }
  }
}
    `;

/**
 * __useLastModifiedFolderFilePerCurrentCustomerFolderExtractQuery__
 *
 * To run a query within a React component, call `useLastModifiedFolderFilePerCurrentCustomerFolderExtractQuery` and pass it any options that fit your needs.
 * When your component renders, `useLastModifiedFolderFilePerCurrentCustomerFolderExtractQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLastModifiedFolderFilePerCurrentCustomerFolderExtractQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useLastModifiedFolderFilePerCurrentCustomerFolderExtractQuery(baseOptions: Apollo.QueryHookOptions<LastModifiedFolderFilePerCurrentCustomerFolderExtractQuery, LastModifiedFolderFilePerCurrentCustomerFolderExtractQueryVariables> & ({ variables: LastModifiedFolderFilePerCurrentCustomerFolderExtractQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LastModifiedFolderFilePerCurrentCustomerFolderExtractQuery, LastModifiedFolderFilePerCurrentCustomerFolderExtractQueryVariables>(LastModifiedFolderFilePerCurrentCustomerFolderExtractDocument, options);
      }
export function useLastModifiedFolderFilePerCurrentCustomerFolderExtractLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LastModifiedFolderFilePerCurrentCustomerFolderExtractQuery, LastModifiedFolderFilePerCurrentCustomerFolderExtractQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LastModifiedFolderFilePerCurrentCustomerFolderExtractQuery, LastModifiedFolderFilePerCurrentCustomerFolderExtractQueryVariables>(LastModifiedFolderFilePerCurrentCustomerFolderExtractDocument, options);
        }
export function useLastModifiedFolderFilePerCurrentCustomerFolderExtractSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LastModifiedFolderFilePerCurrentCustomerFolderExtractQuery, LastModifiedFolderFilePerCurrentCustomerFolderExtractQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LastModifiedFolderFilePerCurrentCustomerFolderExtractQuery, LastModifiedFolderFilePerCurrentCustomerFolderExtractQueryVariables>(LastModifiedFolderFilePerCurrentCustomerFolderExtractDocument, options);
        }
export type LastModifiedFolderFilePerCurrentCustomerFolderExtractQueryHookResult = ReturnType<typeof useLastModifiedFolderFilePerCurrentCustomerFolderExtractQuery>;
export type LastModifiedFolderFilePerCurrentCustomerFolderExtractLazyQueryHookResult = ReturnType<typeof useLastModifiedFolderFilePerCurrentCustomerFolderExtractLazyQuery>;
export type LastModifiedFolderFilePerCurrentCustomerFolderExtractSuspenseQueryHookResult = ReturnType<typeof useLastModifiedFolderFilePerCurrentCustomerFolderExtractSuspenseQuery>;
export type LastModifiedFolderFilePerCurrentCustomerFolderExtractQueryResult = Apollo.QueryResult<LastModifiedFolderFilePerCurrentCustomerFolderExtractQuery, LastModifiedFolderFilePerCurrentCustomerFolderExtractQueryVariables>;
export const LegalStatusListDocument = gql`
    query legalStatusList {
  listElements(elementType: "CustomList2") {
    id
    code
    name
  }
}
    `;

/**
 * __useLegalStatusListQuery__
 *
 * To run a query within a React component, call `useLegalStatusListQuery` and pass it any options that fit your needs.
 * When your component renders, `useLegalStatusListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLegalStatusListQuery({
 *   variables: {
 *   },
 * });
 */
export function useLegalStatusListQuery(baseOptions?: Apollo.QueryHookOptions<LegalStatusListQuery, LegalStatusListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LegalStatusListQuery, LegalStatusListQueryVariables>(LegalStatusListDocument, options);
      }
export function useLegalStatusListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LegalStatusListQuery, LegalStatusListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LegalStatusListQuery, LegalStatusListQueryVariables>(LegalStatusListDocument, options);
        }
export function useLegalStatusListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LegalStatusListQuery, LegalStatusListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LegalStatusListQuery, LegalStatusListQueryVariables>(LegalStatusListDocument, options);
        }
export type LegalStatusListQueryHookResult = ReturnType<typeof useLegalStatusListQuery>;
export type LegalStatusListLazyQueryHookResult = ReturnType<typeof useLegalStatusListLazyQuery>;
export type LegalStatusListSuspenseQueryHookResult = ReturnType<typeof useLegalStatusListSuspenseQuery>;
export type LegalStatusListQueryResult = Apollo.QueryResult<LegalStatusListQuery, LegalStatusListQueryVariables>;
export const LegalStatusListPphDocument = gql`
    query legalStatusListPPH {
  listElements(elementType: "PersonLegalForm") {
    id
    code
    name
  }
}
    `;

/**
 * __useLegalStatusListPphQuery__
 *
 * To run a query within a React component, call `useLegalStatusListPphQuery` and pass it any options that fit your needs.
 * When your component renders, `useLegalStatusListPphQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLegalStatusListPphQuery({
 *   variables: {
 *   },
 * });
 */
export function useLegalStatusListPphQuery(baseOptions?: Apollo.QueryHookOptions<LegalStatusListPphQuery, LegalStatusListPphQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LegalStatusListPphQuery, LegalStatusListPphQueryVariables>(LegalStatusListPphDocument, options);
      }
export function useLegalStatusListPphLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LegalStatusListPphQuery, LegalStatusListPphQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LegalStatusListPphQuery, LegalStatusListPphQueryVariables>(LegalStatusListPphDocument, options);
        }
export function useLegalStatusListPphSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LegalStatusListPphQuery, LegalStatusListPphQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LegalStatusListPphQuery, LegalStatusListPphQueryVariables>(LegalStatusListPphDocument, options);
        }
export type LegalStatusListPphQueryHookResult = ReturnType<typeof useLegalStatusListPphQuery>;
export type LegalStatusListPphLazyQueryHookResult = ReturnType<typeof useLegalStatusListPphLazyQuery>;
export type LegalStatusListPphSuspenseQueryHookResult = ReturnType<typeof useLegalStatusListPphSuspenseQuery>;
export type LegalStatusListPphQueryResult = Apollo.QueryResult<LegalStatusListPphQuery, LegalStatusListPphQueryVariables>;
export const LegalTypesWithRiskListDocument = gql`
    query legalTypesWithRiskList {
  listElements(elementType: "EntityType") {
    ... on EntityType {
      id
      code
      name
      riskValues {
        description
        riskCategory
        key
      }
    }
  }
}
    `;

/**
 * __useLegalTypesWithRiskListQuery__
 *
 * To run a query within a React component, call `useLegalTypesWithRiskListQuery` and pass it any options that fit your needs.
 * When your component renders, `useLegalTypesWithRiskListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLegalTypesWithRiskListQuery({
 *   variables: {
 *   },
 * });
 */
export function useLegalTypesWithRiskListQuery(baseOptions?: Apollo.QueryHookOptions<LegalTypesWithRiskListQuery, LegalTypesWithRiskListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LegalTypesWithRiskListQuery, LegalTypesWithRiskListQueryVariables>(LegalTypesWithRiskListDocument, options);
      }
export function useLegalTypesWithRiskListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LegalTypesWithRiskListQuery, LegalTypesWithRiskListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LegalTypesWithRiskListQuery, LegalTypesWithRiskListQueryVariables>(LegalTypesWithRiskListDocument, options);
        }
export function useLegalTypesWithRiskListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LegalTypesWithRiskListQuery, LegalTypesWithRiskListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LegalTypesWithRiskListQuery, LegalTypesWithRiskListQueryVariables>(LegalTypesWithRiskListDocument, options);
        }
export type LegalTypesWithRiskListQueryHookResult = ReturnType<typeof useLegalTypesWithRiskListQuery>;
export type LegalTypesWithRiskListLazyQueryHookResult = ReturnType<typeof useLegalTypesWithRiskListLazyQuery>;
export type LegalTypesWithRiskListSuspenseQueryHookResult = ReturnType<typeof useLegalTypesWithRiskListSuspenseQuery>;
export type LegalTypesWithRiskListQueryResult = Apollo.QueryResult<LegalTypesWithRiskListQuery, LegalTypesWithRiskListQueryVariables>;
export const MissionsListDocument = gql`
    query missionsList {
  listElements(elementType: "MissionType") {
    ... on MissionType {
      id
      code
      name
      riskValues {
        description
        riskCategory
        key
      }
    }
  }
}
    `;

/**
 * __useMissionsListQuery__
 *
 * To run a query within a React component, call `useMissionsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useMissionsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMissionsListQuery({
 *   variables: {
 *   },
 * });
 */
export function useMissionsListQuery(baseOptions?: Apollo.QueryHookOptions<MissionsListQuery, MissionsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MissionsListQuery, MissionsListQueryVariables>(MissionsListDocument, options);
      }
export function useMissionsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MissionsListQuery, MissionsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MissionsListQuery, MissionsListQueryVariables>(MissionsListDocument, options);
        }
export function useMissionsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MissionsListQuery, MissionsListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MissionsListQuery, MissionsListQueryVariables>(MissionsListDocument, options);
        }
export type MissionsListQueryHookResult = ReturnType<typeof useMissionsListQuery>;
export type MissionsListLazyQueryHookResult = ReturnType<typeof useMissionsListLazyQuery>;
export type MissionsListSuspenseQueryHookResult = ReturnType<typeof useMissionsListSuspenseQuery>;
export type MissionsListQueryResult = Apollo.QueryResult<MissionsListQuery, MissionsListQueryVariables>;
export const PersonEReputationDjDetailsDocument = gql`
    query PersonEReputationDJDetails($id: ID!) {
  entity: entity(id: $id) {
    id
    eReputation {
      details {
        idERep
        format
        searchResults
        detailedResults {
          positionInSearchResults
          content
        }
      }
    }
  }
}
    `;

/**
 * __usePersonEReputationDjDetailsQuery__
 *
 * To run a query within a React component, call `usePersonEReputationDjDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonEReputationDjDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonEReputationDjDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePersonEReputationDjDetailsQuery(baseOptions: Apollo.QueryHookOptions<PersonEReputationDjDetailsQuery, PersonEReputationDjDetailsQueryVariables> & ({ variables: PersonEReputationDjDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PersonEReputationDjDetailsQuery, PersonEReputationDjDetailsQueryVariables>(PersonEReputationDjDetailsDocument, options);
      }
export function usePersonEReputationDjDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PersonEReputationDjDetailsQuery, PersonEReputationDjDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PersonEReputationDjDetailsQuery, PersonEReputationDjDetailsQueryVariables>(PersonEReputationDjDetailsDocument, options);
        }
export function usePersonEReputationDjDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PersonEReputationDjDetailsQuery, PersonEReputationDjDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PersonEReputationDjDetailsQuery, PersonEReputationDjDetailsQueryVariables>(PersonEReputationDjDetailsDocument, options);
        }
export type PersonEReputationDjDetailsQueryHookResult = ReturnType<typeof usePersonEReputationDjDetailsQuery>;
export type PersonEReputationDjDetailsLazyQueryHookResult = ReturnType<typeof usePersonEReputationDjDetailsLazyQuery>;
export type PersonEReputationDjDetailsSuspenseQueryHookResult = ReturnType<typeof usePersonEReputationDjDetailsSuspenseQuery>;
export type PersonEReputationDjDetailsQueryResult = Apollo.QueryResult<PersonEReputationDjDetailsQuery, PersonEReputationDjDetailsQueryVariables>;
export const SearchClientByStringDocument = gql`
    query SearchClientByString($searchString: String!, $limit: Int = 5) {
  folderFilesPage(searchString: $searchString, limit: $limit) {
    ...FolderFilesPageInfo
    summaries {
      customer {
        inputValues(fieldCodes: ["name", "registration"]) {
          inputField {
            fieldCode
          }
          stringValue
        }
      }
      folderFile {
        id
      }
    }
  }
}
    ${FolderFilesPageInfoFragmentDoc}`;

/**
 * __useSearchClientByStringQuery__
 *
 * To run a query within a React component, call `useSearchClientByStringQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchClientByStringQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchClientByStringQuery({
 *   variables: {
 *      searchString: // value for 'searchString'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSearchClientByStringQuery(baseOptions: Apollo.QueryHookOptions<SearchClientByStringQuery, SearchClientByStringQueryVariables> & ({ variables: SearchClientByStringQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchClientByStringQuery, SearchClientByStringQueryVariables>(SearchClientByStringDocument, options);
      }
export function useSearchClientByStringLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchClientByStringQuery, SearchClientByStringQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchClientByStringQuery, SearchClientByStringQueryVariables>(SearchClientByStringDocument, options);
        }
export function useSearchClientByStringSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchClientByStringQuery, SearchClientByStringQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchClientByStringQuery, SearchClientByStringQueryVariables>(SearchClientByStringDocument, options);
        }
export type SearchClientByStringQueryHookResult = ReturnType<typeof useSearchClientByStringQuery>;
export type SearchClientByStringLazyQueryHookResult = ReturnType<typeof useSearchClientByStringLazyQuery>;
export type SearchClientByStringSuspenseQueryHookResult = ReturnType<typeof useSearchClientByStringSuspenseQuery>;
export type SearchClientByStringQueryResult = Apollo.QueryResult<SearchClientByStringQuery, SearchClientByStringQueryVariables>;
export const SearchCustomerFolderByStringDocument = gql`
    query SearchCustomerFolderByString($searchString: String!, $limit: Int = 10, $displayOnlyUserFolders: Boolean = false) {
  customerFoldersPage(searchStringForCusFolder: $searchString, limit: $limit, displayOnlyUserFolders: $displayOnlyUserFolders) {
    pageInfo {
      totalCount
    }
    summaries {
      customer {
        isPerson
        inputValues(fieldCodes: ["name", "registration"]) {
          inputField {
            fieldCode
          }
          stringValue
        }
      }
      customerFolder {
        folderFiles(limit: 1) {
          summaries {
            id
            isEditable
            currentCustomerFolder {
              stakeholders {
                inputValues(fieldCodes: ["firstName", "lastName", "birthDate"]) {
                  inputField {
                    fieldCode
                  }
                  stringValue
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useSearchCustomerFolderByStringQuery__
 *
 * To run a query within a React component, call `useSearchCustomerFolderByStringQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCustomerFolderByStringQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCustomerFolderByStringQuery({
 *   variables: {
 *      searchString: // value for 'searchString'
 *      limit: // value for 'limit'
 *      displayOnlyUserFolders: // value for 'displayOnlyUserFolders'
 *   },
 * });
 */
export function useSearchCustomerFolderByStringQuery(baseOptions: Apollo.QueryHookOptions<SearchCustomerFolderByStringQuery, SearchCustomerFolderByStringQueryVariables> & ({ variables: SearchCustomerFolderByStringQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchCustomerFolderByStringQuery, SearchCustomerFolderByStringQueryVariables>(SearchCustomerFolderByStringDocument, options);
      }
export function useSearchCustomerFolderByStringLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchCustomerFolderByStringQuery, SearchCustomerFolderByStringQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchCustomerFolderByStringQuery, SearchCustomerFolderByStringQueryVariables>(SearchCustomerFolderByStringDocument, options);
        }
export function useSearchCustomerFolderByStringSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchCustomerFolderByStringQuery, SearchCustomerFolderByStringQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchCustomerFolderByStringQuery, SearchCustomerFolderByStringQueryVariables>(SearchCustomerFolderByStringDocument, options);
        }
export type SearchCustomerFolderByStringQueryHookResult = ReturnType<typeof useSearchCustomerFolderByStringQuery>;
export type SearchCustomerFolderByStringLazyQueryHookResult = ReturnType<typeof useSearchCustomerFolderByStringLazyQuery>;
export type SearchCustomerFolderByStringSuspenseQueryHookResult = ReturnType<typeof useSearchCustomerFolderByStringSuspenseQuery>;
export type SearchCustomerFolderByStringQueryResult = Apollo.QueryResult<SearchCustomerFolderByStringQuery, SearchCustomerFolderByStringQueryVariables>;
export const SearchPersonByFirstNameAndLastNameDocument = gql`
    query searchPersonByFirstNameAndLastName($values: [String!]!) {
  advancedPersonSearch(query: "field(firstName):{0} AND field(lastName):{1}", values: $values, limit: 50) {
    persons {
      firstName: inputValue(fieldCode: "firstName") {
        stringValue
      }
      lastName: inputValue(fieldCode: "lastName") {
        stringValue
      }
      birthDate: inputValue(fieldCode: "birthDate") {
        stringValue
      }
      id
      isCustomer
      customerFolders {
        folderFiles(limit: 1) {
          summaries {
            id
          }
        }
      }
    }
  }
}
    `;

/**
 * __useSearchPersonByFirstNameAndLastNameQuery__
 *
 * To run a query within a React component, call `useSearchPersonByFirstNameAndLastNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchPersonByFirstNameAndLastNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchPersonByFirstNameAndLastNameQuery({
 *   variables: {
 *      values: // value for 'values'
 *   },
 * });
 */
export function useSearchPersonByFirstNameAndLastNameQuery(baseOptions: Apollo.QueryHookOptions<SearchPersonByFirstNameAndLastNameQuery, SearchPersonByFirstNameAndLastNameQueryVariables> & ({ variables: SearchPersonByFirstNameAndLastNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchPersonByFirstNameAndLastNameQuery, SearchPersonByFirstNameAndLastNameQueryVariables>(SearchPersonByFirstNameAndLastNameDocument, options);
      }
export function useSearchPersonByFirstNameAndLastNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchPersonByFirstNameAndLastNameQuery, SearchPersonByFirstNameAndLastNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchPersonByFirstNameAndLastNameQuery, SearchPersonByFirstNameAndLastNameQueryVariables>(SearchPersonByFirstNameAndLastNameDocument, options);
        }
export function useSearchPersonByFirstNameAndLastNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchPersonByFirstNameAndLastNameQuery, SearchPersonByFirstNameAndLastNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchPersonByFirstNameAndLastNameQuery, SearchPersonByFirstNameAndLastNameQueryVariables>(SearchPersonByFirstNameAndLastNameDocument, options);
        }
export type SearchPersonByFirstNameAndLastNameQueryHookResult = ReturnType<typeof useSearchPersonByFirstNameAndLastNameQuery>;
export type SearchPersonByFirstNameAndLastNameLazyQueryHookResult = ReturnType<typeof useSearchPersonByFirstNameAndLastNameLazyQuery>;
export type SearchPersonByFirstNameAndLastNameSuspenseQueryHookResult = ReturnType<typeof useSearchPersonByFirstNameAndLastNameSuspenseQuery>;
export type SearchPersonByFirstNameAndLastNameQueryResult = Apollo.QueryResult<SearchPersonByFirstNameAndLastNameQuery, SearchPersonByFirstNameAndLastNameQueryVariables>;
export const SearchPersonByFirstNameAndLastNameAndBirthdateDocument = gql`
    query searchPersonByFirstNameAndLastNameAndBirthdate($values: [String!]!) {
  advancedPersonSearch(query: "field(firstName):{0} AND field(lastName):{1} AND field(birthDate):{2}", values: $values, limit: 50) {
    persons {
      firstName: inputValue(fieldCode: "firstName") {
        stringValue
      }
      lastName: inputValue(fieldCode: "lastName") {
        stringValue
      }
      birthDate: inputValue(fieldCode: "birthDate") {
        stringValue
      }
      id
      isCustomer
      customerFolders {
        folderFiles(limit: 1) {
          summaries {
            id
          }
        }
      }
    }
  }
}
    `;

/**
 * __useSearchPersonByFirstNameAndLastNameAndBirthdateQuery__
 *
 * To run a query within a React component, call `useSearchPersonByFirstNameAndLastNameAndBirthdateQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchPersonByFirstNameAndLastNameAndBirthdateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchPersonByFirstNameAndLastNameAndBirthdateQuery({
 *   variables: {
 *      values: // value for 'values'
 *   },
 * });
 */
export function useSearchPersonByFirstNameAndLastNameAndBirthdateQuery(baseOptions: Apollo.QueryHookOptions<SearchPersonByFirstNameAndLastNameAndBirthdateQuery, SearchPersonByFirstNameAndLastNameAndBirthdateQueryVariables> & ({ variables: SearchPersonByFirstNameAndLastNameAndBirthdateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchPersonByFirstNameAndLastNameAndBirthdateQuery, SearchPersonByFirstNameAndLastNameAndBirthdateQueryVariables>(SearchPersonByFirstNameAndLastNameAndBirthdateDocument, options);
      }
export function useSearchPersonByFirstNameAndLastNameAndBirthdateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchPersonByFirstNameAndLastNameAndBirthdateQuery, SearchPersonByFirstNameAndLastNameAndBirthdateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchPersonByFirstNameAndLastNameAndBirthdateQuery, SearchPersonByFirstNameAndLastNameAndBirthdateQueryVariables>(SearchPersonByFirstNameAndLastNameAndBirthdateDocument, options);
        }
export function useSearchPersonByFirstNameAndLastNameAndBirthdateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchPersonByFirstNameAndLastNameAndBirthdateQuery, SearchPersonByFirstNameAndLastNameAndBirthdateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchPersonByFirstNameAndLastNameAndBirthdateQuery, SearchPersonByFirstNameAndLastNameAndBirthdateQueryVariables>(SearchPersonByFirstNameAndLastNameAndBirthdateDocument, options);
        }
export type SearchPersonByFirstNameAndLastNameAndBirthdateQueryHookResult = ReturnType<typeof useSearchPersonByFirstNameAndLastNameAndBirthdateQuery>;
export type SearchPersonByFirstNameAndLastNameAndBirthdateLazyQueryHookResult = ReturnType<typeof useSearchPersonByFirstNameAndLastNameAndBirthdateLazyQuery>;
export type SearchPersonByFirstNameAndLastNameAndBirthdateSuspenseQueryHookResult = ReturnType<typeof useSearchPersonByFirstNameAndLastNameAndBirthdateSuspenseQuery>;
export type SearchPersonByFirstNameAndLastNameAndBirthdateQueryResult = Apollo.QueryResult<SearchPersonByFirstNameAndLastNameAndBirthdateQuery, SearchPersonByFirstNameAndLastNameAndBirthdateQueryVariables>;
export const SearchPersonByRegistrationDocument = gql`
    query searchPersonByRegistration($values: [String!]!) {
  advancedPersonSearch(query: "(field(registration) : {0})", values: $values, limit: 1) {
    persons {
      id
      siren: inputValue(fieldCode: "registration") {
        stringValue
      }
    }
  }
}
    `;

/**
 * __useSearchPersonByRegistrationQuery__
 *
 * To run a query within a React component, call `useSearchPersonByRegistrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchPersonByRegistrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchPersonByRegistrationQuery({
 *   variables: {
 *      values: // value for 'values'
 *   },
 * });
 */
export function useSearchPersonByRegistrationQuery(baseOptions: Apollo.QueryHookOptions<SearchPersonByRegistrationQuery, SearchPersonByRegistrationQueryVariables> & ({ variables: SearchPersonByRegistrationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchPersonByRegistrationQuery, SearchPersonByRegistrationQueryVariables>(SearchPersonByRegistrationDocument, options);
      }
export function useSearchPersonByRegistrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchPersonByRegistrationQuery, SearchPersonByRegistrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchPersonByRegistrationQuery, SearchPersonByRegistrationQueryVariables>(SearchPersonByRegistrationDocument, options);
        }
export function useSearchPersonByRegistrationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchPersonByRegistrationQuery, SearchPersonByRegistrationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchPersonByRegistrationQuery, SearchPersonByRegistrationQueryVariables>(SearchPersonByRegistrationDocument, options);
        }
export type SearchPersonByRegistrationQueryHookResult = ReturnType<typeof useSearchPersonByRegistrationQuery>;
export type SearchPersonByRegistrationLazyQueryHookResult = ReturnType<typeof useSearchPersonByRegistrationLazyQuery>;
export type SearchPersonByRegistrationSuspenseQueryHookResult = ReturnType<typeof useSearchPersonByRegistrationSuspenseQuery>;
export type SearchPersonByRegistrationQueryResult = Apollo.QueryResult<SearchPersonByRegistrationQuery, SearchPersonByRegistrationQueryVariables>;